(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hsTwZ", function(module, exports) {

var $2IMrA = parcelRequire("2IMrA");

var $cipRL = parcelRequire("cipRL");

var $80CCQ = parcelRequire("80CCQ");

var $HKR4R = parcelRequire("HKR4R");

var $fDTJE = parcelRequire("fDTJE");
const LE = new Uint8Array(Uint16Array.of(0xff).buffer)[0] === 0xff;
function codecFor(encoding) {
    switch(encoding){
        case "ascii":
            return $2IMrA;
        case "base64":
            return $cipRL;
        case "hex":
            return $80CCQ;
        case "utf8":
        case "utf-8":
        case undefined:
            return $HKR4R;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $fDTJE;
        default:
            throw new Error(`Unknown encoding: ${encoding}`);
    }
}
function isBuffer(value) {
    return value instanceof Uint8Array;
}
function isEncoding(encoding) {
    try {
        codecFor(encoding);
        return true;
    } catch  {
        return false;
    }
}
function alloc(size, fill, encoding) {
    const buffer = new Uint8Array(size);
    if (fill !== undefined) exports.fill(buffer, fill, 0, buffer.byteLength, encoding);
    return buffer;
}
function allocUnsafe(size) {
    return new Uint8Array(size);
}
function allocUnsafeSlow(size) {
    return new Uint8Array(size);
}
function byteLength(string, encoding) {
    return codecFor(encoding).byteLength(string);
}
function compare(a, b) {
    if (a === b) return 0;
    const len = Math.min(a.byteLength, b.byteLength);
    a = new DataView(a.buffer, a.byteOffset, a.byteLength);
    b = new DataView(b.buffer, b.byteOffset, b.byteLength);
    let i = 0;
    for(let n = len - len % 4; i < n; i += 4){
        const x = a.getUint32(i, LE);
        const y = b.getUint32(i, LE);
        if (x !== y) break;
    }
    for(; i < len; i++){
        const x = a.getUint8(i);
        const y = b.getUint8(i);
        if (x < y) return -1;
        if (x > y) return 1;
    }
    return a.byteLength > b.byteLength ? 1 : a.byteLength < b.byteLength ? -1 : 0;
}
function concat(buffers, totalLength) {
    if (totalLength === undefined) totalLength = buffers.reduce((len, buffer)=>len + buffer.byteLength, 0);
    const result = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        if (offset + buffer.byteLength > result.byteLength) {
            const sub = buffer.subarray(0, result.byteLength - offset);
            result.set(sub, offset);
            return result;
        }
        result.set(buffer, offset);
        offset += buffer.byteLength;
    }
    return result;
}
function copy(source, target, targetStart = 0, start = 0, end = source.byteLength) {
    if (end > 0 && end < start) return 0;
    if (end === start) return 0;
    if (source.byteLength === 0 || target.byteLength === 0) return 0;
    if (targetStart < 0) throw new RangeError("targetStart is out of range");
    if (start < 0 || start >= source.byteLength) throw new RangeError("sourceStart is out of range");
    if (end < 0) throw new RangeError("sourceEnd is out of range");
    if (targetStart >= target.byteLength) targetStart = target.byteLength;
    if (end > source.byteLength) end = source.byteLength;
    if (target.byteLength - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (source === target) target.copyWithin(targetStart, start, end);
    else target.set(source.subarray(start, end), targetStart);
    return len;
}
function equals(a, b) {
    if (a === b) return true;
    if (a.byteLength !== b.byteLength) return false;
    const len = a.byteLength;
    a = new DataView(a.buffer, a.byteOffset, a.byteLength);
    b = new DataView(b.buffer, b.byteOffset, b.byteLength);
    let i = 0;
    for(let n = len - len % 4; i < n; i += 4){
        if (a.getUint32(i, LE) !== b.getUint32(i, LE)) return false;
    }
    for(; i < len; i++){
        if (a.getUint8(i) !== b.getUint8(i)) return false;
    }
    return true;
}
function fill(buffer, value, offset, end, encoding) {
    if (typeof value === "string") {
        // fill(buffer, string, encoding)
        if (typeof offset === "string") {
            encoding = offset;
            offset = 0;
            end = buffer.byteLength;
        // fill(buffer, string, offset, encoding)
        } else if (typeof end === "string") {
            encoding = end;
            end = buffer.byteLength;
        }
    } else if (typeof value === "number") value = value & 0xff;
    else if (typeof value === "boolean") value = +value;
    if (offset < 0 || buffer.byteLength < offset || buffer.byteLength < end) throw new RangeError("Out of range index");
    if (offset === undefined) offset = 0;
    if (end === undefined) end = buffer.byteLength;
    if (end <= offset) return buffer;
    if (!value) value = 0;
    if (typeof value === "number") for(let i = offset; i < end; ++i)buffer[i] = value;
    else {
        value = isBuffer(value) ? value : from(value, encoding);
        const len = value.byteLength;
        for(let i = 0; i < end - offset; ++i)buffer[i + offset] = value[i % len];
    }
    return buffer;
}
function from(value, encodingOrOffset, length) {
    // from(string, encoding)
    if (typeof value === "string") return fromString(value, encodingOrOffset);
    // from(array)
    if (Array.isArray(value)) return fromArray(value);
    // from(buffer)
    if (ArrayBuffer.isView(value)) return fromBuffer(value);
    // from(arrayBuffer[, byteOffset[, length]])
    return fromArrayBuffer(value, encodingOrOffset, length);
}
function fromString(string, encoding) {
    const codec = codecFor(encoding);
    const buffer = new Uint8Array(codec.byteLength(string));
    codec.write(buffer, string, 0, buffer.byteLength);
    return buffer;
}
function fromArray(array) {
    const buffer = new Uint8Array(array.length);
    buffer.set(array);
    return buffer;
}
function fromBuffer(buffer) {
    const copy = new Uint8Array(buffer.byteLength);
    copy.set(buffer);
    return copy;
}
function fromArrayBuffer(arrayBuffer, byteOffset, length) {
    return new Uint8Array(arrayBuffer, byteOffset, length);
}
function includes(buffer, value, byteOffset, encoding) {
    return indexOf(buffer, value, byteOffset, encoding) !== -1;
}
function bidirectionalIndexOf(buffer, value, byteOffset, encoding, first) {
    if (buffer.byteLength === 0) return -1;
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset === undefined) byteOffset = first ? 0 : buffer.length - 1;
    else if (byteOffset < 0) byteOffset += buffer.byteLength;
    if (byteOffset >= buffer.byteLength) {
        if (first) return -1;
        else byteOffset = buffer.byteLength - 1;
    } else if (byteOffset < 0) {
        if (first) byteOffset = 0;
        else return -1;
    }
    if (typeof value === "string") value = from(value, encoding);
    else if (typeof value === "number") {
        value = value & 0xff;
        if (first) return buffer.indexOf(value, byteOffset);
        else return buffer.lastIndexOf(value, byteOffset);
    }
    if (value.byteLength === 0) return -1;
    if (first) {
        let foundIndex = -1;
        for(let i = byteOffset; i < buffer.byteLength; i++)if (buffer[i] === value[foundIndex === -1 ? 0 : i - foundIndex]) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === value.byteLength) return foundIndex;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + value.byteLength > buffer.byteLength) byteOffset = buffer.byteLength - value.byteLength;
        for(let i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < value.byteLength; j++)if (buffer[i + j] !== value[j]) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
function indexOf(buffer, value, byteOffset, encoding) {
    return bidirectionalIndexOf(buffer, value, byteOffset, encoding, true);
}
function lastIndexOf(buffer, value, byteOffset, encoding) {
    return bidirectionalIndexOf(buffer, value, byteOffset, encoding, false);
}
function swap(buffer, n, m) {
    const i = buffer[n];
    buffer[n] = buffer[m];
    buffer[m] = i;
}
function swap16(buffer) {
    const len = buffer.byteLength;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)swap(buffer, i, i + 1);
    return buffer;
}
function swap32(buffer) {
    const len = buffer.byteLength;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        swap(buffer, i, i + 3);
        swap(buffer, i + 1, i + 2);
    }
    return buffer;
}
function swap64(buffer) {
    const len = buffer.byteLength;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        swap(buffer, i, i + 7);
        swap(buffer, i + 1, i + 6);
        swap(buffer, i + 2, i + 5);
        swap(buffer, i + 3, i + 4);
    }
    return buffer;
}
function toBuffer(buffer) {
    return buffer;
}
function toString(buffer, encoding, start = 0, end = buffer.byteLength) {
    const len = buffer.byteLength;
    if (start >= len) return "";
    if (end <= start) return "";
    if (start < 0) start = 0;
    if (end > len) end = len;
    if (start !== 0 || end < len) buffer = buffer.subarray(start, end);
    return codecFor(encoding).toString(buffer);
}
function write(buffer, string, offset, length, encoding) {
    // write(buffer, string)
    if (offset === undefined) encoding = "utf8";
    else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        offset = undefined;
    // write(buffer, string, offset, encoding)
    } else if (encoding === undefined && typeof length === "string") {
        encoding = length;
        length = undefined;
    }
    return codecFor(encoding).write(buffer, string, offset, length);
}
function writeDoubleLE(buffer, value, offset) {
    if (offset === undefined) offset = 0;
    const view = new DataView(buffer.buffer, buffer.byteOffset, buffer.byteLength);
    view.setFloat64(offset, value, true);
    return offset + 8;
}
function writeFloatLE(buffer, value, offset) {
    if (offset === undefined) offset = 0;
    const view = new DataView(buffer.buffer, buffer.byteOffset, buffer.byteLength);
    view.setFloat32(offset, value, true);
    return offset + 4;
}
function writeUInt32LE(buffer, value, offset) {
    if (offset === undefined) offset = 0;
    const view = new DataView(buffer.buffer, buffer.byteOffset, buffer.byteLength);
    view.setUint32(offset, value, true);
    return offset + 4;
}
function writeInt32LE(buffer, value, offset) {
    if (offset === undefined) offset = 0;
    const view = new DataView(buffer.buffer, buffer.byteOffset, buffer.byteLength);
    view.setInt32(offset, value, true);
    return offset + 4;
}
function readDoubleLE(buffer, offset) {
    if (offset === undefined) offset = 0;
    const view = new DataView(buffer.buffer, buffer.byteOffset, buffer.byteLength);
    return view.getFloat64(offset, true);
}
function readFloatLE(buffer, offset) {
    if (offset === undefined) offset = 0;
    const view = new DataView(buffer.buffer, buffer.byteOffset, buffer.byteLength);
    return view.getFloat32(offset, true);
}
function readUInt32LE(buffer, offset) {
    if (offset === undefined) offset = 0;
    const view = new DataView(buffer.buffer, buffer.byteOffset, buffer.byteLength);
    return view.getUint32(offset, true);
}
function readInt32LE(buffer, offset) {
    if (offset === undefined) offset = 0;
    const view = new DataView(buffer.buffer, buffer.byteOffset, buffer.byteLength);
    return view.getInt32(offset, true);
}
module.exports = exports = {
    isBuffer: isBuffer,
    isEncoding: isEncoding,
    alloc: alloc,
    allocUnsafe: allocUnsafe,
    allocUnsafeSlow: allocUnsafeSlow,
    byteLength: byteLength,
    compare: compare,
    concat: concat,
    copy: copy,
    equals: equals,
    fill: fill,
    from: from,
    includes: includes,
    indexOf: indexOf,
    lastIndexOf: lastIndexOf,
    swap16: swap16,
    swap32: swap32,
    swap64: swap64,
    toBuffer: toBuffer,
    toString: toString,
    write: write,
    writeDoubleLE: writeDoubleLE,
    writeFloatLE: writeFloatLE,
    writeUInt32LE: writeUInt32LE,
    writeInt32LE: writeInt32LE,
    readDoubleLE: readDoubleLE,
    readFloatLE: readFloatLE,
    readUInt32LE: readUInt32LE,
    readInt32LE: readInt32LE
};

});
parcelRegister("2IMrA", function(module, exports) {
function $1fb544cad95fac6b$var$byteLength(string) {
    return string.length;
}
function $1fb544cad95fac6b$var$toString(buffer) {
    const len = buffer.byteLength;
    let result = "";
    for(let i = 0; i < len; i++)result += String.fromCharCode(buffer[i]);
    return result;
}
function $1fb544cad95fac6b$var$write(buffer, string, offset = 0, length = $1fb544cad95fac6b$var$byteLength(string)) {
    const len = Math.min(length, buffer.byteLength - offset);
    for(let i = 0; i < len; i++)buffer[offset + i] = string.charCodeAt(i);
    return len;
}
module.exports = {
    byteLength: $1fb544cad95fac6b$var$byteLength,
    toString: $1fb544cad95fac6b$var$toString,
    write: $1fb544cad95fac6b$var$write
};

});

parcelRegister("cipRL", function(module, exports) {
const $8f3b3af71896dc39$var$alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
const $8f3b3af71896dc39$var$codes = new Uint8Array(256);
for(let i = 0; i < $8f3b3af71896dc39$var$alphabet.length; i++)$8f3b3af71896dc39$var$codes[$8f3b3af71896dc39$var$alphabet.charCodeAt(i)] = i;
$8f3b3af71896dc39$var$codes[/* - */ 0x2d] = 62;
$8f3b3af71896dc39$var$codes[/* _ */ 0x5f] = 63;
function $8f3b3af71896dc39$var$byteLength(string) {
    let len = string.length;
    if (string.charCodeAt(len - 1) === 0x3d) len--;
    if (len > 1 && string.charCodeAt(len - 1) === 0x3d) len--;
    return len * 3 >>> 2;
}
function $8f3b3af71896dc39$var$toString(buffer) {
    const len = buffer.byteLength;
    let result = "";
    for(let i = 0; i < len; i += 3)result += $8f3b3af71896dc39$var$alphabet[buffer[i] >> 2] + $8f3b3af71896dc39$var$alphabet[(buffer[i] & 3) << 4 | buffer[i + 1] >> 4] + $8f3b3af71896dc39$var$alphabet[(buffer[i + 1] & 15) << 2 | buffer[i + 2] >> 6] + $8f3b3af71896dc39$var$alphabet[buffer[i + 2] & 63];
    if (len % 3 === 2) result = result.substring(0, result.length - 1) + "=";
    else if (len % 3 === 1) result = result.substring(0, result.length - 2) + "==";
    return result;
}
function $8f3b3af71896dc39$var$write(buffer, string, offset = 0, length = $8f3b3af71896dc39$var$byteLength(string)) {
    const len = Math.min(length, buffer.byteLength - offset);
    for(let i = 0, j = 0; j < len; i += 4){
        const a = $8f3b3af71896dc39$var$codes[string.charCodeAt(i)];
        const b = $8f3b3af71896dc39$var$codes[string.charCodeAt(i + 1)];
        const c = $8f3b3af71896dc39$var$codes[string.charCodeAt(i + 2)];
        const d = $8f3b3af71896dc39$var$codes[string.charCodeAt(i + 3)];
        buffer[j++] = a << 2 | b >> 4;
        buffer[j++] = (b & 15) << 4 | c >> 2;
        buffer[j++] = (c & 3) << 6 | d & 63;
    }
    return len;
}
module.exports = {
    byteLength: $8f3b3af71896dc39$var$byteLength,
    toString: $8f3b3af71896dc39$var$toString,
    write: $8f3b3af71896dc39$var$write
};

});

parcelRegister("80CCQ", function(module, exports) {
function $5d4c490ae9123a7d$var$byteLength(string) {
    return string.length >>> 1;
}
function $5d4c490ae9123a7d$var$toString(buffer) {
    const len = buffer.byteLength;
    buffer = new DataView(buffer.buffer, buffer.byteOffset, len);
    let result = "";
    let i = 0;
    for(let n = len - len % 4; i < n; i += 4)result += buffer.getUint32(i).toString(16).padStart(8, "0");
    for(; i < len; i++)result += buffer.getUint8(i).toString(16).padStart(2, "0");
    return result;
}
function $5d4c490ae9123a7d$var$write(buffer, string, offset = 0, length = $5d4c490ae9123a7d$var$byteLength(string)) {
    const len = Math.min(length, buffer.byteLength - offset);
    for(let i = 0; i < len; i++){
        const a = $5d4c490ae9123a7d$var$hexValue(string.charCodeAt(i * 2));
        const b = $5d4c490ae9123a7d$var$hexValue(string.charCodeAt(i * 2 + 1));
        if (a === undefined || b === undefined) return buffer.subarray(0, i);
        buffer[offset + i] = a << 4 | b;
    }
    return len;
}
module.exports = {
    byteLength: $5d4c490ae9123a7d$var$byteLength,
    toString: $5d4c490ae9123a7d$var$toString,
    write: $5d4c490ae9123a7d$var$write
};
function $5d4c490ae9123a7d$var$hexValue(char) {
    if (char >= 0x30 && char <= 0x39) return char - 0x30;
    if (char >= 0x41 && char <= 0x46) return char - 0x41 + 10;
    if (char >= 0x61 && char <= 0x66) return char - 0x61 + 10;
}

});

parcelRegister("HKR4R", function(module, exports) {
function $08385cb60d4f21a3$var$byteLength(string) {
    let length = 0;
    for(let i = 0, n = string.length; i < n; i++){
        const code = string.charCodeAt(i);
        if (code >= 0xd800 && code <= 0xdbff && i + 1 < n) {
            const code = string.charCodeAt(i + 1);
            if (code >= 0xdc00 && code <= 0xdfff) {
                length += 4;
                i++;
                continue;
            }
        }
        if (code <= 0x7f) length += 1;
        else if (code <= 0x7ff) length += 2;
        else length += 3;
    }
    return length;
}
let $08385cb60d4f21a3$var$toString;
if (typeof TextDecoder !== "undefined") {
    const decoder = new TextDecoder();
    $08385cb60d4f21a3$var$toString = function toString(buffer) {
        return decoder.decode(buffer);
    };
} else $08385cb60d4f21a3$var$toString = function toString(buffer) {
    const len = buffer.byteLength;
    let output = "";
    let i = 0;
    while(i < len){
        let byte = buffer[i];
        if (byte <= 0x7f) {
            output += String.fromCharCode(byte);
            i++;
            continue;
        }
        let bytesNeeded = 0;
        let codePoint = 0;
        if (byte <= 0xdf) {
            bytesNeeded = 1;
            codePoint = byte & 0x1f;
        } else if (byte <= 0xef) {
            bytesNeeded = 2;
            codePoint = byte & 0x0f;
        } else if (byte <= 0xf4) {
            bytesNeeded = 3;
            codePoint = byte & 0x07;
        }
        if (len - i - bytesNeeded > 0) {
            let k = 0;
            while(k < bytesNeeded){
                byte = buffer[i + k + 1];
                codePoint = codePoint << 6 | byte & 0x3f;
                k += 1;
            }
        } else {
            codePoint = 0xfffd;
            bytesNeeded = len - i;
        }
        output += String.fromCodePoint(codePoint);
        i += bytesNeeded + 1;
    }
    return output;
};
let $08385cb60d4f21a3$var$write;
if (typeof TextEncoder !== "undefined") {
    const encoder = new TextEncoder();
    $08385cb60d4f21a3$var$write = function write(buffer, string, offset = 0, length = $08385cb60d4f21a3$var$byteLength(string)) {
        const len = Math.min(length, buffer.byteLength - offset);
        encoder.encodeInto(string, buffer.subarray(offset, offset + len));
        return len;
    };
} else $08385cb60d4f21a3$var$write = function write(buffer, string, offset = 0, length = $08385cb60d4f21a3$var$byteLength(string)) {
    const len = Math.min(length, buffer.byteLength - offset);
    buffer = buffer.subarray(offset, offset + len);
    let i = 0;
    let j = 0;
    while(i < string.length){
        const code = string.codePointAt(i);
        if (code <= 0x7f) {
            buffer[j++] = code;
            i++;
            continue;
        }
        let count = 0;
        let bits = 0;
        if (code <= 0x7ff) {
            count = 6;
            bits = 0xc0;
        } else if (code <= 0xffff) {
            count = 12;
            bits = 0xe0;
        } else if (code <= 0x1fffff) {
            count = 18;
            bits = 0xf0;
        }
        buffer[j++] = bits | code >> count;
        count -= 6;
        while(count >= 0){
            buffer[j++] = 0x80 | code >> count & 0x3f;
            count -= 6;
        }
        i += code >= 0x10000 ? 2 : 1;
    }
    return len;
};
module.exports = {
    byteLength: $08385cb60d4f21a3$var$byteLength,
    toString: $08385cb60d4f21a3$var$toString,
    write: $08385cb60d4f21a3$var$write
};

});

parcelRegister("fDTJE", function(module, exports) {
function $b635bb63fdffcecf$var$byteLength(string) {
    return string.length * 2;
}
function $b635bb63fdffcecf$var$toString(buffer) {
    const len = buffer.byteLength;
    let result = "";
    for(let i = 0; i < len - 1; i += 2)result += String.fromCharCode(buffer[i] + buffer[i + 1] * 256);
    return result;
}
function $b635bb63fdffcecf$var$write(buffer, string, offset = 0, length = $b635bb63fdffcecf$var$byteLength(string)) {
    const len = Math.min(length, buffer.byteLength - offset);
    let units = len;
    for(let i = 0; i < string.length; ++i){
        if ((units -= 2) < 0) break;
        const c = string.charCodeAt(i);
        const hi = c >> 8;
        const lo = c % 256;
        buffer[offset + i * 2] = lo;
        buffer[offset + i * 2 + 1] = hi;
    }
    return len;
}
module.exports = {
    byteLength: $b635bb63fdffcecf$var$byteLength,
    toString: $b635bb63fdffcecf$var$toString,
    write: $b635bb63fdffcecf$var$write
};

});


parcelRegister("b11PC", function(module, exports) {
"use strict";

// Based on https://github.com/dchest/tweetnacl-js/blob/6dcbcaf5f5cbfd313f2dcfe763db35c828c8ff5b/nacl-fast.js.
// Ported in 2014 by Dmitry Chestnykh and Devi Mandiri.
// Public domain.
//
// Implementation derived from TweetNaCl version 20140427.
// See for details: http://tweetnacl.cr.yp.to/
$8051356e2167972c$var$forward((parcelRequire("aiVbm")));

$8051356e2167972c$var$forward((parcelRequire("3CnRI")));

$8051356e2167972c$var$forward((parcelRequire("itNbj")));

$8051356e2167972c$var$forward((parcelRequire("7wznJ")));

$8051356e2167972c$var$forward((parcelRequire("7sYAq")));

$8051356e2167972c$var$forward((parcelRequire("ihZd3")));

$8051356e2167972c$var$forward((parcelRequire("l4mFx")));

$8051356e2167972c$var$forward((parcelRequire("2lMhZ")));

$8051356e2167972c$var$forward((parcelRequire("47OGR")));

$8051356e2167972c$var$forward((parcelRequire("4PZaT")));

$8051356e2167972c$var$forward((parcelRequire("3bp3a")));

$8051356e2167972c$var$forward((parcelRequire("4smhl")));

$8051356e2167972c$var$forward((parcelRequire("hCFud")));

$8051356e2167972c$var$forward((parcelRequire("en1S3")));

$8051356e2167972c$var$forward((parcelRequire("80TxX")));

$8051356e2167972c$var$forward((parcelRequire("ill7F")));

$8051356e2167972c$var$forward((parcelRequire("gZMW6")));

$8051356e2167972c$var$forward((parcelRequire("4vSiJ")));

$8051356e2167972c$var$forward((parcelRequire("63ApX")));

$8051356e2167972c$var$forward((parcelRequire("hc3Gp")));
function $8051356e2167972c$var$forward(submodule) {
    Object.keys(submodule).forEach(function(prop) {
        module.exports[prop] = submodule[prop];
    });
}

});
parcelRegister("aiVbm", function(module, exports) {

var $6JSie = parcelRequire("6JSie");

var $7807f103cba616dd$var$randombytes = function() {
    var QUOTA = 65536 // limit for QuotaExceededException
    ;
    var crypto = globalThis.crypto || globalThis.msCrypto;
    function browserBytes(out, n) {
        for(let i = 0; i < n; i += QUOTA)crypto.getRandomValues(new Uint8Array(out.buffer, i + out.byteOffset, Math.min(n - i, QUOTA)));
    }
    function nodeBytes(out, n) {
        new Uint8Array(out.buffer, out.byteOffset, n).set(crypto.randomBytes(n));
    }
    function noImpl() {
        throw new Error("No secure random number generator available");
    }
    if (crypto && crypto.getRandomValues) return browserBytes;
    if (undefined != null) {
        // Node.js. Bust Browserify
        crypto = (parcelRequire("1wVs5"));
        if (crypto && crypto.randomBytes) return nodeBytes;
    }
    return noImpl;
}();
// Make non enumerable as this is an internal function
Object.defineProperty(module.exports, "randombytes", {
    value: $7807f103cba616dd$var$randombytes
});
module.exports.randombytes_buf = function(out) {
    $6JSie(out, "out must be given");
    $7807f103cba616dd$var$randombytes(out, out.byteLength);
};

});
parcelRegister("6JSie", function(module, exports) {
module.exports = $4e810f817a8dc2b0$var$assert;
class $4e810f817a8dc2b0$var$AssertionError extends Error {
}
$4e810f817a8dc2b0$var$AssertionError.prototype.name = "AssertionError";
/**
 * Minimal assert function
 * @param  {any} t Value to check if falsy
 * @param  {string=} m Optional assertion error message
 * @throws {AssertionError}
 */ function $4e810f817a8dc2b0$var$assert(t, m) {
    if (!t) {
        var err = new $4e810f817a8dc2b0$var$AssertionError(m);
        if (Error.captureStackTrace) Error.captureStackTrace(err, $4e810f817a8dc2b0$var$assert);
        throw err;
    }
}

});

parcelRegister("1wVs5", function(module, exports) {
"use strict";

});


parcelRegister("3CnRI", function(module, exports) {
/* eslint-disable camelcase */ function $2a276edcc3d518c2$var$sodium_malloc(n) {
    return new Uint8Array(n);
}
function $2a276edcc3d518c2$var$sodium_free(n) {
    $2a276edcc3d518c2$var$sodium_memzero(n);
    $2a276edcc3d518c2$var$loadSink().port1.postMessage(n.buffer, [
        n.buffer
    ]);
}
function $2a276edcc3d518c2$var$sodium_memzero(arr) {
    arr.fill(0);
}
var $2a276edcc3d518c2$var$sink;

function $2a276edcc3d518c2$var$loadSink() {
    if ($2a276edcc3d518c2$var$sink) return $2a276edcc3d518c2$var$sink;
    var MessageChannel = globalThis.MessageChannel;
    if (MessageChannel == null) ({ MessageChannel: MessageChannel } = (parcelRequire("1wVs5")));
    $2a276edcc3d518c2$var$sink = new MessageChannel();
    return $2a276edcc3d518c2$var$sink;
}
module.exports = {
    sodium_malloc: $2a276edcc3d518c2$var$sodium_malloc,
    sodium_free: $2a276edcc3d518c2$var$sodium_free,
    sodium_memzero: $2a276edcc3d518c2$var$sodium_memzero
};

});

parcelRegister("itNbj", function(module, exports) {
/* eslint-disable camelcase */ 
var $6JSie = parcelRequire("6JSie");

var $7wznJ = parcelRequire("7wznJ");
var $d74115d448c81274$require$vn = $7wznJ.vn;
function $d74115d448c81274$var$sodium_increment(n) {
    const nlen = n.byteLength;
    var c = 1;
    for(var i = 0; i < nlen; i++){
        c += n[i];
        n[i] = c;
        c >>= 8;
    }
}
function $d74115d448c81274$var$sodium_memcmp(a, b) {
    $6JSie(a.byteLength === b.byteLength, "buffers must be the same size");
    return $d74115d448c81274$require$vn(a, 0, b, 0, a.byteLength) === 0;
}
function $d74115d448c81274$var$sodium_is_zero(arr) {
    var d = 0;
    for(let i = 0; i < arr.length; i++)d |= arr[i];
    return d === 0;
}
module.exports = {
    sodium_increment: $d74115d448c81274$var$sodium_increment,
    sodium_memcmp: $d74115d448c81274$var$sodium_memcmp,
    sodium_is_zero: $d74115d448c81274$var$sodium_is_zero
};

});
parcelRegister("7wznJ", function(module, exports) {
/* eslint-disable camelcase */ module.exports = {
    crypto_verify_16: $57a6f79ff3a5a232$var$crypto_verify_16,
    crypto_verify_32: $57a6f79ff3a5a232$var$crypto_verify_32,
    crypto_verify_64: $57a6f79ff3a5a232$var$crypto_verify_64
};
function $57a6f79ff3a5a232$var$vn(x, xi, y, yi, n) {
    var d = 0;
    for(let i = 0; i < n; i++)d |= x[xi + i] ^ y[yi + i];
    return (1 & d - 1 >>> 8) - 1;
}
// Make non enumerable as this is an internal function
Object.defineProperty(module.exports, "vn", {
    value: $57a6f79ff3a5a232$var$vn
});
function $57a6f79ff3a5a232$var$crypto_verify_16(x, xi, y, yi) {
    return $57a6f79ff3a5a232$var$vn(x, xi, y, yi, 16) === 0;
}
function $57a6f79ff3a5a232$var$crypto_verify_32(x, xi, y, yi) {
    return $57a6f79ff3a5a232$var$vn(x, xi, y, yi, 32) === 0;
}
function $57a6f79ff3a5a232$var$crypto_verify_64(x, xi, y, yi) {
    return $57a6f79ff3a5a232$var$vn(x, xi, y, yi, 64) === 0;
}

});


parcelRegister("7sYAq", function(module, exports) {
/* eslint-disable camelcase */ 
var $7wznJ = parcelRequire("7wznJ");
var $56fa25202d598fe4$require$crypto_verify_32 = $7wznJ.crypto_verify_32;

var $bfHfZ = parcelRequire("bfHfZ");

var $6JSie = parcelRequire("6JSie");
const $56fa25202d598fe4$var$crypto_auth_BYTES = 32;
const $56fa25202d598fe4$var$crypto_auth_KEYBYTES = 32;
function $56fa25202d598fe4$var$crypto_auth(out, input, k) {
    $6JSie(out.byteLength === $56fa25202d598fe4$var$crypto_auth_BYTES, "out should be 'crypto_auth_BYTES' in length");
    $6JSie(k.byteLength === $56fa25202d598fe4$var$crypto_auth_KEYBYTES, "key should be 'crypto_auth_KEYBYTES' in length");
    const out0 = new Uint8Array(64);
    const hmac = $bfHfZ.HMAC(k);
    hmac.update(input);
    hmac.digest(out0);
    out.set(out0.subarray(0, 32));
}
function $56fa25202d598fe4$var$crypto_auth_verify(h, input, k) {
    $6JSie(h.byteLength === $56fa25202d598fe4$var$crypto_auth_BYTES, "h should be 'crypto_auth_BYTES' in length");
    $6JSie(k.byteLength === $56fa25202d598fe4$var$crypto_auth_KEYBYTES, "key should be 'crypto_auth_KEYBYTES' in length");
    const correct = $bfHfZ.HMAC(k).update(input).digest();
    return $56fa25202d598fe4$require$crypto_verify_32(h, 0, correct, 0);
}
module.exports = {
    crypto_auth_BYTES: $56fa25202d598fe4$var$crypto_auth_BYTES,
    crypto_auth_KEYBYTES: $56fa25202d598fe4$var$crypto_auth_KEYBYTES,
    crypto_auth: $56fa25202d598fe4$var$crypto_auth,
    crypto_auth_verify: $56fa25202d598fe4$var$crypto_auth_verify
};

});
parcelRegister("bfHfZ", function(module, exports) {

var $lWsFd = parcelRequire("lWsFd");

var $j1HSv = parcelRequire("j1HSv");
var $8312a6585769ce3d$var$Proto = $lWsFd;
module.exports = function() {
    return new $8312a6585769ce3d$var$Proto();
};
module.exports.ready = function(cb) {
    $j1HSv.ready(function() {
        cb();
    });
};
module.exports.WASM_SUPPORTED = $j1HSv.SUPPORTED;
module.exports.WASM_LOADED = false;
var $8312a6585769ce3d$var$SHA512_BYTES = module.exports.SHA512_BYTES = 64;
$j1HSv.ready(function(err) {
    if (!err) {
        module.exports.WASM_LOADED = true;
        module.exports = $8312a6585769ce3d$var$Proto = $j1HSv;
    }
});

});
parcelRegister("lWsFd", function(module, exports) {

var $6JSie = parcelRequire("6JSie");

var $hsTwZ = parcelRequire("hsTwZ");
module.exports = $ff953fc217c80086$var$Sha512;
const $ff953fc217c80086$var$BLOCKSIZE = 128;
var $ff953fc217c80086$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $ff953fc217c80086$var$Sha512() {
    if (!(this instanceof $ff953fc217c80086$var$Sha512)) return new $ff953fc217c80086$var$Sha512();
    this.hh = new Int32Array(8);
    this.hl = new Int32Array(8);
    this.buffer = new Uint8Array(128);
    this.finalised = false;
    this.bytesRead = 0;
    this.pos = 0;
    this.hh[0] = 0x6a09e667;
    this.hh[1] = 0xbb67ae85;
    this.hh[2] = 0x3c6ef372;
    this.hh[3] = 0xa54ff53a;
    this.hh[4] = 0x510e527f;
    this.hh[5] = 0x9b05688c;
    this.hh[6] = 0x1f83d9ab;
    this.hh[7] = 0x5be0cd19;
    this.hl[0] = 0xf3bcc908;
    this.hl[1] = 0x84caa73b;
    this.hl[2] = 0xfe94f82b;
    this.hl[3] = 0x5f1d36f1;
    this.hl[4] = 0xade682d1;
    this.hl[5] = 0x2b3e6c1f;
    this.hl[6] = 0xfb41bd6b;
    this.hl[7] = 0x137e2179;
    return this;
}
$ff953fc217c80086$var$Sha512.prototype.update = function(input, enc) {
    $6JSie(this.finalised === false, "Hash instance finalised");
    var [inputBuf, len] = $ff953fc217c80086$var$formatInput(input, enc);
    this.bytesRead += len;
    const full = len + this.pos & -128;
    this.buffer.set(inputBuf.subarray(0, $ff953fc217c80086$var$BLOCKSIZE - this.pos), this.pos);
    const pos = this.pos;
    len -= $ff953fc217c80086$var$BLOCKSIZE - this.pos;
    if (len >= 0) {
        $ff953fc217c80086$var$compress(this.hh, this.hl, this.buffer, 128);
        this.pos = 0;
    }
    if (len > 127) {
        $ff953fc217c80086$var$compress(this.hh, this.hl, inputBuf.subarray($ff953fc217c80086$var$BLOCKSIZE - pos, full - pos), full - $ff953fc217c80086$var$BLOCKSIZE);
        len %= 128;
    }
    this.buffer.set(inputBuf.subarray(inputBuf.byteLength - len));
    this.pos = this.bytesRead & 0x7f;
    this.buffer.fill(0, this.pos);
    return this;
};
$ff953fc217c80086$var$Sha512.prototype.digest = function(enc, offset = 0) {
    $6JSie(this.finalised === false, "Hash instance finalised");
    this.finalised = true;
    this.buffer.fill(0, this.pos);
    this.buffer[this.pos] = 128;
    if (this.pos > 111) {
        $ff953fc217c80086$var$compress(this.hh, this.hl, this.buffer, 128);
        this.buffer.fill(0);
        this.pos = 0;
    }
    $ff953fc217c80086$var$ts64(this.buffer, 120, this.bytesRead / 0x20000000 | 0, this.bytesRead << 3);
    $ff953fc217c80086$var$compress(this.hh, this.hl, this.buffer, 128);
    if (enc instanceof Uint8Array && enc.byteLength > 63) {
        for(let i = 0; i < 8; i++)$ff953fc217c80086$var$ts64(enc, 8 * i + offset, this.hh[i], this.hl[i]);
        return enc;
    }
    const resultBuf = new Uint8Array(64);
    for(let i = 0; i < 8; i++)$ff953fc217c80086$var$ts64(resultBuf, 8 * i, this.hh[i], this.hl[i]);
    if (typeof enc === "string") return $hsTwZ.toString(resultBuf, enc);
    return resultBuf;
};
function $ff953fc217c80086$var$ts64(x, i, h, l) {
    x[i] = h >> 24 & 0xff;
    x[i + 1] = h >> 16 & 0xff;
    x[i + 2] = h >> 8 & 0xff;
    x[i + 3] = h & 0xff;
    x[i + 4] = l >> 24 & 0xff;
    x[i + 5] = l >> 16 & 0xff;
    x[i + 6] = l >> 8 & 0xff;
    x[i + 7] = l & 0xff;
}
function $ff953fc217c80086$var$formatInput(input, enc) {
    var result = $hsTwZ.from(input, enc);
    return [
        result,
        result.byteLength
    ];
}
function $ff953fc217c80086$var$compress(hh, hl, m, n) {
    var wh = new Int32Array(16), wl = new Int32Array(16), bh0, bh1, bh2, bh3, bh4, bh5, bh6, bh7, bl0, bl1, bl2, bl3, bl4, bl5, bl6, bl7, th, tl, i, j, h, l, a, b, c, d;
    var ah0 = hh[0], ah1 = hh[1], ah2 = hh[2], ah3 = hh[3], ah4 = hh[4], ah5 = hh[5], ah6 = hh[6], ah7 = hh[7], al0 = hl[0], al1 = hl[1], al2 = hl[2], al3 = hl[3], al4 = hl[4], al5 = hl[5], al6 = hl[6], al7 = hl[7];
    var pos = 0;
    while(n >= 128){
        for(i = 0; i < 16; i++){
            j = 8 * i + pos;
            wh[i] = m[j + 0] << 24 | m[j + 1] << 16 | m[j + 2] << 8 | m[j + 3];
            wl[i] = m[j + 4] << 24 | m[j + 5] << 16 | m[j + 6] << 8 | m[j + 7];
        }
        for(i = 0; i < 80; i++){
            bh0 = ah0;
            bh1 = ah1;
            bh2 = ah2;
            bh3 = ah3;
            bh4 = ah4;
            bh5 = ah5;
            bh6 = ah6;
            bh7 = ah7;
            bl0 = al0;
            bl1 = al1;
            bl2 = al2;
            bl3 = al3;
            bl4 = al4;
            bl5 = al5;
            bl6 = al6;
            bl7 = al7;
            // add
            h = ah7;
            l = al7;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            // Sigma1
            h = (ah4 >>> 14 | al4 << 18) ^ (ah4 >>> 18 | al4 << 14) ^ (al4 >>> 9 | ah4 << 23);
            l = (al4 >>> 14 | ah4 << 18) ^ (al4 >>> 18 | ah4 << 14) ^ (ah4 >>> 9 | al4 << 23);
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // Ch
            h = ah4 & ah5 ^ ~ah4 & ah6;
            l = al4 & al5 ^ ~al4 & al6;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // K
            h = $ff953fc217c80086$var$K[i * 2];
            l = $ff953fc217c80086$var$K[i * 2 + 1];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // w
            h = wh[i % 16];
            l = wl[i % 16];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            th = c & 0xffff | d << 16;
            tl = a & 0xffff | b << 16;
            // add
            h = th;
            l = tl;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            // Sigma0
            h = (ah0 >>> 28 | al0 << 4) ^ (al0 >>> 2 | ah0 << 30) ^ (al0 >>> 7 | ah0 << 25);
            l = (al0 >>> 28 | ah0 << 4) ^ (ah0 >>> 2 | al0 << 30) ^ (ah0 >>> 7 | al0 << 25);
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // Maj
            h = ah0 & ah1 ^ ah0 & ah2 ^ ah1 & ah2;
            l = al0 & al1 ^ al0 & al2 ^ al1 & al2;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            bh7 = c & 0xffff | d << 16;
            bl7 = a & 0xffff | b << 16;
            // add
            h = bh3;
            l = bl3;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = th;
            l = tl;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            bh3 = c & 0xffff | d << 16;
            bl3 = a & 0xffff | b << 16;
            ah1 = bh0;
            ah2 = bh1;
            ah3 = bh2;
            ah4 = bh3;
            ah5 = bh4;
            ah6 = bh5;
            ah7 = bh6;
            ah0 = bh7;
            al1 = bl0;
            al2 = bl1;
            al3 = bl2;
            al4 = bl3;
            al5 = bl4;
            al6 = bl5;
            al7 = bl6;
            al0 = bl7;
            if (i % 16 === 15) for(j = 0; j < 16; j++){
                // add
                h = wh[j];
                l = wl[j];
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                h = wh[(j + 9) % 16];
                l = wl[(j + 9) % 16];
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // sigma0
                th = wh[(j + 1) % 16];
                tl = wl[(j + 1) % 16];
                h = (th >>> 1 | tl << 31) ^ (th >>> 8 | tl << 24) ^ th >>> 7;
                l = (tl >>> 1 | th << 31) ^ (tl >>> 8 | th << 24) ^ (tl >>> 7 | th << 25);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // sigma1
                th = wh[(j + 14) % 16];
                tl = wl[(j + 14) % 16];
                h = (th >>> 19 | tl << 13) ^ (tl >>> 29 | th << 3) ^ th >>> 6;
                l = (tl >>> 19 | th << 13) ^ (th >>> 29 | tl << 3) ^ (tl >>> 6 | th << 26);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                wh[j] = c & 0xffff | d << 16;
                wl[j] = a & 0xffff | b << 16;
            }
        }
        // add
        h = ah0;
        l = al0;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[0];
        l = hl[0];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[0] = ah0 = c & 0xffff | d << 16;
        hl[0] = al0 = a & 0xffff | b << 16;
        h = ah1;
        l = al1;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[1];
        l = hl[1];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[1] = ah1 = c & 0xffff | d << 16;
        hl[1] = al1 = a & 0xffff | b << 16;
        h = ah2;
        l = al2;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[2];
        l = hl[2];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[2] = ah2 = c & 0xffff | d << 16;
        hl[2] = al2 = a & 0xffff | b << 16;
        h = ah3;
        l = al3;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[3];
        l = hl[3];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[3] = ah3 = c & 0xffff | d << 16;
        hl[3] = al3 = a & 0xffff | b << 16;
        h = ah4;
        l = al4;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[4];
        l = hl[4];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[4] = ah4 = c & 0xffff | d << 16;
        hl[4] = al4 = a & 0xffff | b << 16;
        h = ah5;
        l = al5;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[5];
        l = hl[5];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[5] = ah5 = c & 0xffff | d << 16;
        hl[5] = al5 = a & 0xffff | b << 16;
        h = ah6;
        l = al6;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[6];
        l = hl[6];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[6] = ah6 = c & 0xffff | d << 16;
        hl[6] = al6 = a & 0xffff | b << 16;
        h = ah7;
        l = al7;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[7];
        l = hl[7];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[7] = ah7 = c & 0xffff | d << 16;
        hl[7] = al7 = a & 0xffff | b << 16;
        pos += 128;
        n -= 128;
    }
}
function $ff953fc217c80086$var$HMAC(key) {
    if (!(this instanceof $ff953fc217c80086$var$HMAC)) return new $ff953fc217c80086$var$HMAC(key);
    this.pad = $hsTwZ.alloc(128);
    this.inner = $ff953fc217c80086$var$Sha512();
    this.outer = $ff953fc217c80086$var$Sha512();
    const keyhash = $hsTwZ.alloc(64);
    if (key.byteLength > 128) {
        $ff953fc217c80086$var$Sha512().update(key).digest(keyhash);
        key = keyhash;
    }
    this.pad.fill(0x36);
    for(let i = 0; i < key.byteLength; i++)this.pad[i] ^= key[i];
    this.inner.update(this.pad);
    this.pad.fill(0x5c);
    for(let i = 0; i < key.byteLength; i++)this.pad[i] ^= key[i];
    this.outer.update(this.pad);
    this.pad.fill(0);
    keyhash.fill(0);
}
$ff953fc217c80086$var$HMAC.prototype.update = function(input, enc) {
    this.inner.update(input, enc);
    return this;
};
$ff953fc217c80086$var$HMAC.prototype.digest = function(enc, offset = 0) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc, offset);
};
$ff953fc217c80086$var$Sha512.HMAC = $ff953fc217c80086$var$HMAC;

});

parcelRegister("j1HSv", function(module, exports) {

var $6JSie = parcelRequire("6JSie");

var $hsTwZ = parcelRequire("hsTwZ");

const $dda02596e0302017$var$wasm = typeof WebAssembly !== "undefined" && (parcelRequire("jlTFQ"))({
    imports: {
        debug: {
            log (...args) {
                console.log(...args.map((int)=>(int >>> 0).toString(16).padStart(8, "0")));
            },
            log_tee (arg) {
                console.log((arg >>> 0).toString(16).padStart(8, "0"));
                return arg;
            }
        }
    }
});
let $dda02596e0302017$var$head = 0;
// assetrt head % 8 === 0 to guarantee alignment
const $dda02596e0302017$var$freeList = [];
module.exports = $dda02596e0302017$var$Sha512;
const $dda02596e0302017$var$SHA512_BYTES = module.exports.SHA512_BYTES = 64;
const $dda02596e0302017$var$INPUT_OFFSET = 80;
const $dda02596e0302017$var$STATEBYTES = 216;
const $dda02596e0302017$var$BLOCKSIZE = 128;
function $dda02596e0302017$var$Sha512() {
    if (!(this instanceof $dda02596e0302017$var$Sha512)) return new $dda02596e0302017$var$Sha512();
    if (!$dda02596e0302017$var$wasm) throw new Error("WASM not loaded. Wait for Sha512.ready(cb)");
    if (!$dda02596e0302017$var$freeList.length) {
        $dda02596e0302017$var$freeList.push($dda02596e0302017$var$head);
        $dda02596e0302017$var$head += $dda02596e0302017$var$STATEBYTES;
    }
    this.finalized = false;
    this.digestLength = $dda02596e0302017$var$SHA512_BYTES;
    this.pointer = $dda02596e0302017$var$freeList.pop();
    this.pos = 0;
    this.wasm = $dda02596e0302017$var$wasm;
    this._memory = new Uint8Array($dda02596e0302017$var$wasm.memory.buffer);
    this._memory.fill(0, this.pointer, this.pointer + $dda02596e0302017$var$STATEBYTES);
    if (this.pointer + this.digestLength > this._memory.length) this._realloc(this.pointer + $dda02596e0302017$var$STATEBYTES);
}
$dda02596e0302017$var$Sha512.prototype._realloc = function(size) {
    $dda02596e0302017$var$wasm.memory.grow(Math.max(0, Math.ceil(Math.abs(size - this._memory.length) / 65536)));
    this._memory = new Uint8Array($dda02596e0302017$var$wasm.memory.buffer);
};
$dda02596e0302017$var$Sha512.prototype.update = function(input, enc) {
    $6JSie(this.finalized === false, "Hash instance finalized");
    if ($dda02596e0302017$var$head % 8 !== 0) $dda02596e0302017$var$head += 8 - $dda02596e0302017$var$head % 8;
    $6JSie($dda02596e0302017$var$head % 8 === 0, "input should be aligned for int64");
    const [inputBuf, length] = $dda02596e0302017$var$formatInput(input, enc);
    $6JSie(inputBuf instanceof Uint8Array, "input must be Uint8Array or Buffer");
    if ($dda02596e0302017$var$head + input.length > this._memory.length) this._realloc($dda02596e0302017$var$head + input.length);
    this._memory.fill(0, $dda02596e0302017$var$head, $dda02596e0302017$var$head + $dda02596e0302017$var$roundUp(length, $dda02596e0302017$var$BLOCKSIZE) - $dda02596e0302017$var$BLOCKSIZE);
    this._memory.set(inputBuf.subarray(0, $dda02596e0302017$var$BLOCKSIZE - this.pos), this.pointer + $dda02596e0302017$var$INPUT_OFFSET + this.pos);
    this._memory.set(inputBuf.subarray($dda02596e0302017$var$BLOCKSIZE - this.pos), $dda02596e0302017$var$head);
    this.pos = this.pos + length & 0x7f;
    $dda02596e0302017$var$wasm.sha512(this.pointer, $dda02596e0302017$var$head, length, 0);
    return this;
};
$dda02596e0302017$var$Sha512.prototype.digest = function(enc, offset = 0) {
    $6JSie(this.finalized === false, "Hash instance finalized");
    this.finalized = true;
    $dda02596e0302017$var$freeList.push(this.pointer);
    const paddingStart = this.pointer + $dda02596e0302017$var$INPUT_OFFSET + this.pos;
    this._memory.fill(0, paddingStart, this.pointer + $dda02596e0302017$var$INPUT_OFFSET + $dda02596e0302017$var$BLOCKSIZE);
    $dda02596e0302017$var$wasm.sha512(this.pointer, $dda02596e0302017$var$head, 0, 1);
    const resultBuf = this._memory.subarray(this.pointer, this.pointer + this.digestLength);
    if (!enc) return resultBuf;
    if (typeof enc === "string") return $hsTwZ.toString(resultBuf, enc);
    $6JSie(enc instanceof Uint8Array, "output must be Uint8Array or Buffer");
    $6JSie(enc.byteLength >= this.digestLength + offset, "output must have at least 'SHA512_BYTES' bytes remaining");
    for(let i = 0; i < this.digestLength; i++)enc[i + offset] = resultBuf[i];
    return enc;
};
$dda02596e0302017$var$Sha512.WASM = $dda02596e0302017$var$wasm;
$dda02596e0302017$var$Sha512.WASM_SUPPORTED = typeof WebAssembly !== "undefined";
$dda02596e0302017$var$Sha512.ready = function(cb) {
    if (!cb) cb = $dda02596e0302017$var$noop;
    if (!$dda02596e0302017$var$wasm) return cb(new Error("WebAssembly not supported"));
    cb();
    return Promise.resolve();
};
$dda02596e0302017$var$Sha512.prototype.ready = $dda02596e0302017$var$Sha512.ready;
function $dda02596e0302017$var$HMAC(key) {
    if (!(this instanceof $dda02596e0302017$var$HMAC)) return new $dda02596e0302017$var$HMAC(key);
    this.pad = $hsTwZ.alloc(128);
    this.inner = $dda02596e0302017$var$Sha512();
    this.outer = $dda02596e0302017$var$Sha512();
    const keyhash = $hsTwZ.alloc(64);
    if (key.byteLength > 128) {
        $dda02596e0302017$var$Sha512().update(key).digest(keyhash);
        key = keyhash;
    }
    this.pad.fill(0x36);
    for(let i = 0; i < key.byteLength; i++)this.pad[i] ^= key[i];
    this.inner.update(this.pad);
    this.pad.fill(0x5c);
    for(let i = 0; i < key.byteLength; i++)this.pad[i] ^= key[i];
    this.outer.update(this.pad);
    this.pad.fill(0);
    keyhash.fill(0);
}
$dda02596e0302017$var$HMAC.prototype.update = function(input, enc) {
    this.inner.update(input, enc);
    return this;
};
$dda02596e0302017$var$HMAC.prototype.digest = function(enc, offset = 0) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc, offset);
};
$dda02596e0302017$var$Sha512.HMAC = $dda02596e0302017$var$HMAC;
function $dda02596e0302017$var$noop() {}
function $dda02596e0302017$var$formatInput(input, enc) {
    var result = $hsTwZ.from(input, enc);
    return [
        result,
        result.byteLength
    ];
}
// only works for base that is power of 2
function $dda02596e0302017$var$roundUp(n, base) {
    return n + base - 1 & -base;
}

});
parcelRegister("jlTFQ", function(module, exports) {
var $e16b2a28315d627b$var$__commonJS = (cb, mod)=>function __require() {
        return mod || (0, cb[Object.keys(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
var $e16b2a28315d627b$var$__toBinary = /* @__PURE__ */ (()=>{
    var table = new Uint8Array(128);
    for(var i = 0; i < 64; i++)table[i < 26 ? i + 65 : i < 52 ? i + 71 : i < 62 ? i - 4 : i * 4 - 205] = i;
    return (base64)=>{
        var n = base64.length, bytes2 = new Uint8Array((n - (base64[n - 1] == "=") - (base64[n - 2] == "=")) * 3 / 4 | 0);
        for(var i2 = 0, j = 0; i2 < n;){
            var c0 = table[base64.charCodeAt(i2++)], c1 = table[base64.charCodeAt(i2++)];
            var c2 = table[base64.charCodeAt(i2++)], c3 = table[base64.charCodeAt(i2++)];
            bytes2[j++] = c0 << 2 | c1 >> 4;
            bytes2[j++] = c1 << 4 | c2 >> 2;
            bytes2[j++] = c2 << 6 | c3;
        }
        return bytes2;
    };
})();
// wasm-binary:./sha512.wat
var $e16b2a28315d627b$var$require_sha512 = $e16b2a28315d627b$var$__commonJS({
    "wasm-binary:./sha512.wat" (exports2, module2) {
        module2.exports = $e16b2a28315d627b$var$__toBinary("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");
    }
});
// wasm-module:./sha512.wat
var $e16b2a28315d627b$var$bytes = $e16b2a28315d627b$var$require_sha512();
var $e16b2a28315d627b$var$compiled = new WebAssembly.Module($e16b2a28315d627b$var$bytes);
module.exports = (imports)=>{
    const instance = new WebAssembly.Instance($e16b2a28315d627b$var$compiled, imports);
    return instance.exports;
};

});




parcelRegister("ihZd3", function(module, exports) {
/* eslint-disable camelcase */ 
var $2lMhZ = parcelRequire("2lMhZ");
var $d5094b7e49d73eb2$require$crypto_hash_sha512 = $2lMhZ.crypto_hash_sha512;

var $en1S3 = parcelRequire("en1S3");
var $d5094b7e49d73eb2$require$crypto_scalarmult = $en1S3.crypto_scalarmult;
var $d5094b7e49d73eb2$require$crypto_scalarmult_base = $en1S3.crypto_scalarmult_base;

var $aiVbm = parcelRequire("aiVbm");
var $d5094b7e49d73eb2$require$randombytes = $aiVbm.randombytes;

var $l4mFx = parcelRequire("l4mFx");
var $d5094b7e49d73eb2$require$crypto_generichash_batch = $l4mFx.crypto_generichash_batch;

var $63ApX = parcelRequire("63ApX");
var $d5094b7e49d73eb2$require$crypto_stream_xsalsa20_MESSAGEBYTES_MAX = $63ApX.crypto_stream_xsalsa20_MESSAGEBYTES_MAX;

var $80TxX = parcelRequire("80TxX");
var $d5094b7e49d73eb2$require$crypto_secretbox_open_easy = $80TxX.crypto_secretbox_open_easy;
var $d5094b7e49d73eb2$require$crypto_secretbox_easy = $80TxX.crypto_secretbox_easy;
var $d5094b7e49d73eb2$require$crypto_secretbox_detached = $80TxX.crypto_secretbox_detached;
var $d5094b7e49d73eb2$require$crypto_secretbox_open_detached = $80TxX.crypto_secretbox_open_detached;

var $dheqR = parcelRequire("dheqR");

var $6JSie = parcelRequire("6JSie");
const $d5094b7e49d73eb2$var$crypto_box_PUBLICKEYBYTES = 32;
const $d5094b7e49d73eb2$var$crypto_box_SECRETKEYBYTES = 32;
const $d5094b7e49d73eb2$var$crypto_box_NONCEBYTES = 24;
const $d5094b7e49d73eb2$var$crypto_box_ZEROBYTES = 32;
const $d5094b7e49d73eb2$var$crypto_box_BOXZEROBYTES = 16;
const $d5094b7e49d73eb2$var$crypto_box_SEALBYTES = 48;
const $d5094b7e49d73eb2$var$crypto_box_SEEDBYTES = 32;
const $d5094b7e49d73eb2$var$crypto_box_BEFORENMBYTES = 32;
const $d5094b7e49d73eb2$var$crypto_box_MACBYTES = 16;
const $d5094b7e49d73eb2$var$crypto_box_curve25519xsalsa20poly1305_MACBYTES = 16;
const $d5094b7e49d73eb2$var$crypto_box_MESSAGEBYTES_MAX = $d5094b7e49d73eb2$require$crypto_stream_xsalsa20_MESSAGEBYTES_MAX - $d5094b7e49d73eb2$var$crypto_box_curve25519xsalsa20poly1305_MACBYTES;
module.exports = {
    crypto_box_easy: $d5094b7e49d73eb2$var$crypto_box_easy,
    crypto_box_open_easy: $d5094b7e49d73eb2$var$crypto_box_open_easy,
    crypto_box_keypair: $d5094b7e49d73eb2$var$crypto_box_keypair,
    crypto_box_seed_keypair: $d5094b7e49d73eb2$var$crypto_box_seed_keypair,
    crypto_box_seal: $d5094b7e49d73eb2$var$crypto_box_seal,
    crypto_box_seal_open: $d5094b7e49d73eb2$var$crypto_box_seal_open,
    crypto_box_PUBLICKEYBYTES: $d5094b7e49d73eb2$var$crypto_box_PUBLICKEYBYTES,
    crypto_box_SECRETKEYBYTES: $d5094b7e49d73eb2$var$crypto_box_SECRETKEYBYTES,
    crypto_box_NONCEBYTES: $d5094b7e49d73eb2$var$crypto_box_NONCEBYTES,
    crypto_box_ZEROBYTES: $d5094b7e49d73eb2$var$crypto_box_ZEROBYTES,
    crypto_box_BOXZEROBYTES: $d5094b7e49d73eb2$var$crypto_box_BOXZEROBYTES,
    crypto_box_SEALBYTES: $d5094b7e49d73eb2$var$crypto_box_SEALBYTES,
    crypto_box_SEEDBYTES: $d5094b7e49d73eb2$var$crypto_box_SEEDBYTES,
    crypto_box_BEFORENMBYTES: $d5094b7e49d73eb2$var$crypto_box_BEFORENMBYTES,
    crypto_box_MACBYTES: $d5094b7e49d73eb2$var$crypto_box_MACBYTES
};
function $d5094b7e49d73eb2$var$crypto_box_keypair(pk, sk) {
    $d5094b7e49d73eb2$var$check(pk, $d5094b7e49d73eb2$var$crypto_box_PUBLICKEYBYTES);
    $d5094b7e49d73eb2$var$check(sk, $d5094b7e49d73eb2$var$crypto_box_SECRETKEYBYTES);
    $d5094b7e49d73eb2$require$randombytes(sk, 32);
    return $d5094b7e49d73eb2$require$crypto_scalarmult_base(pk, sk);
}
function $d5094b7e49d73eb2$var$crypto_box_seed_keypair(pk, sk, seed) {
    $6JSie(pk.byteLength === $d5094b7e49d73eb2$var$crypto_box_PUBLICKEYBYTES, "pk should be 'crypto_box_PUBLICKEYBYTES' bytes");
    $6JSie(sk.byteLength === $d5094b7e49d73eb2$var$crypto_box_SECRETKEYBYTES, "sk should be 'crypto_box_SECRETKEYBYTES' bytes");
    $6JSie(sk.byteLength === $d5094b7e49d73eb2$var$crypto_box_SEEDBYTES, "sk should be 'crypto_box_SEEDBYTES' bytes");
    const hash = new Uint8Array(64);
    $d5094b7e49d73eb2$require$crypto_hash_sha512(hash, seed, 32);
    sk.set(hash.subarray(0, 32));
    hash.fill(0);
    return $d5094b7e49d73eb2$require$crypto_scalarmult_base(pk, sk);
}
function $d5094b7e49d73eb2$var$crypto_box_seal(c, m, pk) {
    $d5094b7e49d73eb2$var$check(c, $d5094b7e49d73eb2$var$crypto_box_SEALBYTES + m.length);
    $d5094b7e49d73eb2$var$check(pk, $d5094b7e49d73eb2$var$crypto_box_PUBLICKEYBYTES);
    var epk = c.subarray(0, $d5094b7e49d73eb2$var$crypto_box_PUBLICKEYBYTES);
    var esk = new Uint8Array($d5094b7e49d73eb2$var$crypto_box_SECRETKEYBYTES);
    $d5094b7e49d73eb2$var$crypto_box_keypair(epk, esk);
    var n = new Uint8Array($d5094b7e49d73eb2$var$crypto_box_NONCEBYTES);
    $d5094b7e49d73eb2$require$crypto_generichash_batch(n, [
        epk,
        pk
    ]);
    var s = new Uint8Array($d5094b7e49d73eb2$var$crypto_box_PUBLICKEYBYTES);
    $d5094b7e49d73eb2$require$crypto_scalarmult(s, esk, pk);
    var k = new Uint8Array($d5094b7e49d73eb2$var$crypto_box_BEFORENMBYTES);
    var zero = new Uint8Array(16);
    $dheqR.core_hsalsa20(k, zero, s, $dheqR.SIGMA);
    $d5094b7e49d73eb2$require$crypto_secretbox_easy(c.subarray(epk.length), m, n, k);
    $d5094b7e49d73eb2$var$cleanup(esk);
}
function $d5094b7e49d73eb2$var$crypto_box_seal_open(m, c, pk, sk) {
    $d5094b7e49d73eb2$var$check(c, $d5094b7e49d73eb2$var$crypto_box_SEALBYTES);
    $d5094b7e49d73eb2$var$check(m, c.length - $d5094b7e49d73eb2$var$crypto_box_SEALBYTES);
    $d5094b7e49d73eb2$var$check(pk, $d5094b7e49d73eb2$var$crypto_box_PUBLICKEYBYTES);
    $d5094b7e49d73eb2$var$check(sk, $d5094b7e49d73eb2$var$crypto_box_SECRETKEYBYTES);
    var epk = c.subarray(0, $d5094b7e49d73eb2$var$crypto_box_PUBLICKEYBYTES);
    var n = new Uint8Array($d5094b7e49d73eb2$var$crypto_box_NONCEBYTES);
    $d5094b7e49d73eb2$require$crypto_generichash_batch(n, [
        epk,
        pk
    ]);
    var s = new Uint8Array($d5094b7e49d73eb2$var$crypto_box_PUBLICKEYBYTES);
    $d5094b7e49d73eb2$require$crypto_scalarmult(s, sk, epk);
    var k = new Uint8Array($d5094b7e49d73eb2$var$crypto_box_BEFORENMBYTES);
    var zero = new Uint8Array(16);
    $dheqR.core_hsalsa20(k, zero, s, $dheqR.SIGMA);
    return $d5094b7e49d73eb2$require$crypto_secretbox_open_easy(m, c.subarray(epk.length), n, k);
}
function $d5094b7e49d73eb2$var$crypto_box_beforenm(k, pk, sk) {
    const zero = new Uint8Array(16);
    const s = new Uint8Array(32);
    $6JSie($d5094b7e49d73eb2$require$crypto_scalarmult(s, sk, pk) === 0);
    $dheqR.core_hsalsa20(k, zero, s, $dheqR.SIGMA);
    return true;
}
function $d5094b7e49d73eb2$var$crypto_box_detached_afternm(c, mac, m, n, k) {
    return $d5094b7e49d73eb2$require$crypto_secretbox_detached(c, mac, m, n, k);
}
function $d5094b7e49d73eb2$var$crypto_box_detached(c, mac, m, n, pk, sk) {
    $d5094b7e49d73eb2$var$check(mac, $d5094b7e49d73eb2$var$crypto_box_MACBYTES);
    $d5094b7e49d73eb2$var$check(n, $d5094b7e49d73eb2$var$crypto_box_NONCEBYTES);
    $d5094b7e49d73eb2$var$check(pk, $d5094b7e49d73eb2$var$crypto_box_PUBLICKEYBYTES);
    $d5094b7e49d73eb2$var$check(sk, $d5094b7e49d73eb2$var$crypto_box_SECRETKEYBYTES);
    const k = new Uint8Array($d5094b7e49d73eb2$var$crypto_box_BEFORENMBYTES);
    $6JSie($d5094b7e49d73eb2$var$crypto_box_beforenm(k, pk, sk));
    const ret = $d5094b7e49d73eb2$var$crypto_box_detached_afternm(c, mac, m, n, k);
    $d5094b7e49d73eb2$var$cleanup(k);
    return ret;
}
function $d5094b7e49d73eb2$var$crypto_box_easy(c, m, n, pk, sk) {
    $6JSie(c.length >= m.length + $d5094b7e49d73eb2$var$crypto_box_MACBYTES, "c should be at least 'm.length + crypto_box_MACBYTES' bytes");
    $6JSie(m.length <= $d5094b7e49d73eb2$var$crypto_box_MESSAGEBYTES_MAX, "m should be at most 'crypto_box_MESSAGEBYTES_MAX' bytes");
    return $d5094b7e49d73eb2$var$crypto_box_detached(c.subarray($d5094b7e49d73eb2$var$crypto_box_MACBYTES, m.length + $d5094b7e49d73eb2$var$crypto_box_MACBYTES), c.subarray(0, $d5094b7e49d73eb2$var$crypto_box_MACBYTES), m, n, pk, sk);
}
function $d5094b7e49d73eb2$var$crypto_box_open_detached_afternm(m, c, mac, n, k) {
    return $d5094b7e49d73eb2$require$crypto_secretbox_open_detached(m, c, mac, n, k);
}
function $d5094b7e49d73eb2$var$crypto_box_open_detached(m, c, mac, n, pk, sk) {
    const k = new Uint8Array($d5094b7e49d73eb2$var$crypto_box_BEFORENMBYTES);
    $6JSie($d5094b7e49d73eb2$var$crypto_box_beforenm(k, pk, sk));
    const ret = $d5094b7e49d73eb2$var$crypto_box_open_detached_afternm(m, c, mac, n, k);
    $d5094b7e49d73eb2$var$cleanup(k);
    return ret;
}
function $d5094b7e49d73eb2$var$crypto_box_open_easy(m, c, n, pk, sk) {
    $6JSie(c.length >= m.length + $d5094b7e49d73eb2$var$crypto_box_MACBYTES, "c should be at least 'm.length + crypto_box_MACBYTES' bytes");
    return $d5094b7e49d73eb2$var$crypto_box_open_detached(m, c.subarray($d5094b7e49d73eb2$var$crypto_box_MACBYTES, m.length + $d5094b7e49d73eb2$var$crypto_box_MACBYTES), c.subarray(0, $d5094b7e49d73eb2$var$crypto_box_MACBYTES), n, pk, sk);
}
function $d5094b7e49d73eb2$var$check(buf, len) {
    if (!buf || len && buf.length < len) throw new Error("Argument must be a buffer" + (len ? " of length " + len : ""));
}
function $d5094b7e49d73eb2$var$cleanup(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = 0;
}

});
parcelRegister("2lMhZ", function(module, exports) {
/* eslint-disable camelcase */ 
var $bfHfZ = parcelRequire("bfHfZ");

var $6JSie = parcelRequire("6JSie");
if (new Uint16Array([
    1
])[0] !== 1) throw new Error("Big endian architecture is not supported.");
const $1b63002986360428$var$crypto_hash_sha512_BYTES = 64;
const $1b63002986360428$var$crypto_hash_BYTES = $1b63002986360428$var$crypto_hash_sha512_BYTES;
function $1b63002986360428$var$crypto_hash_sha512(out, m, n) {
    $6JSie(out.byteLength === $1b63002986360428$var$crypto_hash_sha512_BYTES, "out must be 'crypto_hash_sha512_BYTES' bytes long");
    $bfHfZ().update(m.subarray(0, n)).digest(out);
    return 0;
}
function $1b63002986360428$var$crypto_hash(out, m, n) {
    return $1b63002986360428$var$crypto_hash_sha512(out, m, n);
}
module.exports = {
    crypto_hash: $1b63002986360428$var$crypto_hash,
    crypto_hash_sha512: $1b63002986360428$var$crypto_hash_sha512,
    crypto_hash_sha512_BYTES: $1b63002986360428$var$crypto_hash_sha512_BYTES,
    crypto_hash_BYTES: $1b63002986360428$var$crypto_hash_BYTES
};

});

parcelRegister("en1S3", function(module, exports) {
/* eslint-disable camelcase, one-var */ 
var $1ffNT = parcelRequire("1ffNT");
var $a764aa2c17a708ee$require$_9 = $1ffNT._9;
var $a764aa2c17a708ee$require$_121665 = $1ffNT._121665;
var $a764aa2c17a708ee$require$gf = $1ffNT.gf;
var $a764aa2c17a708ee$require$inv25519 = $1ffNT.inv25519;
var $a764aa2c17a708ee$require$pack25519 = $1ffNT.pack25519;
var $a764aa2c17a708ee$require$unpack25519 = $1ffNT.unpack25519;
var $a764aa2c17a708ee$require$sel25519 = $1ffNT.sel25519;
var $a764aa2c17a708ee$require$A = $1ffNT.A;
var $a764aa2c17a708ee$require$M = $1ffNT.M;
var $a764aa2c17a708ee$require$Z = $1ffNT.Z;
var $a764aa2c17a708ee$require$S = $1ffNT.S;
const $a764aa2c17a708ee$var$crypto_scalarmult_BYTES = 32;
const $a764aa2c17a708ee$var$crypto_scalarmult_SCALARBYTES = 32;
module.exports = {
    crypto_scalarmult: $a764aa2c17a708ee$var$crypto_scalarmult,
    crypto_scalarmult_base: $a764aa2c17a708ee$var$crypto_scalarmult_base,
    crypto_scalarmult_BYTES: $a764aa2c17a708ee$var$crypto_scalarmult_BYTES,
    crypto_scalarmult_SCALARBYTES: $a764aa2c17a708ee$var$crypto_scalarmult_SCALARBYTES
};
function $a764aa2c17a708ee$var$crypto_scalarmult(q, n, p) {
    $a764aa2c17a708ee$var$check(q, $a764aa2c17a708ee$var$crypto_scalarmult_BYTES);
    $a764aa2c17a708ee$var$check(n, $a764aa2c17a708ee$var$crypto_scalarmult_SCALARBYTES);
    $a764aa2c17a708ee$var$check(p, $a764aa2c17a708ee$var$crypto_scalarmult_BYTES);
    var z = new Uint8Array(32);
    var x = new Float64Array(80), r, i;
    var a = $a764aa2c17a708ee$require$gf(), b = $a764aa2c17a708ee$require$gf(), c = $a764aa2c17a708ee$require$gf(), d = $a764aa2c17a708ee$require$gf(), e = $a764aa2c17a708ee$require$gf(), f = $a764aa2c17a708ee$require$gf();
    for(i = 0; i < 31; i++)z[i] = n[i];
    z[31] = n[31] & 127 | 64;
    z[0] &= 248;
    $a764aa2c17a708ee$require$unpack25519(x, p);
    for(i = 0; i < 16; i++){
        b[i] = x[i];
        d[i] = a[i] = c[i] = 0;
    }
    a[0] = d[0] = 1;
    for(i = 254; i >= 0; --i){
        r = z[i >>> 3] >>> (i & 7) & 1;
        $a764aa2c17a708ee$require$sel25519(a, b, r);
        $a764aa2c17a708ee$require$sel25519(c, d, r);
        $a764aa2c17a708ee$require$A(e, a, c);
        $a764aa2c17a708ee$require$Z(a, a, c);
        $a764aa2c17a708ee$require$A(c, b, d);
        $a764aa2c17a708ee$require$Z(b, b, d);
        $a764aa2c17a708ee$require$S(d, e);
        $a764aa2c17a708ee$require$S(f, a);
        $a764aa2c17a708ee$require$M(a, c, a);
        $a764aa2c17a708ee$require$M(c, b, e);
        $a764aa2c17a708ee$require$A(e, a, c);
        $a764aa2c17a708ee$require$Z(a, a, c);
        $a764aa2c17a708ee$require$S(b, a);
        $a764aa2c17a708ee$require$Z(c, d, f);
        $a764aa2c17a708ee$require$M(a, c, $a764aa2c17a708ee$require$_121665);
        $a764aa2c17a708ee$require$A(a, a, d);
        $a764aa2c17a708ee$require$M(c, c, a);
        $a764aa2c17a708ee$require$M(a, d, f);
        $a764aa2c17a708ee$require$M(d, b, x);
        $a764aa2c17a708ee$require$S(b, e);
        $a764aa2c17a708ee$require$sel25519(a, b, r);
        $a764aa2c17a708ee$require$sel25519(c, d, r);
    }
    for(i = 0; i < 16; i++){
        x[i + 16] = a[i];
        x[i + 32] = c[i];
        x[i + 48] = b[i];
        x[i + 64] = d[i];
    }
    var x32 = x.subarray(32);
    var x16 = x.subarray(16);
    $a764aa2c17a708ee$require$inv25519(x32, x32);
    $a764aa2c17a708ee$require$M(x16, x16, x32);
    $a764aa2c17a708ee$require$pack25519(q, x16);
    return 0;
}
function $a764aa2c17a708ee$var$crypto_scalarmult_base(q, n) {
    return $a764aa2c17a708ee$var$crypto_scalarmult(q, n, $a764aa2c17a708ee$require$_9);
}
function $a764aa2c17a708ee$var$check(buf, len) {
    if (!buf || len && buf.length < len) throw new Error("Argument must be a buffer" + (len ? " of length " + len : ""));
}

});
parcelRegister("1ffNT", function(module, exports) {
if (new Uint16Array([
    1
])[0] !== 1) throw new Error("Big endian architecture is not supported.");
var $0e8373790e48a307$var$gf = function(init) {
    var i, r = new Float64Array(16);
    if (init) for(i = 0; i < init.length; i++)r[i] = init[i];
    return r;
};
var $0e8373790e48a307$var$_0 = new Uint8Array(16);
var $0e8373790e48a307$var$_9 = new Uint8Array(32);
$0e8373790e48a307$var$_9[0] = 9;
var $0e8373790e48a307$var$gf0 = $0e8373790e48a307$var$gf(), $0e8373790e48a307$var$gf1 = $0e8373790e48a307$var$gf([
    1
]), $0e8373790e48a307$var$_121665 = $0e8373790e48a307$var$gf([
    0xdb41,
    1
]), $0e8373790e48a307$var$D = $0e8373790e48a307$var$gf([
    0x78a3,
    0x1359,
    0x4dca,
    0x75eb,
    0xd8ab,
    0x4141,
    0x0a4d,
    0x0070,
    0xe898,
    0x7779,
    0x4079,
    0x8cc7,
    0xfe73,
    0x2b6f,
    0x6cee,
    0x5203
]), $0e8373790e48a307$var$D2 = $0e8373790e48a307$var$gf([
    0xf159,
    0x26b2,
    0x9b94,
    0xebd6,
    0xb156,
    0x8283,
    0x149a,
    0x00e0,
    0xd130,
    0xeef3,
    0x80f2,
    0x198e,
    0xfce7,
    0x56df,
    0xd9dc,
    0x2406
]), $0e8373790e48a307$var$X = $0e8373790e48a307$var$gf([
    0xd51a,
    0x8f25,
    0x2d60,
    0xc956,
    0xa7b2,
    0x9525,
    0xc760,
    0x692c,
    0xdc5c,
    0xfdd6,
    0xe231,
    0xc0a4,
    0x53fe,
    0xcd6e,
    0x36d3,
    0x2169
]), $0e8373790e48a307$var$Y = $0e8373790e48a307$var$gf([
    0x6658,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666
]), $0e8373790e48a307$var$I = $0e8373790e48a307$var$gf([
    0xa0b0,
    0x4a0e,
    0x1b27,
    0xc4ee,
    0xe478,
    0xad2f,
    0x1806,
    0x2f43,
    0xd7a7,
    0x3dfb,
    0x0099,
    0x2b4d,
    0xdf0b,
    0x4fc1,
    0x2480,
    0x2b83
]);
function $0e8373790e48a307$var$A(o, a, b) {
    for(var i = 0; i < 16; i++)o[i] = a[i] + b[i];
}
function $0e8373790e48a307$var$Z(o, a, b) {
    for(var i = 0; i < 16; i++)o[i] = a[i] - b[i];
}
function $0e8373790e48a307$var$M(o, a, b) {
    var v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    v = a[0];
    t0 += v * b0;
    t1 += v * b1;
    t2 += v * b2;
    t3 += v * b3;
    t4 += v * b4;
    t5 += v * b5;
    t6 += v * b6;
    t7 += v * b7;
    t8 += v * b8;
    t9 += v * b9;
    t10 += v * b10;
    t11 += v * b11;
    t12 += v * b12;
    t13 += v * b13;
    t14 += v * b14;
    t15 += v * b15;
    v = a[1];
    t1 += v * b0;
    t2 += v * b1;
    t3 += v * b2;
    t4 += v * b3;
    t5 += v * b4;
    t6 += v * b5;
    t7 += v * b6;
    t8 += v * b7;
    t9 += v * b8;
    t10 += v * b9;
    t11 += v * b10;
    t12 += v * b11;
    t13 += v * b12;
    t14 += v * b13;
    t15 += v * b14;
    t16 += v * b15;
    v = a[2];
    t2 += v * b0;
    t3 += v * b1;
    t4 += v * b2;
    t5 += v * b3;
    t6 += v * b4;
    t7 += v * b5;
    t8 += v * b6;
    t9 += v * b7;
    t10 += v * b8;
    t11 += v * b9;
    t12 += v * b10;
    t13 += v * b11;
    t14 += v * b12;
    t15 += v * b13;
    t16 += v * b14;
    t17 += v * b15;
    v = a[3];
    t3 += v * b0;
    t4 += v * b1;
    t5 += v * b2;
    t6 += v * b3;
    t7 += v * b4;
    t8 += v * b5;
    t9 += v * b6;
    t10 += v * b7;
    t11 += v * b8;
    t12 += v * b9;
    t13 += v * b10;
    t14 += v * b11;
    t15 += v * b12;
    t16 += v * b13;
    t17 += v * b14;
    t18 += v * b15;
    v = a[4];
    t4 += v * b0;
    t5 += v * b1;
    t6 += v * b2;
    t7 += v * b3;
    t8 += v * b4;
    t9 += v * b5;
    t10 += v * b6;
    t11 += v * b7;
    t12 += v * b8;
    t13 += v * b9;
    t14 += v * b10;
    t15 += v * b11;
    t16 += v * b12;
    t17 += v * b13;
    t18 += v * b14;
    t19 += v * b15;
    v = a[5];
    t5 += v * b0;
    t6 += v * b1;
    t7 += v * b2;
    t8 += v * b3;
    t9 += v * b4;
    t10 += v * b5;
    t11 += v * b6;
    t12 += v * b7;
    t13 += v * b8;
    t14 += v * b9;
    t15 += v * b10;
    t16 += v * b11;
    t17 += v * b12;
    t18 += v * b13;
    t19 += v * b14;
    t20 += v * b15;
    v = a[6];
    t6 += v * b0;
    t7 += v * b1;
    t8 += v * b2;
    t9 += v * b3;
    t10 += v * b4;
    t11 += v * b5;
    t12 += v * b6;
    t13 += v * b7;
    t14 += v * b8;
    t15 += v * b9;
    t16 += v * b10;
    t17 += v * b11;
    t18 += v * b12;
    t19 += v * b13;
    t20 += v * b14;
    t21 += v * b15;
    v = a[7];
    t7 += v * b0;
    t8 += v * b1;
    t9 += v * b2;
    t10 += v * b3;
    t11 += v * b4;
    t12 += v * b5;
    t13 += v * b6;
    t14 += v * b7;
    t15 += v * b8;
    t16 += v * b9;
    t17 += v * b10;
    t18 += v * b11;
    t19 += v * b12;
    t20 += v * b13;
    t21 += v * b14;
    t22 += v * b15;
    v = a[8];
    t8 += v * b0;
    t9 += v * b1;
    t10 += v * b2;
    t11 += v * b3;
    t12 += v * b4;
    t13 += v * b5;
    t14 += v * b6;
    t15 += v * b7;
    t16 += v * b8;
    t17 += v * b9;
    t18 += v * b10;
    t19 += v * b11;
    t20 += v * b12;
    t21 += v * b13;
    t22 += v * b14;
    t23 += v * b15;
    v = a[9];
    t9 += v * b0;
    t10 += v * b1;
    t11 += v * b2;
    t12 += v * b3;
    t13 += v * b4;
    t14 += v * b5;
    t15 += v * b6;
    t16 += v * b7;
    t17 += v * b8;
    t18 += v * b9;
    t19 += v * b10;
    t20 += v * b11;
    t21 += v * b12;
    t22 += v * b13;
    t23 += v * b14;
    t24 += v * b15;
    v = a[10];
    t10 += v * b0;
    t11 += v * b1;
    t12 += v * b2;
    t13 += v * b3;
    t14 += v * b4;
    t15 += v * b5;
    t16 += v * b6;
    t17 += v * b7;
    t18 += v * b8;
    t19 += v * b9;
    t20 += v * b10;
    t21 += v * b11;
    t22 += v * b12;
    t23 += v * b13;
    t24 += v * b14;
    t25 += v * b15;
    v = a[11];
    t11 += v * b0;
    t12 += v * b1;
    t13 += v * b2;
    t14 += v * b3;
    t15 += v * b4;
    t16 += v * b5;
    t17 += v * b6;
    t18 += v * b7;
    t19 += v * b8;
    t20 += v * b9;
    t21 += v * b10;
    t22 += v * b11;
    t23 += v * b12;
    t24 += v * b13;
    t25 += v * b14;
    t26 += v * b15;
    v = a[12];
    t12 += v * b0;
    t13 += v * b1;
    t14 += v * b2;
    t15 += v * b3;
    t16 += v * b4;
    t17 += v * b5;
    t18 += v * b6;
    t19 += v * b7;
    t20 += v * b8;
    t21 += v * b9;
    t22 += v * b10;
    t23 += v * b11;
    t24 += v * b12;
    t25 += v * b13;
    t26 += v * b14;
    t27 += v * b15;
    v = a[13];
    t13 += v * b0;
    t14 += v * b1;
    t15 += v * b2;
    t16 += v * b3;
    t17 += v * b4;
    t18 += v * b5;
    t19 += v * b6;
    t20 += v * b7;
    t21 += v * b8;
    t22 += v * b9;
    t23 += v * b10;
    t24 += v * b11;
    t25 += v * b12;
    t26 += v * b13;
    t27 += v * b14;
    t28 += v * b15;
    v = a[14];
    t14 += v * b0;
    t15 += v * b1;
    t16 += v * b2;
    t17 += v * b3;
    t18 += v * b4;
    t19 += v * b5;
    t20 += v * b6;
    t21 += v * b7;
    t22 += v * b8;
    t23 += v * b9;
    t24 += v * b10;
    t25 += v * b11;
    t26 += v * b12;
    t27 += v * b13;
    t28 += v * b14;
    t29 += v * b15;
    v = a[15];
    t15 += v * b0;
    t16 += v * b1;
    t17 += v * b2;
    t18 += v * b3;
    t19 += v * b4;
    t20 += v * b5;
    t21 += v * b6;
    t22 += v * b7;
    t23 += v * b8;
    t24 += v * b9;
    t25 += v * b10;
    t26 += v * b11;
    t27 += v * b12;
    t28 += v * b13;
    t29 += v * b14;
    t30 += v * b15;
    t0 += 38 * t16;
    t1 += 38 * t17;
    t2 += 38 * t18;
    t3 += 38 * t19;
    t4 += 38 * t20;
    t5 += 38 * t21;
    t6 += 38 * t22;
    t7 += 38 * t23;
    t8 += 38 * t24;
    t9 += 38 * t25;
    t10 += 38 * t26;
    t11 += 38 * t27;
    t12 += 38 * t28;
    t13 += 38 * t29;
    t14 += 38 * t30;
    // t15 left as is
    // first car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    // second car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    o[0] = t0;
    o[1] = t1;
    o[2] = t2;
    o[3] = t3;
    o[4] = t4;
    o[5] = t5;
    o[6] = t6;
    o[7] = t7;
    o[8] = t8;
    o[9] = t9;
    o[10] = t10;
    o[11] = t11;
    o[12] = t12;
    o[13] = t13;
    o[14] = t14;
    o[15] = t15;
}
function $0e8373790e48a307$var$S(o, a) {
    $0e8373790e48a307$var$M(o, a, a);
}
function $0e8373790e48a307$var$sel25519(p, q, b) {
    var t, c = ~(b - 1);
    for(var i = 0; i < 16; i++){
        t = c & (p[i] ^ q[i]);
        p[i] ^= t;
        q[i] ^= t;
    }
}
function $0e8373790e48a307$var$pack25519(o, n) {
    var i, j, b;
    var m = $0e8373790e48a307$var$gf(), t = $0e8373790e48a307$var$gf();
    for(i = 0; i < 16; i++)t[i] = n[i];
    $0e8373790e48a307$var$car25519(t);
    $0e8373790e48a307$var$car25519(t);
    $0e8373790e48a307$var$car25519(t);
    for(j = 0; j < 2; j++){
        m[0] = t[0] - 0xffed;
        for(i = 1; i < 15; i++){
            m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
            m[i - 1] &= 0xffff;
        }
        m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
        b = m[15] >> 16 & 1;
        m[14] &= 0xffff;
        $0e8373790e48a307$var$sel25519(t, m, 1 - b);
    }
    for(i = 0; i < 16; i++){
        o[2 * i] = t[i] & 0xff;
        o[2 * i + 1] = t[i] >> 8;
    }
}
function $0e8373790e48a307$var$unpack25519(o, n) {
    var i;
    for(i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
    o[15] &= 0x7fff;
}
function $0e8373790e48a307$var$inv25519(o, i) {
    var c = $0e8373790e48a307$var$gf();
    var a;
    for(a = 0; a < 16; a++)c[a] = i[a];
    for(a = 253; a >= 0; a--){
        $0e8373790e48a307$var$S(c, c);
        if (a !== 2 && a !== 4) $0e8373790e48a307$var$M(c, c, i);
    }
    for(a = 0; a < 16; a++)o[a] = c[a];
}
function $0e8373790e48a307$var$car25519(o) {
    var i, v, c = 1;
    for(i = 0; i < 16; i++){
        v = o[i] + c + 65535;
        c = Math.floor(v / 65536);
        o[i] = v - c * 65536;
    }
    o[0] += c - 1 + 37 * (c - 1);
}
module.exports = {
    gf: $0e8373790e48a307$var$gf,
    A: $0e8373790e48a307$var$A,
    Z: $0e8373790e48a307$var$Z,
    M: $0e8373790e48a307$var$M,
    S: $0e8373790e48a307$var$S,
    sel25519: $0e8373790e48a307$var$sel25519,
    pack25519: $0e8373790e48a307$var$pack25519,
    unpack25519: $0e8373790e48a307$var$unpack25519,
    inv25519: $0e8373790e48a307$var$inv25519,
    gf0: $0e8373790e48a307$var$gf0,
    gf1: $0e8373790e48a307$var$gf1,
    _9: $0e8373790e48a307$var$_9,
    _121665: $0e8373790e48a307$var$_121665,
    D: $0e8373790e48a307$var$D,
    D2: $0e8373790e48a307$var$D2,
    X: $0e8373790e48a307$var$X,
    Y: $0e8373790e48a307$var$Y,
    I: $0e8373790e48a307$var$I
};

});


parcelRegister("l4mFx", function(module, exports) {

$parcel$export(module.exports, "crypto_generichash_PRIMITIVE", function () { return $f56b8e4a465f2f9e$export$ddd0fcbcffe51cfd; }, function (v) { return $f56b8e4a465f2f9e$export$ddd0fcbcffe51cfd = v; });
$parcel$export(module.exports, "crypto_generichash_BYTES_MIN", function () { return $f56b8e4a465f2f9e$export$af379eea3a9857dd; }, function (v) { return $f56b8e4a465f2f9e$export$af379eea3a9857dd = v; });
$parcel$export(module.exports, "crypto_generichash_BYTES_MAX", function () { return $f56b8e4a465f2f9e$export$a3a8b565a8a0be4; }, function (v) { return $f56b8e4a465f2f9e$export$a3a8b565a8a0be4 = v; });
$parcel$export(module.exports, "crypto_generichash_BYTES", function () { return $f56b8e4a465f2f9e$export$419bf5597e2fa76c; }, function (v) { return $f56b8e4a465f2f9e$export$419bf5597e2fa76c = v; });
$parcel$export(module.exports, "crypto_generichash_KEYBYTES_MIN", function () { return $f56b8e4a465f2f9e$export$bfb37abfac735ec5; }, function (v) { return $f56b8e4a465f2f9e$export$bfb37abfac735ec5 = v; });
$parcel$export(module.exports, "crypto_generichash_KEYBYTES_MAX", function () { return $f56b8e4a465f2f9e$export$1debcccfed9ee69b; }, function (v) { return $f56b8e4a465f2f9e$export$1debcccfed9ee69b = v; });
$parcel$export(module.exports, "crypto_generichash_KEYBYTES", function () { return $f56b8e4a465f2f9e$export$705f19147abc006c; }, function (v) { return $f56b8e4a465f2f9e$export$705f19147abc006c = v; });
$parcel$export(module.exports, "crypto_generichash_WASM_SUPPORTED", function () { return $f56b8e4a465f2f9e$export$4b4289c583afaa0e; }, function (v) { return $f56b8e4a465f2f9e$export$4b4289c583afaa0e = v; });
$parcel$export(module.exports, "crypto_generichash_WASM_LOADED", function () { return $f56b8e4a465f2f9e$export$eae1900c59d799f5; }, function (v) { return $f56b8e4a465f2f9e$export$eae1900c59d799f5 = v; });
$parcel$export(module.exports, "crypto_generichash", function () { return $f56b8e4a465f2f9e$export$1d2a9dc468831ff8; }, function (v) { return $f56b8e4a465f2f9e$export$1d2a9dc468831ff8 = v; });
$parcel$export(module.exports, "crypto_generichash_ready", function () { return $f56b8e4a465f2f9e$export$5f7002b768efcab7; }, function (v) { return $f56b8e4a465f2f9e$export$5f7002b768efcab7 = v; });
$parcel$export(module.exports, "crypto_generichash_batch", function () { return $f56b8e4a465f2f9e$export$2932b0d3a963592b; }, function (v) { return $f56b8e4a465f2f9e$export$2932b0d3a963592b = v; });
$parcel$export(module.exports, "crypto_generichash_instance", function () { return $f56b8e4a465f2f9e$export$f3bfafb6331e3cc9; }, function (v) { return $f56b8e4a465f2f9e$export$f3bfafb6331e3cc9 = v; });
var $f56b8e4a465f2f9e$export$ddd0fcbcffe51cfd;
var $f56b8e4a465f2f9e$export$af379eea3a9857dd;
var $f56b8e4a465f2f9e$export$a3a8b565a8a0be4;
var $f56b8e4a465f2f9e$export$419bf5597e2fa76c;
var $f56b8e4a465f2f9e$export$bfb37abfac735ec5;
var $f56b8e4a465f2f9e$export$1debcccfed9ee69b;
var $f56b8e4a465f2f9e$export$705f19147abc006c;
var $f56b8e4a465f2f9e$export$4b4289c583afaa0e;
var $f56b8e4a465f2f9e$export$eae1900c59d799f5;
var $f56b8e4a465f2f9e$export$1d2a9dc468831ff8;
var $f56b8e4a465f2f9e$export$5f7002b768efcab7;
var $f56b8e4a465f2f9e$export$2932b0d3a963592b;
var $f56b8e4a465f2f9e$export$f3bfafb6331e3cc9;

var $deivC = parcelRequire("deivC");
if (new Uint16Array([
    1
])[0] !== 1) throw new Error("Big endian architecture is not supported.");
$f56b8e4a465f2f9e$export$ddd0fcbcffe51cfd = "blake2b";
$f56b8e4a465f2f9e$export$af379eea3a9857dd = $deivC.BYTES_MIN;
$f56b8e4a465f2f9e$export$a3a8b565a8a0be4 = $deivC.BYTES_MAX;
$f56b8e4a465f2f9e$export$419bf5597e2fa76c = $deivC.BYTES;
$f56b8e4a465f2f9e$export$bfb37abfac735ec5 = $deivC.KEYBYTES_MIN;
$f56b8e4a465f2f9e$export$1debcccfed9ee69b = $deivC.KEYBYTES_MAX;
$f56b8e4a465f2f9e$export$705f19147abc006c = $deivC.KEYBYTES;
$f56b8e4a465f2f9e$export$4b4289c583afaa0e = $deivC.WASM_SUPPORTED;
$f56b8e4a465f2f9e$export$eae1900c59d799f5 = false;
$f56b8e4a465f2f9e$export$1d2a9dc468831ff8 = function(output, input, key) {
    $deivC(output.length, key).update(input).final(output);
};
$f56b8e4a465f2f9e$export$5f7002b768efcab7 = $deivC.ready;
$f56b8e4a465f2f9e$export$2932b0d3a963592b = function(output, inputArray, key) {
    var ctx = $deivC(output.length, key);
    for(var i = 0; i < inputArray.length; i++)ctx.update(inputArray[i]);
    ctx.final(output);
};
$f56b8e4a465f2f9e$export$f3bfafb6331e3cc9 = function(key, outlen) {
    if (outlen == null) outlen = $f56b8e4a465f2f9e$export$419bf5597e2fa76c;
    return $deivC(outlen, key);
};
$deivC.ready(function(_) {
    $f56b8e4a465f2f9e$export$eae1900c59d799f5 = $deivC.WASM_LOADED;
});

});
parcelRegister("deivC", function(module, exports) {

var $6JSie = parcelRequire("6JSie");

var $aJRYj = parcelRequire("aJRYj");
// 64-bit unsigned addition
// Sets v[a,a+1] += v[b,b+1]
// v should be a Uint32Array
function $9a1af0afc9270f9a$var$ADD64AA(v, a, b) {
    var o0 = v[a] + v[b];
    var o1 = v[a + 1] + v[b + 1];
    if (o0 >= 0x100000000) o1++;
    v[a] = o0;
    v[a + 1] = o1;
}
// 64-bit unsigned addition
// Sets v[a,a+1] += b
// b0 is the low 32 bits of b, b1 represents the high 32 bits
function $9a1af0afc9270f9a$var$ADD64AC(v, a, b0, b1) {
    var o0 = v[a] + b0;
    if (b0 < 0) o0 += 0x100000000;
    var o1 = v[a + 1] + b1;
    if (o0 >= 0x100000000) o1++;
    v[a] = o0;
    v[a + 1] = o1;
}
// Little-endian byte access
function $9a1af0afc9270f9a$var$B2B_GET32(arr, i) {
    return arr[i] ^ arr[i + 1] << 8 ^ arr[i + 2] << 16 ^ arr[i + 3] << 24;
}
// G Mixing function
// The ROTRs are inlined for speed
function $9a1af0afc9270f9a$var$B2B_G(a, b, c, d, ix, iy) {
    var x0 = $9a1af0afc9270f9a$var$m[ix];
    var x1 = $9a1af0afc9270f9a$var$m[ix + 1];
    var y0 = $9a1af0afc9270f9a$var$m[iy];
    var y1 = $9a1af0afc9270f9a$var$m[iy + 1];
    $9a1af0afc9270f9a$var$ADD64AA($9a1af0afc9270f9a$var$v, a, b) // v[a,a+1] += v[b,b+1] ... in JS we must store a uint64 as two uint32s
    ;
    $9a1af0afc9270f9a$var$ADD64AC($9a1af0afc9270f9a$var$v, a, x0, x1) // v[a, a+1] += x ... x0 is the low 32 bits of x, x1 is the high 32 bits
    ;
    // v[d,d+1] = (v[d,d+1] xor v[a,a+1]) rotated to the right by 32 bits
    var xor0 = $9a1af0afc9270f9a$var$v[d] ^ $9a1af0afc9270f9a$var$v[a];
    var xor1 = $9a1af0afc9270f9a$var$v[d + 1] ^ $9a1af0afc9270f9a$var$v[a + 1];
    $9a1af0afc9270f9a$var$v[d] = xor1;
    $9a1af0afc9270f9a$var$v[d + 1] = xor0;
    $9a1af0afc9270f9a$var$ADD64AA($9a1af0afc9270f9a$var$v, c, d);
    // v[b,b+1] = (v[b,b+1] xor v[c,c+1]) rotated right by 24 bits
    xor0 = $9a1af0afc9270f9a$var$v[b] ^ $9a1af0afc9270f9a$var$v[c];
    xor1 = $9a1af0afc9270f9a$var$v[b + 1] ^ $9a1af0afc9270f9a$var$v[c + 1];
    $9a1af0afc9270f9a$var$v[b] = xor0 >>> 24 ^ xor1 << 8;
    $9a1af0afc9270f9a$var$v[b + 1] = xor1 >>> 24 ^ xor0 << 8;
    $9a1af0afc9270f9a$var$ADD64AA($9a1af0afc9270f9a$var$v, a, b);
    $9a1af0afc9270f9a$var$ADD64AC($9a1af0afc9270f9a$var$v, a, y0, y1);
    // v[d,d+1] = (v[d,d+1] xor v[a,a+1]) rotated right by 16 bits
    xor0 = $9a1af0afc9270f9a$var$v[d] ^ $9a1af0afc9270f9a$var$v[a];
    xor1 = $9a1af0afc9270f9a$var$v[d + 1] ^ $9a1af0afc9270f9a$var$v[a + 1];
    $9a1af0afc9270f9a$var$v[d] = xor0 >>> 16 ^ xor1 << 16;
    $9a1af0afc9270f9a$var$v[d + 1] = xor1 >>> 16 ^ xor0 << 16;
    $9a1af0afc9270f9a$var$ADD64AA($9a1af0afc9270f9a$var$v, c, d);
    // v[b,b+1] = (v[b,b+1] xor v[c,c+1]) rotated right by 63 bits
    xor0 = $9a1af0afc9270f9a$var$v[b] ^ $9a1af0afc9270f9a$var$v[c];
    xor1 = $9a1af0afc9270f9a$var$v[b + 1] ^ $9a1af0afc9270f9a$var$v[c + 1];
    $9a1af0afc9270f9a$var$v[b] = xor1 >>> 31 ^ xor0 << 1;
    $9a1af0afc9270f9a$var$v[b + 1] = xor0 >>> 31 ^ xor1 << 1;
}
// Initialization Vector
var $9a1af0afc9270f9a$var$BLAKE2B_IV32 = new Uint32Array([
    0xF3BCC908,
    0x6A09E667,
    0x84CAA73B,
    0xBB67AE85,
    0xFE94F82B,
    0x3C6EF372,
    0x5F1D36F1,
    0xA54FF53A,
    0xADE682D1,
    0x510E527F,
    0x2B3E6C1F,
    0x9B05688C,
    0xFB41BD6B,
    0x1F83D9AB,
    0x137E2179,
    0x5BE0CD19
]);
var $9a1af0afc9270f9a$var$SIGMA8 = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    14,
    10,
    4,
    8,
    9,
    15,
    13,
    6,
    1,
    12,
    0,
    2,
    11,
    7,
    5,
    3,
    11,
    8,
    12,
    0,
    5,
    2,
    15,
    13,
    10,
    14,
    3,
    6,
    7,
    1,
    9,
    4,
    7,
    9,
    3,
    1,
    13,
    12,
    11,
    14,
    2,
    6,
    5,
    10,
    4,
    0,
    15,
    8,
    9,
    0,
    5,
    7,
    2,
    4,
    10,
    15,
    14,
    1,
    11,
    12,
    6,
    8,
    3,
    13,
    2,
    12,
    6,
    10,
    0,
    11,
    8,
    3,
    4,
    13,
    7,
    5,
    15,
    14,
    1,
    9,
    12,
    5,
    1,
    15,
    14,
    13,
    4,
    10,
    0,
    7,
    6,
    3,
    9,
    2,
    8,
    11,
    13,
    11,
    7,
    14,
    12,
    1,
    3,
    9,
    5,
    0,
    15,
    4,
    8,
    6,
    2,
    10,
    6,
    15,
    14,
    9,
    11,
    3,
    0,
    8,
    12,
    2,
    13,
    7,
    1,
    4,
    10,
    5,
    10,
    2,
    8,
    4,
    7,
    6,
    1,
    5,
    15,
    11,
    9,
    14,
    3,
    12,
    13,
    0,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    14,
    10,
    4,
    8,
    9,
    15,
    13,
    6,
    1,
    12,
    0,
    2,
    11,
    7,
    5,
    3
];
// These are offsets into a uint64 buffer.
// Multiply them all by 2 to make them offsets into a uint32 buffer,
// because this is Javascript and we don't have uint64s
var $9a1af0afc9270f9a$var$SIGMA82 = new Uint8Array($9a1af0afc9270f9a$var$SIGMA8.map(function(x) {
    return x * 2;
}));
// Compression function. 'last' flag indicates last block.
// Note we're representing 16 uint64s as 32 uint32s
var $9a1af0afc9270f9a$var$v = new Uint32Array(32);
var $9a1af0afc9270f9a$var$m = new Uint32Array(32);
function $9a1af0afc9270f9a$var$blake2bCompress(ctx, last) {
    var i = 0;
    // init work variables
    for(i = 0; i < 16; i++){
        $9a1af0afc9270f9a$var$v[i] = ctx.h[i];
        $9a1af0afc9270f9a$var$v[i + 16] = $9a1af0afc9270f9a$var$BLAKE2B_IV32[i];
    }
    // low 64 bits of offset
    $9a1af0afc9270f9a$var$v[24] = $9a1af0afc9270f9a$var$v[24] ^ ctx.t;
    $9a1af0afc9270f9a$var$v[25] = $9a1af0afc9270f9a$var$v[25] ^ ctx.t / 0x100000000;
    // high 64 bits not supported, offset may not be higher than 2**53-1
    // last block flag set ?
    if (last) {
        $9a1af0afc9270f9a$var$v[28] = ~$9a1af0afc9270f9a$var$v[28];
        $9a1af0afc9270f9a$var$v[29] = ~$9a1af0afc9270f9a$var$v[29];
    }
    // get little-endian words
    for(i = 0; i < 32; i++)$9a1af0afc9270f9a$var$m[i] = $9a1af0afc9270f9a$var$B2B_GET32(ctx.b, 4 * i);
    // twelve rounds of mixing
    for(i = 0; i < 12; i++){
        $9a1af0afc9270f9a$var$B2B_G(0, 8, 16, 24, $9a1af0afc9270f9a$var$SIGMA82[i * 16 + 0], $9a1af0afc9270f9a$var$SIGMA82[i * 16 + 1]);
        $9a1af0afc9270f9a$var$B2B_G(2, 10, 18, 26, $9a1af0afc9270f9a$var$SIGMA82[i * 16 + 2], $9a1af0afc9270f9a$var$SIGMA82[i * 16 + 3]);
        $9a1af0afc9270f9a$var$B2B_G(4, 12, 20, 28, $9a1af0afc9270f9a$var$SIGMA82[i * 16 + 4], $9a1af0afc9270f9a$var$SIGMA82[i * 16 + 5]);
        $9a1af0afc9270f9a$var$B2B_G(6, 14, 22, 30, $9a1af0afc9270f9a$var$SIGMA82[i * 16 + 6], $9a1af0afc9270f9a$var$SIGMA82[i * 16 + 7]);
        $9a1af0afc9270f9a$var$B2B_G(0, 10, 20, 30, $9a1af0afc9270f9a$var$SIGMA82[i * 16 + 8], $9a1af0afc9270f9a$var$SIGMA82[i * 16 + 9]);
        $9a1af0afc9270f9a$var$B2B_G(2, 12, 22, 24, $9a1af0afc9270f9a$var$SIGMA82[i * 16 + 10], $9a1af0afc9270f9a$var$SIGMA82[i * 16 + 11]);
        $9a1af0afc9270f9a$var$B2B_G(4, 14, 16, 26, $9a1af0afc9270f9a$var$SIGMA82[i * 16 + 12], $9a1af0afc9270f9a$var$SIGMA82[i * 16 + 13]);
        $9a1af0afc9270f9a$var$B2B_G(6, 8, 18, 28, $9a1af0afc9270f9a$var$SIGMA82[i * 16 + 14], $9a1af0afc9270f9a$var$SIGMA82[i * 16 + 15]);
    }
    for(i = 0; i < 16; i++)ctx.h[i] = ctx.h[i] ^ $9a1af0afc9270f9a$var$v[i] ^ $9a1af0afc9270f9a$var$v[i + 16];
}
// reusable parameter_block
var $9a1af0afc9270f9a$var$parameter_block = new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0 // 60: personal
]);
// Creates a BLAKE2b hashing context
// Requires an output length between 1 and 64 bytes
// Takes an optional Uint8Array key
function $9a1af0afc9270f9a$var$Blake2b(outlen, key, salt, personal) {
    // zero out parameter_block before usage
    $9a1af0afc9270f9a$var$parameter_block.fill(0);
    // state, 'param block'
    this.b = new Uint8Array(128);
    this.h = new Uint32Array(16);
    this.t = 0 // input count
    ;
    this.c = 0 // pointer within buffer
    ;
    this.outlen = outlen // output length in bytes
    ;
    $9a1af0afc9270f9a$var$parameter_block[0] = outlen;
    if (key) $9a1af0afc9270f9a$var$parameter_block[1] = key.length;
    $9a1af0afc9270f9a$var$parameter_block[2] = 1 // fanout
    ;
    $9a1af0afc9270f9a$var$parameter_block[3] = 1 // depth
    ;
    if (salt) $9a1af0afc9270f9a$var$parameter_block.set(salt, 32);
    if (personal) $9a1af0afc9270f9a$var$parameter_block.set(personal, 48);
    // initialize hash state
    for(var i = 0; i < 16; i++)this.h[i] = $9a1af0afc9270f9a$var$BLAKE2B_IV32[i] ^ $9a1af0afc9270f9a$var$B2B_GET32($9a1af0afc9270f9a$var$parameter_block, i * 4);
    // key the hash, if applicable
    if (key) {
        $9a1af0afc9270f9a$var$blake2bUpdate(this, key);
        // at the end
        this.c = 128;
    }
}
$9a1af0afc9270f9a$var$Blake2b.prototype.update = function(input) {
    $6JSie(input instanceof Uint8Array, "input must be Uint8Array or Buffer");
    $9a1af0afc9270f9a$var$blake2bUpdate(this, input);
    return this;
};
$9a1af0afc9270f9a$var$Blake2b.prototype.digest = function(out) {
    var buf = !out || out === "binary" || out === "hex" ? new Uint8Array(this.outlen) : out;
    $6JSie(buf instanceof Uint8Array, 'out must be "binary", "hex", Uint8Array, or Buffer');
    $6JSie(buf.length >= this.outlen, "out must have at least outlen bytes of space");
    $9a1af0afc9270f9a$var$blake2bFinal(this, buf);
    if (out === "hex") return $9a1af0afc9270f9a$var$hexSlice(buf);
    return buf;
};
$9a1af0afc9270f9a$var$Blake2b.prototype.final = $9a1af0afc9270f9a$var$Blake2b.prototype.digest;
$9a1af0afc9270f9a$var$Blake2b.ready = function(cb) {
    $aJRYj.ready(function() {
        cb() // ignore the error
        ;
    });
};
// Updates a BLAKE2b streaming hash
// Requires hash context and Uint8Array (byte array)
function $9a1af0afc9270f9a$var$blake2bUpdate(ctx, input) {
    for(var i = 0; i < input.length; i++){
        if (ctx.c === 128) {
            ctx.t += ctx.c // add counters
            ;
            $9a1af0afc9270f9a$var$blake2bCompress(ctx, false) // compress (not last)
            ;
            ctx.c = 0 // counter to zero
            ;
        }
        ctx.b[ctx.c++] = input[i];
    }
}
// Completes a BLAKE2b streaming hash
// Returns a Uint8Array containing the message digest
function $9a1af0afc9270f9a$var$blake2bFinal(ctx, out) {
    ctx.t += ctx.c // mark last block offset
    ;
    while(ctx.c < 128)ctx.b[ctx.c++] = 0;
    $9a1af0afc9270f9a$var$blake2bCompress(ctx, true) // final block flag = 1
    ;
    for(var i = 0; i < ctx.outlen; i++)out[i] = ctx.h[i >> 2] >> 8 * (i & 3);
    return out;
}
function $9a1af0afc9270f9a$var$hexSlice(buf) {
    var str = "";
    for(var i = 0; i < buf.length; i++)str += $9a1af0afc9270f9a$var$toHex(buf[i]);
    return str;
}
function $9a1af0afc9270f9a$var$toHex(n) {
    if (n < 16) return "0" + n.toString(16);
    return n.toString(16);
}
var $9a1af0afc9270f9a$var$Proto = $9a1af0afc9270f9a$var$Blake2b;
module.exports = function createHash(outlen, key, salt, personal, noAssert) {
    if (noAssert !== true) {
        $6JSie(outlen >= $9a1af0afc9270f9a$var$BYTES_MIN, "outlen must be at least " + $9a1af0afc9270f9a$var$BYTES_MIN + ", was given " + outlen);
        $6JSie(outlen <= $9a1af0afc9270f9a$var$BYTES_MAX, "outlen must be at most " + $9a1af0afc9270f9a$var$BYTES_MAX + ", was given " + outlen);
        if (key != null) {
            $6JSie(key instanceof Uint8Array, "key must be Uint8Array or Buffer");
            $6JSie(key.length >= $9a1af0afc9270f9a$var$KEYBYTES_MIN, "key must be at least " + $9a1af0afc9270f9a$var$KEYBYTES_MIN + ", was given " + key.length);
            $6JSie(key.length <= $9a1af0afc9270f9a$var$KEYBYTES_MAX, "key must be at most " + $9a1af0afc9270f9a$var$KEYBYTES_MAX + ", was given " + key.length);
        }
        if (salt != null) {
            $6JSie(salt instanceof Uint8Array, "salt must be Uint8Array or Buffer");
            $6JSie(salt.length === $9a1af0afc9270f9a$var$SALTBYTES, "salt must be exactly " + $9a1af0afc9270f9a$var$SALTBYTES + ", was given " + salt.length);
        }
        if (personal != null) {
            $6JSie(personal instanceof Uint8Array, "personal must be Uint8Array or Buffer");
            $6JSie(personal.length === $9a1af0afc9270f9a$var$PERSONALBYTES, "personal must be exactly " + $9a1af0afc9270f9a$var$PERSONALBYTES + ", was given " + personal.length);
        }
    }
    return new $9a1af0afc9270f9a$var$Proto(outlen, key, salt, personal);
};
module.exports.ready = function(cb) {
    $aJRYj.ready(function() {
        cb();
    });
};
module.exports.WASM_SUPPORTED = $aJRYj.SUPPORTED;
module.exports.WASM_LOADED = false;
var $9a1af0afc9270f9a$var$BYTES_MIN = module.exports.BYTES_MIN = 16;
var $9a1af0afc9270f9a$var$BYTES_MAX = module.exports.BYTES_MAX = 64;
var $9a1af0afc9270f9a$var$BYTES = module.exports.BYTES = 32;
var $9a1af0afc9270f9a$var$KEYBYTES_MIN = module.exports.KEYBYTES_MIN = 16;
var $9a1af0afc9270f9a$var$KEYBYTES_MAX = module.exports.KEYBYTES_MAX = 64;
var $9a1af0afc9270f9a$var$KEYBYTES = module.exports.KEYBYTES = 32;
var $9a1af0afc9270f9a$var$SALTBYTES = module.exports.SALTBYTES = 16;
var $9a1af0afc9270f9a$var$PERSONALBYTES = module.exports.PERSONALBYTES = 16;
$aJRYj.ready(function(err) {
    if (!err) {
        module.exports.WASM_LOADED = true;
        module.exports = $aJRYj;
    }
});

});
parcelRegister("aJRYj", function(module, exports) {

var $6JSie = parcelRequire("6JSie");

var $hsTwZ = parcelRequire("hsTwZ");
var $7d17f90871eba3e7$var$wasm = null;

var $7d17f90871eba3e7$var$wasmPromise = typeof WebAssembly !== "undefined" && (parcelRequire("12JpT"))().then((mod)=>{
    $7d17f90871eba3e7$var$wasm = mod;
});
var $7d17f90871eba3e7$var$head = 64;
var $7d17f90871eba3e7$var$freeList = [];
module.exports = $7d17f90871eba3e7$var$Blake2b;
var $7d17f90871eba3e7$var$BYTES_MIN = module.exports.BYTES_MIN = 16;
var $7d17f90871eba3e7$var$BYTES_MAX = module.exports.BYTES_MAX = 64;
var $7d17f90871eba3e7$var$BYTES = module.exports.BYTES = 32;
var $7d17f90871eba3e7$var$KEYBYTES_MIN = module.exports.KEYBYTES_MIN = 16;
var $7d17f90871eba3e7$var$KEYBYTES_MAX = module.exports.KEYBYTES_MAX = 64;
var $7d17f90871eba3e7$var$KEYBYTES = module.exports.KEYBYTES = 32;
var $7d17f90871eba3e7$var$SALTBYTES = module.exports.SALTBYTES = 16;
var $7d17f90871eba3e7$var$PERSONALBYTES = module.exports.PERSONALBYTES = 16;
function $7d17f90871eba3e7$var$Blake2b(digestLength, key, salt, personal, noAssert) {
    if (!(this instanceof $7d17f90871eba3e7$var$Blake2b)) return new $7d17f90871eba3e7$var$Blake2b(digestLength, key, salt, personal, noAssert);
    if (!$7d17f90871eba3e7$var$wasm) throw new Error("WASM not loaded. Wait for Blake2b.ready(cb)");
    if (!digestLength) digestLength = 32;
    if (noAssert !== true) {
        $6JSie(digestLength >= $7d17f90871eba3e7$var$BYTES_MIN, "digestLength must be at least " + $7d17f90871eba3e7$var$BYTES_MIN + ", was given " + digestLength);
        $6JSie(digestLength <= $7d17f90871eba3e7$var$BYTES_MAX, "digestLength must be at most " + $7d17f90871eba3e7$var$BYTES_MAX + ", was given " + digestLength);
        if (key != null) {
            $6JSie(key instanceof Uint8Array, "key must be Uint8Array or Buffer");
            $6JSie(key.length >= $7d17f90871eba3e7$var$KEYBYTES_MIN, "key must be at least " + $7d17f90871eba3e7$var$KEYBYTES_MIN + ", was given " + key.length);
            $6JSie(key.length <= $7d17f90871eba3e7$var$KEYBYTES_MAX, "key must be at least " + $7d17f90871eba3e7$var$KEYBYTES_MAX + ", was given " + key.length);
        }
        if (salt != null) {
            $6JSie(salt instanceof Uint8Array, "salt must be Uint8Array or Buffer");
            $6JSie(salt.length === $7d17f90871eba3e7$var$SALTBYTES, "salt must be exactly " + $7d17f90871eba3e7$var$SALTBYTES + ", was given " + salt.length);
        }
        if (personal != null) {
            $6JSie(personal instanceof Uint8Array, "personal must be Uint8Array or Buffer");
            $6JSie(personal.length === $7d17f90871eba3e7$var$PERSONALBYTES, "personal must be exactly " + $7d17f90871eba3e7$var$PERSONALBYTES + ", was given " + personal.length);
        }
    }
    if (!$7d17f90871eba3e7$var$freeList.length) {
        $7d17f90871eba3e7$var$freeList.push($7d17f90871eba3e7$var$head);
        $7d17f90871eba3e7$var$head += 216;
    }
    this.digestLength = digestLength;
    this.finalized = false;
    this.pointer = $7d17f90871eba3e7$var$freeList.pop();
    this._memory = new Uint8Array($7d17f90871eba3e7$var$wasm.memory.buffer);
    this._memory.fill(0, 0, 64);
    this._memory[0] = this.digestLength;
    this._memory[1] = key ? key.length : 0;
    this._memory[2] = 1 // fanout
    ;
    this._memory[3] = 1 // depth
    ;
    if (salt) this._memory.set(salt, 32);
    if (personal) this._memory.set(personal, 48);
    if (this.pointer + 216 > this._memory.length) this._realloc(this.pointer + 216) // we need 216 bytes for the state
    ;
    $7d17f90871eba3e7$var$wasm.blake2b_init(this.pointer, this.digestLength);
    if (key) {
        this.update(key);
        this._memory.fill(0, $7d17f90871eba3e7$var$head, $7d17f90871eba3e7$var$head + key.length) // whiteout key
        ;
        this._memory[this.pointer + 200] = 128;
    }
}
$7d17f90871eba3e7$var$Blake2b.prototype._realloc = function(size) {
    $7d17f90871eba3e7$var$wasm.memory.grow(Math.max(0, Math.ceil(Math.abs(size - this._memory.length) / 65536)));
    this._memory = new Uint8Array($7d17f90871eba3e7$var$wasm.memory.buffer);
};
$7d17f90871eba3e7$var$Blake2b.prototype.update = function(input) {
    $6JSie(this.finalized === false, "Hash instance finalized");
    $6JSie(input instanceof Uint8Array, "input must be Uint8Array or Buffer");
    if ($7d17f90871eba3e7$var$head + input.length > this._memory.length) this._realloc($7d17f90871eba3e7$var$head + input.length);
    this._memory.set(input, $7d17f90871eba3e7$var$head);
    $7d17f90871eba3e7$var$wasm.blake2b_update(this.pointer, $7d17f90871eba3e7$var$head, $7d17f90871eba3e7$var$head + input.length);
    return this;
};
$7d17f90871eba3e7$var$Blake2b.prototype.digest = function(enc) {
    $6JSie(this.finalized === false, "Hash instance finalized");
    this.finalized = true;
    $7d17f90871eba3e7$var$freeList.push(this.pointer);
    $7d17f90871eba3e7$var$wasm.blake2b_final(this.pointer);
    if (!enc || enc === "binary") return this._memory.slice(this.pointer + 128, this.pointer + 128 + this.digestLength);
    if (typeof enc === "string") return $hsTwZ.toString(this._memory, enc, this.pointer + 128, this.pointer + 128 + this.digestLength);
    $6JSie(enc instanceof Uint8Array && enc.length >= this.digestLength, "input must be Uint8Array or Buffer");
    for(var i = 0; i < this.digestLength; i++)enc[i] = this._memory[this.pointer + 128 + i];
    return enc;
};
// libsodium compat
$7d17f90871eba3e7$var$Blake2b.prototype.final = $7d17f90871eba3e7$var$Blake2b.prototype.digest;
$7d17f90871eba3e7$var$Blake2b.WASM = $7d17f90871eba3e7$var$wasm;
$7d17f90871eba3e7$var$Blake2b.SUPPORTED = typeof WebAssembly !== "undefined";
$7d17f90871eba3e7$var$Blake2b.ready = function(cb) {
    if (!cb) cb = $7d17f90871eba3e7$var$noop;
    if (!$7d17f90871eba3e7$var$wasmPromise) return cb(new Error("WebAssembly not supported"));
    return $7d17f90871eba3e7$var$wasmPromise.then(()=>cb(), cb);
};
$7d17f90871eba3e7$var$Blake2b.prototype.ready = $7d17f90871eba3e7$var$Blake2b.ready;
$7d17f90871eba3e7$var$Blake2b.prototype.getPartialHash = function() {
    return this._memory.slice(this.pointer, this.pointer + 216);
};
$7d17f90871eba3e7$var$Blake2b.prototype.setPartialHash = function(ph) {
    this._memory.set(ph, this.pointer);
};
function $7d17f90871eba3e7$var$noop() {}

});
parcelRegister("12JpT", function(module, exports) {
var $0c29352742ba7b8b$var$__commonJS = (cb, mod)=>function __require() {
        return mod || (0, cb[Object.keys(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
var $0c29352742ba7b8b$var$__toBinary = /* @__PURE__ */ (()=>{
    var table = new Uint8Array(128);
    for(var i = 0; i < 64; i++)table[i < 26 ? i + 65 : i < 52 ? i + 71 : i < 62 ? i - 4 : i * 4 - 205] = i;
    return (base64)=>{
        var n = base64.length, bytes2 = new Uint8Array((n - (base64[n - 1] == "=") - (base64[n - 2] == "=")) * 3 / 4 | 0);
        for(var i2 = 0, j = 0; i2 < n;){
            var c0 = table[base64.charCodeAt(i2++)], c1 = table[base64.charCodeAt(i2++)];
            var c2 = table[base64.charCodeAt(i2++)], c3 = table[base64.charCodeAt(i2++)];
            bytes2[j++] = c0 << 2 | c1 >> 4;
            bytes2[j++] = c1 << 4 | c2 >> 2;
            bytes2[j++] = c2 << 6 | c3;
        }
        return bytes2;
    };
})();
// wasm-binary:./blake2b.wat
var $0c29352742ba7b8b$var$require_blake2b = $0c29352742ba7b8b$var$__commonJS({
    "wasm-binary:./blake2b.wat" (exports2, module2) {
        module2.exports = $0c29352742ba7b8b$var$__toBinary("AGFzbQEAAAABEANgAn9/AGADf39/AGABfwADBQQAAQICBQUBAQroBwdNBQZtZW1vcnkCAAxibGFrZTJiX2luaXQAAA5ibGFrZTJiX3VwZGF0ZQABDWJsYWtlMmJfZmluYWwAAhBibGFrZTJiX2NvbXByZXNzAAMKvz8EwAIAIABCADcDACAAQgA3AwggAEIANwMQIABCADcDGCAAQgA3AyAgAEIANwMoIABCADcDMCAAQgA3AzggAEIANwNAIABCADcDSCAAQgA3A1AgAEIANwNYIABCADcDYCAAQgA3A2ggAEIANwNwIABCADcDeCAAQoiS853/zPmE6gBBACkDAIU3A4ABIABCu86qptjQ67O7f0EIKQMAhTcDiAEgAEKr8NP0r+68tzxBECkDAIU3A5ABIABC8e30+KWn/aelf0EYKQMAhTcDmAEgAELRhZrv+s+Uh9EAQSApAwCFNwOgASAAQp/Y+dnCkdqCm39BKCkDAIU3A6gBIABC6/qG2r+19sEfQTApAwCFNwOwASAAQvnC+JuRo7Pw2wBBOCkDAIU3A7gBIABCADcDwAEgAEIANwPIASAAQgA3A9ABC20BA38gAEHAAWohAyAAQcgBaiEEIAQpAwCnIQUCQANAIAEgAkYNASAFQYABRgRAIAMgAykDACAFrXw3AwBBACEFIAAQAwsgACAFaiABLQAAOgAAIAVBAWohBSABQQFqIQEMAAsLIAQgBa03AwALYQEDfyAAQcABaiEBIABByAFqIQIgASABKQMAIAIpAwB8NwMAIABCfzcD0AEgAikDAKchAwJAA0AgA0GAAUYNASAAIANqQQA6AAAgA0EBaiEDDAALCyACIAOtNwMAIAAQAwuqOwIgfgl/IABBgAFqISEgAEGIAWohIiAAQZABaiEjIABBmAFqISQgAEGgAWohJSAAQagBaiEmIABBsAFqIScgAEG4AWohKCAhKQMAIQEgIikDACECICMpAwAhAyAkKQMAIQQgJSkDACEFICYpAwAhBiAnKQMAIQcgKCkDACEIQoiS853/zPmE6gAhCUK7zqqm2NDrs7t/IQpCq/DT9K/uvLc8IQtC8e30+KWn/aelfyEMQtGFmu/6z5SH0QAhDUKf2PnZwpHagpt/IQ5C6/qG2r+19sEfIQ9C+cL4m5Gjs/DbACEQIAApAwAhESAAKQMIIRIgACkDECETIAApAxghFCAAKQMgIRUgACkDKCEWIAApAzAhFyAAKQM4IRggACkDQCEZIAApA0ghGiAAKQNQIRsgACkDWCEcIAApA2AhHSAAKQNoIR4gACkDcCEfIAApA3ghICANIAApA8ABhSENIA8gACkD0AGFIQ8gASAFIBF8fCEBIA0gAYVCIIohDSAJIA18IQkgBSAJhUIYiiEFIAEgBSASfHwhASANIAGFQhCKIQ0gCSANfCEJIAUgCYVCP4ohBSACIAYgE3x8IQIgDiAChUIgiiEOIAogDnwhCiAGIAqFQhiKIQYgAiAGIBR8fCECIA4gAoVCEIohDiAKIA58IQogBiAKhUI/iiEGIAMgByAVfHwhAyAPIAOFQiCKIQ8gCyAPfCELIAcgC4VCGIohByADIAcgFnx8IQMgDyADhUIQiiEPIAsgD3whCyAHIAuFQj+KIQcgBCAIIBd8fCEEIBAgBIVCIIohECAMIBB8IQwgCCAMhUIYiiEIIAQgCCAYfHwhBCAQIASFQhCKIRAgDCAQfCEMIAggDIVCP4ohCCABIAYgGXx8IQEgECABhUIgiiEQIAsgEHwhCyAGIAuFQhiKIQYgASAGIBp8fCEBIBAgAYVCEIohECALIBB8IQsgBiALhUI/iiEGIAIgByAbfHwhAiANIAKFQiCKIQ0gDCANfCEMIAcgDIVCGIohByACIAcgHHx8IQIgDSAChUIQiiENIAwgDXwhDCAHIAyFQj+KIQcgAyAIIB18fCEDIA4gA4VCIIohDiAJIA58IQkgCCAJhUIYiiEIIAMgCCAefHwhAyAOIAOFQhCKIQ4gCSAOfCEJIAggCYVCP4ohCCAEIAUgH3x8IQQgDyAEhUIgiiEPIAogD3whCiAFIAqFQhiKIQUgBCAFICB8fCEEIA8gBIVCEIohDyAKIA98IQogBSAKhUI/iiEFIAEgBSAffHwhASANIAGFQiCKIQ0gCSANfCEJIAUgCYVCGIohBSABIAUgG3x8IQEgDSABhUIQiiENIAkgDXwhCSAFIAmFQj+KIQUgAiAGIBV8fCECIA4gAoVCIIohDiAKIA58IQogBiAKhUIYiiEGIAIgBiAZfHwhAiAOIAKFQhCKIQ4gCiAOfCEKIAYgCoVCP4ohBiADIAcgGnx8IQMgDyADhUIgiiEPIAsgD3whCyAHIAuFQhiKIQcgAyAHICB8fCEDIA8gA4VCEIohDyALIA98IQsgByALhUI/iiEHIAQgCCAefHwhBCAQIASFQiCKIRAgDCAQfCEMIAggDIVCGIohCCAEIAggF3x8IQQgECAEhUIQiiEQIAwgEHwhDCAIIAyFQj+KIQggASAGIBJ8fCEBIBAgAYVCIIohECALIBB8IQsgBiALhUIYiiEGIAEgBiAdfHwhASAQIAGFQhCKIRAgCyAQfCELIAYgC4VCP4ohBiACIAcgEXx8IQIgDSAChUIgiiENIAwgDXwhDCAHIAyFQhiKIQcgAiAHIBN8fCECIA0gAoVCEIohDSAMIA18IQwgByAMhUI/iiEHIAMgCCAcfHwhAyAOIAOFQiCKIQ4gCSAOfCEJIAggCYVCGIohCCADIAggGHx8IQMgDiADhUIQiiEOIAkgDnwhCSAIIAmFQj+KIQggBCAFIBZ8fCEEIA8gBIVCIIohDyAKIA98IQogBSAKhUIYiiEFIAQgBSAUfHwhBCAPIASFQhCKIQ8gCiAPfCEKIAUgCoVCP4ohBSABIAUgHHx8IQEgDSABhUIgiiENIAkgDXwhCSAFIAmFQhiKIQUgASAFIBl8fCEBIA0gAYVCEIohDSAJIA18IQkgBSAJhUI/iiEFIAIgBiAdfHwhAiAOIAKFQiCKIQ4gCiAOfCEKIAYgCoVCGIohBiACIAYgEXx8IQIgDiAChUIQiiEOIAogDnwhCiAGIAqFQj+KIQYgAyAHIBZ8fCEDIA8gA4VCIIohDyALIA98IQsgByALhUIYiiEHIAMgByATfHwhAyAPIAOFQhCKIQ8gCyAPfCELIAcgC4VCP4ohByAEIAggIHx8IQQgECAEhUIgiiEQIAwgEHwhDCAIIAyFQhiKIQggBCAIIB58fCEEIBAgBIVCEIohECAMIBB8IQwgCCAMhUI/iiEIIAEgBiAbfHwhASAQIAGFQiCKIRAgCyAQfCELIAYgC4VCGIohBiABIAYgH3x8IQEgECABhUIQiiEQIAsgEHwhCyAGIAuFQj+KIQYgAiAHIBR8fCECIA0gAoVCIIohDSAMIA18IQwgByAMhUIYiiEHIAIgByAXfHwhAiANIAKFQhCKIQ0gDCANfCEMIAcgDIVCP4ohByADIAggGHx8IQMgDiADhUIgiiEOIAkgDnwhCSAIIAmFQhiKIQggAyAIIBJ8fCEDIA4gA4VCEIohDiAJIA58IQkgCCAJhUI/iiEIIAQgBSAafHwhBCAPIASFQiCKIQ8gCiAPfCEKIAUgCoVCGIohBSAEIAUgFXx8IQQgDyAEhUIQiiEPIAogD3whCiAFIAqFQj+KIQUgASAFIBh8fCEBIA0gAYVCIIohDSAJIA18IQkgBSAJhUIYiiEFIAEgBSAafHwhASANIAGFQhCKIQ0gCSANfCEJIAUgCYVCP4ohBSACIAYgFHx8IQIgDiAChUIgiiEOIAogDnwhCiAGIAqFQhiKIQYgAiAGIBJ8fCECIA4gAoVCEIohDiAKIA58IQogBiAKhUI/iiEGIAMgByAefHwhAyAPIAOFQiCKIQ8gCyAPfCELIAcgC4VCGIohByADIAcgHXx8IQMgDyADhUIQiiEPIAsgD3whCyAHIAuFQj+KIQcgBCAIIBx8fCEEIBAgBIVCIIohECAMIBB8IQwgCCAMhUIYiiEIIAQgCCAffHwhBCAQIASFQhCKIRAgDCAQfCEMIAggDIVCP4ohCCABIAYgE3x8IQEgECABhUIgiiEQIAsgEHwhCyAGIAuFQhiKIQYgASAGIBd8fCEBIBAgAYVCEIohECALIBB8IQsgBiALhUI/iiEGIAIgByAWfHwhAiANIAKFQiCKIQ0gDCANfCEMIAcgDIVCGIohByACIAcgG3x8IQIgDSAChUIQiiENIAwgDXwhDCAHIAyFQj+KIQcgAyAIIBV8fCEDIA4gA4VCIIohDiAJIA58IQkgCCAJhUIYiiEIIAMgCCARfHwhAyAOIAOFQhCKIQ4gCSAOfCEJIAggCYVCP4ohCCAEIAUgIHx8IQQgDyAEhUIgiiEPIAogD3whCiAFIAqFQhiKIQUgBCAFIBl8fCEEIA8gBIVCEIohDyAKIA98IQogBSAKhUI/iiEFIAEgBSAafHwhASANIAGFQiCKIQ0gCSANfCEJIAUgCYVCGIohBSABIAUgEXx8IQEgDSABhUIQiiENIAkgDXwhCSAFIAmFQj+KIQUgAiAGIBZ8fCECIA4gAoVCIIohDiAKIA58IQogBiAKhUIYiiEGIAIgBiAYfHwhAiAOIAKFQhCKIQ4gCiAOfCEKIAYgCoVCP4ohBiADIAcgE3x8IQMgDyADhUIgiiEPIAsgD3whCyAHIAuFQhiKIQcgAyAHIBV8fCEDIA8gA4VCEIohDyALIA98IQsgByALhUI/iiEHIAQgCCAbfHwhBCAQIASFQiCKIRAgDCAQfCEMIAggDIVCGIohCCAEIAggIHx8IQQgECAEhUIQiiEQIAwgEHwhDCAIIAyFQj+KIQggASAGIB98fCEBIBAgAYVCIIohECALIBB8IQsgBiALhUIYiiEGIAEgBiASfHwhASAQIAGFQhCKIRAgCyAQfCELIAYgC4VCP4ohBiACIAcgHHx8IQIgDSAChUIgiiENIAwgDXwhDCAHIAyFQhiKIQcgAiAHIB18fCECIA0gAoVCEIohDSAMIA18IQwgByAMhUI/iiEHIAMgCCAXfHwhAyAOIAOFQiCKIQ4gCSAOfCEJIAggCYVCGIohCCADIAggGXx8IQMgDiADhUIQiiEOIAkgDnwhCSAIIAmFQj+KIQggBCAFIBR8fCEEIA8gBIVCIIohDyAKIA98IQogBSAKhUIYiiEFIAQgBSAefHwhBCAPIASFQhCKIQ8gCiAPfCEKIAUgCoVCP4ohBSABIAUgE3x8IQEgDSABhUIgiiENIAkgDXwhCSAFIAmFQhiKIQUgASAFIB18fCEBIA0gAYVCEIohDSAJIA18IQkgBSAJhUI/iiEFIAIgBiAXfHwhAiAOIAKFQiCKIQ4gCiAOfCEKIAYgCoVCGIohBiACIAYgG3x8IQIgDiAChUIQiiEOIAogDnwhCiAGIAqFQj+KIQYgAyAHIBF8fCEDIA8gA4VCIIohDyALIA98IQsgByALhUIYiiEHIAMgByAcfHwhAyAPIAOFQhCKIQ8gCyAPfCELIAcgC4VCP4ohByAEIAggGXx8IQQgECAEhUIgiiEQIAwgEHwhDCAIIAyFQhiKIQggBCAIIBR8fCEEIBAgBIVCEIohECAMIBB8IQwgCCAMhUI/iiEIIAEgBiAVfHwhASAQIAGFQiCKIRAgCyAQfCELIAYgC4VCGIohBiABIAYgHnx8IQEgECABhUIQiiEQIAsgEHwhCyAGIAuFQj+KIQYgAiAHIBh8fCECIA0gAoVCIIohDSAMIA18IQwgByAMhUIYiiEHIAIgByAWfHwhAiANIAKFQhCKIQ0gDCANfCEMIAcgDIVCP4ohByADIAggIHx8IQMgDiADhUIgiiEOIAkgDnwhCSAIIAmFQhiKIQggAyAIIB98fCEDIA4gA4VCEIohDiAJIA58IQkgCCAJhUI/iiEIIAQgBSASfHwhBCAPIASFQiCKIQ8gCiAPfCEKIAUgCoVCGIohBSAEIAUgGnx8IQQgDyAEhUIQiiEPIAogD3whCiAFIAqFQj+KIQUgASAFIB18fCEBIA0gAYVCIIohDSAJIA18IQkgBSAJhUIYiiEFIAEgBSAWfHwhASANIAGFQhCKIQ0gCSANfCEJIAUgCYVCP4ohBSACIAYgEnx8IQIgDiAChUIgiiEOIAogDnwhCiAGIAqFQhiKIQYgAiAGICB8fCECIA4gAoVCEIohDiAKIA58IQogBiAKhUI/iiEGIAMgByAffHwhAyAPIAOFQiCKIQ8gCyAPfCELIAcgC4VCGIohByADIAcgHnx8IQMgDyADhUIQiiEPIAsgD3whCyAHIAuFQj+KIQcgBCAIIBV8fCEEIBAgBIVCIIohECAMIBB8IQwgCCAMhUIYiiEIIAQgCCAbfHwhBCAQIASFQhCKIRAgDCAQfCEMIAggDIVCP4ohCCABIAYgEXx8IQEgECABhUIgiiEQIAsgEHwhCyAGIAuFQhiKIQYgASAGIBh8fCEBIBAgAYVCEIohECALIBB8IQsgBiALhUI/iiEGIAIgByAXfHwhAiANIAKFQiCKIQ0gDCANfCEMIAcgDIVCGIohByACIAcgFHx8IQIgDSAChUIQiiENIAwgDXwhDCAHIAyFQj+KIQcgAyAIIBp8fCEDIA4gA4VCIIohDiAJIA58IQkgCCAJhUIYiiEIIAMgCCATfHwhAyAOIAOFQhCKIQ4gCSAOfCEJIAggCYVCP4ohCCAEIAUgGXx8IQQgDyAEhUIgiiEPIAogD3whCiAFIAqFQhiKIQUgBCAFIBx8fCEEIA8gBIVCEIohDyAKIA98IQogBSAKhUI/iiEFIAEgBSAefHwhASANIAGFQiCKIQ0gCSANfCEJIAUgCYVCGIohBSABIAUgHHx8IQEgDSABhUIQiiENIAkgDXwhCSAFIAmFQj+KIQUgAiAGIBh8fCECIA4gAoVCIIohDiAKIA58IQogBiAKhUIYiiEGIAIgBiAffHwhAiAOIAKFQhCKIQ4gCiAOfCEKIAYgCoVCP4ohBiADIAcgHXx8IQMgDyADhUIgiiEPIAsgD3whCyAHIAuFQhiKIQcgAyAHIBJ8fCEDIA8gA4VCEIohDyALIA98IQsgByALhUI/iiEHIAQgCCAUfHwhBCAQIASFQiCKIRAgDCAQfCEMIAggDIVCGIohCCAEIAggGnx8IQQgECAEhUIQiiEQIAwgEHwhDCAIIAyFQj+KIQggASAGIBZ8fCEBIBAgAYVCIIohECALIBB8IQsgBiALhUIYiiEGIAEgBiARfHwhASAQIAGFQhCKIRAgCyAQfCELIAYgC4VCP4ohBiACIAcgIHx8IQIgDSAChUIgiiENIAwgDXwhDCAHIAyFQhiKIQcgAiAHIBV8fCECIA0gAoVCEIohDSAMIA18IQwgByAMhUI/iiEHIAMgCCAZfHwhAyAOIAOFQiCKIQ4gCSAOfCEJIAggCYVCGIohCCADIAggF3x8IQMgDiADhUIQiiEOIAkgDnwhCSAIIAmFQj+KIQggBCAFIBN8fCEEIA8gBIVCIIohDyAKIA98IQogBSAKhUIYiiEFIAQgBSAbfHwhBCAPIASFQhCKIQ8gCiAPfCEKIAUgCoVCP4ohBSABIAUgF3x8IQEgDSABhUIgiiENIAkgDXwhCSAFIAmFQhiKIQUgASAFICB8fCEBIA0gAYVCEIohDSAJIA18IQkgBSAJhUI/iiEFIAIgBiAffHwhAiAOIAKFQiCKIQ4gCiAOfCEKIAYgCoVCGIohBiACIAYgGnx8IQIgDiAChUIQiiEOIAogDnwhCiAGIAqFQj+KIQYgAyAHIBx8fCEDIA8gA4VCIIohDyALIA98IQsgByALhUIYiiEHIAMgByAUfHwhAyAPIAOFQhCKIQ8gCyAPfCELIAcgC4VCP4ohByAEIAggEXx8IQQgECAEhUIgiiEQIAwgEHwhDCAIIAyFQhiKIQggBCAIIBl8fCEEIBAgBIVCEIohECAMIBB8IQwgCCAMhUI/iiEIIAEgBiAdfHwhASAQIAGFQiCKIRAgCyAQfCELIAYgC4VCGIohBiABIAYgE3x8IQEgECABhUIQiiEQIAsgEHwhCyAGIAuFQj+KIQYgAiAHIB58fCECIA0gAoVCIIohDSAMIA18IQwgByAMhUIYiiEHIAIgByAYfHwhAiANIAKFQhCKIQ0gDCANfCEMIAcgDIVCP4ohByADIAggEnx8IQMgDiADhUIgiiEOIAkgDnwhCSAIIAmFQhiKIQggAyAIIBV8fCEDIA4gA4VCEIohDiAJIA58IQkgCCAJhUI/iiEIIAQgBSAbfHwhBCAPIASFQiCKIQ8gCiAPfCEKIAUgCoVCGIohBSAEIAUgFnx8IQQgDyAEhUIQiiEPIAogD3whCiAFIAqFQj+KIQUgASAFIBt8fCEBIA0gAYVCIIohDSAJIA18IQkgBSAJhUIYiiEFIAEgBSATfHwhASANIAGFQhCKIQ0gCSANfCEJIAUgCYVCP4ohBSACIAYgGXx8IQIgDiAChUIgiiEOIAogDnwhCiAGIAqFQhiKIQYgAiAGIBV8fCECIA4gAoVCEIohDiAKIA58IQogBiAKhUI/iiEGIAMgByAYfHwhAyAPIAOFQiCKIQ8gCyAPfCELIAcgC4VCGIohByADIAcgF3x8IQMgDyADhUIQiiEPIAsgD3whCyAHIAuFQj+KIQcgBCAIIBJ8fCEEIBAgBIVCIIohECAMIBB8IQwgCCAMhUIYiiEIIAQgCCAWfHwhBCAQIASFQhCKIRAgDCAQfCEMIAggDIVCP4ohCCABIAYgIHx8IQEgECABhUIgiiEQIAsgEHwhCyAGIAuFQhiKIQYgASAGIBx8fCEBIBAgAYVCEIohECALIBB8IQsgBiALhUI/iiEGIAIgByAafHwhAiANIAKFQiCKIQ0gDCANfCEMIAcgDIVCGIohByACIAcgH3x8IQIgDSAChUIQiiENIAwgDXwhDCAHIAyFQj+KIQcgAyAIIBR8fCEDIA4gA4VCIIohDiAJIA58IQkgCCAJhUIYiiEIIAMgCCAdfHwhAyAOIAOFQhCKIQ4gCSAOfCEJIAggCYVCP4ohCCAEIAUgHnx8IQQgDyAEhUIgiiEPIAogD3whCiAFIAqFQhiKIQUgBCAFIBF8fCEEIA8gBIVCEIohDyAKIA98IQogBSAKhUI/iiEFIAEgBSARfHwhASANIAGFQiCKIQ0gCSANfCEJIAUgCYVCGIohBSABIAUgEnx8IQEgDSABhUIQiiENIAkgDXwhCSAFIAmFQj+KIQUgAiAGIBN8fCECIA4gAoVCIIohDiAKIA58IQogBiAKhUIYiiEGIAIgBiAUfHwhAiAOIAKFQhCKIQ4gCiAOfCEKIAYgCoVCP4ohBiADIAcgFXx8IQMgDyADhUIgiiEPIAsgD3whCyAHIAuFQhiKIQcgAyAHIBZ8fCEDIA8gA4VCEIohDyALIA98IQsgByALhUI/iiEHIAQgCCAXfHwhBCAQIASFQiCKIRAgDCAQfCEMIAggDIVCGIohCCAEIAggGHx8IQQgECAEhUIQiiEQIAwgEHwhDCAIIAyFQj+KIQggASAGIBl8fCEBIBAgAYVCIIohECALIBB8IQsgBiALhUIYiiEGIAEgBiAafHwhASAQIAGFQhCKIRAgCyAQfCELIAYgC4VCP4ohBiACIAcgG3x8IQIgDSAChUIgiiENIAwgDXwhDCAHIAyFQhiKIQcgAiAHIBx8fCECIA0gAoVCEIohDSAMIA18IQwgByAMhUI/iiEHIAMgCCAdfHwhAyAOIAOFQiCKIQ4gCSAOfCEJIAggCYVCGIohCCADIAggHnx8IQMgDiADhUIQiiEOIAkgDnwhCSAIIAmFQj+KIQggBCAFIB98fCEEIA8gBIVCIIohDyAKIA98IQogBSAKhUIYiiEFIAQgBSAgfHwhBCAPIASFQhCKIQ8gCiAPfCEKIAUgCoVCP4ohBSABIAUgH3x8IQEgDSABhUIgiiENIAkgDXwhCSAFIAmFQhiKIQUgASAFIBt8fCEBIA0gAYVCEIohDSAJIA18IQkgBSAJhUI/iiEFIAIgBiAVfHwhAiAOIAKFQiCKIQ4gCiAOfCEKIAYgCoVCGIohBiACIAYgGXx8IQIgDiAChUIQiiEOIAogDnwhCiAGIAqFQj+KIQYgAyAHIBp8fCEDIA8gA4VCIIohDyALIA98IQsgByALhUIYiiEHIAMgByAgfHwhAyAPIAOFQhCKIQ8gCyAPfCELIAcgC4VCP4ohByAEIAggHnx8IQQgECAEhUIgiiEQIAwgEHwhDCAIIAyFQhiKIQggBCAIIBd8fCEEIBAgBIVCEIohECAMIBB8IQwgCCAMhUI/iiEIIAEgBiASfHwhASAQIAGFQiCKIRAgCyAQfCELIAYgC4VCGIohBiABIAYgHXx8IQEgECABhUIQiiEQIAsgEHwhCyAGIAuFQj+KIQYgAiAHIBF8fCECIA0gAoVCIIohDSAMIA18IQwgByAMhUIYiiEHIAIgByATfHwhAiANIAKFQhCKIQ0gDCANfCEMIAcgDIVCP4ohByADIAggHHx8IQMgDiADhUIgiiEOIAkgDnwhCSAIIAmFQhiKIQggAyAIIBh8fCEDIA4gA4VCEIohDiAJIA58IQkgCCAJhUI/iiEIIAQgBSAWfHwhBCAPIASFQiCKIQ8gCiAPfCEKIAUgCoVCGIohBSAEIAUgFHx8IQQgDyAEhUIQiiEPIAogD3whCiAFIAqFQj+KIQUgISAhKQMAIAEgCYWFNwMAICIgIikDACACIAqFhTcDACAjICMpAwAgAyALhYU3AwAgJCAkKQMAIAQgDIWFNwMAICUgJSkDACAFIA2FhTcDACAmICYpAwAgBiAOhYU3AwAgJyAnKQMAIAcgD4WFNwMAICggKCkDACAIIBCFhTcDAAs=");
    }
});
// wasm-module:./blake2b.wat
var $0c29352742ba7b8b$var$bytes = $0c29352742ba7b8b$var$require_blake2b();
var $0c29352742ba7b8b$var$compiled = WebAssembly.compile($0c29352742ba7b8b$var$bytes);
module.exports = async (imports)=>{
    const instance = await WebAssembly.instantiate(await $0c29352742ba7b8b$var$compiled, imports);
    return instance.exports;
};

});




parcelRegister("63ApX", function(module, exports) {

$parcel$export(module.exports, "crypto_stream_KEYBYTES", function () { return $468f45af757832a7$export$1a2bfc45d4093093; }, function (v) { return $468f45af757832a7$export$1a2bfc45d4093093 = v; });
$parcel$export(module.exports, "crypto_stream_NONCEBYTES", function () { return $468f45af757832a7$export$41d696a1c503f1fc; }, function (v) { return $468f45af757832a7$export$41d696a1c503f1fc = v; });
$parcel$export(module.exports, "crypto_stream_PRIMITIVE", function () { return $468f45af757832a7$export$aa15e03a34bfb2eb; }, function (v) { return $468f45af757832a7$export$aa15e03a34bfb2eb = v; });
$parcel$export(module.exports, "crypto_stream_xsalsa20_MESSAGEBYTES_MAX", function () { return $468f45af757832a7$export$e4faff90e9518180; }, function (v) { return $468f45af757832a7$export$e4faff90e9518180 = v; });
$parcel$export(module.exports, "crypto_stream", function () { return $468f45af757832a7$export$dc553c665625914a; }, function (v) { return $468f45af757832a7$export$dc553c665625914a = v; });
$parcel$export(module.exports, "crypto_stream_xor", function () { return $468f45af757832a7$export$e237fdc2f8f4df6f; }, function (v) { return $468f45af757832a7$export$e237fdc2f8f4df6f = v; });
$parcel$export(module.exports, "crypto_stream_xor_instance", function () { return $468f45af757832a7$export$583737553630b507; }, function (v) { return $468f45af757832a7$export$583737553630b507 = v; });
/* eslint-disable camelcase */ var $468f45af757832a7$export$1a2bfc45d4093093;
var $468f45af757832a7$export$41d696a1c503f1fc;
var $468f45af757832a7$export$aa15e03a34bfb2eb;
var $468f45af757832a7$export$e4faff90e9518180;
var $468f45af757832a7$export$dc553c665625914a;
var $468f45af757832a7$export$e237fdc2f8f4df6f;
var $468f45af757832a7$export$583737553630b507;

var $dheqR = parcelRequire("dheqR");
if (new Uint16Array([
    1
])[0] !== 1) throw new Error("Big endian architecture is not supported.");
$468f45af757832a7$export$1a2bfc45d4093093 = 32;
$468f45af757832a7$export$41d696a1c503f1fc = 24;
$468f45af757832a7$export$aa15e03a34bfb2eb = "xsalsa20";
$468f45af757832a7$export$e4faff90e9518180 = Number.MAX_SAFE_INTEGER;
$468f45af757832a7$export$dc553c665625914a = function(c, nonce, key) {
    c.fill(0);
    $468f45af757832a7$export$e237fdc2f8f4df6f(c, c, nonce, key);
};
$468f45af757832a7$export$e237fdc2f8f4df6f = function(c, m, nonce, key) {
    const xor = $dheqR(nonce, key);
    xor.update(m, c);
    xor.final();
};
$468f45af757832a7$export$583737553630b507 = function(nonce, key) {
    return new $468f45af757832a7$var$XOR(nonce, key);
};
function $468f45af757832a7$var$XOR(nonce, key) {
    this._instance = $dheqR(nonce, key);
}
$468f45af757832a7$var$XOR.prototype.update = function(out, inp) {
    this._instance.update(inp, out);
};
$468f45af757832a7$var$XOR.prototype.final = function() {
    this._instance.finalize();
    this._instance = null;
};

});
parcelRegister("dheqR", function(module, exports) {

var $9aa80ed9c9a8fa70$var$xsalsa20 = typeof WebAssembly !== "undefined" && (parcelRequire("6X24w"))();
var $9aa80ed9c9a8fa70$var$SIGMA = new Uint8Array([
    101,
    120,
    112,
    97,
    110,
    100,
    32,
    51,
    50,
    45,
    98,
    121,
    116,
    101,
    32,
    107
]);
var $9aa80ed9c9a8fa70$var$head = 144;
var $9aa80ed9c9a8fa70$var$top = $9aa80ed9c9a8fa70$var$head;
var $9aa80ed9c9a8fa70$var$free = [];
module.exports = $9aa80ed9c9a8fa70$var$XSalsa20;
$9aa80ed9c9a8fa70$var$XSalsa20.NONCEBYTES = 24;
$9aa80ed9c9a8fa70$var$XSalsa20.KEYBYTES = 32;
$9aa80ed9c9a8fa70$var$XSalsa20.core_hsalsa20 = $9aa80ed9c9a8fa70$var$core_hsalsa20;
$9aa80ed9c9a8fa70$var$XSalsa20.SIGMA = $9aa80ed9c9a8fa70$var$SIGMA;
function $9aa80ed9c9a8fa70$var$XSalsa20(nonce, key) {
    if (!(this instanceof $9aa80ed9c9a8fa70$var$XSalsa20)) return new $9aa80ed9c9a8fa70$var$XSalsa20(nonce, key);
    if (!nonce || nonce.length < 24) throw new Error("nonce must be at least 24 bytes");
    if (!key || key.length < 32) throw new Error("key must be at least 32 bytes");
    this._xor = $9aa80ed9c9a8fa70$var$xsalsa20 ? new $9aa80ed9c9a8fa70$var$WASM(nonce, key) : new $9aa80ed9c9a8fa70$var$Fallback(nonce, key);
}
$9aa80ed9c9a8fa70$var$XSalsa20.prototype.update = function(input, output) {
    if (!input) throw new Error("input must be Uint8Array or Buffer");
    if (!output) output = new Uint8Array(input.length);
    if (input.length) this._xor.update(input, output);
    return output;
};
$9aa80ed9c9a8fa70$var$XSalsa20.prototype.final = $9aa80ed9c9a8fa70$var$XSalsa20.prototype.finalize = function() {
    this._xor.finalize();
    this._xor = null;
};
function $9aa80ed9c9a8fa70$var$WASM(nonce, key) {
    if (!$9aa80ed9c9a8fa70$var$free.length) {
        $9aa80ed9c9a8fa70$var$free.push($9aa80ed9c9a8fa70$var$head);
        $9aa80ed9c9a8fa70$var$head += 64;
    }
    this._pointer = $9aa80ed9c9a8fa70$var$free.pop();
    this._nonce = this._pointer + 8;
    this._key = this._nonce + 24;
    this._overflow = 0;
    this._memory = new Uint8Array($9aa80ed9c9a8fa70$var$xsalsa20.memory.buffer);
    this._memory.fill(0, this._pointer, this._pointer + 8);
    this._memory.set(nonce, this._nonce);
    this._memory.set(key, this._key);
}
$9aa80ed9c9a8fa70$var$WASM.prototype.realloc = function(size) {
    $9aa80ed9c9a8fa70$var$xsalsa20.memory.grow(Math.ceil(Math.abs(size - this._memory.length) / 65536));
    this._memory = new Uint8Array($9aa80ed9c9a8fa70$var$xsalsa20.memory.buffer);
};
$9aa80ed9c9a8fa70$var$WASM.prototype.update = function(input, output) {
    var len = this._overflow + input.length;
    var start = $9aa80ed9c9a8fa70$var$head + this._overflow;
    $9aa80ed9c9a8fa70$var$top = $9aa80ed9c9a8fa70$var$head + len;
    if ($9aa80ed9c9a8fa70$var$top >= this._memory.length) this.realloc($9aa80ed9c9a8fa70$var$top);
    this._memory.set(input, start);
    $9aa80ed9c9a8fa70$var$xsalsa20.xsalsa20_xor(this._pointer, $9aa80ed9c9a8fa70$var$head, $9aa80ed9c9a8fa70$var$head, len, this._nonce, this._key);
    output.set(this._memory.subarray(start, $9aa80ed9c9a8fa70$var$head + len));
    this._overflow = len & 63;
};
$9aa80ed9c9a8fa70$var$WASM.prototype.finalize = function() {
    this._memory.fill(0, this._pointer, this._key + 32);
    if ($9aa80ed9c9a8fa70$var$top > $9aa80ed9c9a8fa70$var$head) {
        this._memory.fill(0, $9aa80ed9c9a8fa70$var$head, $9aa80ed9c9a8fa70$var$top);
        $9aa80ed9c9a8fa70$var$top = 0;
    }
    $9aa80ed9c9a8fa70$var$free.push(this._pointer);
};
function $9aa80ed9c9a8fa70$var$Fallback(nonce, key) {
    this._s = new Uint8Array(32);
    this._z = new Uint8Array(16);
    this._overflow = 0;
    $9aa80ed9c9a8fa70$var$core_hsalsa20(this._s, nonce, key, $9aa80ed9c9a8fa70$var$SIGMA);
    for(var i = 0; i < 8; i++)this._z[i] = nonce[i + 16];
}
$9aa80ed9c9a8fa70$var$Fallback.prototype.update = function(input, output) {
    var x = new Uint8Array(64);
    var u = 0;
    var i = this._overflow;
    var b = input.length + this._overflow;
    var z = this._z;
    var mpos = -this._overflow;
    var cpos = -this._overflow;
    while(b >= 64){
        $9aa80ed9c9a8fa70$var$core_salsa20(x, z, this._s, $9aa80ed9c9a8fa70$var$SIGMA);
        for(; i < 64; i++)output[cpos + i] = input[mpos + i] ^ x[i];
        u = 1;
        for(i = 8; i < 16; i++){
            u += z[i] & 0xff | 0;
            z[i] = u & 0xff;
            u >>>= 8;
        }
        b -= 64;
        cpos += 64;
        mpos += 64;
        i = 0;
    }
    if (b > 0) {
        $9aa80ed9c9a8fa70$var$core_salsa20(x, z, this._s, $9aa80ed9c9a8fa70$var$SIGMA);
        for(; i < b; i++)output[cpos + i] = input[mpos + i] ^ x[i];
    }
    this._overflow = b & 63;
};
$9aa80ed9c9a8fa70$var$Fallback.prototype.finalize = function() {
    this._s.fill(0);
    this._z.fill(0);
};
// below methods are ported from tweet nacl
function $9aa80ed9c9a8fa70$var$core_salsa20(o, p, k, c) {
    var j0 = c[0] & 0xff | (c[1] & 0xff) << 8 | (c[2] & 0xff) << 16 | (c[3] & 0xff) << 24, j1 = k[0] & 0xff | (k[1] & 0xff) << 8 | (k[2] & 0xff) << 16 | (k[3] & 0xff) << 24, j2 = k[4] & 0xff | (k[5] & 0xff) << 8 | (k[6] & 0xff) << 16 | (k[7] & 0xff) << 24, j3 = k[8] & 0xff | (k[9] & 0xff) << 8 | (k[10] & 0xff) << 16 | (k[11] & 0xff) << 24, j4 = k[12] & 0xff | (k[13] & 0xff) << 8 | (k[14] & 0xff) << 16 | (k[15] & 0xff) << 24, j5 = c[4] & 0xff | (c[5] & 0xff) << 8 | (c[6] & 0xff) << 16 | (c[7] & 0xff) << 24, j6 = p[0] & 0xff | (p[1] & 0xff) << 8 | (p[2] & 0xff) << 16 | (p[3] & 0xff) << 24, j7 = p[4] & 0xff | (p[5] & 0xff) << 8 | (p[6] & 0xff) << 16 | (p[7] & 0xff) << 24, j8 = p[8] & 0xff | (p[9] & 0xff) << 8 | (p[10] & 0xff) << 16 | (p[11] & 0xff) << 24, j9 = p[12] & 0xff | (p[13] & 0xff) << 8 | (p[14] & 0xff) << 16 | (p[15] & 0xff) << 24, j10 = c[8] & 0xff | (c[9] & 0xff) << 8 | (c[10] & 0xff) << 16 | (c[11] & 0xff) << 24, j11 = k[16] & 0xff | (k[17] & 0xff) << 8 | (k[18] & 0xff) << 16 | (k[19] & 0xff) << 24, j12 = k[20] & 0xff | (k[21] & 0xff) << 8 | (k[22] & 0xff) << 16 | (k[23] & 0xff) << 24, j13 = k[24] & 0xff | (k[25] & 0xff) << 8 | (k[26] & 0xff) << 16 | (k[27] & 0xff) << 24, j14 = k[28] & 0xff | (k[29] & 0xff) << 8 | (k[30] & 0xff) << 16 | (k[31] & 0xff) << 24, j15 = c[12] & 0xff | (c[13] & 0xff) << 8 | (c[14] & 0xff) << 16 | (c[15] & 0xff) << 24;
    var x0 = j0, x1 = j1, x2 = j2, x3 = j3, x4 = j4, x5 = j5, x6 = j6, x7 = j7, x8 = j8, x9 = j9, x10 = j10, x11 = j11, x12 = j12, x13 = j13, x14 = j14, x15 = j15, u;
    for(var i = 0; i < 20; i += 2){
        u = x0 + x12 | 0;
        x4 ^= u << 7 | u >>> 25;
        u = x4 + x0 | 0;
        x8 ^= u << 9 | u >>> 23;
        u = x8 + x4 | 0;
        x12 ^= u << 13 | u >>> 19;
        u = x12 + x8 | 0;
        x0 ^= u << 18 | u >>> 14;
        u = x5 + x1 | 0;
        x9 ^= u << 7 | u >>> 25;
        u = x9 + x5 | 0;
        x13 ^= u << 9 | u >>> 23;
        u = x13 + x9 | 0;
        x1 ^= u << 13 | u >>> 19;
        u = x1 + x13 | 0;
        x5 ^= u << 18 | u >>> 14;
        u = x10 + x6 | 0;
        x14 ^= u << 7 | u >>> 25;
        u = x14 + x10 | 0;
        x2 ^= u << 9 | u >>> 23;
        u = x2 + x14 | 0;
        x6 ^= u << 13 | u >>> 19;
        u = x6 + x2 | 0;
        x10 ^= u << 18 | u >>> 14;
        u = x15 + x11 | 0;
        x3 ^= u << 7 | u >>> 25;
        u = x3 + x15 | 0;
        x7 ^= u << 9 | u >>> 23;
        u = x7 + x3 | 0;
        x11 ^= u << 13 | u >>> 19;
        u = x11 + x7 | 0;
        x15 ^= u << 18 | u >>> 14;
        u = x0 + x3 | 0;
        x1 ^= u << 7 | u >>> 25;
        u = x1 + x0 | 0;
        x2 ^= u << 9 | u >>> 23;
        u = x2 + x1 | 0;
        x3 ^= u << 13 | u >>> 19;
        u = x3 + x2 | 0;
        x0 ^= u << 18 | u >>> 14;
        u = x5 + x4 | 0;
        x6 ^= u << 7 | u >>> 25;
        u = x6 + x5 | 0;
        x7 ^= u << 9 | u >>> 23;
        u = x7 + x6 | 0;
        x4 ^= u << 13 | u >>> 19;
        u = x4 + x7 | 0;
        x5 ^= u << 18 | u >>> 14;
        u = x10 + x9 | 0;
        x11 ^= u << 7 | u >>> 25;
        u = x11 + x10 | 0;
        x8 ^= u << 9 | u >>> 23;
        u = x8 + x11 | 0;
        x9 ^= u << 13 | u >>> 19;
        u = x9 + x8 | 0;
        x10 ^= u << 18 | u >>> 14;
        u = x15 + x14 | 0;
        x12 ^= u << 7 | u >>> 25;
        u = x12 + x15 | 0;
        x13 ^= u << 9 | u >>> 23;
        u = x13 + x12 | 0;
        x14 ^= u << 13 | u >>> 19;
        u = x14 + x13 | 0;
        x15 ^= u << 18 | u >>> 14;
    }
    x0 = x0 + j0 | 0;
    x1 = x1 + j1 | 0;
    x2 = x2 + j2 | 0;
    x3 = x3 + j3 | 0;
    x4 = x4 + j4 | 0;
    x5 = x5 + j5 | 0;
    x6 = x6 + j6 | 0;
    x7 = x7 + j7 | 0;
    x8 = x8 + j8 | 0;
    x9 = x9 + j9 | 0;
    x10 = x10 + j10 | 0;
    x11 = x11 + j11 | 0;
    x12 = x12 + j12 | 0;
    x13 = x13 + j13 | 0;
    x14 = x14 + j14 | 0;
    x15 = x15 + j15 | 0;
    o[0] = x0 >>> 0 & 0xff;
    o[1] = x0 >>> 8 & 0xff;
    o[2] = x0 >>> 16 & 0xff;
    o[3] = x0 >>> 24 & 0xff;
    o[4] = x1 >>> 0 & 0xff;
    o[5] = x1 >>> 8 & 0xff;
    o[6] = x1 >>> 16 & 0xff;
    o[7] = x1 >>> 24 & 0xff;
    o[8] = x2 >>> 0 & 0xff;
    o[9] = x2 >>> 8 & 0xff;
    o[10] = x2 >>> 16 & 0xff;
    o[11] = x2 >>> 24 & 0xff;
    o[12] = x3 >>> 0 & 0xff;
    o[13] = x3 >>> 8 & 0xff;
    o[14] = x3 >>> 16 & 0xff;
    o[15] = x3 >>> 24 & 0xff;
    o[16] = x4 >>> 0 & 0xff;
    o[17] = x4 >>> 8 & 0xff;
    o[18] = x4 >>> 16 & 0xff;
    o[19] = x4 >>> 24 & 0xff;
    o[20] = x5 >>> 0 & 0xff;
    o[21] = x5 >>> 8 & 0xff;
    o[22] = x5 >>> 16 & 0xff;
    o[23] = x5 >>> 24 & 0xff;
    o[24] = x6 >>> 0 & 0xff;
    o[25] = x6 >>> 8 & 0xff;
    o[26] = x6 >>> 16 & 0xff;
    o[27] = x6 >>> 24 & 0xff;
    o[28] = x7 >>> 0 & 0xff;
    o[29] = x7 >>> 8 & 0xff;
    o[30] = x7 >>> 16 & 0xff;
    o[31] = x7 >>> 24 & 0xff;
    o[32] = x8 >>> 0 & 0xff;
    o[33] = x8 >>> 8 & 0xff;
    o[34] = x8 >>> 16 & 0xff;
    o[35] = x8 >>> 24 & 0xff;
    o[36] = x9 >>> 0 & 0xff;
    o[37] = x9 >>> 8 & 0xff;
    o[38] = x9 >>> 16 & 0xff;
    o[39] = x9 >>> 24 & 0xff;
    o[40] = x10 >>> 0 & 0xff;
    o[41] = x10 >>> 8 & 0xff;
    o[42] = x10 >>> 16 & 0xff;
    o[43] = x10 >>> 24 & 0xff;
    o[44] = x11 >>> 0 & 0xff;
    o[45] = x11 >>> 8 & 0xff;
    o[46] = x11 >>> 16 & 0xff;
    o[47] = x11 >>> 24 & 0xff;
    o[48] = x12 >>> 0 & 0xff;
    o[49] = x12 >>> 8 & 0xff;
    o[50] = x12 >>> 16 & 0xff;
    o[51] = x12 >>> 24 & 0xff;
    o[52] = x13 >>> 0 & 0xff;
    o[53] = x13 >>> 8 & 0xff;
    o[54] = x13 >>> 16 & 0xff;
    o[55] = x13 >>> 24 & 0xff;
    o[56] = x14 >>> 0 & 0xff;
    o[57] = x14 >>> 8 & 0xff;
    o[58] = x14 >>> 16 & 0xff;
    o[59] = x14 >>> 24 & 0xff;
    o[60] = x15 >>> 0 & 0xff;
    o[61] = x15 >>> 8 & 0xff;
    o[62] = x15 >>> 16 & 0xff;
    o[63] = x15 >>> 24 & 0xff;
}
function $9aa80ed9c9a8fa70$var$core_hsalsa20(o, p, k, c) {
    var j0 = c[0] & 0xff | (c[1] & 0xff) << 8 | (c[2] & 0xff) << 16 | (c[3] & 0xff) << 24, j1 = k[0] & 0xff | (k[1] & 0xff) << 8 | (k[2] & 0xff) << 16 | (k[3] & 0xff) << 24, j2 = k[4] & 0xff | (k[5] & 0xff) << 8 | (k[6] & 0xff) << 16 | (k[7] & 0xff) << 24, j3 = k[8] & 0xff | (k[9] & 0xff) << 8 | (k[10] & 0xff) << 16 | (k[11] & 0xff) << 24, j4 = k[12] & 0xff | (k[13] & 0xff) << 8 | (k[14] & 0xff) << 16 | (k[15] & 0xff) << 24, j5 = c[4] & 0xff | (c[5] & 0xff) << 8 | (c[6] & 0xff) << 16 | (c[7] & 0xff) << 24, j6 = p[0] & 0xff | (p[1] & 0xff) << 8 | (p[2] & 0xff) << 16 | (p[3] & 0xff) << 24, j7 = p[4] & 0xff | (p[5] & 0xff) << 8 | (p[6] & 0xff) << 16 | (p[7] & 0xff) << 24, j8 = p[8] & 0xff | (p[9] & 0xff) << 8 | (p[10] & 0xff) << 16 | (p[11] & 0xff) << 24, j9 = p[12] & 0xff | (p[13] & 0xff) << 8 | (p[14] & 0xff) << 16 | (p[15] & 0xff) << 24, j10 = c[8] & 0xff | (c[9] & 0xff) << 8 | (c[10] & 0xff) << 16 | (c[11] & 0xff) << 24, j11 = k[16] & 0xff | (k[17] & 0xff) << 8 | (k[18] & 0xff) << 16 | (k[19] & 0xff) << 24, j12 = k[20] & 0xff | (k[21] & 0xff) << 8 | (k[22] & 0xff) << 16 | (k[23] & 0xff) << 24, j13 = k[24] & 0xff | (k[25] & 0xff) << 8 | (k[26] & 0xff) << 16 | (k[27] & 0xff) << 24, j14 = k[28] & 0xff | (k[29] & 0xff) << 8 | (k[30] & 0xff) << 16 | (k[31] & 0xff) << 24, j15 = c[12] & 0xff | (c[13] & 0xff) << 8 | (c[14] & 0xff) << 16 | (c[15] & 0xff) << 24;
    var x0 = j0, x1 = j1, x2 = j2, x3 = j3, x4 = j4, x5 = j5, x6 = j6, x7 = j7, x8 = j8, x9 = j9, x10 = j10, x11 = j11, x12 = j12, x13 = j13, x14 = j14, x15 = j15, u;
    for(var i = 0; i < 20; i += 2){
        u = x0 + x12 | 0;
        x4 ^= u << 7 | u >>> 25;
        u = x4 + x0 | 0;
        x8 ^= u << 9 | u >>> 23;
        u = x8 + x4 | 0;
        x12 ^= u << 13 | u >>> 19;
        u = x12 + x8 | 0;
        x0 ^= u << 18 | u >>> 14;
        u = x5 + x1 | 0;
        x9 ^= u << 7 | u >>> 25;
        u = x9 + x5 | 0;
        x13 ^= u << 9 | u >>> 23;
        u = x13 + x9 | 0;
        x1 ^= u << 13 | u >>> 19;
        u = x1 + x13 | 0;
        x5 ^= u << 18 | u >>> 14;
        u = x10 + x6 | 0;
        x14 ^= u << 7 | u >>> 25;
        u = x14 + x10 | 0;
        x2 ^= u << 9 | u >>> 23;
        u = x2 + x14 | 0;
        x6 ^= u << 13 | u >>> 19;
        u = x6 + x2 | 0;
        x10 ^= u << 18 | u >>> 14;
        u = x15 + x11 | 0;
        x3 ^= u << 7 | u >>> 25;
        u = x3 + x15 | 0;
        x7 ^= u << 9 | u >>> 23;
        u = x7 + x3 | 0;
        x11 ^= u << 13 | u >>> 19;
        u = x11 + x7 | 0;
        x15 ^= u << 18 | u >>> 14;
        u = x0 + x3 | 0;
        x1 ^= u << 7 | u >>> 25;
        u = x1 + x0 | 0;
        x2 ^= u << 9 | u >>> 23;
        u = x2 + x1 | 0;
        x3 ^= u << 13 | u >>> 19;
        u = x3 + x2 | 0;
        x0 ^= u << 18 | u >>> 14;
        u = x5 + x4 | 0;
        x6 ^= u << 7 | u >>> 25;
        u = x6 + x5 | 0;
        x7 ^= u << 9 | u >>> 23;
        u = x7 + x6 | 0;
        x4 ^= u << 13 | u >>> 19;
        u = x4 + x7 | 0;
        x5 ^= u << 18 | u >>> 14;
        u = x10 + x9 | 0;
        x11 ^= u << 7 | u >>> 25;
        u = x11 + x10 | 0;
        x8 ^= u << 9 | u >>> 23;
        u = x8 + x11 | 0;
        x9 ^= u << 13 | u >>> 19;
        u = x9 + x8 | 0;
        x10 ^= u << 18 | u >>> 14;
        u = x15 + x14 | 0;
        x12 ^= u << 7 | u >>> 25;
        u = x12 + x15 | 0;
        x13 ^= u << 9 | u >>> 23;
        u = x13 + x12 | 0;
        x14 ^= u << 13 | u >>> 19;
        u = x14 + x13 | 0;
        x15 ^= u << 18 | u >>> 14;
    }
    o[0] = x0 >>> 0 & 0xff;
    o[1] = x0 >>> 8 & 0xff;
    o[2] = x0 >>> 16 & 0xff;
    o[3] = x0 >>> 24 & 0xff;
    o[4] = x5 >>> 0 & 0xff;
    o[5] = x5 >>> 8 & 0xff;
    o[6] = x5 >>> 16 & 0xff;
    o[7] = x5 >>> 24 & 0xff;
    o[8] = x10 >>> 0 & 0xff;
    o[9] = x10 >>> 8 & 0xff;
    o[10] = x10 >>> 16 & 0xff;
    o[11] = x10 >>> 24 & 0xff;
    o[12] = x15 >>> 0 & 0xff;
    o[13] = x15 >>> 8 & 0xff;
    o[14] = x15 >>> 16 & 0xff;
    o[15] = x15 >>> 24 & 0xff;
    o[16] = x6 >>> 0 & 0xff;
    o[17] = x6 >>> 8 & 0xff;
    o[18] = x6 >>> 16 & 0xff;
    o[19] = x6 >>> 24 & 0xff;
    o[20] = x7 >>> 0 & 0xff;
    o[21] = x7 >>> 8 & 0xff;
    o[22] = x7 >>> 16 & 0xff;
    o[23] = x7 >>> 24 & 0xff;
    o[24] = x8 >>> 0 & 0xff;
    o[25] = x8 >>> 8 & 0xff;
    o[26] = x8 >>> 16 & 0xff;
    o[27] = x8 >>> 24 & 0xff;
    o[28] = x9 >>> 0 & 0xff;
    o[29] = x9 >>> 8 & 0xff;
    o[30] = x9 >>> 16 & 0xff;
    o[31] = x9 >>> 24 & 0xff;
}

});
parcelRegister("6X24w", function(module, exports) {
var $50f9dc3570aabcde$var$__commonJS = (cb, mod)=>function __require() {
        return mod || (0, cb[Object.keys(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
var $50f9dc3570aabcde$var$__toBinary = /* @__PURE__ */ (()=>{
    var table = new Uint8Array(128);
    for(var i = 0; i < 64; i++)table[i < 26 ? i + 65 : i < 52 ? i + 71 : i < 62 ? i - 4 : i * 4 - 205] = i;
    return (base64)=>{
        var n = base64.length, bytes2 = new Uint8Array((n - (base64[n - 1] == "=") - (base64[n - 2] == "=")) * 3 / 4 | 0);
        for(var i2 = 0, j = 0; i2 < n;){
            var c0 = table[base64.charCodeAt(i2++)], c1 = table[base64.charCodeAt(i2++)];
            var c2 = table[base64.charCodeAt(i2++)], c3 = table[base64.charCodeAt(i2++)];
            bytes2[j++] = c0 << 2 | c1 >> 4;
            bytes2[j++] = c1 << 4 | c2 >> 2;
            bytes2[j++] = c2 << 6 | c3;
        }
        return bytes2;
    };
})();
// wasm-binary:./xsalsa20.wat
var $50f9dc3570aabcde$var$require_xsalsa20 = $50f9dc3570aabcde$var$__commonJS({
    "wasm-binary:./xsalsa20.wat" (exports2, module2) {
        module2.exports = $50f9dc3570aabcde$var$__toBinary("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");
    }
});
// wasm-module:./xsalsa20.wat
var $50f9dc3570aabcde$var$bytes = $50f9dc3570aabcde$var$require_xsalsa20();
var $50f9dc3570aabcde$var$compiled = new WebAssembly.Module($50f9dc3570aabcde$var$bytes);
module.exports = (imports)=>{
    const instance = new WebAssembly.Instance($50f9dc3570aabcde$var$compiled, imports);
    return instance.exports;
};

});



parcelRegister("80TxX", function(module, exports) {
/* eslint-disable camelcase */ 
var $6JSie = parcelRequire("6JSie");

var $63ApX = parcelRequire("63ApX");
var $5d596936e9d1c11e$require$crypto_stream = $63ApX.crypto_stream;
var $5d596936e9d1c11e$require$crypto_stream_xor = $63ApX.crypto_stream_xor;

var $hCFud = parcelRequire("hCFud");
var $5d596936e9d1c11e$require$crypto_onetimeauth = $hCFud.crypto_onetimeauth;
var $5d596936e9d1c11e$require$crypto_onetimeauth_verify = $hCFud.crypto_onetimeauth_verify;
var $5d596936e9d1c11e$require$crypto_onetimeauth_BYTES = $hCFud.crypto_onetimeauth_BYTES;
var $5d596936e9d1c11e$require$crypto_onetimeauth_KEYBYTES = $hCFud.crypto_onetimeauth_KEYBYTES;
const $5d596936e9d1c11e$var$crypto_secretbox_KEYBYTES = 32;
const $5d596936e9d1c11e$var$crypto_secretbox_NONCEBYTES = 24;
const $5d596936e9d1c11e$var$crypto_secretbox_ZEROBYTES = 32;
const $5d596936e9d1c11e$var$crypto_secretbox_BOXZEROBYTES = 16;
const $5d596936e9d1c11e$var$crypto_secretbox_MACBYTES = 16;
module.exports = {
    crypto_secretbox: $5d596936e9d1c11e$var$crypto_secretbox,
    crypto_secretbox_open: $5d596936e9d1c11e$var$crypto_secretbox_open,
    crypto_secretbox_detached: $5d596936e9d1c11e$var$crypto_secretbox_detached,
    crypto_secretbox_open_detached: $5d596936e9d1c11e$var$crypto_secretbox_open_detached,
    crypto_secretbox_easy: $5d596936e9d1c11e$var$crypto_secretbox_easy,
    crypto_secretbox_open_easy: $5d596936e9d1c11e$var$crypto_secretbox_open_easy,
    crypto_secretbox_KEYBYTES: $5d596936e9d1c11e$var$crypto_secretbox_KEYBYTES,
    crypto_secretbox_NONCEBYTES: $5d596936e9d1c11e$var$crypto_secretbox_NONCEBYTES,
    crypto_secretbox_ZEROBYTES: $5d596936e9d1c11e$var$crypto_secretbox_ZEROBYTES,
    crypto_secretbox_BOXZEROBYTES: $5d596936e9d1c11e$var$crypto_secretbox_BOXZEROBYTES,
    crypto_secretbox_MACBYTES: $5d596936e9d1c11e$var$crypto_secretbox_MACBYTES
};
function $5d596936e9d1c11e$var$crypto_secretbox(c, m, n, k) {
    $6JSie(c.byteLength === m.byteLength, "c must be 'm.byteLength' bytes");
    const mlen = m.byteLength;
    $6JSie(mlen >= $5d596936e9d1c11e$var$crypto_secretbox_ZEROBYTES, "mlen must be at least 'crypto_secretbox_ZEROBYTES'");
    $6JSie(n.byteLength === $5d596936e9d1c11e$var$crypto_secretbox_NONCEBYTES, "n must be 'crypto_secretbox_NONCEBYTES' bytes");
    $6JSie(k.byteLength === $5d596936e9d1c11e$var$crypto_secretbox_KEYBYTES, "k must be 'crypto_secretbox_KEYBYTES' bytes");
    $5d596936e9d1c11e$require$crypto_stream_xor(c, m, n, k);
    $5d596936e9d1c11e$require$crypto_onetimeauth(c.subarray($5d596936e9d1c11e$var$crypto_secretbox_BOXZEROBYTES, $5d596936e9d1c11e$var$crypto_secretbox_BOXZEROBYTES + $5d596936e9d1c11e$require$crypto_onetimeauth_BYTES), c.subarray($5d596936e9d1c11e$var$crypto_secretbox_BOXZEROBYTES + $5d596936e9d1c11e$require$crypto_onetimeauth_BYTES, c.byteLength), c.subarray(0, $5d596936e9d1c11e$require$crypto_onetimeauth_KEYBYTES));
    c.fill(0, 0, $5d596936e9d1c11e$var$crypto_secretbox_BOXZEROBYTES);
}
function $5d596936e9d1c11e$var$crypto_secretbox_open(m, c, n, k) {
    $6JSie(c.byteLength === m.byteLength, "c must be 'm.byteLength' bytes");
    const mlen = m.byteLength;
    $6JSie(mlen >= $5d596936e9d1c11e$var$crypto_secretbox_ZEROBYTES, "mlen must be at least 'crypto_secretbox_ZEROBYTES'");
    $6JSie(n.byteLength === $5d596936e9d1c11e$var$crypto_secretbox_NONCEBYTES, "n must be 'crypto_secretbox_NONCEBYTES' bytes");
    $6JSie(k.byteLength === $5d596936e9d1c11e$var$crypto_secretbox_KEYBYTES, "k must be 'crypto_secretbox_KEYBYTES' bytes");
    const x = new Uint8Array($5d596936e9d1c11e$require$crypto_onetimeauth_KEYBYTES);
    $5d596936e9d1c11e$require$crypto_stream(x, n, k);
    const validMac = $5d596936e9d1c11e$require$crypto_onetimeauth_verify(c.subarray($5d596936e9d1c11e$var$crypto_secretbox_BOXZEROBYTES, $5d596936e9d1c11e$var$crypto_secretbox_BOXZEROBYTES + $5d596936e9d1c11e$require$crypto_onetimeauth_BYTES), c.subarray($5d596936e9d1c11e$var$crypto_secretbox_BOXZEROBYTES + $5d596936e9d1c11e$require$crypto_onetimeauth_BYTES, c.byteLength), x);
    if (validMac === false) return false;
    $5d596936e9d1c11e$require$crypto_stream_xor(m, c, n, k);
    m.fill(0, 0, 32);
    return true;
}
function $5d596936e9d1c11e$var$crypto_secretbox_detached(o, mac, msg, n, k) {
    $6JSie(o.byteLength === msg.byteLength, "o must be 'msg.byteLength' bytes");
    $6JSie(mac.byteLength === $5d596936e9d1c11e$var$crypto_secretbox_MACBYTES, "mac must be 'crypto_secretbox_MACBYTES' bytes");
    $6JSie(n.byteLength === $5d596936e9d1c11e$var$crypto_secretbox_NONCEBYTES, "n must be 'crypto_secretbox_NONCEBYTES' bytes");
    $6JSie(k.byteLength === $5d596936e9d1c11e$var$crypto_secretbox_KEYBYTES, "k must be 'crypto_secretbox_KEYBYTES' bytes");
    const tmp = new Uint8Array(msg.byteLength + mac.byteLength);
    $5d596936e9d1c11e$var$crypto_secretbox_easy(tmp, msg, n, k);
    mac.set(tmp.subarray(0, mac.byteLength));
    o.set(tmp.subarray(mac.byteLength));
    return true;
}
function $5d596936e9d1c11e$var$crypto_secretbox_open_detached(msg, o, mac, n, k) {
    $6JSie(o.byteLength === msg.byteLength, "o must be 'msg.byteLength' bytes");
    $6JSie(mac.byteLength === $5d596936e9d1c11e$var$crypto_secretbox_MACBYTES, "mac must be 'crypto_secretbox_MACBYTES' bytes");
    $6JSie(n.byteLength === $5d596936e9d1c11e$var$crypto_secretbox_NONCEBYTES, "n must be 'crypto_secretbox_NONCEBYTES' bytes");
    $6JSie(k.byteLength === $5d596936e9d1c11e$var$crypto_secretbox_KEYBYTES, "k must be 'crypto_secretbox_KEYBYTES' bytes");
    const tmp = new Uint8Array(o.byteLength + mac.byteLength);
    tmp.set(mac);
    tmp.set(o, mac.byteLength);
    return $5d596936e9d1c11e$var$crypto_secretbox_open_easy(msg, tmp, n, k);
}
function $5d596936e9d1c11e$var$crypto_secretbox_easy(o, msg, n, k) {
    $6JSie(o.byteLength === msg.byteLength + $5d596936e9d1c11e$var$crypto_secretbox_MACBYTES, "o must be 'msg.byteLength + crypto_secretbox_MACBYTES' bytes");
    $6JSie(n.byteLength === $5d596936e9d1c11e$var$crypto_secretbox_NONCEBYTES, "n must be 'crypto_secretbox_NONCEBYTES' bytes");
    $6JSie(k.byteLength === $5d596936e9d1c11e$var$crypto_secretbox_KEYBYTES, "k must be 'crypto_secretbox_KEYBYTES' bytes");
    const m = new Uint8Array($5d596936e9d1c11e$var$crypto_secretbox_ZEROBYTES + msg.byteLength);
    const c = new Uint8Array(m.byteLength);
    m.set(msg, $5d596936e9d1c11e$var$crypto_secretbox_ZEROBYTES);
    $5d596936e9d1c11e$var$crypto_secretbox(c, m, n, k);
    o.set(c.subarray($5d596936e9d1c11e$var$crypto_secretbox_BOXZEROBYTES));
}
function $5d596936e9d1c11e$var$crypto_secretbox_open_easy(msg, box, n, k) {
    $6JSie(box.byteLength === msg.byteLength + $5d596936e9d1c11e$var$crypto_secretbox_MACBYTES, "box must be 'msg.byteLength + crypto_secretbox_MACBYTES' bytes");
    $6JSie(n.byteLength === $5d596936e9d1c11e$var$crypto_secretbox_NONCEBYTES, "n must be 'crypto_secretbox_NONCEBYTES' bytes");
    $6JSie(k.byteLength === $5d596936e9d1c11e$var$crypto_secretbox_KEYBYTES, "k must be 'crypto_secretbox_KEYBYTES' bytes");
    const c = new Uint8Array($5d596936e9d1c11e$var$crypto_secretbox_BOXZEROBYTES + box.byteLength);
    const m = new Uint8Array(c.byteLength);
    c.set(box, $5d596936e9d1c11e$var$crypto_secretbox_BOXZEROBYTES);
    if ($5d596936e9d1c11e$var$crypto_secretbox_open(m, c, n, k) === false) return false;
    msg.set(m.subarray($5d596936e9d1c11e$var$crypto_secretbox_ZEROBYTES));
    return true;
}

});
parcelRegister("hCFud", function(module, exports) {
/* eslint-disable camelcase */ 
var $6JSie = parcelRequire("6JSie");

var $hbqU7 = parcelRequire("hbqU7");

var $7wznJ = parcelRequire("7wznJ");
var $cd462a93e306e7d0$require$crypto_verify_16 = $7wznJ.crypto_verify_16;
const $cd462a93e306e7d0$var$crypto_onetimeauth_BYTES = 16;
const $cd462a93e306e7d0$var$crypto_onetimeauth_KEYBYTES = 32;
const $cd462a93e306e7d0$var$crypto_onetimeauth_PRIMITIVE = "poly1305";
module.exports = {
    crypto_onetimeauth: $cd462a93e306e7d0$var$crypto_onetimeauth,
    crypto_onetimeauth_verify: $cd462a93e306e7d0$var$crypto_onetimeauth_verify,
    crypto_onetimeauth_BYTES: $cd462a93e306e7d0$var$crypto_onetimeauth_BYTES,
    crypto_onetimeauth_KEYBYTES: $cd462a93e306e7d0$var$crypto_onetimeauth_KEYBYTES,
    crypto_onetimeauth_PRIMITIVE: $cd462a93e306e7d0$var$crypto_onetimeauth_PRIMITIVE
};
function $cd462a93e306e7d0$var$crypto_onetimeauth(mac, msg, key) {
    $6JSie(mac.byteLength === $cd462a93e306e7d0$var$crypto_onetimeauth_BYTES, "mac must be 'crypto_onetimeauth_BYTES' bytes");
    $6JSie(msg.byteLength != null, "msg must be buffer");
    $6JSie(key.byteLength === $cd462a93e306e7d0$var$crypto_onetimeauth_KEYBYTES, "key must be 'crypto_onetimeauth_KEYBYTES' bytes");
    var s = new $hbqU7(key);
    s.update(msg, 0, msg.byteLength);
    s.finish(mac, 0);
}
function $cd462a93e306e7d0$var$crypto_onetimeauth_verify(mac, msg, key) {
    $6JSie(mac.byteLength === $cd462a93e306e7d0$var$crypto_onetimeauth_BYTES, "mac must be 'crypto_onetimeauth_BYTES' bytes");
    $6JSie(msg.byteLength != null, "msg must be buffer");
    $6JSie(key.byteLength === $cd462a93e306e7d0$var$crypto_onetimeauth_KEYBYTES, "key must be 'crypto_onetimeauth_KEYBYTES' bytes");
    var tmp = new Uint8Array(16);
    $cd462a93e306e7d0$var$crypto_onetimeauth(tmp, msg, key);
    return $cd462a93e306e7d0$require$crypto_verify_16(mac, 0, tmp, 0);
}

});
parcelRegister("hbqU7", function(module, exports) {
/*
* Port of Andrew Moon's Poly1305-donna-16. Public domain.
* https://github.com/floodyberry/poly1305-donna
*/ if (new Uint16Array([
    1
])[0] !== 1) throw new Error("Big endian architecture is not supported.");
var $c828555fec53e656$var$poly1305 = function(key) {
    this.buffer = new Uint8Array(16);
    this.r = new Uint16Array(10);
    this.h = new Uint16Array(10);
    this.pad = new Uint16Array(8);
    this.leftover = 0;
    this.fin = 0;
    var t0, t1, t2, t3, t4, t5, t6, t7;
    t0 = key[0] & 0xff | (key[1] & 0xff) << 8;
    this.r[0] = t0 & 0x1fff;
    t1 = key[2] & 0xff | (key[3] & 0xff) << 8;
    this.r[1] = (t0 >>> 13 | t1 << 3) & 0x1fff;
    t2 = key[4] & 0xff | (key[5] & 0xff) << 8;
    this.r[2] = (t1 >>> 10 | t2 << 6) & 0x1f03;
    t3 = key[6] & 0xff | (key[7] & 0xff) << 8;
    this.r[3] = (t2 >>> 7 | t3 << 9) & 0x1fff;
    t4 = key[8] & 0xff | (key[9] & 0xff) << 8;
    this.r[4] = (t3 >>> 4 | t4 << 12) & 0x00ff;
    this.r[5] = t4 >>> 1 & 0x1ffe;
    t5 = key[10] & 0xff | (key[11] & 0xff) << 8;
    this.r[6] = (t4 >>> 14 | t5 << 2) & 0x1fff;
    t6 = key[12] & 0xff | (key[13] & 0xff) << 8;
    this.r[7] = (t5 >>> 11 | t6 << 5) & 0x1f81;
    t7 = key[14] & 0xff | (key[15] & 0xff) << 8;
    this.r[8] = (t6 >>> 8 | t7 << 8) & 0x1fff;
    this.r[9] = t7 >>> 5 & 0x007f;
    this.pad[0] = key[16] & 0xff | (key[17] & 0xff) << 8;
    this.pad[1] = key[18] & 0xff | (key[19] & 0xff) << 8;
    this.pad[2] = key[20] & 0xff | (key[21] & 0xff) << 8;
    this.pad[3] = key[22] & 0xff | (key[23] & 0xff) << 8;
    this.pad[4] = key[24] & 0xff | (key[25] & 0xff) << 8;
    this.pad[5] = key[26] & 0xff | (key[27] & 0xff) << 8;
    this.pad[6] = key[28] & 0xff | (key[29] & 0xff) << 8;
    this.pad[7] = key[30] & 0xff | (key[31] & 0xff) << 8;
};
$c828555fec53e656$var$poly1305.prototype.blocks = function(m, mpos, bytes) {
    var hibit = this.fin ? 0 : 2048;
    var t0, t1, t2, t3, t4, t5, t6, t7, c;
    var d0, d1, d2, d3, d4, d5, d6, d7, d8, d9;
    var h0 = this.h[0], h1 = this.h[1], h2 = this.h[2], h3 = this.h[3], h4 = this.h[4], h5 = this.h[5], h6 = this.h[6], h7 = this.h[7], h8 = this.h[8], h9 = this.h[9];
    var r0 = this.r[0], r1 = this.r[1], r2 = this.r[2], r3 = this.r[3], r4 = this.r[4], r5 = this.r[5], r6 = this.r[6], r7 = this.r[7], r8 = this.r[8], r9 = this.r[9];
    while(bytes >= 16){
        t0 = m[mpos + 0] & 0xff | (m[mpos + 1] & 0xff) << 8;
        h0 += t0 & 0x1fff;
        t1 = m[mpos + 2] & 0xff | (m[mpos + 3] & 0xff) << 8;
        h1 += (t0 >>> 13 | t1 << 3) & 0x1fff;
        t2 = m[mpos + 4] & 0xff | (m[mpos + 5] & 0xff) << 8;
        h2 += (t1 >>> 10 | t2 << 6) & 0x1fff;
        t3 = m[mpos + 6] & 0xff | (m[mpos + 7] & 0xff) << 8;
        h3 += (t2 >>> 7 | t3 << 9) & 0x1fff;
        t4 = m[mpos + 8] & 0xff | (m[mpos + 9] & 0xff) << 8;
        h4 += (t3 >>> 4 | t4 << 12) & 0x1fff;
        h5 += t4 >>> 1 & 0x1fff;
        t5 = m[mpos + 10] & 0xff | (m[mpos + 11] & 0xff) << 8;
        h6 += (t4 >>> 14 | t5 << 2) & 0x1fff;
        t6 = m[mpos + 12] & 0xff | (m[mpos + 13] & 0xff) << 8;
        h7 += (t5 >>> 11 | t6 << 5) & 0x1fff;
        t7 = m[mpos + 14] & 0xff | (m[mpos + 15] & 0xff) << 8;
        h8 += (t6 >>> 8 | t7 << 8) & 0x1fff;
        h9 += t7 >>> 5 | hibit;
        c = 0;
        d0 = c;
        d0 += h0 * r0;
        d0 += h1 * (5 * r9);
        d0 += h2 * (5 * r8);
        d0 += h3 * (5 * r7);
        d0 += h4 * (5 * r6);
        c = d0 >>> 13;
        d0 &= 0x1fff;
        d0 += h5 * (5 * r5);
        d0 += h6 * (5 * r4);
        d0 += h7 * (5 * r3);
        d0 += h8 * (5 * r2);
        d0 += h9 * (5 * r1);
        c += d0 >>> 13;
        d0 &= 0x1fff;
        d1 = c;
        d1 += h0 * r1;
        d1 += h1 * r0;
        d1 += h2 * (5 * r9);
        d1 += h3 * (5 * r8);
        d1 += h4 * (5 * r7);
        c = d1 >>> 13;
        d1 &= 0x1fff;
        d1 += h5 * (5 * r6);
        d1 += h6 * (5 * r5);
        d1 += h7 * (5 * r4);
        d1 += h8 * (5 * r3);
        d1 += h9 * (5 * r2);
        c += d1 >>> 13;
        d1 &= 0x1fff;
        d2 = c;
        d2 += h0 * r2;
        d2 += h1 * r1;
        d2 += h2 * r0;
        d2 += h3 * (5 * r9);
        d2 += h4 * (5 * r8);
        c = d2 >>> 13;
        d2 &= 0x1fff;
        d2 += h5 * (5 * r7);
        d2 += h6 * (5 * r6);
        d2 += h7 * (5 * r5);
        d2 += h8 * (5 * r4);
        d2 += h9 * (5 * r3);
        c += d2 >>> 13;
        d2 &= 0x1fff;
        d3 = c;
        d3 += h0 * r3;
        d3 += h1 * r2;
        d3 += h2 * r1;
        d3 += h3 * r0;
        d3 += h4 * (5 * r9);
        c = d3 >>> 13;
        d3 &= 0x1fff;
        d3 += h5 * (5 * r8);
        d3 += h6 * (5 * r7);
        d3 += h7 * (5 * r6);
        d3 += h8 * (5 * r5);
        d3 += h9 * (5 * r4);
        c += d3 >>> 13;
        d3 &= 0x1fff;
        d4 = c;
        d4 += h0 * r4;
        d4 += h1 * r3;
        d4 += h2 * r2;
        d4 += h3 * r1;
        d4 += h4 * r0;
        c = d4 >>> 13;
        d4 &= 0x1fff;
        d4 += h5 * (5 * r9);
        d4 += h6 * (5 * r8);
        d4 += h7 * (5 * r7);
        d4 += h8 * (5 * r6);
        d4 += h9 * (5 * r5);
        c += d4 >>> 13;
        d4 &= 0x1fff;
        d5 = c;
        d5 += h0 * r5;
        d5 += h1 * r4;
        d5 += h2 * r3;
        d5 += h3 * r2;
        d5 += h4 * r1;
        c = d5 >>> 13;
        d5 &= 0x1fff;
        d5 += h5 * r0;
        d5 += h6 * (5 * r9);
        d5 += h7 * (5 * r8);
        d5 += h8 * (5 * r7);
        d5 += h9 * (5 * r6);
        c += d5 >>> 13;
        d5 &= 0x1fff;
        d6 = c;
        d6 += h0 * r6;
        d6 += h1 * r5;
        d6 += h2 * r4;
        d6 += h3 * r3;
        d6 += h4 * r2;
        c = d6 >>> 13;
        d6 &= 0x1fff;
        d6 += h5 * r1;
        d6 += h6 * r0;
        d6 += h7 * (5 * r9);
        d6 += h8 * (5 * r8);
        d6 += h9 * (5 * r7);
        c += d6 >>> 13;
        d6 &= 0x1fff;
        d7 = c;
        d7 += h0 * r7;
        d7 += h1 * r6;
        d7 += h2 * r5;
        d7 += h3 * r4;
        d7 += h4 * r3;
        c = d7 >>> 13;
        d7 &= 0x1fff;
        d7 += h5 * r2;
        d7 += h6 * r1;
        d7 += h7 * r0;
        d7 += h8 * (5 * r9);
        d7 += h9 * (5 * r8);
        c += d7 >>> 13;
        d7 &= 0x1fff;
        d8 = c;
        d8 += h0 * r8;
        d8 += h1 * r7;
        d8 += h2 * r6;
        d8 += h3 * r5;
        d8 += h4 * r4;
        c = d8 >>> 13;
        d8 &= 0x1fff;
        d8 += h5 * r3;
        d8 += h6 * r2;
        d8 += h7 * r1;
        d8 += h8 * r0;
        d8 += h9 * (5 * r9);
        c += d8 >>> 13;
        d8 &= 0x1fff;
        d9 = c;
        d9 += h0 * r9;
        d9 += h1 * r8;
        d9 += h2 * r7;
        d9 += h3 * r6;
        d9 += h4 * r5;
        c = d9 >>> 13;
        d9 &= 0x1fff;
        d9 += h5 * r4;
        d9 += h6 * r3;
        d9 += h7 * r2;
        d9 += h8 * r1;
        d9 += h9 * r0;
        c += d9 >>> 13;
        d9 &= 0x1fff;
        c = (c << 2) + c | 0;
        c = c + d0 | 0;
        d0 = c & 0x1fff;
        c = c >>> 13;
        d1 += c;
        h0 = d0;
        h1 = d1;
        h2 = d2;
        h3 = d3;
        h4 = d4;
        h5 = d5;
        h6 = d6;
        h7 = d7;
        h8 = d8;
        h9 = d9;
        mpos += 16;
        bytes -= 16;
    }
    this.h[0] = h0;
    this.h[1] = h1;
    this.h[2] = h2;
    this.h[3] = h3;
    this.h[4] = h4;
    this.h[5] = h5;
    this.h[6] = h6;
    this.h[7] = h7;
    this.h[8] = h8;
    this.h[9] = h9;
};
$c828555fec53e656$var$poly1305.prototype.finish = function(mac, macpos) {
    var g = new Uint16Array(10);
    var c, mask, f, i;
    if (this.leftover) {
        i = this.leftover;
        this.buffer[i++] = 1;
        for(; i < 16; i++)this.buffer[i] = 0;
        this.fin = 1;
        this.blocks(this.buffer, 0, 16);
    }
    c = this.h[1] >>> 13;
    this.h[1] &= 0x1fff;
    for(i = 2; i < 10; i++){
        this.h[i] += c;
        c = this.h[i] >>> 13;
        this.h[i] &= 0x1fff;
    }
    this.h[0] += c * 5;
    c = this.h[0] >>> 13;
    this.h[0] &= 0x1fff;
    this.h[1] += c;
    c = this.h[1] >>> 13;
    this.h[1] &= 0x1fff;
    this.h[2] += c;
    g[0] = this.h[0] + 5;
    c = g[0] >>> 13;
    g[0] &= 0x1fff;
    for(i = 1; i < 10; i++){
        g[i] = this.h[i] + c;
        c = g[i] >>> 13;
        g[i] &= 0x1fff;
    }
    g[9] -= 8192;
    mask = (c ^ 1) - 1;
    for(i = 0; i < 10; i++)g[i] &= mask;
    mask = ~mask;
    for(i = 0; i < 10; i++)this.h[i] = this.h[i] & mask | g[i];
    this.h[0] = (this.h[0] | this.h[1] << 13) & 0xffff;
    this.h[1] = (this.h[1] >>> 3 | this.h[2] << 10) & 0xffff;
    this.h[2] = (this.h[2] >>> 6 | this.h[3] << 7) & 0xffff;
    this.h[3] = (this.h[3] >>> 9 | this.h[4] << 4) & 0xffff;
    this.h[4] = (this.h[4] >>> 12 | this.h[5] << 1 | this.h[6] << 14) & 0xffff;
    this.h[5] = (this.h[6] >>> 2 | this.h[7] << 11) & 0xffff;
    this.h[6] = (this.h[7] >>> 5 | this.h[8] << 8) & 0xffff;
    this.h[7] = (this.h[8] >>> 8 | this.h[9] << 5) & 0xffff;
    f = this.h[0] + this.pad[0];
    this.h[0] = f & 0xffff;
    for(i = 1; i < 8; i++){
        f = (this.h[i] + this.pad[i] | 0) + (f >>> 16) | 0;
        this.h[i] = f & 0xffff;
    }
    mac[macpos + 0] = this.h[0] >>> 0 & 0xff;
    mac[macpos + 1] = this.h[0] >>> 8 & 0xff;
    mac[macpos + 2] = this.h[1] >>> 0 & 0xff;
    mac[macpos + 3] = this.h[1] >>> 8 & 0xff;
    mac[macpos + 4] = this.h[2] >>> 0 & 0xff;
    mac[macpos + 5] = this.h[2] >>> 8 & 0xff;
    mac[macpos + 6] = this.h[3] >>> 0 & 0xff;
    mac[macpos + 7] = this.h[3] >>> 8 & 0xff;
    mac[macpos + 8] = this.h[4] >>> 0 & 0xff;
    mac[macpos + 9] = this.h[4] >>> 8 & 0xff;
    mac[macpos + 10] = this.h[5] >>> 0 & 0xff;
    mac[macpos + 11] = this.h[5] >>> 8 & 0xff;
    mac[macpos + 12] = this.h[6] >>> 0 & 0xff;
    mac[macpos + 13] = this.h[6] >>> 8 & 0xff;
    mac[macpos + 14] = this.h[7] >>> 0 & 0xff;
    mac[macpos + 15] = this.h[7] >>> 8 & 0xff;
};
$c828555fec53e656$var$poly1305.prototype.update = function(m, mpos, bytes) {
    var i, want;
    if (this.leftover) {
        want = 16 - this.leftover;
        if (want > bytes) want = bytes;
        for(i = 0; i < want; i++)this.buffer[this.leftover + i] = m[mpos + i];
        bytes -= want;
        mpos += want;
        this.leftover += want;
        if (this.leftover < 16) return;
        this.blocks(this.buffer, 0, 16);
        this.leftover = 0;
    }
    if (bytes >= 16) {
        want = bytes - bytes % 16;
        this.blocks(m, mpos, want);
        mpos += want;
        bytes -= want;
    }
    if (bytes) {
        for(i = 0; i < bytes; i++)this.buffer[this.leftover + i] = m[mpos + i];
        this.leftover += bytes;
    }
};
module.exports = $c828555fec53e656$var$poly1305;

});




parcelRegister("47OGR", function(module, exports) {
/* eslint-disable camelcase */ 
var $1qnAx = parcelRequire("1qnAx");

var $6JSie = parcelRequire("6JSie");
if (new Uint16Array([
    1
])[0] !== 1) throw new Error("Big endian architecture is not supported.");
const $300f22ec6bacf4dd$var$crypto_hash_sha256_BYTES = 32;
function $300f22ec6bacf4dd$var$crypto_hash_sha256(out, m, n) {
    $6JSie(out.byteLength === $300f22ec6bacf4dd$var$crypto_hash_sha256_BYTES, "out must be 'crypto_hash_sha256_BYTES' bytes long");
    $1qnAx().update(m.subarray(0, n)).digest(out);
    return 0;
}
module.exports = {
    crypto_hash_sha256: $300f22ec6bacf4dd$var$crypto_hash_sha256,
    crypto_hash_sha256_BYTES: $300f22ec6bacf4dd$var$crypto_hash_sha256_BYTES
};

});
parcelRegister("1qnAx", function(module, exports) {

var $iYBSl = parcelRequire("iYBSl");

var $5sJoO = parcelRequire("5sJoO");
var $109a844f5c6b7ae3$var$Proto = $iYBSl;
module.exports = function() {
    return new $109a844f5c6b7ae3$var$Proto();
};
module.exports.ready = function(cb) {
    $5sJoO.ready(function() {
        cb();
    });
};
module.exports.WASM_SUPPORTED = $5sJoO.WASM_SUPPORTED;
module.exports.WASM_LOADED = false;
var $109a844f5c6b7ae3$var$SHA256_BYTES = module.exports.SHA256_BYTES = 32;
$5sJoO.ready(function(err) {
    if (!err) {
        module.exports.WASM_LOADED = true;
        module.exports = $109a844f5c6b7ae3$var$Proto = $5sJoO;
    }
});

});
parcelRegister("iYBSl", function(module, exports) {

var $6JSie = parcelRequire("6JSie");

var $hsTwZ = parcelRequire("hsTwZ");
module.exports = $dd0b35e0d9fd639f$var$Sha256;
const $dd0b35e0d9fd639f$var$SHA256_BYTES = module.exports.SHA256_BYTES = 32;
const $dd0b35e0d9fd639f$var$BLOCKSIZE = 64;
const $dd0b35e0d9fd639f$var$K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $dd0b35e0d9fd639f$var$expand(a, b, c, d) {
    var b_ = ((a >>> 17 | a << 15) ^ (a >>> 19 | a << 13) ^ a >>> 10) + b;
    var d_ = ((c >>> 7 | c << 25) ^ (c >>> 18 | c << 14) ^ c >>> 3) + d;
    return b_ + d_ << 0;
}
function $dd0b35e0d9fd639f$var$compress(state, words) {
    // initialise registers
    var ch, maj, s0, s1, T1, T2;
    var [a, b, c, d, e, f, g, h] = state;
    // expand message schedule
    const w = new Uint32Array(64);
    for(let i = 0; i < 16; i++)w[i] = $dd0b35e0d9fd639f$var$bswap(words[i]);
    for(let i = 16; i < 64; i++)w[i] = $dd0b35e0d9fd639f$var$expand(w[i - 2], w[i - 7], w[i - 15], w[i - 16]);
    for(let i = 0; i < 64; i += 4)round(i);
    state[0] = state[0] + a;
    state[1] = state[1] + b;
    state[2] = state[2] + c;
    state[3] = state[3] + d;
    state[4] = state[4] + e;
    state[5] = state[5] + f;
    state[6] = state[6] + g;
    state[7] = state[7] + h;
    function round(n) {
        ch = e & f ^ ~e & g;
        maj = a & b ^ a & c ^ b & c;
        s0 = (a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10);
        s1 = (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
        T1 = h + ch + s1 + w[n] + $dd0b35e0d9fd639f$var$K[n];
        T2 = s0 + maj;
        h = d + T1;
        d = T1 + T2;
        ch = h & e ^ ~h & f;
        maj = d & a ^ d & b ^ a & b;
        s0 = (d >>> 2 | d << 30) ^ (d >>> 13 | d << 19) ^ (d >>> 22 | d << 10);
        s1 = (h >>> 6 | h << 26) ^ (h >>> 11 | h << 21) ^ (h >>> 25 | h << 7);
        T1 = g + ch + s1 + w[n + 1] + $dd0b35e0d9fd639f$var$K[n + 1];
        T2 = s0 + maj;
        g = c + T1;
        c = T1 + T2;
        ch = g & h ^ ~g & e;
        maj = c & d ^ c & a ^ d & a;
        s0 = (c >>> 2 | c << 30) ^ (c >>> 13 | c << 19) ^ (c >>> 22 | c << 10);
        s1 = (g >>> 6 | g << 26) ^ (g >>> 11 | g << 21) ^ (g >>> 25 | g << 7);
        T1 = f + ch + s1 + w[n + 2] + $dd0b35e0d9fd639f$var$K[n + 2];
        T2 = s0 + maj;
        f = b + T1;
        b = T1 + T2;
        ch = f & g ^ ~f & h;
        maj = b & c ^ b & d ^ c & d;
        s0 = (b >>> 2 | b << 30) ^ (b >>> 13 | b << 19) ^ (b >>> 22 | b << 10);
        s1 = (f >>> 6 | f << 26) ^ (f >>> 11 | f << 21) ^ (f >>> 25 | f << 7);
        T1 = e + ch + s1 + w[n + 3] + $dd0b35e0d9fd639f$var$K[n + 3];
        T2 = s0 + maj;
        e = a + T1;
        a = T1 + T2;
    }
}
function $dd0b35e0d9fd639f$var$Sha256() {
    if (!(this instanceof $dd0b35e0d9fd639f$var$Sha256)) return new $dd0b35e0d9fd639f$var$Sha256();
    this.buffer = new ArrayBuffer(64);
    this.bytesRead = 0;
    this.pos = 0;
    this.digestLength = $dd0b35e0d9fd639f$var$SHA256_BYTES;
    this.finalised = false;
    this.load = new Uint8Array(this.buffer);
    this.words = new Uint32Array(this.buffer);
    this.state = new Uint32Array([
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ]);
    return this;
}
$dd0b35e0d9fd639f$var$Sha256.prototype.update = function(input, enc) {
    $6JSie(this.finalised === false, "Hash instance finalised");
    var [inputBuf, len] = $dd0b35e0d9fd639f$var$formatInput(input, enc);
    var i = 0;
    this.bytesRead += len;
    while(len > 0){
        this.load.set(inputBuf.subarray(i, i + $dd0b35e0d9fd639f$var$BLOCKSIZE - this.pos), this.pos);
        i += $dd0b35e0d9fd639f$var$BLOCKSIZE - this.pos;
        len -= $dd0b35e0d9fd639f$var$BLOCKSIZE - this.pos;
        if (len < 0) break;
        this.pos = 0;
        $dd0b35e0d9fd639f$var$compress(this.state, this.words);
    }
    this.pos = this.bytesRead & 0x3f;
    this.load.fill(0, this.pos);
    return this;
};
$dd0b35e0d9fd639f$var$Sha256.prototype.digest = function(enc, offset = 0) {
    $6JSie(this.finalised === false, "Hash instance finalised");
    this.finalised = true;
    this.load.fill(0, this.pos);
    this.load[this.pos] = 0x80;
    if (this.pos > 55) {
        $dd0b35e0d9fd639f$var$compress(this.state, this.words);
        this.words.fill(0);
        this.pos = 0;
    }
    const view = new DataView(this.buffer);
    view.setUint32(56, this.bytesRead / 2 ** 29);
    view.setUint32(60, this.bytesRead << 3);
    $dd0b35e0d9fd639f$var$compress(this.state, this.words);
    const resultBuf = new Uint8Array(this.state.map($dd0b35e0d9fd639f$var$bswap).buffer);
    if (!enc) return new Uint8Array(resultBuf);
    if (typeof enc === "string") return $hsTwZ.toString(resultBuf, enc);
    $6JSie(enc instanceof Uint8Array, "input must be Uint8Array or Buffer");
    $6JSie(enc.byteLength >= this.digestLength + offset, "input not large enough for digest");
    for(let i = 0; i < this.digestLength; i++)enc[i + offset] = resultBuf[i];
    return enc;
};
function $dd0b35e0d9fd639f$var$HMAC(key) {
    if (!(this instanceof $dd0b35e0d9fd639f$var$HMAC)) return new $dd0b35e0d9fd639f$var$HMAC(key);
    this.pad = $hsTwZ.alloc(64);
    this.inner = $dd0b35e0d9fd639f$var$Sha256();
    this.outer = $dd0b35e0d9fd639f$var$Sha256();
    const keyhash = $hsTwZ.alloc(32);
    if (key.byteLength > 64) {
        $dd0b35e0d9fd639f$var$Sha256().update(key).digest(keyhash);
        key = keyhash;
    }
    this.pad.fill(0x36);
    for(let i = 0; i < key.byteLength; i++)this.pad[i] ^= key[i];
    this.inner.update(this.pad);
    this.pad.fill(0x5c);
    for(let i = 0; i < key.byteLength; i++)this.pad[i] ^= key[i];
    this.outer.update(this.pad);
    this.pad.fill(0);
    keyhash.fill(0);
}
$dd0b35e0d9fd639f$var$HMAC.prototype.update = function(input, enc) {
    this.inner.update(input, enc);
    return this;
};
$dd0b35e0d9fd639f$var$HMAC.prototype.digest = function(enc, offset = 0) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc, offset);
};
$dd0b35e0d9fd639f$var$Sha256.HMAC = $dd0b35e0d9fd639f$var$HMAC;
function $dd0b35e0d9fd639f$var$formatInput(input, enc) {
    var result = $hsTwZ.from(input, enc);
    return [
        result,
        result.byteLength
    ];
}
function $dd0b35e0d9fd639f$var$bswap(a) {
    var r = (a & 0x00ff00ff) >>> 8 | (a & 0x00ff00ff) << 24;
    var l = (a & 0xff00ff00) << 8 | (a & 0xff00ff00) >>> 24;
    return r | l;
}

});

parcelRegister("5sJoO", function(module, exports) {

var $6JSie = parcelRequire("6JSie");

var $hsTwZ = parcelRequire("hsTwZ");

const $3fa2c8a1bec89892$var$wasm = typeof WebAssembly !== "undefined" && (parcelRequire("fv7vz"))({
    imports: {
        debug: {
            log (...args) {
                console.log(...args.map((int)=>(int >>> 0).toString(16).padStart(8, "0")));
            },
            log_tee (arg) {
                console.log((arg >>> 0).toString(16).padStart(8, "0"));
                return arg;
            }
        }
    }
});
let $3fa2c8a1bec89892$var$head = 0;
const $3fa2c8a1bec89892$var$freeList = [];
module.exports = $3fa2c8a1bec89892$var$Sha256;
const $3fa2c8a1bec89892$var$SHA256_BYTES = module.exports.SHA256_BYTES = 32;
const $3fa2c8a1bec89892$var$INPUT_OFFSET = 40;
const $3fa2c8a1bec89892$var$STATEBYTES = 108;
const $3fa2c8a1bec89892$var$BLOCKSIZE = 64;
function $3fa2c8a1bec89892$var$Sha256() {
    if (!(this instanceof $3fa2c8a1bec89892$var$Sha256)) return new $3fa2c8a1bec89892$var$Sha256();
    if (!$3fa2c8a1bec89892$var$wasm) throw new Error("WASM not loaded. Wait for Sha256.ready(cb)");
    if (!$3fa2c8a1bec89892$var$freeList.length) {
        $3fa2c8a1bec89892$var$freeList.push($3fa2c8a1bec89892$var$head);
        $3fa2c8a1bec89892$var$head += $3fa2c8a1bec89892$var$STATEBYTES // need 100 bytes for internal state
        ;
    }
    this.finalized = false;
    this.digestLength = $3fa2c8a1bec89892$var$SHA256_BYTES;
    this.pointer = $3fa2c8a1bec89892$var$freeList.pop();
    this.pos = 0;
    this._memory = new Uint8Array($3fa2c8a1bec89892$var$wasm.memory.buffer);
    this._memory.fill(0, this.pointer, this.pointer + $3fa2c8a1bec89892$var$STATEBYTES);
    if (this.pointer + this.digestLength > this._memory.length) this._realloc(this.pointer + $3fa2c8a1bec89892$var$STATEBYTES);
}
$3fa2c8a1bec89892$var$Sha256.prototype._realloc = function(size) {
    $3fa2c8a1bec89892$var$wasm.memory.grow(Math.max(0, Math.ceil(Math.abs(size - this._memory.length) / 65536)));
    this._memory = new Uint8Array($3fa2c8a1bec89892$var$wasm.memory.buffer);
};
$3fa2c8a1bec89892$var$Sha256.prototype.update = function(input, enc) {
    $6JSie(this.finalized === false, "Hash instance finalized");
    if ($3fa2c8a1bec89892$var$head % 4 !== 0) $3fa2c8a1bec89892$var$head += 4 - $3fa2c8a1bec89892$var$head % 4;
    $6JSie($3fa2c8a1bec89892$var$head % 4 === 0, "input shoud be aligned for int32");
    const [inputBuf, length] = $3fa2c8a1bec89892$var$formatInput(input, enc);
    $6JSie(inputBuf instanceof Uint8Array, "input must be Uint8Array or Buffer");
    if ($3fa2c8a1bec89892$var$head + length > this._memory.length) this._realloc($3fa2c8a1bec89892$var$head + input.length);
    this._memory.fill(0, $3fa2c8a1bec89892$var$head, $3fa2c8a1bec89892$var$head + $3fa2c8a1bec89892$var$roundUp(length, $3fa2c8a1bec89892$var$BLOCKSIZE) - $3fa2c8a1bec89892$var$BLOCKSIZE);
    this._memory.set(inputBuf.subarray(0, $3fa2c8a1bec89892$var$BLOCKSIZE - this.pos), this.pointer + $3fa2c8a1bec89892$var$INPUT_OFFSET + this.pos);
    this._memory.set(inputBuf.subarray($3fa2c8a1bec89892$var$BLOCKSIZE - this.pos), $3fa2c8a1bec89892$var$head);
    this.pos = this.pos + length & 0x3f;
    $3fa2c8a1bec89892$var$wasm.sha256(this.pointer, $3fa2c8a1bec89892$var$head, length, 0);
    return this;
};
$3fa2c8a1bec89892$var$Sha256.prototype.digest = function(enc, offset = 0) {
    $6JSie(this.finalized === false, "Hash instance finalized");
    this.finalized = true;
    $3fa2c8a1bec89892$var$freeList.push(this.pointer);
    const paddingStart = this.pointer + $3fa2c8a1bec89892$var$INPUT_OFFSET + this.pos;
    this._memory.fill(0, paddingStart, this.pointer + $3fa2c8a1bec89892$var$INPUT_OFFSET + $3fa2c8a1bec89892$var$BLOCKSIZE);
    $3fa2c8a1bec89892$var$wasm.sha256(this.pointer, $3fa2c8a1bec89892$var$head, 0, 1);
    const resultBuf = this._memory.subarray(this.pointer, this.pointer + this.digestLength);
    if (!enc) return resultBuf;
    if (typeof enc === "string") return $hsTwZ.toString(resultBuf, enc);
    $6JSie(enc instanceof Uint8Array, "output must be Uint8Array or Buffer");
    $6JSie(enc.byteLength >= this.digestLength + offset, "output must have at least 'SHA256_BYTES' bytes remaining");
    for(let i = 0; i < this.digestLength; i++)enc[i + offset] = resultBuf[i];
    return enc;
};
$3fa2c8a1bec89892$var$Sha256.WASM = $3fa2c8a1bec89892$var$wasm;
$3fa2c8a1bec89892$var$Sha256.WASM_SUPPORTED = typeof WebAssembly !== "undefined";
$3fa2c8a1bec89892$var$Sha256.ready = function(cb) {
    if (!cb) cb = $3fa2c8a1bec89892$var$noop;
    if (!$3fa2c8a1bec89892$var$wasm) return cb(new Error("WebAssembly not supported"));
    cb();
    return Promise.resolve();
};
$3fa2c8a1bec89892$var$Sha256.prototype.ready = $3fa2c8a1bec89892$var$Sha256.ready;
function $3fa2c8a1bec89892$var$HMAC(key) {
    if (!(this instanceof $3fa2c8a1bec89892$var$HMAC)) return new $3fa2c8a1bec89892$var$HMAC(key);
    this.pad = $hsTwZ.alloc(64);
    this.inner = $3fa2c8a1bec89892$var$Sha256();
    this.outer = $3fa2c8a1bec89892$var$Sha256();
    const keyhash = $hsTwZ.alloc(32);
    if (key.byteLength > 64) {
        $3fa2c8a1bec89892$var$Sha256().update(key).digest(keyhash);
        key = keyhash;
    }
    this.pad.fill(0x36);
    for(let i = 0; i < key.byteLength; i++)this.pad[i] ^= key[i];
    this.inner.update(this.pad);
    this.pad.fill(0x5c);
    for(let i = 0; i < key.byteLength; i++)this.pad[i] ^= key[i];
    this.outer.update(this.pad);
    this.pad.fill(0);
    keyhash.fill(0);
}
$3fa2c8a1bec89892$var$HMAC.prototype.update = function(input, enc) {
    this.inner.update(input, enc);
    return this;
};
$3fa2c8a1bec89892$var$HMAC.prototype.digest = function(enc, offset = 0) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc, offset);
};
$3fa2c8a1bec89892$var$Sha256.HMAC = $3fa2c8a1bec89892$var$HMAC;
function $3fa2c8a1bec89892$var$noop() {}
function $3fa2c8a1bec89892$var$formatInput(input, enc) {
    var result = $hsTwZ.from(input, enc);
    return [
        result,
        result.byteLength
    ];
}
// only works for base that is power of 2
function $3fa2c8a1bec89892$var$roundUp(n, base) {
    return n + base - 1 & -base;
}

});
parcelRegister("fv7vz", function(module, exports) {
var $b48f933ac91c9584$var$__commonJS = (cb, mod)=>function __require() {
        return mod || (0, cb[Object.keys(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
var $b48f933ac91c9584$var$__toBinary = /* @__PURE__ */ (()=>{
    var table = new Uint8Array(128);
    for(var i = 0; i < 64; i++)table[i < 26 ? i + 65 : i < 52 ? i + 71 : i < 62 ? i - 4 : i * 4 - 205] = i;
    return (base64)=>{
        var n = base64.length, bytes2 = new Uint8Array((n - (base64[n - 1] == "=") - (base64[n - 2] == "=")) * 3 / 4 | 0);
        for(var i2 = 0, j = 0; i2 < n;){
            var c0 = table[base64.charCodeAt(i2++)], c1 = table[base64.charCodeAt(i2++)];
            var c2 = table[base64.charCodeAt(i2++)], c3 = table[base64.charCodeAt(i2++)];
            bytes2[j++] = c0 << 2 | c1 >> 4;
            bytes2[j++] = c1 << 4 | c2 >> 2;
            bytes2[j++] = c2 << 6 | c3;
        }
        return bytes2;
    };
})();
// wasm-binary:./sha256.wat
var $b48f933ac91c9584$var$require_sha256 = $b48f933ac91c9584$var$__commonJS({
    "wasm-binary:./sha256.wat" (exports2, module2) {
        module2.exports = $b48f933ac91c9584$var$__toBinary("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");
    }
});
// wasm-module:./sha256.wat
var $b48f933ac91c9584$var$bytes = $b48f933ac91c9584$var$require_sha256();
var $b48f933ac91c9584$var$compiled = new WebAssembly.Module($b48f933ac91c9584$var$bytes);
module.exports = (imports)=>{
    const instance = new WebAssembly.Instance($b48f933ac91c9584$var$compiled, imports);
    return instance.exports;
};

});




parcelRegister("4PZaT", function(module, exports) {

$parcel$export(module.exports, "crypto_kdf_PRIMITIVE", function () { return $385b60dd2c804f8d$export$94bb6208ac041788; }, function (v) { return $385b60dd2c804f8d$export$94bb6208ac041788 = v; });
$parcel$export(module.exports, "crypto_kdf_BYTES_MIN", function () { return $385b60dd2c804f8d$export$6a780666eb446418; }, function (v) { return $385b60dd2c804f8d$export$6a780666eb446418 = v; });
$parcel$export(module.exports, "crypto_kdf_BYTES_MAX", function () { return $385b60dd2c804f8d$export$d65d66e3f35e3782; }, function (v) { return $385b60dd2c804f8d$export$d65d66e3f35e3782 = v; });
$parcel$export(module.exports, "crypto_kdf_CONTEXTBYTES", function () { return $385b60dd2c804f8d$export$6779660f523795e1; }, function (v) { return $385b60dd2c804f8d$export$6779660f523795e1 = v; });
$parcel$export(module.exports, "crypto_kdf_KEYBYTES", function () { return $385b60dd2c804f8d$export$206ff928aba79124; }, function (v) { return $385b60dd2c804f8d$export$206ff928aba79124 = v; });
$parcel$export(module.exports, "crypto_kdf_derive_from_key", function () { return $385b60dd2c804f8d$export$32af7516497f36ca; }, function (v) { return $385b60dd2c804f8d$export$32af7516497f36ca = v; });
$parcel$export(module.exports, "crypto_kdf_keygen", function () { return $385b60dd2c804f8d$export$2dd15be3651ed57e; }, function (v) { return $385b60dd2c804f8d$export$2dd15be3651ed57e = v; });
/* eslint-disable camelcase */ var $385b60dd2c804f8d$export$94bb6208ac041788;
var $385b60dd2c804f8d$export$6a780666eb446418;
var $385b60dd2c804f8d$export$d65d66e3f35e3782;
var $385b60dd2c804f8d$export$6779660f523795e1;
var $385b60dd2c804f8d$export$206ff928aba79124;
var $385b60dd2c804f8d$export$32af7516497f36ca;
var $385b60dd2c804f8d$export$2dd15be3651ed57e;

var $6JSie = parcelRequire("6JSie");

var $aiVbm = parcelRequire("aiVbm");
var $385b60dd2c804f8d$require$randombytes_buf = $aiVbm.randombytes_buf;

var $deivC = parcelRequire("deivC");
$385b60dd2c804f8d$export$94bb6208ac041788 = "blake2b";
$385b60dd2c804f8d$export$6a780666eb446418 = 16;
$385b60dd2c804f8d$export$d65d66e3f35e3782 = 64;
$385b60dd2c804f8d$export$6779660f523795e1 = 8;
$385b60dd2c804f8d$export$206ff928aba79124 = 32;
function $385b60dd2c804f8d$var$STORE64_LE(dest, int) {
    var mul = 1;
    var i = 0;
    dest[0] = int & 0xFF;
    while(++i < 8 && (mul *= 0x100))dest[i] = int / mul & 0xFF;
}
$385b60dd2c804f8d$export$32af7516497f36ca = function crypto_kdf_derive_from_key(subkey, subkey_id, ctx, key) {
    $6JSie(subkey.length >= $385b60dd2c804f8d$export$6a780666eb446418, "subkey must be at least crypto_kdf_BYTES_MIN");
    $6JSie(subkey_id >= 0 && subkey_id <= 0x1fffffffffffff, "subkey_id must be safe integer");
    $6JSie(ctx.length >= $385b60dd2c804f8d$export$6779660f523795e1, "context must be at least crypto_kdf_CONTEXTBYTES");
    var ctx_padded = new Uint8Array($deivC.PERSONALBYTES);
    var salt = new Uint8Array($deivC.SALTBYTES);
    ctx_padded.set(ctx, 0, $385b60dd2c804f8d$export$6779660f523795e1);
    $385b60dd2c804f8d$var$STORE64_LE(salt, subkey_id);
    var outlen = Math.min(subkey.length, $385b60dd2c804f8d$export$d65d66e3f35e3782);
    $deivC(outlen, key.subarray(0, $385b60dd2c804f8d$export$206ff928aba79124), salt, ctx_padded, true).final(subkey);
};
$385b60dd2c804f8d$export$2dd15be3651ed57e = function crypto_kdf_keygen(out) {
    $6JSie(out.length >= $385b60dd2c804f8d$export$206ff928aba79124, "out.length must be crypto_kdf_KEYBYTES");
    $385b60dd2c804f8d$require$randombytes_buf(out.subarray(0, $385b60dd2c804f8d$export$206ff928aba79124));
};

});

parcelRegister("3bp3a", function(module, exports) {
/* eslint-disable camelcase */ 
var $en1S3 = parcelRequire("en1S3");
var $2515d493de411204$require$crypto_scalarmult_base = $en1S3.crypto_scalarmult_base;

var $l4mFx = parcelRequire("l4mFx");
var $2515d493de411204$require$crypto_generichash = $l4mFx.crypto_generichash;

var $aiVbm = parcelRequire("aiVbm");
var $2515d493de411204$require$randombytes_buf = $aiVbm.randombytes_buf;

var $6JSie = parcelRequire("6JSie");
const $2515d493de411204$var$crypto_kx_SEEDBYTES = 32;
const $2515d493de411204$var$crypto_kx_PUBLICKEYBYTES = 32;
const $2515d493de411204$var$crypto_kx_SECRETKEYBYTES = 32;
function $2515d493de411204$var$crypto_kx_keypair(pk, sk) {
    $6JSie(pk.byteLength === $2515d493de411204$var$crypto_kx_PUBLICKEYBYTES, "pk must be 'crypto_kx_PUBLICKEYBYTES' bytes");
    $6JSie(sk.byteLength === $2515d493de411204$var$crypto_kx_SECRETKEYBYTES, "sk must be 'crypto_kx_SECRETKEYBYTES' bytes");
    $2515d493de411204$require$randombytes_buf(sk, $2515d493de411204$var$crypto_kx_SECRETKEYBYTES);
    return $2515d493de411204$require$crypto_scalarmult_base(pk, sk);
}
function $2515d493de411204$var$crypto_kx_seed_keypair(pk, sk, seed) {
    $6JSie(pk.byteLength === $2515d493de411204$var$crypto_kx_PUBLICKEYBYTES, "pk must be 'crypto_kx_PUBLICKEYBYTES' bytes");
    $6JSie(sk.byteLength === $2515d493de411204$var$crypto_kx_SECRETKEYBYTES, "sk must be 'crypto_kx_SECRETKEYBYTES' bytes");
    $6JSie(seed.byteLength === $2515d493de411204$var$crypto_kx_SEEDBYTES, "seed must be 'crypto_kx_SEEDBYTES' bytes");
    $2515d493de411204$require$crypto_generichash(sk, seed);
    return $2515d493de411204$require$crypto_scalarmult_base(pk, sk);
}
module.exports = {
    crypto_kx_keypair: $2515d493de411204$var$crypto_kx_keypair,
    crypto_kx_seed_keypair: $2515d493de411204$var$crypto_kx_seed_keypair,
    crypto_kx_SEEDBYTES: $2515d493de411204$var$crypto_kx_SEEDBYTES,
    crypto_kx_SECRETKEYBYTES: $2515d493de411204$var$crypto_kx_SECRETKEYBYTES,
    crypto_kx_PUBLICKEYBYTES: $2515d493de411204$var$crypto_kx_PUBLICKEYBYTES
};

});

parcelRegister("4smhl", function(module, exports) {
/* eslint-disable camelcase */ 
var $hc3Gp = parcelRequire("hc3Gp");
var $33eb0f0f2a3ba92d$require$crypto_stream_chacha20_ietf = $hc3Gp.crypto_stream_chacha20_ietf;
var $33eb0f0f2a3ba92d$require$crypto_stream_chacha20_ietf_xor_ic = $hc3Gp.crypto_stream_chacha20_ietf_xor_ic;

var $7wznJ = parcelRequire("7wznJ");
var $33eb0f0f2a3ba92d$require$crypto_verify_16 = $7wznJ.crypto_verify_16;

var $hbqU7 = parcelRequire("hbqU7");

var $6JSie = parcelRequire("6JSie");
const $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_KEYBYTES = 32;
const $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_NSECBYTES = 0;
const $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_NPUBBYTES = 12;
const $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_ABYTES = 16;
const $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_MESSAGEBYTES_MAX = Number.MAX_SAFE_INTEGER;
const $33eb0f0f2a3ba92d$var$_pad0 = new Uint8Array(16);
function $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_encrypt(c, m, ad, nsec, npub, k) {
    if (ad === null) return $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_encrypt(c, m, new Uint8Array(0), nsec, npub, k);
    $6JSie(c.byteLength === m.byteLength + $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_ABYTES, "ciphertext should be 'crypto_aead_chacha20poly1305_ietf_ABYTES' longer than message");
    $6JSie(npub.byteLength === $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_NPUBBYTES, "npub should be 'crypto_aead_chacha20poly1305_ietf_NPUBBYTES' long");
    $6JSie(k.byteLength === $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_KEYBYTES, "k should be 'crypto_aead_chacha20poly1305_ietf_KEYBYTES' long");
    $6JSie(m.byteLength <= $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_MESSAGEBYTES_MAX, "message is too large");
    const ret = $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_encrypt_detached(c.subarray(0, m.byteLength), c.subarray(m.byteLength), m, ad, nsec, npub, k);
    return m.byteLength + ret;
}
function $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_encrypt_detached(c, mac, m, ad, nsec, npub, k) {
    if (ad === null) return $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_encrypt_detached(c, mac, m, new Uint8Array(0), nsec, npub, k);
    $6JSie(c.byteLength === m.byteLength, "ciphertext should be same length than message");
    $6JSie(npub.byteLength === $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_NPUBBYTES, "npub should be 'crypto_aead_chacha20poly1305_ietf_NPUBBYTES' long");
    $6JSie(k.byteLength === $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_KEYBYTES, "k should be 'crypto_aead_chacha20poly1305_ietf_KEYBYTES' long");
    $6JSie(m.byteLength <= $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_MESSAGEBYTES_MAX, "message is too large");
    $6JSie(mac.byteLength <= $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_ABYTES, "mac should be 'crypto_aead_chacha20poly1305_ietf_ABYTES' long");
    const block0 = new Uint8Array(64);
    var slen = new Uint8Array(8);
    $33eb0f0f2a3ba92d$require$crypto_stream_chacha20_ietf(block0, npub, k);
    const poly = new $hbqU7(block0);
    block0.fill(0);
    poly.update(ad, 0, ad.byteLength);
    poly.update($33eb0f0f2a3ba92d$var$_pad0, 0, 0x10 - ad.byteLength & 0xf);
    $33eb0f0f2a3ba92d$require$crypto_stream_chacha20_ietf_xor_ic(c, m, npub, 1, k);
    poly.update(c, 0, m.byteLength);
    poly.update($33eb0f0f2a3ba92d$var$_pad0, 0, 0x10 - m.byteLength & 0xf);
    $33eb0f0f2a3ba92d$var$write64LE(slen, 0, ad.byteLength);
    poly.update(slen, 0, slen.byteLength);
    $33eb0f0f2a3ba92d$var$write64LE(slen, 0, m.byteLength);
    poly.update(slen, 0, slen.byteLength);
    poly.finish(mac, 0);
    slen.fill(0);
    return $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_ABYTES;
}
function $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_decrypt(m, nsec, c, ad, npub, k) {
    if (ad === null) return $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_decrypt(m, nsec, c, new Uint8Array(0), npub, k);
    $6JSie(m.byteLength === c.byteLength - $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_ABYTES, "message should be 'crypto_aead_chacha20poly1305_ietf_ABYTES' shorter than ciphertext");
    $6JSie(npub.byteLength === $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_NPUBBYTES, "npub should be 'crypto_aead_chacha20poly1305_ietf_NPUBBYTES' long");
    $6JSie(k.byteLength === $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_KEYBYTES, "k should be 'crypto_aead_chacha20poly1305_ietf_KEYBYTES' long");
    $6JSie(m.byteLength <= $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_MESSAGEBYTES_MAX, "message is too large");
    if (c.byteLength < $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_ABYTES) throw new Error("could not verify data");
    $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_decrypt_detached(m, nsec, c.subarray(0, c.byteLength - $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_ABYTES), c.subarray(c.byteLength - $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_ABYTES), ad, npub, k);
    return c.byteLength - $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_ABYTES;
}
function $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_decrypt_detached(m, nsec, c, mac, ad, npub, k) {
    if (ad === null) return $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_decrypt_detached(m, nsec, c, mac, new Uint8Array(0), npub, k);
    $6JSie(c.byteLength === m.byteLength, "message should be same length than ciphertext");
    $6JSie(npub.byteLength === $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_NPUBBYTES, "npub should be 'crypto_aead_chacha20poly1305_ietf_NPUBBYTES' long");
    $6JSie(k.byteLength === $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_KEYBYTES, "k should be 'crypto_aead_chacha20poly1305_ietf_KEYBYTES' long");
    $6JSie(m.byteLength <= $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_MESSAGEBYTES_MAX, "message is too large");
    $6JSie(mac.byteLength <= $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_ABYTES, "mac should be 'crypto_aead_chacha20poly1305_ietf_ABYTES' long");
    const block0 = new Uint8Array(64);
    const slen = new Uint8Array(8);
    const computed_mac = new Uint8Array($33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_ABYTES);
    $33eb0f0f2a3ba92d$require$crypto_stream_chacha20_ietf(block0, npub, k);
    const poly = new $hbqU7(block0);
    block0.fill(0);
    poly.update(ad, 0, ad.byteLength);
    poly.update($33eb0f0f2a3ba92d$var$_pad0, 0, 0x10 - ad.byteLength & 0xf);
    const mlen = c.byteLength;
    poly.update(c, 0, mlen);
    poly.update($33eb0f0f2a3ba92d$var$_pad0, 0, 0x10 - mlen & 0xf);
    $33eb0f0f2a3ba92d$var$write64LE(slen, 0, ad.byteLength);
    poly.update(slen, 0, slen.byteLength);
    $33eb0f0f2a3ba92d$var$write64LE(slen, 0, mlen);
    poly.update(slen, 0, slen.byteLength);
    poly.finish(computed_mac, 0);
    $6JSie(computed_mac.byteLength === 16);
    const ret = $33eb0f0f2a3ba92d$require$crypto_verify_16(computed_mac, 0, mac, 0);
    computed_mac.fill(0);
    slen.fill(0);
    if (!ret) {
        m.fill(0);
        throw new Error("could not verify data");
    }
    $33eb0f0f2a3ba92d$require$crypto_stream_chacha20_ietf_xor_ic(m, c, npub, 1, k);
}
function $33eb0f0f2a3ba92d$var$write64LE(buf, offset, int) {
    buf.fill(0, 0, 8);
    const view = new DataView(buf.buffer, buf.byteOffset, buf.byteLength);
    view.setUint32(offset, int & 0xffffffff, true);
    view.setUint32(offset + 4, int / 2 ** 32 & 0xffffffff, true);
}
module.exports = {
    crypto_aead_chacha20poly1305_ietf_encrypt: $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_encrypt,
    crypto_aead_chacha20poly1305_ietf_encrypt_detached: $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_encrypt_detached,
    crypto_aead_chacha20poly1305_ietf_decrypt: $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_decrypt,
    crypto_aead_chacha20poly1305_ietf_decrypt_detached: $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_decrypt_detached,
    crypto_aead_chacha20poly1305_ietf_ABYTES: $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_ABYTES,
    crypto_aead_chacha20poly1305_ietf_KEYBYTES: $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_KEYBYTES,
    crypto_aead_chacha20poly1305_ietf_NPUBBYTES: $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_NPUBBYTES,
    crypto_aead_chacha20poly1305_ietf_NSECBYTES: $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_NSECBYTES,
    crypto_aead_chacha20poly1305_ietf_MESSAGEBYTES_MAX: $33eb0f0f2a3ba92d$var$crypto_aead_chacha20poly1305_ietf_MESSAGEBYTES_MAX
};

});
parcelRegister("hc3Gp", function(module, exports) {

$parcel$export(module.exports, "crypto_stream_chacha20_KEYBYTES", function () { return $c8466a044c8103dd$export$bab1d3e06a344c6c; }, function (v) { return $c8466a044c8103dd$export$bab1d3e06a344c6c = v; });
$parcel$export(module.exports, "crypto_stream_chacha20_NONCEBYTES", function () { return $c8466a044c8103dd$export$45ba58e99e81210; }, function (v) { return $c8466a044c8103dd$export$45ba58e99e81210 = v; });
$parcel$export(module.exports, "crypto_stream_chacha20_MESSAGEBYTES_MAX", function () { return $c8466a044c8103dd$export$1e9942fcbc38afb7; }, function (v) { return $c8466a044c8103dd$export$1e9942fcbc38afb7 = v; });
$parcel$export(module.exports, "crypto_stream_chacha20_ietf_KEYBYTES", function () { return $c8466a044c8103dd$export$b695c0fe4c1325fa; }, function (v) { return $c8466a044c8103dd$export$b695c0fe4c1325fa = v; });
$parcel$export(module.exports, "crypto_stream_chacha20_ietf_NONCEBYTES", function () { return $c8466a044c8103dd$export$f9aa3338125b6b28; }, function (v) { return $c8466a044c8103dd$export$f9aa3338125b6b28 = v; });
$parcel$export(module.exports, "crypto_stream_chacha20_ietf_MESSAGEBYTES_MAX", function () { return $c8466a044c8103dd$export$475ae230fd4acca9; }, function (v) { return $c8466a044c8103dd$export$475ae230fd4acca9 = v; });
$parcel$export(module.exports, "crypto_stream_chacha20", function () { return $c8466a044c8103dd$export$8c68ce8a5306a502; }, function (v) { return $c8466a044c8103dd$export$8c68ce8a5306a502 = v; });
$parcel$export(module.exports, "crypto_stream_chacha20_xor", function () { return $c8466a044c8103dd$export$b2add12923dc7c22; }, function (v) { return $c8466a044c8103dd$export$b2add12923dc7c22 = v; });
$parcel$export(module.exports, "crypto_stream_chacha20_xor_ic", function () { return $c8466a044c8103dd$export$b9b3bb1ce5c699ff; }, function (v) { return $c8466a044c8103dd$export$b9b3bb1ce5c699ff = v; });
$parcel$export(module.exports, "crypto_stream_chacha20_xor_instance", function () { return $c8466a044c8103dd$export$ae5f9078a5ea513a; }, function (v) { return $c8466a044c8103dd$export$ae5f9078a5ea513a = v; });
$parcel$export(module.exports, "crypto_stream_chacha20_ietf", function () { return $c8466a044c8103dd$export$cdcaf63cb14ecbcf; }, function (v) { return $c8466a044c8103dd$export$cdcaf63cb14ecbcf = v; });
$parcel$export(module.exports, "crypto_stream_chacha20_ietf_xor", function () { return $c8466a044c8103dd$export$808bf033cd8672cd; }, function (v) { return $c8466a044c8103dd$export$808bf033cd8672cd = v; });
$parcel$export(module.exports, "crypto_stream_chacha20_ietf_xor_ic", function () { return $c8466a044c8103dd$export$569c57f0ae67b2b6; }, function (v) { return $c8466a044c8103dd$export$569c57f0ae67b2b6 = v; });
$parcel$export(module.exports, "crypto_stream_chacha20_ietf_xor_instance", function () { return $c8466a044c8103dd$export$a30b512b30ffc7c8; }, function (v) { return $c8466a044c8103dd$export$a30b512b30ffc7c8 = v; });
var $c8466a044c8103dd$export$bab1d3e06a344c6c;
var $c8466a044c8103dd$export$45ba58e99e81210;
var $c8466a044c8103dd$export$1e9942fcbc38afb7;
var $c8466a044c8103dd$export$b695c0fe4c1325fa;
var $c8466a044c8103dd$export$f9aa3338125b6b28;
var $c8466a044c8103dd$export$475ae230fd4acca9;
var $c8466a044c8103dd$export$8c68ce8a5306a502;
var $c8466a044c8103dd$export$b2add12923dc7c22;
var $c8466a044c8103dd$export$b9b3bb1ce5c699ff;
var $c8466a044c8103dd$export$ae5f9078a5ea513a;
var $c8466a044c8103dd$export$cdcaf63cb14ecbcf;
var $c8466a044c8103dd$export$808bf033cd8672cd;
var $c8466a044c8103dd$export$569c57f0ae67b2b6;
var $c8466a044c8103dd$export$a30b512b30ffc7c8;

var $6JSie = parcelRequire("6JSie");

var $2phpa = parcelRequire("2phpa");
if (new Uint16Array([
    1
])[0] !== 1) throw new Error("Big endian architecture is not supported.");
$c8466a044c8103dd$export$bab1d3e06a344c6c = 32;
$c8466a044c8103dd$export$45ba58e99e81210 = 8;
$c8466a044c8103dd$export$1e9942fcbc38afb7 = Number.MAX_SAFE_INTEGER;
$c8466a044c8103dd$export$b695c0fe4c1325fa = 32;
$c8466a044c8103dd$export$f9aa3338125b6b28 = 12;
$c8466a044c8103dd$export$475ae230fd4acca9 = 2 ** 32;
$c8466a044c8103dd$export$8c68ce8a5306a502 = function(c, n, k) {
    c.fill(0);
    $c8466a044c8103dd$export$b2add12923dc7c22(c, c, n, k);
};
$c8466a044c8103dd$export$b2add12923dc7c22 = function(c, m, n, k) {
    $6JSie(n.byteLength === $c8466a044c8103dd$export$45ba58e99e81210, "n should be crypto_stream_chacha20_NONCEBYTES");
    $6JSie(k.byteLength === $c8466a044c8103dd$export$bab1d3e06a344c6c, "k should be crypto_stream_chacha20_KEYBYTES");
    const xor = new $2phpa(n, k);
    xor.update(c, m);
    xor.final();
};
$c8466a044c8103dd$export$b9b3bb1ce5c699ff = function(c, m, n, ic, k) {
    $6JSie(n.byteLength === $c8466a044c8103dd$export$45ba58e99e81210, "n should be crypto_stream_chacha20_NONCEBYTES");
    $6JSie(k.byteLength === $c8466a044c8103dd$export$bab1d3e06a344c6c, "k should be crypto_stream_chacha20_KEYBYTES");
    const xor = new $2phpa(n, k, ic);
    xor.update(c, m);
    xor.final();
};
$c8466a044c8103dd$export$ae5f9078a5ea513a = function(n, k) {
    $6JSie(n.byteLength === $c8466a044c8103dd$export$45ba58e99e81210, "n should be crypto_stream_chacha20_NONCEBYTES");
    $6JSie(k.byteLength === $c8466a044c8103dd$export$bab1d3e06a344c6c, "k should be crypto_stream_chacha20_KEYBYTES");
    return new $2phpa(n, k);
};
$c8466a044c8103dd$export$cdcaf63cb14ecbcf = function(c, n, k) {
    c.fill(0);
    $c8466a044c8103dd$export$808bf033cd8672cd(c, c, n, k);
};
$c8466a044c8103dd$export$808bf033cd8672cd = function(c, m, n, k) {
    $6JSie(n.byteLength === $c8466a044c8103dd$export$f9aa3338125b6b28, "n should be crypto_stream_chacha20_ietf_NONCEBYTES");
    $6JSie(k.byteLength === $c8466a044c8103dd$export$b695c0fe4c1325fa, "k should be crypto_stream_chacha20_ietf_KEYBYTES");
    const xor = new $2phpa(n, k);
    xor.update(c, m);
    xor.final();
};
$c8466a044c8103dd$export$569c57f0ae67b2b6 = function(c, m, n, ic, k) {
    $6JSie(n.byteLength === $c8466a044c8103dd$export$f9aa3338125b6b28, "n should be crypto_stream_chacha20_ietf_NONCEBYTES");
    $6JSie(k.byteLength === $c8466a044c8103dd$export$b695c0fe4c1325fa, "k should be crypto_stream_chacha20_ietf_KEYBYTES");
    const xor = new $2phpa(n, k, ic);
    xor.update(c, m);
    xor.final();
};
$c8466a044c8103dd$export$a30b512b30ffc7c8 = function(n, k) {
    $6JSie(n.byteLength === $c8466a044c8103dd$export$f9aa3338125b6b28, "n should be crypto_stream_chacha20_ietf_NONCEBYTES");
    $6JSie(k.byteLength === $c8466a044c8103dd$export$b695c0fe4c1325fa, "k should be crypto_stream_chacha20_ietf_KEYBYTES");
    return new $2phpa(n, k);
};

});
parcelRegister("2phpa", function(module, exports) {

var $6JSie = parcelRequire("6JSie");
module.exports = $1c0b6acf68f8353c$var$Chacha20;
const $1c0b6acf68f8353c$var$constant = [
    1634760805,
    857760878,
    2036477234,
    1797285236
];
function $1c0b6acf68f8353c$var$Chacha20(nonce, key, counter) {
    $6JSie(key.byteLength === 32);
    $6JSie(nonce.byteLength === 8 || nonce.byteLength === 12);
    const n = new Uint32Array(nonce.buffer, nonce.byteOffset, nonce.byteLength / 4);
    const k = new Uint32Array(key.buffer, key.byteOffset, key.byteLength / 4);
    if (!counter) counter = 0;
    $6JSie(counter < Number.MAX_SAFE_INTEGER);
    this.finalized = false;
    this.pos = 0;
    this.state = new Uint32Array(16);
    for(let i = 0; i < 4; i++)this.state[i] = $1c0b6acf68f8353c$var$constant[i];
    for(let i = 0; i < 8; i++)this.state[4 + i] = k[i];
    this.state[12] = counter & 0xffffffff;
    if (n.byteLength === 8) {
        this.state[13] = (counter && 0xffffffff00000000) >> 32;
        this.state[14] = n[0];
        this.state[15] = n[1];
    } else {
        this.state[13] = n[0];
        this.state[14] = n[1];
        this.state[15] = n[2];
    }
    return this;
}
$1c0b6acf68f8353c$var$Chacha20.prototype.update = function(output, input) {
    $6JSie(!this.finalized, "cipher finalized.");
    $6JSie(output.byteLength >= input.byteLength, "output cannot be shorter than input.");
    let len = input.length;
    let offset = this.pos % 64;
    this.pos += len;
    // input position
    let j = 0;
    let keyStream = $1c0b6acf68f8353c$var$chacha20Block(this.state);
    // try to finsih the current block
    while(offset > 0 && len > 0){
        output[j] = input[j++] ^ keyStream[offset];
        offset = offset + 1 & 0x3f;
        if (!offset) this.state[12]++;
        len--;
    }
    // encrypt rest block at a time
    while(len > 0){
        keyStream = $1c0b6acf68f8353c$var$chacha20Block(this.state);
        // less than a full block remaining
        if (len < 64) {
            for(let i = 0; i < len; i++){
                output[j] = input[j++] ^ keyStream[offset++];
                offset &= 0x3f;
            }
            return;
        }
        for(; offset < 64;)output[j] = input[j++] ^ keyStream[offset++];
        this.state[12]++;
        offset = 0;
        len -= 64;
    }
};
$1c0b6acf68f8353c$var$Chacha20.prototype.final = function() {
    this.state.fill(0);
    this.pos = 0;
    this.finalized = true;
};
function $1c0b6acf68f8353c$var$chacha20Block(state) {
    // working state
    const ws = new Uint32Array(16);
    for(let i = 16; i--;)ws[i] = state[i];
    for(let i = 0; i < 20; i += 2){
        $1c0b6acf68f8353c$var$QR(ws, 0, 4, 8, 12) // column 0
        ;
        $1c0b6acf68f8353c$var$QR(ws, 1, 5, 9, 13) // column 1
        ;
        $1c0b6acf68f8353c$var$QR(ws, 2, 6, 10, 14) // column 2
        ;
        $1c0b6acf68f8353c$var$QR(ws, 3, 7, 11, 15) // column 3
        ;
        $1c0b6acf68f8353c$var$QR(ws, 0, 5, 10, 15) // diagonal 1 (main diagonal)
        ;
        $1c0b6acf68f8353c$var$QR(ws, 1, 6, 11, 12) // diagonal 2
        ;
        $1c0b6acf68f8353c$var$QR(ws, 2, 7, 8, 13) // diagonal 3
        ;
        $1c0b6acf68f8353c$var$QR(ws, 3, 4, 9, 14) // diagonal 4
        ;
    }
    for(let i = 0; i < 16; i++)ws[i] += state[i];
    return new Uint8Array(ws.buffer, ws.byteOffset, ws.byteLength);
}
function $1c0b6acf68f8353c$var$rotl(a, b) {
    return a << b | a >>> 32 - b;
}
function $1c0b6acf68f8353c$var$QR(obj, a, b, c, d) {
    obj[a] += obj[b];
    obj[d] ^= obj[a];
    obj[d] = $1c0b6acf68f8353c$var$rotl(obj[d], 16);
    obj[c] += obj[d];
    obj[b] ^= obj[c];
    obj[b] = $1c0b6acf68f8353c$var$rotl(obj[b], 12);
    obj[a] += obj[b];
    obj[d] ^= obj[a];
    obj[d] = $1c0b6acf68f8353c$var$rotl(obj[d], 8);
    obj[c] += obj[d];
    obj[b] ^= obj[c];
    obj[b] = $1c0b6acf68f8353c$var$rotl(obj[b], 7);
}

});



parcelRegister("ill7F", function(module, exports) {
/* eslint-disable camelcase */ 
var $6JSie = parcelRequire("6JSie");

var $aiVbm = parcelRequire("aiVbm");
var $d5aa92b178446626$require$randombytes_buf = $aiVbm.randombytes_buf;

var $hc3Gp = parcelRequire("hc3Gp");
var $d5aa92b178446626$require$crypto_stream_chacha20_ietf = $hc3Gp.crypto_stream_chacha20_ietf;
var $d5aa92b178446626$require$crypto_stream_chacha20_ietf_xor = $hc3Gp.crypto_stream_chacha20_ietf_xor;
var $d5aa92b178446626$require$crypto_stream_chacha20_ietf_xor_ic = $hc3Gp.crypto_stream_chacha20_ietf_xor_ic;
var $d5aa92b178446626$require$crypto_stream_chacha20_ietf_KEYBYTES = $hc3Gp.crypto_stream_chacha20_ietf_KEYBYTES;

var $jjWZS = parcelRequire("jjWZS");
var $d5aa92b178446626$require$crypto_core_hchacha20 = $jjWZS.crypto_core_hchacha20;
var $d5aa92b178446626$require$crypto_core_hchacha20_INPUTBYTES = $jjWZS.crypto_core_hchacha20_INPUTBYTES;

var $hbqU7 = parcelRequire("hbqU7");

var $itNbj = parcelRequire("itNbj");
var $d5aa92b178446626$require$sodium_increment = $itNbj.sodium_increment;
var $d5aa92b178446626$require$sodium_is_zero = $itNbj.sodium_is_zero;
var $d5aa92b178446626$require$sodium_memcmp = $itNbj.sodium_memcmp;
const $d5aa92b178446626$var$crypto_onetimeauth_poly1305_BYTES = 16;
const $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_COUNTERBYTES = 4;
const $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_INONCEBYTES = 8;
const $d5aa92b178446626$var$crypto_aead_xchacha20poly1305_ietf_KEYBYTES = 32;
const $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_KEYBYTES = $d5aa92b178446626$var$crypto_aead_xchacha20poly1305_ietf_KEYBYTES;
const $d5aa92b178446626$var$crypto_aead_xchacha20poly1305_ietf_NPUBBYTES = 24;
const $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_HEADERBYTES = $d5aa92b178446626$var$crypto_aead_xchacha20poly1305_ietf_NPUBBYTES;
const $d5aa92b178446626$var$crypto_aead_xchacha20poly1305_ietf_ABYTES = 16;
const $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_ABYTES = 1 + $d5aa92b178446626$var$crypto_aead_xchacha20poly1305_ietf_ABYTES;
const $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_MESSAGEBYTES_MAX = Number.MAX_SAFE_INTEGER;
const $d5aa92b178446626$var$crypto_aead_chacha20poly1305_ietf_MESSAGEBYTES_MAX = Number.MAX_SAFE_INTEGER;
const $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_TAGBYTES = 1;
const $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_TAG_MESSAGE = new Uint8Array([
    0
]);
const $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_TAG_PUSH = new Uint8Array([
    1
]);
const $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_TAG_REKEY = new Uint8Array([
    2
]);
const $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_TAG_FINAL = new Uint8Array([
    $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_TAG_PUSH | $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_TAG_REKEY
]);
const $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_STATEBYTES = $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_KEYBYTES + $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_INONCEBYTES + $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_COUNTERBYTES + 8;
const $d5aa92b178446626$var$KEY_OFFSET = 0;
const $d5aa92b178446626$var$NONCE_OFFSET = $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_KEYBYTES;
const $d5aa92b178446626$var$PAD_OFFSET = $d5aa92b178446626$var$NONCE_OFFSET + $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_INONCEBYTES + $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_COUNTERBYTES;
const $d5aa92b178446626$var$_pad0 = new Uint8Array(16);
function $d5aa92b178446626$var$STORE64_LE(dest, int) {
    let mul = 1;
    let i = 0;
    dest[0] = int & 0xFF;
    while(++i < 8 && (mul *= 0x100))dest[i] = int / mul & 0xFF;
}
function $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_counter_reset(state) {
    $6JSie(state.byteLength === $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_STATEBYTES, "state is should be crypto_secretstream_xchacha20poly1305_STATEBYTES long");
    const nonce = state.subarray($d5aa92b178446626$var$NONCE_OFFSET, $d5aa92b178446626$var$PAD_OFFSET);
    for(let i = 0; i < $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_COUNTERBYTES; i++)nonce[i] = 0;
    nonce[0] = 1;
}
function $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_keygen(k) {
    $6JSie(k.length === $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_KEYBYTES);
    $d5aa92b178446626$require$randombytes_buf(k);
}
function $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_init_push(state, out, key) {
    $6JSie(state.byteLength === $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_STATEBYTES, "state is should be crypto_secretstream_xchacha20poly1305_STATEBYTES long");
    $6JSie(out instanceof Uint8Array && out.length === $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_HEADERBYTES, "out not byte array of length crypto_secretstream_xchacha20poly1305_HEADERBYTES");
    $6JSie(key instanceof Uint8Array && key.length === $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_KEYBYTES, "key not byte array of length crypto_secretstream_xchacha20poly1305_KEYBYTES");
    const k = state.subarray($d5aa92b178446626$var$KEY_OFFSET, $d5aa92b178446626$var$NONCE_OFFSET);
    const nonce = state.subarray($d5aa92b178446626$var$NONCE_OFFSET, $d5aa92b178446626$var$PAD_OFFSET);
    const pad = state.subarray($d5aa92b178446626$var$PAD_OFFSET);
    $d5aa92b178446626$require$randombytes_buf(out, $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_HEADERBYTES);
    $d5aa92b178446626$require$crypto_core_hchacha20(k, out, key, null);
    $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_counter_reset(state);
    for(let i = 0; i < $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_INONCEBYTES; i++)nonce[i + $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_COUNTERBYTES] = out[i + $d5aa92b178446626$require$crypto_core_hchacha20_INPUTBYTES];
    pad.fill(0);
}
function $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_init_pull(state, _in, key) {
    $6JSie(state.byteLength === $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_STATEBYTES, "state is should be crypto_secretstream_xchacha20poly1305_STATEBYTES long");
    $6JSie(_in instanceof Uint8Array && _in.length === $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_HEADERBYTES, "_in not byte array of length crypto_secretstream_xchacha20poly1305_HEADERBYTES");
    $6JSie(key instanceof Uint8Array && key.length === $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_KEYBYTES, "key not byte array of length crypto_secretstream_xchacha20poly1305_KEYBYTES");
    const k = state.subarray($d5aa92b178446626$var$KEY_OFFSET, $d5aa92b178446626$var$NONCE_OFFSET);
    const nonce = state.subarray($d5aa92b178446626$var$NONCE_OFFSET, $d5aa92b178446626$var$PAD_OFFSET);
    const pad = state.subarray($d5aa92b178446626$var$PAD_OFFSET);
    $d5aa92b178446626$require$crypto_core_hchacha20(k, _in, key, null);
    $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_counter_reset(state);
    for(let i = 0; i < $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_INONCEBYTES; i++)nonce[i + $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_COUNTERBYTES] = _in[i + $d5aa92b178446626$require$crypto_core_hchacha20_INPUTBYTES];
    pad.fill(0);
}
function $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_rekey(state) {
    $6JSie(state.byteLength === $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_STATEBYTES, "state is should be crypto_secretstream_xchacha20poly1305_STATEBYTES long");
    const k = state.subarray($d5aa92b178446626$var$KEY_OFFSET, $d5aa92b178446626$var$NONCE_OFFSET);
    const nonce = state.subarray($d5aa92b178446626$var$NONCE_OFFSET, $d5aa92b178446626$var$PAD_OFFSET);
    const new_key_and_inonce = new Uint8Array($d5aa92b178446626$require$crypto_stream_chacha20_ietf_KEYBYTES + $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_INONCEBYTES);
    let i;
    for(i = 0; i < $d5aa92b178446626$require$crypto_stream_chacha20_ietf_KEYBYTES; i++)new_key_and_inonce[i] = k[i];
    for(i = 0; i < $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_INONCEBYTES; i++)new_key_and_inonce[$d5aa92b178446626$require$crypto_stream_chacha20_ietf_KEYBYTES + i] = nonce[$d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_COUNTERBYTES + i];
    $d5aa92b178446626$require$crypto_stream_chacha20_ietf_xor(new_key_and_inonce, new_key_and_inonce, nonce, k);
    for(i = 0; i < $d5aa92b178446626$require$crypto_stream_chacha20_ietf_KEYBYTES; i++)k[i] = new_key_and_inonce[i];
    for(i = 0; i < $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_INONCEBYTES; i++)nonce[$d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_COUNTERBYTES + i] = new_key_and_inonce[$d5aa92b178446626$require$crypto_stream_chacha20_ietf_KEYBYTES + i];
    $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_counter_reset(state);
}
function $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_push(state, out, m, ad, tag) {
    $6JSie(state.byteLength === $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_STATEBYTES, "state is should be crypto_secretstream_xchacha20poly1305_STATEBYTES long");
    if (!ad) ad = new Uint8Array(0);
    const k = state.subarray($d5aa92b178446626$var$KEY_OFFSET, $d5aa92b178446626$var$NONCE_OFFSET);
    const nonce = state.subarray($d5aa92b178446626$var$NONCE_OFFSET, $d5aa92b178446626$var$PAD_OFFSET);
    const block = new Uint8Array(64);
    const slen = new Uint8Array(8);
    $6JSie($d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_MESSAGEBYTES_MAX <= $d5aa92b178446626$var$crypto_aead_chacha20poly1305_ietf_MESSAGEBYTES_MAX);
    $d5aa92b178446626$require$crypto_stream_chacha20_ietf(block, nonce, k);
    const poly = new $hbqU7(block);
    block.fill(0);
    poly.update(ad, 0, ad.byteLength);
    poly.update($d5aa92b178446626$var$_pad0, 0, 0x10 - ad.byteLength & 0xf);
    block[0] = tag[0];
    $d5aa92b178446626$require$crypto_stream_chacha20_ietf_xor_ic(block, block, nonce, 1, k);
    poly.update(block, 0, block.byteLength);
    out[0] = block[0];
    const c = out.subarray(1, out.byteLength);
    $d5aa92b178446626$require$crypto_stream_chacha20_ietf_xor_ic(c, m, nonce, 2, k);
    poly.update(c, 0, m.byteLength);
    poly.update($d5aa92b178446626$var$_pad0, 0, 0x10 - block.byteLength + m.byteLength & 0xf);
    $d5aa92b178446626$var$STORE64_LE(slen, ad.byteLength);
    poly.update(slen, 0, slen.byteLength);
    $d5aa92b178446626$var$STORE64_LE(slen, block.byteLength + m.byteLength);
    poly.update(slen, 0, slen.byteLength);
    const mac = out.subarray(1 + m.byteLength, out.byteLength);
    poly.finish(mac, 0);
    $6JSie($d5aa92b178446626$var$crypto_onetimeauth_poly1305_BYTES >= $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_INONCEBYTES);
    $d5aa92b178446626$var$xor_buf(nonce.subarray($d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_COUNTERBYTES, nonce.length), mac, $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_INONCEBYTES);
    $d5aa92b178446626$require$sodium_increment(nonce);
    if ((tag[0] & $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_TAG_REKEY) !== 0 || $d5aa92b178446626$require$sodium_is_zero(nonce.subarray(0, $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_COUNTERBYTES))) $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_rekey(state);
    return $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_ABYTES + m.byteLength;
}
function $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_pull(state, m, tag, _in, ad) {
    $6JSie(state.byteLength === $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_STATEBYTES, "state is should be crypto_secretstream_xchacha20poly1305_STATEBYTES long");
    if (!ad) ad = new Uint8Array(0);
    const k = state.subarray($d5aa92b178446626$var$KEY_OFFSET, $d5aa92b178446626$var$NONCE_OFFSET);
    const nonce = state.subarray($d5aa92b178446626$var$NONCE_OFFSET, $d5aa92b178446626$var$PAD_OFFSET);
    const block = new Uint8Array(64);
    const slen = new Uint8Array(8);
    const mac = new Uint8Array($d5aa92b178446626$var$crypto_onetimeauth_poly1305_BYTES);
    $6JSie(_in.byteLength >= $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_ABYTES, "ciphertext is too short.");
    const mlen = _in.byteLength - $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_ABYTES;
    $d5aa92b178446626$require$crypto_stream_chacha20_ietf(block, nonce, k);
    const poly = new $hbqU7(block);
    block.fill(0) // sodium_memzero(block, sizeof block);
    ;
    poly.update(ad, 0, ad.byteLength);
    poly.update($d5aa92b178446626$var$_pad0, 0, 0x10 - ad.byteLength & 0xf);
    block.fill(0) // memset(block, 0, sizeof block);
    ;
    block[0] = _in[0];
    $d5aa92b178446626$require$crypto_stream_chacha20_ietf_xor_ic(block, block, nonce, 1, k);
    tag[0] = block[0];
    block[0] = _in[0];
    poly.update(block, 0, block.byteLength);
    const c = _in.subarray(1, _in.length);
    poly.update(c, 0, mlen);
    poly.update($d5aa92b178446626$var$_pad0, 0, 0x10 - block.byteLength + mlen & 0xf);
    $d5aa92b178446626$var$STORE64_LE(slen, ad.byteLength);
    poly.update(slen, 0, slen.byteLength);
    $d5aa92b178446626$var$STORE64_LE(slen, block.byteLength + m.byteLength);
    poly.update(slen, 0, slen.byteLength);
    poly.finish(mac, 0);
    const stored_mac = _in.subarray(1 + mlen, _in.length);
    if (!$d5aa92b178446626$require$sodium_memcmp(mac, stored_mac)) {
        mac.fill(0);
        throw new Error("MAC could not be verified.");
    }
    $d5aa92b178446626$require$crypto_stream_chacha20_ietf_xor_ic(m, c.subarray(0, m.length), nonce, 2, k);
    $d5aa92b178446626$var$xor_buf(nonce.subarray($d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_COUNTERBYTES, nonce.length), mac, $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_INONCEBYTES);
    $d5aa92b178446626$require$sodium_increment(nonce);
    if ((tag & $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_TAG_REKEY) !== 0 || $d5aa92b178446626$require$sodium_is_zero(nonce.subarray(0, $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_COUNTERBYTES))) $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_rekey(state);
    return mlen;
}
function $d5aa92b178446626$var$xor_buf(out, _in, n) {
    for(let i = 0; i < n; i++)out[i] ^= _in[i];
}
module.exports = {
    crypto_secretstream_xchacha20poly1305_keygen: $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_keygen,
    crypto_secretstream_xchacha20poly1305_init_push: $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_init_push,
    crypto_secretstream_xchacha20poly1305_init_pull: $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_init_pull,
    crypto_secretstream_xchacha20poly1305_rekey: $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_rekey,
    crypto_secretstream_xchacha20poly1305_push: $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_push,
    crypto_secretstream_xchacha20poly1305_pull: $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_pull,
    crypto_secretstream_xchacha20poly1305_STATEBYTES: $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_STATEBYTES,
    crypto_secretstream_xchacha20poly1305_ABYTES: $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_ABYTES,
    crypto_secretstream_xchacha20poly1305_HEADERBYTES: $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_HEADERBYTES,
    crypto_secretstream_xchacha20poly1305_KEYBYTES: $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_KEYBYTES,
    crypto_secretstream_xchacha20poly1305_MESSAGEBYTES_MAX: $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_MESSAGEBYTES_MAX,
    crypto_secretstream_xchacha20poly1305_TAGBYTES: $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_TAGBYTES,
    crypto_secretstream_xchacha20poly1305_TAG_MESSAGE: $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_TAG_MESSAGE,
    crypto_secretstream_xchacha20poly1305_TAG_PUSH: $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_TAG_PUSH,
    crypto_secretstream_xchacha20poly1305_TAG_REKEY: $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_TAG_REKEY,
    crypto_secretstream_xchacha20poly1305_TAG_FINAL: $d5aa92b178446626$var$crypto_secretstream_xchacha20poly1305_TAG_FINAL
};

});
parcelRegister("jjWZS", function(module, exports) {
/* eslint-disable camelcase */ 
var $3CnRI = parcelRequire("3CnRI");
var $e10d8e3f195c492d$require$sodium_malloc = $3CnRI.sodium_malloc;

var $6JSie = parcelRequire("6JSie");
if (new Uint16Array([
    1
])[0] !== 1) throw new Error("Big endian architecture is not supported.");
const $e10d8e3f195c492d$var$crypto_core_hchacha20_OUTPUTBYTES = 32;
const $e10d8e3f195c492d$var$crypto_core_hchacha20_INPUTBYTES = 16;
const $e10d8e3f195c492d$var$crypto_core_hchacha20_KEYBYTES = 32;
const $e10d8e3f195c492d$var$crypto_core_hchacha20_CONSTBYTES = 16;
function $e10d8e3f195c492d$var$ROTL32(x, b) {
    x &= 0xFFFFFFFF;
    b &= 0xFFFFFFFF;
    return x << b | x >>> 32 - b;
}
function $e10d8e3f195c492d$var$LOAD32_LE(src, offset) {
    $6JSie(src instanceof Uint8Array, "src not byte array");
    let w = src[offset];
    w |= src[offset + 1] << 8;
    w |= src[offset + 2] << 16;
    w |= src[offset + 3] << 24;
    return w;
}
function $e10d8e3f195c492d$var$STORE32_LE(dest, int, offset) {
    $6JSie(dest instanceof Uint8Array, "dest not byte array");
    var mul = 1;
    var i = 0;
    dest[offset] = int & 0xFF // grab bottom byte
    ;
    while(++i < 4 && (mul *= 0x100))dest[offset + i] = int / mul & 0xFF;
}
function $e10d8e3f195c492d$var$QUARTERROUND(l, A, B, C, D) {
    l[A] += l[B];
    l[D] = $e10d8e3f195c492d$var$ROTL32(l[D] ^ l[A], 16);
    l[C] += l[D];
    l[B] = $e10d8e3f195c492d$var$ROTL32(l[B] ^ l[C], 12);
    l[A] += l[B];
    l[D] = $e10d8e3f195c492d$var$ROTL32(l[D] ^ l[A], 8);
    l[C] += l[D];
    l[B] = $e10d8e3f195c492d$var$ROTL32(l[B] ^ l[C], 7);
}
function $e10d8e3f195c492d$var$crypto_core_hchacha20(out, _in, k, c) {
    $6JSie(out instanceof Uint8Array && out.length === 32, "out is not an array of 32 bytes");
    $6JSie(k instanceof Uint8Array && k.length === 32, "k is not an array of 32 bytes");
    $6JSie(c === null || c instanceof Uint8Array && c.length === 16, "c is not null or an array of 16 bytes");
    let i = 0;
    const x = new Uint32Array(16);
    if (!c) {
        x[0] = 0x61707865;
        x[1] = 0x3320646E;
        x[2] = 0x79622D32;
        x[3] = 0x6B206574;
    } else {
        x[0] = $e10d8e3f195c492d$var$LOAD32_LE(c, 0);
        x[1] = $e10d8e3f195c492d$var$LOAD32_LE(c, 4);
        x[2] = $e10d8e3f195c492d$var$LOAD32_LE(c, 8);
        x[3] = $e10d8e3f195c492d$var$LOAD32_LE(c, 12);
    }
    x[4] = $e10d8e3f195c492d$var$LOAD32_LE(k, 0);
    x[5] = $e10d8e3f195c492d$var$LOAD32_LE(k, 4);
    x[6] = $e10d8e3f195c492d$var$LOAD32_LE(k, 8);
    x[7] = $e10d8e3f195c492d$var$LOAD32_LE(k, 12);
    x[8] = $e10d8e3f195c492d$var$LOAD32_LE(k, 16);
    x[9] = $e10d8e3f195c492d$var$LOAD32_LE(k, 20);
    x[10] = $e10d8e3f195c492d$var$LOAD32_LE(k, 24);
    x[11] = $e10d8e3f195c492d$var$LOAD32_LE(k, 28);
    x[12] = $e10d8e3f195c492d$var$LOAD32_LE(_in, 0);
    x[13] = $e10d8e3f195c492d$var$LOAD32_LE(_in, 4);
    x[14] = $e10d8e3f195c492d$var$LOAD32_LE(_in, 8);
    x[15] = $e10d8e3f195c492d$var$LOAD32_LE(_in, 12);
    for(i = 0; i < 10; i++){
        $e10d8e3f195c492d$var$QUARTERROUND(x, 0, 4, 8, 12);
        $e10d8e3f195c492d$var$QUARTERROUND(x, 1, 5, 9, 13);
        $e10d8e3f195c492d$var$QUARTERROUND(x, 2, 6, 10, 14);
        $e10d8e3f195c492d$var$QUARTERROUND(x, 3, 7, 11, 15);
        $e10d8e3f195c492d$var$QUARTERROUND(x, 0, 5, 10, 15);
        $e10d8e3f195c492d$var$QUARTERROUND(x, 1, 6, 11, 12);
        $e10d8e3f195c492d$var$QUARTERROUND(x, 2, 7, 8, 13);
        $e10d8e3f195c492d$var$QUARTERROUND(x, 3, 4, 9, 14);
    }
    $e10d8e3f195c492d$var$STORE32_LE(out, x[0], 0);
    $e10d8e3f195c492d$var$STORE32_LE(out, x[1], 4);
    $e10d8e3f195c492d$var$STORE32_LE(out, x[2], 8);
    $e10d8e3f195c492d$var$STORE32_LE(out, x[3], 12);
    $e10d8e3f195c492d$var$STORE32_LE(out, x[12], 16);
    $e10d8e3f195c492d$var$STORE32_LE(out, x[13], 20);
    $e10d8e3f195c492d$var$STORE32_LE(out, x[14], 24);
    $e10d8e3f195c492d$var$STORE32_LE(out, x[15], 28);
    return 0;
}
function $e10d8e3f195c492d$var$crypto_core_hchacha20_outputbytes() {
    return $e10d8e3f195c492d$var$crypto_core_hchacha20_OUTPUTBYTES;
}
function $e10d8e3f195c492d$var$crypto_core_hchacha20_inputbytes() {
    return $e10d8e3f195c492d$var$crypto_core_hchacha20_INPUTBYTES;
}
function $e10d8e3f195c492d$var$crypto_core_hchacha20_keybytes() {
    return $e10d8e3f195c492d$var$crypto_core_hchacha20_KEYBYTES;
}
function $e10d8e3f195c492d$var$crypto_core_hchacha20_constbytes() {
    return $e10d8e3f195c492d$var$crypto_core_hchacha20_CONSTBYTES;
}
module.exports = {
    crypto_core_hchacha20_INPUTBYTES: $e10d8e3f195c492d$var$crypto_core_hchacha20_INPUTBYTES,
    LOAD32_LE: $e10d8e3f195c492d$var$LOAD32_LE,
    STORE32_LE: $e10d8e3f195c492d$var$STORE32_LE,
    QUARTERROUND: $e10d8e3f195c492d$var$QUARTERROUND,
    crypto_core_hchacha20: $e10d8e3f195c492d$var$crypto_core_hchacha20,
    crypto_core_hchacha20_outputbytes: $e10d8e3f195c492d$var$crypto_core_hchacha20_outputbytes,
    crypto_core_hchacha20_inputbytes: $e10d8e3f195c492d$var$crypto_core_hchacha20_inputbytes,
    crypto_core_hchacha20_keybytes: $e10d8e3f195c492d$var$crypto_core_hchacha20_keybytes,
    crypto_core_hchacha20_constbytes: $e10d8e3f195c492d$var$crypto_core_hchacha20_constbytes
};

});


parcelRegister("gZMW6", function(module, exports) {

$parcel$export(module.exports, "crypto_shorthash_PRIMITIVE", function () { return $c5f84d8ba02e8978$export$16e4d3a6fb8f1166; }, function (v) { return $c5f84d8ba02e8978$export$16e4d3a6fb8f1166 = v; });
$parcel$export(module.exports, "crypto_shorthash_BYTES", function () { return $c5f84d8ba02e8978$export$2964915db378cc94; }, function (v) { return $c5f84d8ba02e8978$export$2964915db378cc94 = v; });
$parcel$export(module.exports, "crypto_shorthash_KEYBYTES", function () { return $c5f84d8ba02e8978$export$93bb61a54b2dfdfb; }, function (v) { return $c5f84d8ba02e8978$export$93bb61a54b2dfdfb = v; });
$parcel$export(module.exports, "crypto_shorthash_WASM_SUPPORTED", function () { return $c5f84d8ba02e8978$export$b29c8c84cd87f789; }, function (v) { return $c5f84d8ba02e8978$export$b29c8c84cd87f789 = v; });
$parcel$export(module.exports, "crypto_shorthash_WASM_LOADED", function () { return $c5f84d8ba02e8978$export$fe02a1077c2bc17; }, function (v) { return $c5f84d8ba02e8978$export$fe02a1077c2bc17 = v; });
$parcel$export(module.exports, "crypto_shorthash", function () { return $c5f84d8ba02e8978$export$8c412a3f8541f5cd; }, function (v) { return $c5f84d8ba02e8978$export$8c412a3f8541f5cd = v; });
var $c5f84d8ba02e8978$export$16e4d3a6fb8f1166;
var $c5f84d8ba02e8978$export$2964915db378cc94;
var $c5f84d8ba02e8978$export$93bb61a54b2dfdfb;
var $c5f84d8ba02e8978$export$b29c8c84cd87f789;
var $c5f84d8ba02e8978$export$fe02a1077c2bc17;
var $c5f84d8ba02e8978$export$8c412a3f8541f5cd;

var $7Aq04 = parcelRequire("7Aq04");
if (new Uint16Array([
    1
])[0] !== 1) throw new Error("Big endian architecture is not supported.");
$c5f84d8ba02e8978$export$16e4d3a6fb8f1166 = "siphash24";
$c5f84d8ba02e8978$export$2964915db378cc94 = $7Aq04.BYTES;
$c5f84d8ba02e8978$export$93bb61a54b2dfdfb = $7Aq04.KEYBYTES;
$c5f84d8ba02e8978$export$b29c8c84cd87f789 = $7Aq04.WASM_SUPPORTED;
$c5f84d8ba02e8978$export$fe02a1077c2bc17 = $7Aq04.WASM_LOADED;
$c5f84d8ba02e8978$export$8c412a3f8541f5cd = $c5f84d8ba02e8978$var$shorthash;
function $c5f84d8ba02e8978$var$shorthash(out, data, key, noAssert) {
    $7Aq04(data, key, out, noAssert);
}

});
parcelRegister("7Aq04", function(module, exports) {

var $6JSie = parcelRequire("6JSie");

var $58601044efa6e709$var$wasm = typeof WebAssembly !== "undefined" && (parcelRequire("9BNab"))();

var $17iVN = parcelRequire("17iVN");
module.exports = $58601044efa6e709$var$siphash24;
var $58601044efa6e709$var$BYTES = $58601044efa6e709$var$siphash24.BYTES = 8;
var $58601044efa6e709$var$KEYBYTES = $58601044efa6e709$var$siphash24.KEYBYTES = 16;
$58601044efa6e709$var$siphash24.WASM_SUPPORTED = !!$58601044efa6e709$var$wasm;
$58601044efa6e709$var$siphash24.WASM_LOADED = !!$58601044efa6e709$var$wasm;
var $58601044efa6e709$var$memory = new Uint8Array($58601044efa6e709$var$wasm ? $58601044efa6e709$var$wasm.memory.buffer : 0);
function $58601044efa6e709$var$siphash24(data, key, out, noAssert) {
    if (!out) out = new Uint8Array(8);
    if (noAssert !== true) {
        $6JSie(out.length >= $58601044efa6e709$var$BYTES, "output must be at least " + $58601044efa6e709$var$BYTES);
        $6JSie(key.length >= $58601044efa6e709$var$KEYBYTES, "key must be at least " + $58601044efa6e709$var$KEYBYTES);
    }
    if ($58601044efa6e709$var$wasm) {
        if (data.length + 24 > $58601044efa6e709$var$memory.length) $58601044efa6e709$var$realloc(data.length + 24);
        $58601044efa6e709$var$memory.set(key, 8);
        $58601044efa6e709$var$memory.set(data, 24);
        $58601044efa6e709$var$wasm.siphash(24, data.length);
        out.set($58601044efa6e709$var$memory.subarray(0, 8));
    } else $17iVN(out, data, key);
    return out;
}
function $58601044efa6e709$var$realloc(size) {
    $58601044efa6e709$var$wasm.memory.grow(Math.max(0, Math.ceil(Math.abs(size - $58601044efa6e709$var$memory.length) / 65536)));
    $58601044efa6e709$var$memory = new Uint8Array($58601044efa6e709$var$wasm.memory.buffer);
}

});
parcelRegister("9BNab", function(module, exports) {
var $6fedb48d2e71b701$var$__commonJS = (cb, mod)=>function __require() {
        return mod || (0, cb[Object.keys(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
var $6fedb48d2e71b701$var$__toBinary = /* @__PURE__ */ (()=>{
    var table = new Uint8Array(128);
    for(var i = 0; i < 64; i++)table[i < 26 ? i + 65 : i < 52 ? i + 71 : i < 62 ? i - 4 : i * 4 - 205] = i;
    return (base64)=>{
        var n = base64.length, bytes2 = new Uint8Array((n - (base64[n - 1] == "=") - (base64[n - 2] == "=")) * 3 / 4 | 0);
        for(var i2 = 0, j = 0; i2 < n;){
            var c0 = table[base64.charCodeAt(i2++)], c1 = table[base64.charCodeAt(i2++)];
            var c2 = table[base64.charCodeAt(i2++)], c3 = table[base64.charCodeAt(i2++)];
            bytes2[j++] = c0 << 2 | c1 >> 4;
            bytes2[j++] = c1 << 4 | c2 >> 2;
            bytes2[j++] = c2 << 6 | c3;
        }
        return bytes2;
    };
})();
// wasm-binary:./siphash24.wat
var $6fedb48d2e71b701$var$require_siphash24 = $6fedb48d2e71b701$var$__commonJS({
    "wasm-binary:./siphash24.wat" (exports2, module2) {
        module2.exports = $6fedb48d2e71b701$var$__toBinary("AGFzbQEAAAABBgFgAn9/AAMCAQAFBQEBCpBOBxQCBm1lbW9yeQIAB3NpcGhhc2gAAArdCAHaCAIIfgJ/QvXKzYPXrNu38wAhAkLt3pHzlszct+QAIQNC4eSV89bs2bzsACEEQvPK0cunjNmy9AAhBUEIKQMAIQdBECkDACEIIAGtQjiGIQYgAUEHcSELIAAgAWogC2shCiAFIAiFIQUgBCAHhSEEIAMgCIUhAyACIAeFIQICQANAIAAgCkYNASAAKQMAIQkgBSAJhSEFIAIgA3whAiADQg2JIQMgAyAChSEDIAJCIIkhAiAEIAV8IQQgBUIQiSEFIAUgBIUhBSACIAV8IQIgBUIViSEFIAUgAoUhBSAEIAN8IQQgA0IRiSEDIAMgBIUhAyAEQiCJIQQgAiADfCECIANCDYkhAyADIAKFIQMgAkIgiSECIAQgBXwhBCAFQhCJIQUgBSAEhSEFIAIgBXwhAiAFQhWJIQUgBSAChSEFIAQgA3whBCADQhGJIQMgAyAEhSEDIARCIIkhBCACIAmFIQIgAEEIaiEADAALCwJAAkACQAJAAkACQAJAAkAgCw4HBwYFBAMCAQALIAYgADEABkIwhoQhBgsgBiAAMQAFQiiGhCEGCyAGIAAxAARCIIaEIQYLIAYgADEAA0IYhoQhBgsgBiAAMQACQhCGhCEGCyAGIAAxAAFCCIaEIQYLIAYgADEAAIQhBgsgBSAGhSEFIAIgA3whAiADQg2JIQMgAyAChSEDIAJCIIkhAiAEIAV8IQQgBUIQiSEFIAUgBIUhBSACIAV8IQIgBUIViSEFIAUgAoUhBSAEIAN8IQQgA0IRiSEDIAMgBIUhAyAEQiCJIQQgAiADfCECIANCDYkhAyADIAKFIQMgAkIgiSECIAQgBXwhBCAFQhCJIQUgBSAEhSEFIAIgBXwhAiAFQhWJIQUgBSAChSEFIAQgA3whBCADQhGJIQMgAyAEhSEDIARCIIkhBCACIAaFIQIgBEL/AYUhBCACIAN8IQIgA0INiSEDIAMgAoUhAyACQiCJIQIgBCAFfCEEIAVCEIkhBSAFIASFIQUgAiAFfCECIAVCFYkhBSAFIAKFIQUgBCADfCEEIANCEYkhAyADIASFIQMgBEIgiSEEIAIgA3whAiADQg2JIQMgAyAChSEDIAJCIIkhAiAEIAV8IQQgBUIQiSEFIAUgBIUhBSACIAV8IQIgBUIViSEFIAUgAoUhBSAEIAN8IQQgA0IRiSEDIAMgBIUhAyAEQiCJIQQgAiADfCECIANCDYkhAyADIAKFIQMgAkIgiSECIAQgBXwhBCAFQhCJIQUgBSAEhSEFIAIgBXwhAiAFQhWJIQUgBSAChSEFIAQgA3whBCADQhGJIQMgAyAEhSEDIARCIIkhBCACIAN8IQIgA0INiSEDIAMgAoUhAyACQiCJIQIgBCAFfCEEIAVCEIkhBSAFIASFIQUgAiAFfCECIAVCFYkhBSAFIAKFIQUgBCADfCEEIANCEYkhAyADIASFIQMgBEIgiSEEQQAgAiADIAQgBYWFhTcDAAs=");
    }
});
// wasm-module:./siphash24.wat
var $6fedb48d2e71b701$var$bytes = $6fedb48d2e71b701$var$require_siphash24();
var $6fedb48d2e71b701$var$compiled = new WebAssembly.Module($6fedb48d2e71b701$var$bytes);
module.exports = (imports)=>{
    const instance = new WebAssembly.Instance($6fedb48d2e71b701$var$compiled, imports);
    return instance.exports;
};

});

parcelRegister("17iVN", function(module, exports) {
module.exports = $0d0521369f03cf0d$var$fallback;
function $0d0521369f03cf0d$var$_add(a, b) {
    var rl = a.l + b.l;
    var a2 = {
        h: a.h + b.h + (rl / 2 >>> 31) >>> 0,
        l: rl >>> 0
    };
    a.h = a2.h;
    a.l = a2.l;
}
function $0d0521369f03cf0d$var$_xor(a, b) {
    a.h ^= b.h;
    a.h >>>= 0;
    a.l ^= b.l;
    a.l >>>= 0;
}
function $0d0521369f03cf0d$var$_rotl(a, n) {
    var a2 = {
        h: a.h << n | a.l >>> 32 - n,
        l: a.l << n | a.h >>> 32 - n
    };
    a.h = a2.h;
    a.l = a2.l;
}
function $0d0521369f03cf0d$var$_rotl32(a) {
    var al = a.l;
    a.l = a.h;
    a.h = al;
}
function $0d0521369f03cf0d$var$_compress(v0, v1, v2, v3) {
    $0d0521369f03cf0d$var$_add(v0, v1);
    $0d0521369f03cf0d$var$_add(v2, v3);
    $0d0521369f03cf0d$var$_rotl(v1, 13);
    $0d0521369f03cf0d$var$_rotl(v3, 16);
    $0d0521369f03cf0d$var$_xor(v1, v0);
    $0d0521369f03cf0d$var$_xor(v3, v2);
    $0d0521369f03cf0d$var$_rotl32(v0);
    $0d0521369f03cf0d$var$_add(v2, v1);
    $0d0521369f03cf0d$var$_add(v0, v3);
    $0d0521369f03cf0d$var$_rotl(v1, 17);
    $0d0521369f03cf0d$var$_rotl(v3, 21);
    $0d0521369f03cf0d$var$_xor(v1, v2);
    $0d0521369f03cf0d$var$_xor(v3, v0);
    $0d0521369f03cf0d$var$_rotl32(v2);
}
function $0d0521369f03cf0d$var$_get_int(a, offset) {
    return a[offset + 3] << 24 | a[offset + 2] << 16 | a[offset + 1] << 8 | a[offset];
}
function $0d0521369f03cf0d$var$fallback(out, m, key) {
    var k0 = {
        h: $0d0521369f03cf0d$var$_get_int(key, 4),
        l: $0d0521369f03cf0d$var$_get_int(key, 0)
    };
    var k1 = {
        h: $0d0521369f03cf0d$var$_get_int(key, 12),
        l: $0d0521369f03cf0d$var$_get_int(key, 8)
    };
    var v0 = {
        h: k0.h,
        l: k0.l
    };
    var v2 = k0;
    var v1 = {
        h: k1.h,
        l: k1.l
    };
    var v3 = k1;
    var mi;
    var mp = 0;
    var ml = m.length;
    var ml7 = ml - 7;
    var buf = new Uint8Array(new ArrayBuffer(8));
    $0d0521369f03cf0d$var$_xor(v0, {
        h: 0x736f6d65,
        l: 0x70736575
    });
    $0d0521369f03cf0d$var$_xor(v1, {
        h: 0x646f7261,
        l: 0x6e646f6d
    });
    $0d0521369f03cf0d$var$_xor(v2, {
        h: 0x6c796765,
        l: 0x6e657261
    });
    $0d0521369f03cf0d$var$_xor(v3, {
        h: 0x74656462,
        l: 0x79746573
    });
    while(mp < ml7){
        mi = {
            h: $0d0521369f03cf0d$var$_get_int(m, mp + 4),
            l: $0d0521369f03cf0d$var$_get_int(m, mp)
        };
        $0d0521369f03cf0d$var$_xor(v3, mi);
        $0d0521369f03cf0d$var$_compress(v0, v1, v2, v3);
        $0d0521369f03cf0d$var$_compress(v0, v1, v2, v3);
        $0d0521369f03cf0d$var$_xor(v0, mi);
        mp += 8;
    }
    buf[7] = ml;
    var ic = 0;
    while(mp < ml)buf[ic++] = m[mp++];
    while(ic < 7)buf[ic++] = 0;
    mi = {
        h: buf[7] << 24 | buf[6] << 16 | buf[5] << 8 | buf[4],
        l: buf[3] << 24 | buf[2] << 16 | buf[1] << 8 | buf[0]
    };
    $0d0521369f03cf0d$var$_xor(v3, mi);
    $0d0521369f03cf0d$var$_compress(v0, v1, v2, v3);
    $0d0521369f03cf0d$var$_compress(v0, v1, v2, v3);
    $0d0521369f03cf0d$var$_xor(v0, mi);
    $0d0521369f03cf0d$var$_xor(v2, {
        h: 0,
        l: 0xff
    });
    $0d0521369f03cf0d$var$_compress(v0, v1, v2, v3);
    $0d0521369f03cf0d$var$_compress(v0, v1, v2, v3);
    $0d0521369f03cf0d$var$_compress(v0, v1, v2, v3);
    $0d0521369f03cf0d$var$_compress(v0, v1, v2, v3);
    var h = v0;
    $0d0521369f03cf0d$var$_xor(h, v1);
    $0d0521369f03cf0d$var$_xor(h, v2);
    $0d0521369f03cf0d$var$_xor(h, v3);
    out[0] = h.l & 0xff;
    out[1] = h.l >> 8 & 0xff;
    out[2] = h.l >> 16 & 0xff;
    out[3] = h.l >> 24 & 0xff;
    out[4] = h.h & 0xff;
    out[5] = h.h >> 8 & 0xff;
    out[6] = h.h >> 16 & 0xff;
    out[7] = h.h >> 24 & 0xff;
}

});



parcelRegister("4vSiJ", function(module, exports) {
/* eslint-disable camelcase, one-var */ 
var $7wznJ = parcelRequire("7wznJ");
var $34942dbb96878e9c$require$crypto_verify_32 = $7wznJ.crypto_verify_32;

var $2lMhZ = parcelRequire("2lMhZ");
var $34942dbb96878e9c$require$crypto_hash = $2lMhZ.crypto_hash;

var $1ffNT = parcelRequire("1ffNT");
var $34942dbb96878e9c$require$gf = $1ffNT.gf;
var $34942dbb96878e9c$require$gf0 = $1ffNT.gf0;
var $34942dbb96878e9c$require$gf1 = $1ffNT.gf1;
var $34942dbb96878e9c$require$D = $1ffNT.D;
var $34942dbb96878e9c$require$D2 = $1ffNT.D2;
var $34942dbb96878e9c$require$X = $1ffNT.X;
var $34942dbb96878e9c$require$Y = $1ffNT.Y;
var $34942dbb96878e9c$require$I = $1ffNT.I;
var $34942dbb96878e9c$require$A = $1ffNT.A;
var $34942dbb96878e9c$require$Z = $1ffNT.Z;
var $34942dbb96878e9c$require$M = $1ffNT.M;
var $34942dbb96878e9c$require$S = $1ffNT.S;
var $34942dbb96878e9c$require$sel25519 = $1ffNT.sel25519;
var $34942dbb96878e9c$require$pack25519 = $1ffNT.pack25519;
var $34942dbb96878e9c$require$inv25519 = $1ffNT.inv25519;
var $34942dbb96878e9c$require$unpack25519 = $1ffNT.unpack25519;

var $aiVbm = parcelRequire("aiVbm");
var $34942dbb96878e9c$require$randombytes = $aiVbm.randombytes;

var $en1S3 = parcelRequire("en1S3");
var $34942dbb96878e9c$require$crypto_scalarmult_BYTES = $en1S3.crypto_scalarmult_BYTES;

var $2lMhZ = parcelRequire("2lMhZ");
var $34942dbb96878e9c$require$crypto_hash_sha512_BYTES = $2lMhZ.crypto_hash_sha512_BYTES;

var $6JSie = parcelRequire("6JSie");
const $34942dbb96878e9c$var$crypto_sign_ed25519_PUBLICKEYBYTES = 32;
const $34942dbb96878e9c$var$crypto_sign_ed25519_SECRETKEYBYTES = 64;
const $34942dbb96878e9c$var$crypto_sign_ed25519_SEEDBYTES = 32;
const $34942dbb96878e9c$var$crypto_sign_ed25519_BYTES = 64;
const $34942dbb96878e9c$var$crypto_sign_BYTES = $34942dbb96878e9c$var$crypto_sign_ed25519_BYTES;
const $34942dbb96878e9c$var$crypto_sign_PUBLICKEYBYTES = $34942dbb96878e9c$var$crypto_sign_ed25519_PUBLICKEYBYTES;
const $34942dbb96878e9c$var$crypto_sign_SECRETKEYBYTES = $34942dbb96878e9c$var$crypto_sign_ed25519_SECRETKEYBYTES;
const $34942dbb96878e9c$var$crypto_sign_SEEDBYTES = $34942dbb96878e9c$var$crypto_sign_ed25519_SEEDBYTES;
module.exports = {
    crypto_sign_keypair: $34942dbb96878e9c$var$crypto_sign_keypair,
    crypto_sign_seed_keypair: $34942dbb96878e9c$var$crypto_sign_seed_keypair,
    crypto_sign: $34942dbb96878e9c$var$crypto_sign,
    crypto_sign_detached: $34942dbb96878e9c$var$crypto_sign_detached,
    crypto_sign_open: $34942dbb96878e9c$var$crypto_sign_open,
    crypto_sign_verify_detached: $34942dbb96878e9c$var$crypto_sign_verify_detached,
    crypto_sign_BYTES: $34942dbb96878e9c$var$crypto_sign_BYTES,
    crypto_sign_PUBLICKEYBYTES: $34942dbb96878e9c$var$crypto_sign_PUBLICKEYBYTES,
    crypto_sign_SECRETKEYBYTES: $34942dbb96878e9c$var$crypto_sign_SECRETKEYBYTES,
    crypto_sign_SEEDBYTES: $34942dbb96878e9c$var$crypto_sign_SEEDBYTES,
    crypto_sign_ed25519_PUBLICKEYBYTES: $34942dbb96878e9c$var$crypto_sign_ed25519_PUBLICKEYBYTES,
    crypto_sign_ed25519_SECRETKEYBYTES: $34942dbb96878e9c$var$crypto_sign_ed25519_SECRETKEYBYTES,
    crypto_sign_ed25519_SEEDBYTES: $34942dbb96878e9c$var$crypto_sign_ed25519_SEEDBYTES,
    crypto_sign_ed25519_BYTES: $34942dbb96878e9c$var$crypto_sign_ed25519_BYTES,
    crypto_sign_ed25519_pk_to_curve25519: $34942dbb96878e9c$var$crypto_sign_ed25519_pk_to_curve25519,
    crypto_sign_ed25519_sk_to_curve25519: $34942dbb96878e9c$var$crypto_sign_ed25519_sk_to_curve25519,
    crypto_sign_ed25519_sk_to_pk: $34942dbb96878e9c$var$crypto_sign_ed25519_sk_to_pk,
    unpackneg: $34942dbb96878e9c$var$unpackneg,
    pack: $34942dbb96878e9c$var$pack
};
function $34942dbb96878e9c$var$set25519(r, a) {
    for(let i = 0; i < 16; i++)r[i] = a[i] | 0;
}
function $34942dbb96878e9c$var$pow2523(o, i) {
    var c = $34942dbb96878e9c$require$gf();
    var a;
    for(a = 0; a < 16; a++)c[a] = i[a];
    for(a = 250; a >= 0; a--){
        $34942dbb96878e9c$require$S(c, c);
        if (a !== 1) $34942dbb96878e9c$require$M(c, c, i);
    }
    for(a = 0; a < 16; a++)o[a] = c[a];
}
function $34942dbb96878e9c$var$add(p, q) {
    var a = $34942dbb96878e9c$require$gf(), b = $34942dbb96878e9c$require$gf(), c = $34942dbb96878e9c$require$gf(), d = $34942dbb96878e9c$require$gf(), e = $34942dbb96878e9c$require$gf(), f = $34942dbb96878e9c$require$gf(), g = $34942dbb96878e9c$require$gf(), h = $34942dbb96878e9c$require$gf(), t = $34942dbb96878e9c$require$gf();
    $34942dbb96878e9c$require$Z(a, p[1], p[0]);
    $34942dbb96878e9c$require$Z(t, q[1], q[0]);
    $34942dbb96878e9c$require$M(a, a, t);
    $34942dbb96878e9c$require$A(b, p[0], p[1]);
    $34942dbb96878e9c$require$A(t, q[0], q[1]);
    $34942dbb96878e9c$require$M(b, b, t);
    $34942dbb96878e9c$require$M(c, p[3], q[3]);
    $34942dbb96878e9c$require$M(c, c, $34942dbb96878e9c$require$D2);
    $34942dbb96878e9c$require$M(d, p[2], q[2]);
    $34942dbb96878e9c$require$A(d, d, d);
    $34942dbb96878e9c$require$Z(e, b, a);
    $34942dbb96878e9c$require$Z(f, d, c);
    $34942dbb96878e9c$require$A(g, d, c);
    $34942dbb96878e9c$require$A(h, b, a);
    $34942dbb96878e9c$require$M(p[0], e, f);
    $34942dbb96878e9c$require$M(p[1], h, g);
    $34942dbb96878e9c$require$M(p[2], g, f);
    $34942dbb96878e9c$require$M(p[3], e, h);
}
function $34942dbb96878e9c$var$cswap(p, q, b) {
    var i;
    for(i = 0; i < 4; i++)$34942dbb96878e9c$require$sel25519(p[i], q[i], b);
}
function $34942dbb96878e9c$var$pack(r, p) {
    var tx = $34942dbb96878e9c$require$gf(), ty = $34942dbb96878e9c$require$gf(), zi = $34942dbb96878e9c$require$gf();
    $34942dbb96878e9c$require$inv25519(zi, p[2]);
    $34942dbb96878e9c$require$M(tx, p[0], zi);
    $34942dbb96878e9c$require$M(ty, p[1], zi);
    $34942dbb96878e9c$require$pack25519(r, ty);
    r[31] ^= $34942dbb96878e9c$var$par25519(tx) << 7;
}
function $34942dbb96878e9c$var$scalarmult(p, q, s) {
    // don't mutate q
    var h = [
        $34942dbb96878e9c$require$gf(q[0]),
        $34942dbb96878e9c$require$gf(q[1]),
        $34942dbb96878e9c$require$gf(q[2]),
        $34942dbb96878e9c$require$gf(q[3])
    ];
    var b, i;
    $34942dbb96878e9c$var$set25519(p[0], $34942dbb96878e9c$require$gf0);
    $34942dbb96878e9c$var$set25519(p[1], $34942dbb96878e9c$require$gf1);
    $34942dbb96878e9c$var$set25519(p[2], $34942dbb96878e9c$require$gf1);
    $34942dbb96878e9c$var$set25519(p[3], $34942dbb96878e9c$require$gf0);
    for(i = 255; i >= 0; --i){
        b = s[i / 8 | 0] >> (i & 7) & 1;
        $34942dbb96878e9c$var$cswap(p, h, b);
        $34942dbb96878e9c$var$add(h, p);
        $34942dbb96878e9c$var$add(p, p);
        $34942dbb96878e9c$var$cswap(p, h, b);
    }
}
function $34942dbb96878e9c$var$scalarbase(p, s) {
    var q = [
        $34942dbb96878e9c$require$gf(),
        $34942dbb96878e9c$require$gf(),
        $34942dbb96878e9c$require$gf(),
        $34942dbb96878e9c$require$gf()
    ];
    $34942dbb96878e9c$var$set25519(q[0], $34942dbb96878e9c$require$X);
    $34942dbb96878e9c$var$set25519(q[1], $34942dbb96878e9c$require$Y);
    $34942dbb96878e9c$var$set25519(q[2], $34942dbb96878e9c$require$gf1);
    $34942dbb96878e9c$require$M(q[3], $34942dbb96878e9c$require$X, $34942dbb96878e9c$require$Y);
    $34942dbb96878e9c$var$scalarmult(p, q, s);
}
function $34942dbb96878e9c$var$crypto_sign_keypair(pk, sk, seeded) {
    $34942dbb96878e9c$var$check(pk, $34942dbb96878e9c$var$crypto_sign_PUBLICKEYBYTES);
    $34942dbb96878e9c$var$check(sk, $34942dbb96878e9c$var$crypto_sign_SECRETKEYBYTES);
    var d = new Uint8Array(64);
    var p = [
        $34942dbb96878e9c$require$gf(),
        $34942dbb96878e9c$require$gf(),
        $34942dbb96878e9c$require$gf(),
        $34942dbb96878e9c$require$gf()
    ];
    var i;
    if (!seeded) $34942dbb96878e9c$require$randombytes(sk, 32);
    $34942dbb96878e9c$require$crypto_hash(d, sk, 32);
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    $34942dbb96878e9c$var$scalarbase(p, d);
    $34942dbb96878e9c$var$pack(pk, p);
    for(i = 0; i < 32; i++)sk[i + 32] = pk[i];
}
function $34942dbb96878e9c$var$crypto_sign_seed_keypair(pk, sk, seed) {
    $34942dbb96878e9c$var$check(seed, $34942dbb96878e9c$var$crypto_sign_SEEDBYTES);
    sk.set(seed);
    return $34942dbb96878e9c$var$crypto_sign_keypair(pk, sk, true);
}
var $34942dbb96878e9c$var$L = new Float64Array([
    0xed,
    0xd3,
    0xf5,
    0x5c,
    0x1a,
    0x63,
    0x12,
    0x58,
    0xd6,
    0x9c,
    0xf7,
    0xa2,
    0xde,
    0xf9,
    0xde,
    0x14,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0x10
]);
function $34942dbb96878e9c$var$modL(r, x) {
    var carry, i, j, k;
    for(i = 63; i >= 32; --i){
        carry = 0;
        for(j = i - 32, k = i - 12; j < k; ++j){
            x[j] += carry - 16 * x[i] * $34942dbb96878e9c$var$L[j - (i - 32)];
            carry = x[j] + 128 >> 8;
            x[j] -= carry * 256;
        }
        x[j] += carry;
        x[i] = 0;
    }
    carry = 0;
    for(j = 0; j < 32; j++){
        x[j] += carry - (x[31] >> 4) * $34942dbb96878e9c$var$L[j];
        carry = x[j] >> 8;
        x[j] &= 255;
    }
    for(j = 0; j < 32; j++)x[j] -= carry * $34942dbb96878e9c$var$L[j];
    for(i = 0; i < 32; i++){
        x[i + 1] += x[i] >> 8;
        r[i] = x[i] & 255;
    }
}
function $34942dbb96878e9c$var$reduce(r) {
    var x = new Float64Array(64);
    for(let i = 0; i < 64; i++)x[i] = r[i];
    for(let i = 0; i < 64; i++)r[i] = 0;
    $34942dbb96878e9c$var$modL(r, x);
}
// Note: difference from C - smlen returned, not passed as argument.
function $34942dbb96878e9c$var$crypto_sign(sm, m, sk) {
    $34942dbb96878e9c$var$check(sm, $34942dbb96878e9c$var$crypto_sign_BYTES + m.length);
    $34942dbb96878e9c$var$check(m, 0);
    $34942dbb96878e9c$var$check(sk, $34942dbb96878e9c$var$crypto_sign_SECRETKEYBYTES);
    var n = m.length;
    var d = new Uint8Array(64), h = new Uint8Array(64), r = new Uint8Array(64);
    var i, j, x = new Float64Array(64);
    var p = [
        $34942dbb96878e9c$require$gf(),
        $34942dbb96878e9c$require$gf(),
        $34942dbb96878e9c$require$gf(),
        $34942dbb96878e9c$require$gf()
    ];
    $34942dbb96878e9c$require$crypto_hash(d, sk, 32);
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    var smlen = n + 64;
    for(i = 0; i < n; i++)sm[64 + i] = m[i];
    for(i = 0; i < 32; i++)sm[32 + i] = d[32 + i];
    $34942dbb96878e9c$require$crypto_hash(r, sm.subarray(32), n + 32);
    $34942dbb96878e9c$var$reduce(r);
    $34942dbb96878e9c$var$scalarbase(p, r);
    $34942dbb96878e9c$var$pack(sm, p);
    for(i = 32; i < 64; i++)sm[i] = sk[i];
    $34942dbb96878e9c$require$crypto_hash(h, sm, n + 64);
    $34942dbb96878e9c$var$reduce(h);
    for(i = 0; i < 64; i++)x[i] = 0;
    for(i = 0; i < 32; i++)x[i] = r[i];
    for(i = 0; i < 32; i++)for(j = 0; j < 32; j++)x[i + j] += h[i] * d[j];
    $34942dbb96878e9c$var$modL(sm.subarray(32), x);
    return smlen;
}
function $34942dbb96878e9c$var$crypto_sign_detached(sig, m, sk) {
    var sm = new Uint8Array(m.length + $34942dbb96878e9c$var$crypto_sign_BYTES);
    $34942dbb96878e9c$var$crypto_sign(sm, m, sk);
    for(let i = 0; i < $34942dbb96878e9c$var$crypto_sign_BYTES; i++)sig[i] = sm[i];
}
function $34942dbb96878e9c$var$unpackneg(r, p) {
    var t = $34942dbb96878e9c$require$gf(), chk = $34942dbb96878e9c$require$gf(), num = $34942dbb96878e9c$require$gf(), den = $34942dbb96878e9c$require$gf(), den2 = $34942dbb96878e9c$require$gf(), den4 = $34942dbb96878e9c$require$gf(), den6 = $34942dbb96878e9c$require$gf();
    $34942dbb96878e9c$var$set25519(r[2], $34942dbb96878e9c$require$gf1);
    $34942dbb96878e9c$require$unpack25519(r[1], p);
    $34942dbb96878e9c$require$S(num, r[1]);
    $34942dbb96878e9c$require$M(den, num, $34942dbb96878e9c$require$D);
    $34942dbb96878e9c$require$Z(num, num, r[2]);
    $34942dbb96878e9c$require$A(den, r[2], den);
    $34942dbb96878e9c$require$S(den2, den);
    $34942dbb96878e9c$require$S(den4, den2);
    $34942dbb96878e9c$require$M(den6, den4, den2);
    $34942dbb96878e9c$require$M(t, den6, num);
    $34942dbb96878e9c$require$M(t, t, den);
    $34942dbb96878e9c$var$pow2523(t, t);
    $34942dbb96878e9c$require$M(t, t, num);
    $34942dbb96878e9c$require$M(t, t, den);
    $34942dbb96878e9c$require$M(t, t, den);
    $34942dbb96878e9c$require$M(r[0], t, den);
    $34942dbb96878e9c$require$S(chk, r[0]);
    $34942dbb96878e9c$require$M(chk, chk, den);
    if (!$34942dbb96878e9c$var$neq25519(chk, num)) $34942dbb96878e9c$require$M(r[0], r[0], $34942dbb96878e9c$require$I);
    $34942dbb96878e9c$require$S(chk, r[0]);
    $34942dbb96878e9c$require$M(chk, chk, den);
    if (!$34942dbb96878e9c$var$neq25519(chk, num)) return false;
    if ($34942dbb96878e9c$var$par25519(r[0]) === p[31] >> 7) $34942dbb96878e9c$require$Z(r[0], $34942dbb96878e9c$require$gf(), r[0]);
    $34942dbb96878e9c$require$M(r[3], r[0], r[1]);
    return true;
}
/* eslint-disable no-unused-vars */ function $34942dbb96878e9c$var$crypto_sign_open(msg, sm, pk) {
    $34942dbb96878e9c$var$check(msg, sm.length - $34942dbb96878e9c$var$crypto_sign_BYTES);
    $34942dbb96878e9c$var$check(sm, $34942dbb96878e9c$var$crypto_sign_BYTES);
    $34942dbb96878e9c$var$check(pk, $34942dbb96878e9c$var$crypto_sign_PUBLICKEYBYTES);
    var n = sm.length;
    var m = new Uint8Array(sm.length);
    var i, mlen;
    var t = new Uint8Array(32), h = new Uint8Array(64);
    var p = [
        $34942dbb96878e9c$require$gf(),
        $34942dbb96878e9c$require$gf(),
        $34942dbb96878e9c$require$gf(),
        $34942dbb96878e9c$require$gf()
    ], q = [
        $34942dbb96878e9c$require$gf(),
        $34942dbb96878e9c$require$gf(),
        $34942dbb96878e9c$require$gf(),
        $34942dbb96878e9c$require$gf()
    ];
    mlen = -1;
    if (n < 64) return false;
    if (!$34942dbb96878e9c$var$unpackneg(q, pk)) return false;
    for(i = 0; i < n; i++)m[i] = sm[i];
    for(i = 0; i < 32; i++)m[i + 32] = pk[i];
    $34942dbb96878e9c$require$crypto_hash(h, m, n);
    $34942dbb96878e9c$var$reduce(h);
    $34942dbb96878e9c$var$scalarmult(p, q, h);
    $34942dbb96878e9c$var$scalarbase(q, sm.subarray(32));
    $34942dbb96878e9c$var$add(p, q);
    $34942dbb96878e9c$var$pack(t, p);
    n -= 64;
    if (!$34942dbb96878e9c$require$crypto_verify_32(sm, 0, t, 0)) {
        for(i = 0; i < n; i++)m[i] = 0;
        return false;
    // throw new Error('crypto_sign_open failed')
    }
    for(i = 0; i < n; i++)msg[i] = sm[i + 64];
    mlen = n;
    return true;
}
/* eslint-enable no-unused-vars */ function $34942dbb96878e9c$var$crypto_sign_verify_detached(sig, m, pk) {
    $34942dbb96878e9c$var$check(sig, $34942dbb96878e9c$var$crypto_sign_BYTES);
    var sm = new Uint8Array(m.length + $34942dbb96878e9c$var$crypto_sign_BYTES);
    var i = 0;
    for(i = 0; i < $34942dbb96878e9c$var$crypto_sign_BYTES; i++)sm[i] = sig[i];
    for(i = 0; i < m.length; i++)sm[i + $34942dbb96878e9c$var$crypto_sign_BYTES] = m[i];
    return $34942dbb96878e9c$var$crypto_sign_open(m, sm, pk);
}
function $34942dbb96878e9c$var$par25519(a) {
    var d = new Uint8Array(32);
    $34942dbb96878e9c$require$pack25519(d, a);
    return d[0] & 1;
}
function $34942dbb96878e9c$var$neq25519(a, b) {
    var c = new Uint8Array(32), d = new Uint8Array(32);
    $34942dbb96878e9c$require$pack25519(c, a);
    $34942dbb96878e9c$require$pack25519(d, b);
    return $34942dbb96878e9c$require$crypto_verify_32(c, 0, d, 0);
}
function $34942dbb96878e9c$var$ed25519_mul_l(p, q) {
    $34942dbb96878e9c$var$scalarmult(p, q, $34942dbb96878e9c$var$L);
}
function $34942dbb96878e9c$var$ed25519_is_on_main_subgroup(p) {
    var pl = [
        $34942dbb96878e9c$require$gf(),
        $34942dbb96878e9c$require$gf(),
        $34942dbb96878e9c$require$gf(),
        $34942dbb96878e9c$require$gf()
    ];
    $34942dbb96878e9c$var$ed25519_mul_l(pl, p);
    var zero = 0;
    for(let i = 0; i < 16; i++)zero |= pl[0][i] & 0xffff;
    return zero === 0;
}
function $34942dbb96878e9c$var$crypto_sign_ed25519_pk_to_curve25519(x25519_pk, ed25519_pk) {
    $34942dbb96878e9c$var$check(x25519_pk, $34942dbb96878e9c$var$crypto_sign_PUBLICKEYBYTES);
    $34942dbb96878e9c$var$check(ed25519_pk, $34942dbb96878e9c$var$crypto_sign_ed25519_PUBLICKEYBYTES);
    var a = [
        $34942dbb96878e9c$require$gf(),
        $34942dbb96878e9c$require$gf(),
        $34942dbb96878e9c$require$gf(),
        $34942dbb96878e9c$require$gf()
    ];
    var x = $34942dbb96878e9c$require$gf([
        1
    ]);
    var one_minus_y = $34942dbb96878e9c$require$gf([
        1
    ]);
    $6JSie($34942dbb96878e9c$var$isSmallOrder(ed25519_pk) && $34942dbb96878e9c$var$unpackneg(a, ed25519_pk) && $34942dbb96878e9c$var$ed25519_is_on_main_subgroup(a), "Cannot convert key: bad point");
    for(let i = 0; i < a.length; i++)$34942dbb96878e9c$require$pack25519(x25519_pk, a[i]);
    $34942dbb96878e9c$require$Z(one_minus_y, one_minus_y, a[1]);
    $34942dbb96878e9c$require$A(x, x, a[1]);
    $34942dbb96878e9c$require$inv25519(one_minus_y, one_minus_y);
    $34942dbb96878e9c$require$M(x, x, one_minus_y);
    $34942dbb96878e9c$require$pack25519(x25519_pk, x);
    return 0;
}
function $34942dbb96878e9c$var$isSmallOrder(s) {
    Uint8Array.from([]);
    var bad_points = [
        // 0 (order 4)
        Uint8Array.from([
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00
        ]),
        // 1 (order 1)
        Uint8Array.from([
            0x01,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00
        ]),
        // 2707385501144840649318225287225658788936804267575313519463743609750303402022(order 8)
        Uint8Array.from([
            0x26,
            0xe8,
            0x95,
            0x8f,
            0xc2,
            0xb2,
            0x27,
            0xb0,
            0x45,
            0xc3,
            0xf4,
            0x89,
            0xf2,
            0xef,
            0x98,
            0xf0,
            0xd5,
            0xdf,
            0xac,
            0x05,
            0xd3,
            0xc6,
            0x33,
            0x39,
            0xb1,
            0x38,
            0x02,
            0x88,
            0x6d,
            0x53,
            0xfc,
            0x05
        ]),
        // 55188659117513257062467267217118295137698188065244968500265048394206261417927 (order 8)
        Uint8Array.from([
            0xc7,
            0x17,
            0x6a,
            0x70,
            0x3d,
            0x4d,
            0xd8,
            0x4f,
            0xba,
            0x3c,
            0x0b,
            0x76,
            0x0d,
            0x10,
            0x67,
            0x0f,
            0x2a,
            0x20,
            0x53,
            0xfa,
            0x2c,
            0x39,
            0xcc,
            0xc6,
            0x4e,
            0xc7,
            0xfd,
            0x77,
            0x92,
            0xac,
            0x03,
            0x7a
        ]),
        // p-1 (order 2)
        Uint8Array.from([
            0xec,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0x7f
        ]),
        //  p (=0 order 4)
        Uint8Array.from([
            0xed,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0x7f
        ]),
        // p + 1 (=1 order 1)
        Uint8Array.from([
            0xee,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0xff,
            0x7f
        ])
    ];
    var c = new Uint8Array(7);
    var j;
    $34942dbb96878e9c$var$check(bad_points, 7);
    for(let i = 0; i < bad_points.length; i++)for(j = 0; j < 31; j++)c[i] |= s[j] ^ bad_points[i][j];
    for(let i = 0; i < bad_points.length; i++)c[i] |= s[j] & 0x7f ^ bad_points[i][j];
    var k = 0;
    for(let i = 0; i < bad_points.length; i++)k |= c[i] - 1;
    return (k >> 8 & 1) === 0;
}
function $34942dbb96878e9c$var$crypto_sign_ed25519_sk_to_pk(pk, sk) {
    $34942dbb96878e9c$var$check(pk, $34942dbb96878e9c$var$crypto_sign_ed25519_PUBLICKEYBYTES);
    pk.set(sk.subarray($34942dbb96878e9c$var$crypto_sign_ed25519_SEEDBYTES));
    return pk;
}
function $34942dbb96878e9c$var$crypto_sign_ed25519_sk_to_curve25519(curveSk, edSk) {
    $6JSie(curveSk && curveSk.byteLength === $34942dbb96878e9c$require$crypto_scalarmult_BYTES, "curveSk must be 'crypto_sign_SECRETKEYBYTES' long");
    $6JSie(edSk && edSk.byteLength === $34942dbb96878e9c$var$crypto_sign_ed25519_SECRETKEYBYTES, "edSk must be 'crypto_sign_ed25519_SECRETKEYBYTES' long");
    var h = new Uint8Array($34942dbb96878e9c$require$crypto_hash_sha512_BYTES);
    $34942dbb96878e9c$require$crypto_hash(h, edSk, 32);
    h[0] &= 248;
    h[31] &= 127;
    h[31] |= 64;
    curveSk.set(h.subarray(0, $34942dbb96878e9c$require$crypto_scalarmult_BYTES));
    h.fill(0);
    return curveSk;
}
function $34942dbb96878e9c$var$check(buf, len, arg = "Argument") {
    if (!buf || len && buf.length < len) throw new Error(arg + " must be a buffer" + (len ? " of length " + len : ""));
}

});


let $9ac5634fc6778fc7$var$taskIdCounter = 1, $9ac5634fc6778fc7$var$isCallbackScheduled = false, $9ac5634fc6778fc7$var$isPerformingWork = false, $9ac5634fc6778fc7$var$taskQueue = [], $9ac5634fc6778fc7$var$currentTask = null, $9ac5634fc6778fc7$var$shouldYieldToHost = null, $9ac5634fc6778fc7$var$yieldInterval = 5, $9ac5634fc6778fc7$var$deadline = 0, $9ac5634fc6778fc7$var$maxYieldInterval = 300, $9ac5634fc6778fc7$var$scheduleCallback = null, $9ac5634fc6778fc7$var$scheduledCallback = null;
const $9ac5634fc6778fc7$var$maxSigned31BitInt = 1073741823;
function $9ac5634fc6778fc7$var$setupScheduler() {
    const channel = new MessageChannel(), port = channel.port2;
    $9ac5634fc6778fc7$var$scheduleCallback = ()=>port.postMessage(null);
    channel.port1.onmessage = ()=>{
        if ($9ac5634fc6778fc7$var$scheduledCallback !== null) {
            const currentTime = performance.now();
            $9ac5634fc6778fc7$var$deadline = currentTime + $9ac5634fc6778fc7$var$yieldInterval;
            const hasTimeRemaining = true;
            try {
                const hasMoreWork = $9ac5634fc6778fc7$var$scheduledCallback(hasTimeRemaining, currentTime);
                if (!hasMoreWork) $9ac5634fc6778fc7$var$scheduledCallback = null;
                else port.postMessage(null);
            } catch (error) {
                port.postMessage(null);
                throw error;
            }
        }
    };
    if (navigator && navigator.scheduling && navigator.scheduling.isInputPending) {
        const scheduling = navigator.scheduling;
        $9ac5634fc6778fc7$var$shouldYieldToHost = ()=>{
            const currentTime = performance.now();
            if (currentTime >= $9ac5634fc6778fc7$var$deadline) {
                if (scheduling.isInputPending()) return true;
                return currentTime >= $9ac5634fc6778fc7$var$maxYieldInterval;
            } else return false;
        };
    } else $9ac5634fc6778fc7$var$shouldYieldToHost = ()=>performance.now() >= $9ac5634fc6778fc7$var$deadline;
}
function $9ac5634fc6778fc7$var$enqueue(taskQueue, task) {
    function findIndex() {
        let m = 0;
        let n = taskQueue.length - 1;
        while(m <= n){
            const k = n + m >> 1;
            const cmp = task.expirationTime - taskQueue[k].expirationTime;
            if (cmp > 0) m = k + 1;
            else if (cmp < 0) n = k - 1;
            else return k;
        }
        return m;
    }
    taskQueue.splice(findIndex(), 0, task);
}
function $9ac5634fc6778fc7$export$4b5e076b3a2fbe0a(fn, options) {
    if (!$9ac5634fc6778fc7$var$scheduleCallback) $9ac5634fc6778fc7$var$setupScheduler();
    let startTime = performance.now(), timeout = $9ac5634fc6778fc7$var$maxSigned31BitInt;
    if (options && options.timeout) timeout = options.timeout;
    const newTask = {
        id: $9ac5634fc6778fc7$var$taskIdCounter++,
        fn: fn,
        startTime: startTime,
        expirationTime: startTime + timeout
    };
    $9ac5634fc6778fc7$var$enqueue($9ac5634fc6778fc7$var$taskQueue, newTask);
    if (!$9ac5634fc6778fc7$var$isCallbackScheduled && !$9ac5634fc6778fc7$var$isPerformingWork) {
        $9ac5634fc6778fc7$var$isCallbackScheduled = true;
        $9ac5634fc6778fc7$var$scheduledCallback = $9ac5634fc6778fc7$var$flushWork;
        $9ac5634fc6778fc7$var$scheduleCallback();
    }
    return newTask;
}
function $9ac5634fc6778fc7$export$b888d8f981c07a46(task) {
    task.fn = null;
}
function $9ac5634fc6778fc7$var$flushWork(hasTimeRemaining, initialTime) {
    $9ac5634fc6778fc7$var$isCallbackScheduled = false;
    $9ac5634fc6778fc7$var$isPerformingWork = true;
    try {
        return $9ac5634fc6778fc7$var$workLoop(hasTimeRemaining, initialTime);
    } finally{
        $9ac5634fc6778fc7$var$currentTask = null;
        $9ac5634fc6778fc7$var$isPerformingWork = false;
    }
}
function $9ac5634fc6778fc7$var$workLoop(hasTimeRemaining, initialTime) {
    let currentTime = initialTime;
    $9ac5634fc6778fc7$var$currentTask = $9ac5634fc6778fc7$var$taskQueue[0] || null;
    while($9ac5634fc6778fc7$var$currentTask !== null){
        if ($9ac5634fc6778fc7$var$currentTask.expirationTime > currentTime && (!hasTimeRemaining || $9ac5634fc6778fc7$var$shouldYieldToHost())) break;
        const callback = $9ac5634fc6778fc7$var$currentTask.fn;
        if (callback !== null) {
            $9ac5634fc6778fc7$var$currentTask.fn = null;
            const didUserCallbackTimeout = $9ac5634fc6778fc7$var$currentTask.expirationTime <= currentTime;
            callback(didUserCallbackTimeout);
            currentTime = performance.now();
            if ($9ac5634fc6778fc7$var$currentTask === $9ac5634fc6778fc7$var$taskQueue[0]) $9ac5634fc6778fc7$var$taskQueue.shift();
        } else $9ac5634fc6778fc7$var$taskQueue.shift();
        $9ac5634fc6778fc7$var$currentTask = $9ac5634fc6778fc7$var$taskQueue[0] || null;
    }
    return $9ac5634fc6778fc7$var$currentTask !== null;
}
const $9ac5634fc6778fc7$export$2cb4986bed338027 = {
    context: undefined,
    registry: undefined
};
function $9ac5634fc6778fc7$var$setHydrateContext(context) {
    $9ac5634fc6778fc7$export$2cb4986bed338027.context = context;
}
function $9ac5634fc6778fc7$var$nextHydrateContext() {
    return {
        ...$9ac5634fc6778fc7$export$2cb4986bed338027.context,
        id: `${$9ac5634fc6778fc7$export$2cb4986bed338027.context.id}${$9ac5634fc6778fc7$export$2cb4986bed338027.context.count++}-`,
        count: 0
    };
}
const $9ac5634fc6778fc7$export$34b67c27f2ca7498 = (a, b)=>a === b;
const $9ac5634fc6778fc7$export$5cd89106e2f6c2c5 = Symbol("solid-proxy");
const $9ac5634fc6778fc7$export$17a675b7c02a7b1d = Symbol("solid-track");
const $9ac5634fc6778fc7$export$f5625ae0b78e5b20 = Symbol("solid-dev-component");
const $9ac5634fc6778fc7$var$signalOptions = {
    equals: $9ac5634fc6778fc7$export$34b67c27f2ca7498
};
let $9ac5634fc6778fc7$var$ERROR = null;
let $9ac5634fc6778fc7$var$runEffects = $9ac5634fc6778fc7$var$runQueue;
const $9ac5634fc6778fc7$var$STALE = 1;
const $9ac5634fc6778fc7$var$PENDING = 2;
const $9ac5634fc6778fc7$var$UNOWNED = {
    owned: null,
    cleanups: null,
    context: null,
    owner: null
};
const $9ac5634fc6778fc7$var$NO_INIT = {};
var $9ac5634fc6778fc7$var$Owner = null;
let $9ac5634fc6778fc7$var$Transition = null;
let $9ac5634fc6778fc7$var$Scheduler = null;
let $9ac5634fc6778fc7$var$ExternalSourceFactory = null;
let $9ac5634fc6778fc7$var$Listener = null;
let $9ac5634fc6778fc7$var$Updates = null;
let $9ac5634fc6778fc7$var$Effects = null;
let $9ac5634fc6778fc7$var$ExecCount = 0;
const [$9ac5634fc6778fc7$var$transPending, $9ac5634fc6778fc7$var$setTransPending] = /*@__PURE__*/ $9ac5634fc6778fc7$export$c1e1e1ecbbe76a5(false);
function $9ac5634fc6778fc7$export$882461b6382ed46c(fn, detachedOwner) {
    const listener = $9ac5634fc6778fc7$var$Listener, owner = $9ac5634fc6778fc7$var$Owner, unowned = fn.length === 0, current = detachedOwner === undefined ? owner : detachedOwner, root = unowned ? $9ac5634fc6778fc7$var$UNOWNED : {
        owned: null,
        cleanups: null,
        context: current ? current.context : null,
        owner: current
    }, updateFn = unowned ? fn : ()=>fn(()=>$9ac5634fc6778fc7$export$363ebc4b78b8f807(()=>$9ac5634fc6778fc7$var$cleanNode(root)));
    $9ac5634fc6778fc7$var$Owner = root;
    $9ac5634fc6778fc7$var$Listener = null;
    try {
        return $9ac5634fc6778fc7$var$runUpdates(updateFn, true);
    } finally{
        $9ac5634fc6778fc7$var$Listener = listener;
        $9ac5634fc6778fc7$var$Owner = owner;
    }
}
function $9ac5634fc6778fc7$export$c1e1e1ecbbe76a5(value, options) {
    options = options ? Object.assign({}, $9ac5634fc6778fc7$var$signalOptions, options) : $9ac5634fc6778fc7$var$signalOptions;
    const s = {
        value: value,
        observers: null,
        observerSlots: null,
        comparator: options.equals || undefined
    };
    const setter = (value)=>{
        if (typeof value === "function") {
            if ($9ac5634fc6778fc7$var$Transition && $9ac5634fc6778fc7$var$Transition.running && $9ac5634fc6778fc7$var$Transition.sources.has(s)) value = value(s.tValue);
            else value = value(s.value);
        }
        return $9ac5634fc6778fc7$var$writeSignal(s, value);
    };
    return [
        $9ac5634fc6778fc7$var$readSignal.bind(s),
        setter
    ];
}
function $9ac5634fc6778fc7$export$234a23cdc77e6a3d(fn, value, options) {
    const c = $9ac5634fc6778fc7$var$createComputation(fn, value, true, $9ac5634fc6778fc7$var$STALE);
    if ($9ac5634fc6778fc7$var$Scheduler && $9ac5634fc6778fc7$var$Transition && $9ac5634fc6778fc7$var$Transition.running) $9ac5634fc6778fc7$var$Updates.push(c);
    else $9ac5634fc6778fc7$var$updateComputation(c);
}
function $9ac5634fc6778fc7$export$314dade334ae905d(fn, value, options) {
    const c = $9ac5634fc6778fc7$var$createComputation(fn, value, false, $9ac5634fc6778fc7$var$STALE);
    if ($9ac5634fc6778fc7$var$Scheduler && $9ac5634fc6778fc7$var$Transition && $9ac5634fc6778fc7$var$Transition.running) $9ac5634fc6778fc7$var$Updates.push(c);
    else $9ac5634fc6778fc7$var$updateComputation(c);
}
function $9ac5634fc6778fc7$export$7ea7134f704deda4(fn, value, options) {
    $9ac5634fc6778fc7$var$runEffects = $9ac5634fc6778fc7$var$runUserEffects;
    const c = $9ac5634fc6778fc7$var$createComputation(fn, value, false, $9ac5634fc6778fc7$var$STALE), s = $9ac5634fc6778fc7$var$SuspenseContext && $9ac5634fc6778fc7$export$fae74005e78b1a27($9ac5634fc6778fc7$var$SuspenseContext);
    if (s) c.suspense = s;
    if (!options || !options.render) c.user = true;
    $9ac5634fc6778fc7$var$Effects ? $9ac5634fc6778fc7$var$Effects.push(c) : $9ac5634fc6778fc7$var$updateComputation(c);
}
function $9ac5634fc6778fc7$export$5ce14d95ebb45542(onInvalidate, options) {
    let fn;
    const c = $9ac5634fc6778fc7$var$createComputation(()=>{
        fn ? fn() : $9ac5634fc6778fc7$export$363ebc4b78b8f807(onInvalidate);
        fn = undefined;
    }, undefined, false, 0), s = $9ac5634fc6778fc7$var$SuspenseContext && $9ac5634fc6778fc7$export$fae74005e78b1a27($9ac5634fc6778fc7$var$SuspenseContext);
    if (s) c.suspense = s;
    c.user = true;
    return (tracking)=>{
        fn = tracking;
        $9ac5634fc6778fc7$var$updateComputation(c);
    };
}
function $9ac5634fc6778fc7$export$c0c6c8b9c16bf6aa(fn, value, options) {
    options = options ? Object.assign({}, $9ac5634fc6778fc7$var$signalOptions, options) : $9ac5634fc6778fc7$var$signalOptions;
    const c = $9ac5634fc6778fc7$var$createComputation(fn, value, true, 0);
    c.observers = null;
    c.observerSlots = null;
    c.comparator = options.equals || undefined;
    if ($9ac5634fc6778fc7$var$Scheduler && $9ac5634fc6778fc7$var$Transition && $9ac5634fc6778fc7$var$Transition.running) {
        c.tState = $9ac5634fc6778fc7$var$STALE;
        $9ac5634fc6778fc7$var$Updates.push(c);
    } else $9ac5634fc6778fc7$var$updateComputation(c);
    return $9ac5634fc6778fc7$var$readSignal.bind(c);
}
function $9ac5634fc6778fc7$var$isPromise(v) {
    return v && typeof v === "object" && "then" in v;
}
function $9ac5634fc6778fc7$export$edd172c6c83c39cc(pSource, pFetcher, pOptions) {
    let source;
    let fetcher;
    let options;
    if (arguments.length === 2 && typeof pFetcher === "object" || arguments.length === 1) {
        source = true;
        fetcher = pSource;
        options = pFetcher || {};
    } else {
        source = pSource;
        fetcher = pFetcher;
        options = pOptions || {};
    }
    let pr = null, initP = $9ac5634fc6778fc7$var$NO_INIT, id = null, loadedUnderTransition = false, scheduled = false, resolved = "initialValue" in options, dynamic = typeof source === "function" && $9ac5634fc6778fc7$export$c0c6c8b9c16bf6aa(source);
    const contexts = new Set(), [value, setValue] = (options.storage || $9ac5634fc6778fc7$export$c1e1e1ecbbe76a5)(options.initialValue), [error, setError] = $9ac5634fc6778fc7$export$c1e1e1ecbbe76a5(undefined), [track, trigger] = $9ac5634fc6778fc7$export$c1e1e1ecbbe76a5(undefined, {
        equals: false
    }), [state, setState] = $9ac5634fc6778fc7$export$c1e1e1ecbbe76a5(resolved ? "ready" : "unresolved");
    if ($9ac5634fc6778fc7$export$2cb4986bed338027.context) {
        id = `${$9ac5634fc6778fc7$export$2cb4986bed338027.context.id}${$9ac5634fc6778fc7$export$2cb4986bed338027.context.count++}`;
        let v;
        if (options.ssrLoadFrom === "initial") initP = options.initialValue;
        else if ($9ac5634fc6778fc7$export$2cb4986bed338027.load && (v = $9ac5634fc6778fc7$export$2cb4986bed338027.load(id))) initP = v;
    }
    function loadEnd(p, v, error, key) {
        if (pr === p) {
            pr = null;
            key !== undefined && (resolved = true);
            if ((p === initP || v === initP) && options.onHydrated) queueMicrotask(()=>options.onHydrated(key, {
                    value: v
                }));
            initP = $9ac5634fc6778fc7$var$NO_INIT;
            if ($9ac5634fc6778fc7$var$Transition && p && loadedUnderTransition) {
                $9ac5634fc6778fc7$var$Transition.promises.delete(p);
                loadedUnderTransition = false;
                $9ac5634fc6778fc7$var$runUpdates(()=>{
                    $9ac5634fc6778fc7$var$Transition.running = true;
                    completeLoad(v, error);
                }, false);
            } else completeLoad(v, error);
        }
        return v;
    }
    function completeLoad(v, err) {
        $9ac5634fc6778fc7$var$runUpdates(()=>{
            if (err === undefined) setValue(()=>v);
            setState(err !== undefined ? "errored" : resolved ? "ready" : "unresolved");
            setError(err);
            for (const c of contexts.keys())c.decrement();
            contexts.clear();
        }, false);
    }
    function read() {
        const c = $9ac5634fc6778fc7$var$SuspenseContext && $9ac5634fc6778fc7$export$fae74005e78b1a27($9ac5634fc6778fc7$var$SuspenseContext), v = value(), err = error();
        if (err !== undefined && !pr) throw err;
        if ($9ac5634fc6778fc7$var$Listener && !$9ac5634fc6778fc7$var$Listener.user && c) $9ac5634fc6778fc7$export$234a23cdc77e6a3d(()=>{
            track();
            if (pr) {
                if (c.resolved && $9ac5634fc6778fc7$var$Transition && loadedUnderTransition) $9ac5634fc6778fc7$var$Transition.promises.add(pr);
                else if (!contexts.has(c)) {
                    c.increment();
                    contexts.add(c);
                }
            }
        });
        return v;
    }
    function load(refetching = true) {
        if (refetching !== false && scheduled) return;
        scheduled = false;
        const lookup = dynamic ? dynamic() : source;
        loadedUnderTransition = $9ac5634fc6778fc7$var$Transition && $9ac5634fc6778fc7$var$Transition.running;
        if (lookup == null || lookup === false) {
            loadEnd(pr, $9ac5634fc6778fc7$export$363ebc4b78b8f807(value));
            return;
        }
        if ($9ac5634fc6778fc7$var$Transition && pr) $9ac5634fc6778fc7$var$Transition.promises.delete(pr);
        const p = initP !== $9ac5634fc6778fc7$var$NO_INIT ? initP : $9ac5634fc6778fc7$export$363ebc4b78b8f807(()=>fetcher(lookup, {
                value: value(),
                refetching: refetching
            }));
        if (!$9ac5634fc6778fc7$var$isPromise(p)) {
            loadEnd(pr, p, undefined, lookup);
            return p;
        }
        pr = p;
        if ("value" in p) {
            if (p.status === "success") loadEnd(pr, p.value, undefined, lookup);
            else loadEnd(pr, undefined, undefined, lookup);
            return p;
        }
        scheduled = true;
        queueMicrotask(()=>scheduled = false);
        $9ac5634fc6778fc7$var$runUpdates(()=>{
            setState(resolved ? "refreshing" : "pending");
            trigger();
        }, false);
        return p.then((v)=>loadEnd(p, v, undefined, lookup), (e)=>loadEnd(p, undefined, $9ac5634fc6778fc7$var$castError(e), lookup));
    }
    Object.defineProperties(read, {
        state: {
            get: ()=>state()
        },
        error: {
            get: ()=>error()
        },
        loading: {
            get () {
                const s = state();
                return s === "pending" || s === "refreshing";
            }
        },
        latest: {
            get () {
                if (!resolved) return read();
                const err = error();
                if (err && !pr) throw err;
                return value();
            }
        }
    });
    if (dynamic) $9ac5634fc6778fc7$export$234a23cdc77e6a3d(()=>load(false));
    else load(false);
    return [
        read,
        {
            refetch: load,
            mutate: setValue
        }
    ];
}
function $9ac5634fc6778fc7$export$e673efccd97e4223(source, options) {
    let t, timeout = options ? options.timeoutMs : undefined;
    const node = $9ac5634fc6778fc7$var$createComputation(()=>{
        if (!t || !t.fn) t = $9ac5634fc6778fc7$export$4b5e076b3a2fbe0a(()=>setDeferred(()=>node.value), timeout !== undefined ? {
            timeout: timeout
        } : undefined);
        return source();
    }, undefined, true);
    const [deferred, setDeferred] = $9ac5634fc6778fc7$export$c1e1e1ecbbe76a5($9ac5634fc6778fc7$var$Transition && $9ac5634fc6778fc7$var$Transition.running && $9ac5634fc6778fc7$var$Transition.sources.has(node) ? node.tValue : node.value, options);
    $9ac5634fc6778fc7$var$updateComputation(node);
    setDeferred(()=>$9ac5634fc6778fc7$var$Transition && $9ac5634fc6778fc7$var$Transition.running && $9ac5634fc6778fc7$var$Transition.sources.has(node) ? node.tValue : node.value);
    return deferred;
}
function $9ac5634fc6778fc7$export$595d22ed68ca2841(source, fn = $9ac5634fc6778fc7$export$34b67c27f2ca7498, options) {
    const subs = new Map();
    const node = $9ac5634fc6778fc7$var$createComputation((p)=>{
        const v = source();
        for (const [key, val] of subs.entries())if (fn(key, v) !== fn(key, p)) for (const c of val.values()){
            c.state = $9ac5634fc6778fc7$var$STALE;
            if (c.pure) $9ac5634fc6778fc7$var$Updates.push(c);
            else $9ac5634fc6778fc7$var$Effects.push(c);
        }
        return v;
    }, undefined, true, $9ac5634fc6778fc7$var$STALE);
    $9ac5634fc6778fc7$var$updateComputation(node);
    return (key)=>{
        const listener = $9ac5634fc6778fc7$var$Listener;
        if (listener) {
            let l;
            if (l = subs.get(key)) l.add(listener);
            else subs.set(key, l = new Set([
                listener
            ]));
            $9ac5634fc6778fc7$export$b36e5eaa3e8c43ab(()=>{
                l.delete(listener);
                !l.size && subs.delete(key);
            });
        }
        return fn(key, $9ac5634fc6778fc7$var$Transition && $9ac5634fc6778fc7$var$Transition.running && $9ac5634fc6778fc7$var$Transition.sources.has(node) ? node.tValue : node.value);
    };
}
function $9ac5634fc6778fc7$export$712ea50be43a7858(fn) {
    return $9ac5634fc6778fc7$var$runUpdates(fn, false);
}
function $9ac5634fc6778fc7$export$363ebc4b78b8f807(fn) {
    if ($9ac5634fc6778fc7$var$Listener === null) return fn();
    const listener = $9ac5634fc6778fc7$var$Listener;
    $9ac5634fc6778fc7$var$Listener = null;
    try {
        return fn();
    } finally{
        $9ac5634fc6778fc7$var$Listener = listener;
    }
}
function $9ac5634fc6778fc7$export$af631764ddc44097(deps, fn, options) {
    const isArray = Array.isArray(deps);
    let prevInput;
    let defer = options && options.defer;
    return (prevValue)=>{
        let input;
        if (isArray) {
            input = Array(deps.length);
            for(let i = 0; i < deps.length; i++)input[i] = deps[i]();
        } else input = deps();
        if (defer) {
            defer = false;
            return undefined;
        }
        const result = $9ac5634fc6778fc7$export$363ebc4b78b8f807(()=>fn(input, prevInput, prevValue));
        prevInput = input;
        return result;
    };
}
function $9ac5634fc6778fc7$export$1e848a9e87980bd5(fn) {
    $9ac5634fc6778fc7$export$7ea7134f704deda4(()=>$9ac5634fc6778fc7$export$363ebc4b78b8f807(fn));
}
function $9ac5634fc6778fc7$export$b36e5eaa3e8c43ab(fn) {
    if ($9ac5634fc6778fc7$var$Owner === null) ;
    else if ($9ac5634fc6778fc7$var$Owner.cleanups === null) $9ac5634fc6778fc7$var$Owner.cleanups = [
        fn
    ];
    else $9ac5634fc6778fc7$var$Owner.cleanups.push(fn);
    return fn;
}
function $9ac5634fc6778fc7$export$3dede90624df3ba9(fn, handler) {
    $9ac5634fc6778fc7$var$ERROR || ($9ac5634fc6778fc7$var$ERROR = Symbol("error"));
    $9ac5634fc6778fc7$var$Owner = $9ac5634fc6778fc7$var$createComputation(undefined, undefined, true);
    $9ac5634fc6778fc7$var$Owner.context = {
        ...$9ac5634fc6778fc7$var$Owner.context,
        [$9ac5634fc6778fc7$var$ERROR]: [
            handler
        ]
    };
    if ($9ac5634fc6778fc7$var$Transition && $9ac5634fc6778fc7$var$Transition.running) $9ac5634fc6778fc7$var$Transition.sources.add($9ac5634fc6778fc7$var$Owner);
    try {
        return fn();
    } catch (err) {
        $9ac5634fc6778fc7$var$handleError(err);
    } finally{
        $9ac5634fc6778fc7$var$Owner = $9ac5634fc6778fc7$var$Owner.owner;
    }
}
function $9ac5634fc6778fc7$export$12abb5141c6fdc9c() {
    return $9ac5634fc6778fc7$var$Listener;
}
function $9ac5634fc6778fc7$export$5f4ed0d56c2c0edf() {
    return $9ac5634fc6778fc7$var$Owner;
}
function $9ac5634fc6778fc7$export$c14f3e3abbc7d6b5(o, fn) {
    const prev = $9ac5634fc6778fc7$var$Owner;
    const prevListener = $9ac5634fc6778fc7$var$Listener;
    $9ac5634fc6778fc7$var$Owner = o;
    $9ac5634fc6778fc7$var$Listener = null;
    try {
        return $9ac5634fc6778fc7$var$runUpdates(fn, true);
    } catch (err) {
        $9ac5634fc6778fc7$var$handleError(err);
    } finally{
        $9ac5634fc6778fc7$var$Owner = prev;
        $9ac5634fc6778fc7$var$Listener = prevListener;
    }
}
function $9ac5634fc6778fc7$export$45e8540700504e87(scheduler = $9ac5634fc6778fc7$export$4b5e076b3a2fbe0a) {
    $9ac5634fc6778fc7$var$Scheduler = scheduler;
}
function $9ac5634fc6778fc7$export$7568632d0d33d16d(fn) {
    if ($9ac5634fc6778fc7$var$Transition && $9ac5634fc6778fc7$var$Transition.running) {
        fn();
        return $9ac5634fc6778fc7$var$Transition.done;
    }
    const l = $9ac5634fc6778fc7$var$Listener;
    const o = $9ac5634fc6778fc7$var$Owner;
    return Promise.resolve().then(()=>{
        $9ac5634fc6778fc7$var$Listener = l;
        $9ac5634fc6778fc7$var$Owner = o;
        let t;
        if ($9ac5634fc6778fc7$var$Scheduler || $9ac5634fc6778fc7$var$SuspenseContext) {
            t = $9ac5634fc6778fc7$var$Transition || ($9ac5634fc6778fc7$var$Transition = {
                sources: new Set(),
                effects: [],
                promises: new Set(),
                disposed: new Set(),
                queue: new Set(),
                running: true
            });
            t.done || (t.done = new Promise((res)=>t.resolve = res));
            t.running = true;
        }
        $9ac5634fc6778fc7$var$runUpdates(fn, false);
        $9ac5634fc6778fc7$var$Listener = $9ac5634fc6778fc7$var$Owner = null;
        return t ? t.done : undefined;
    });
}
function $9ac5634fc6778fc7$export$7b286972b8d8ccbf() {
    return [
        $9ac5634fc6778fc7$var$transPending,
        $9ac5634fc6778fc7$export$7568632d0d33d16d
    ];
}
function $9ac5634fc6778fc7$var$resumeEffects(e) {
    $9ac5634fc6778fc7$var$Effects.push.apply($9ac5634fc6778fc7$var$Effects, e);
    e.length = 0;
}
function $9ac5634fc6778fc7$export$fd42f52fd3ae1109(defaultValue, options) {
    const id = Symbol("context");
    return {
        id: id,
        Provider: $9ac5634fc6778fc7$var$createProvider(id),
        defaultValue: defaultValue
    };
}
function $9ac5634fc6778fc7$export$fae74005e78b1a27(context) {
    return $9ac5634fc6778fc7$var$Owner && $9ac5634fc6778fc7$var$Owner.context && $9ac5634fc6778fc7$var$Owner.context[context.id] !== undefined ? $9ac5634fc6778fc7$var$Owner.context[context.id] : context.defaultValue;
}
function $9ac5634fc6778fc7$export$bacb5cc5a11aef16(fn) {
    const children = $9ac5634fc6778fc7$export$c0c6c8b9c16bf6aa(fn);
    const memo = $9ac5634fc6778fc7$export$c0c6c8b9c16bf6aa(()=>$9ac5634fc6778fc7$var$resolveChildren(children()));
    memo.toArray = ()=>{
        const c = memo();
        return Array.isArray(c) ? c : c != null ? [
            c
        ] : [];
    };
    return memo;
}
let $9ac5634fc6778fc7$var$SuspenseContext;
function $9ac5634fc6778fc7$var$getSuspenseContext() {
    return $9ac5634fc6778fc7$var$SuspenseContext || ($9ac5634fc6778fc7$var$SuspenseContext = $9ac5634fc6778fc7$export$fd42f52fd3ae1109());
}
function $9ac5634fc6778fc7$export$315ab94ce87a624f(factory) {
    if ($9ac5634fc6778fc7$var$ExternalSourceFactory) {
        const oldFactory = $9ac5634fc6778fc7$var$ExternalSourceFactory;
        $9ac5634fc6778fc7$var$ExternalSourceFactory = (fn, trigger)=>{
            const oldSource = oldFactory(fn, trigger);
            const source = factory((x)=>oldSource.track(x), trigger);
            return {
                track: (x)=>source.track(x),
                dispose () {
                    source.dispose();
                    oldSource.dispose();
                }
            };
        };
    } else $9ac5634fc6778fc7$var$ExternalSourceFactory = factory;
}
function $9ac5634fc6778fc7$var$readSignal() {
    const runningTransition = $9ac5634fc6778fc7$var$Transition && $9ac5634fc6778fc7$var$Transition.running;
    if (this.sources && (runningTransition ? this.tState : this.state)) {
        if ((runningTransition ? this.tState : this.state) === $9ac5634fc6778fc7$var$STALE) $9ac5634fc6778fc7$var$updateComputation(this);
        else {
            const updates = $9ac5634fc6778fc7$var$Updates;
            $9ac5634fc6778fc7$var$Updates = null;
            $9ac5634fc6778fc7$var$runUpdates(()=>$9ac5634fc6778fc7$var$lookUpstream(this), false);
            $9ac5634fc6778fc7$var$Updates = updates;
        }
    }
    if ($9ac5634fc6778fc7$var$Listener) {
        const sSlot = this.observers ? this.observers.length : 0;
        if (!$9ac5634fc6778fc7$var$Listener.sources) {
            $9ac5634fc6778fc7$var$Listener.sources = [
                this
            ];
            $9ac5634fc6778fc7$var$Listener.sourceSlots = [
                sSlot
            ];
        } else {
            $9ac5634fc6778fc7$var$Listener.sources.push(this);
            $9ac5634fc6778fc7$var$Listener.sourceSlots.push(sSlot);
        }
        if (!this.observers) {
            this.observers = [
                $9ac5634fc6778fc7$var$Listener
            ];
            this.observerSlots = [
                $9ac5634fc6778fc7$var$Listener.sources.length - 1
            ];
        } else {
            this.observers.push($9ac5634fc6778fc7$var$Listener);
            this.observerSlots.push($9ac5634fc6778fc7$var$Listener.sources.length - 1);
        }
    }
    if (runningTransition && $9ac5634fc6778fc7$var$Transition.sources.has(this)) return this.tValue;
    return this.value;
}
function $9ac5634fc6778fc7$var$writeSignal(node, value, isComp) {
    let current = $9ac5634fc6778fc7$var$Transition && $9ac5634fc6778fc7$var$Transition.running && $9ac5634fc6778fc7$var$Transition.sources.has(node) ? node.tValue : node.value;
    if (!node.comparator || !node.comparator(current, value)) {
        if ($9ac5634fc6778fc7$var$Transition) {
            const TransitionRunning = $9ac5634fc6778fc7$var$Transition.running;
            if (TransitionRunning || !isComp && $9ac5634fc6778fc7$var$Transition.sources.has(node)) {
                $9ac5634fc6778fc7$var$Transition.sources.add(node);
                node.tValue = value;
            }
            if (!TransitionRunning) node.value = value;
        } else node.value = value;
        if (node.observers && node.observers.length) $9ac5634fc6778fc7$var$runUpdates(()=>{
            for(let i = 0; i < node.observers.length; i += 1){
                const o = node.observers[i];
                const TransitionRunning = $9ac5634fc6778fc7$var$Transition && $9ac5634fc6778fc7$var$Transition.running;
                if (TransitionRunning && $9ac5634fc6778fc7$var$Transition.disposed.has(o)) continue;
                if (TransitionRunning ? !o.tState : !o.state) {
                    if (o.pure) $9ac5634fc6778fc7$var$Updates.push(o);
                    else $9ac5634fc6778fc7$var$Effects.push(o);
                    if (o.observers) $9ac5634fc6778fc7$var$markDownstream(o);
                }
                if (!TransitionRunning) o.state = $9ac5634fc6778fc7$var$STALE;
                else o.tState = $9ac5634fc6778fc7$var$STALE;
            }
            if ($9ac5634fc6778fc7$var$Updates.length > 10e5) {
                $9ac5634fc6778fc7$var$Updates = [];
                throw new Error();
            }
        }, false);
    }
    return value;
}
function $9ac5634fc6778fc7$var$updateComputation(node) {
    if (!node.fn) return;
    $9ac5634fc6778fc7$var$cleanNode(node);
    const owner = $9ac5634fc6778fc7$var$Owner, listener = $9ac5634fc6778fc7$var$Listener, time = $9ac5634fc6778fc7$var$ExecCount;
    $9ac5634fc6778fc7$var$Listener = $9ac5634fc6778fc7$var$Owner = node;
    $9ac5634fc6778fc7$var$runComputation(node, $9ac5634fc6778fc7$var$Transition && $9ac5634fc6778fc7$var$Transition.running && $9ac5634fc6778fc7$var$Transition.sources.has(node) ? node.tValue : node.value, time);
    if ($9ac5634fc6778fc7$var$Transition && !$9ac5634fc6778fc7$var$Transition.running && $9ac5634fc6778fc7$var$Transition.sources.has(node)) queueMicrotask(()=>{
        $9ac5634fc6778fc7$var$runUpdates(()=>{
            $9ac5634fc6778fc7$var$Transition && ($9ac5634fc6778fc7$var$Transition.running = true);
            $9ac5634fc6778fc7$var$Listener = $9ac5634fc6778fc7$var$Owner = node;
            $9ac5634fc6778fc7$var$runComputation(node, node.tValue, time);
            $9ac5634fc6778fc7$var$Listener = $9ac5634fc6778fc7$var$Owner = null;
        }, false);
    });
    $9ac5634fc6778fc7$var$Listener = listener;
    $9ac5634fc6778fc7$var$Owner = owner;
}
function $9ac5634fc6778fc7$var$runComputation(node, value, time) {
    let nextValue;
    try {
        nextValue = node.fn(value);
    } catch (err) {
        if (node.pure) {
            if ($9ac5634fc6778fc7$var$Transition && $9ac5634fc6778fc7$var$Transition.running) {
                node.tState = $9ac5634fc6778fc7$var$STALE;
                node.tOwned && node.tOwned.forEach($9ac5634fc6778fc7$var$cleanNode);
                node.tOwned = undefined;
            } else {
                node.state = $9ac5634fc6778fc7$var$STALE;
                node.owned && node.owned.forEach($9ac5634fc6778fc7$var$cleanNode);
                node.owned = null;
            }
        }
        node.updatedAt = time + 1;
        return $9ac5634fc6778fc7$var$handleError(err);
    }
    if (!node.updatedAt || node.updatedAt <= time) {
        if (node.updatedAt != null && "observers" in node) $9ac5634fc6778fc7$var$writeSignal(node, nextValue, true);
        else if ($9ac5634fc6778fc7$var$Transition && $9ac5634fc6778fc7$var$Transition.running && node.pure) {
            $9ac5634fc6778fc7$var$Transition.sources.add(node);
            node.tValue = nextValue;
        } else node.value = nextValue;
        node.updatedAt = time;
    }
}
function $9ac5634fc6778fc7$var$createComputation(fn, init, pure, state = $9ac5634fc6778fc7$var$STALE, options) {
    const c = {
        fn: fn,
        state: state,
        updatedAt: null,
        owned: null,
        sources: null,
        sourceSlots: null,
        cleanups: null,
        value: init,
        owner: $9ac5634fc6778fc7$var$Owner,
        context: $9ac5634fc6778fc7$var$Owner ? $9ac5634fc6778fc7$var$Owner.context : null,
        pure: pure
    };
    if ($9ac5634fc6778fc7$var$Transition && $9ac5634fc6778fc7$var$Transition.running) {
        c.state = 0;
        c.tState = state;
    }
    if ($9ac5634fc6778fc7$var$Owner === null) ;
    else if ($9ac5634fc6778fc7$var$Owner !== $9ac5634fc6778fc7$var$UNOWNED) {
        if ($9ac5634fc6778fc7$var$Transition && $9ac5634fc6778fc7$var$Transition.running && $9ac5634fc6778fc7$var$Owner.pure) {
            if (!$9ac5634fc6778fc7$var$Owner.tOwned) $9ac5634fc6778fc7$var$Owner.tOwned = [
                c
            ];
            else $9ac5634fc6778fc7$var$Owner.tOwned.push(c);
        } else if (!$9ac5634fc6778fc7$var$Owner.owned) $9ac5634fc6778fc7$var$Owner.owned = [
            c
        ];
        else $9ac5634fc6778fc7$var$Owner.owned.push(c);
    }
    if ($9ac5634fc6778fc7$var$ExternalSourceFactory) {
        const [track, trigger] = $9ac5634fc6778fc7$export$c1e1e1ecbbe76a5(undefined, {
            equals: false
        });
        const ordinary = $9ac5634fc6778fc7$var$ExternalSourceFactory(c.fn, trigger);
        $9ac5634fc6778fc7$export$b36e5eaa3e8c43ab(()=>ordinary.dispose());
        const triggerInTransition = ()=>$9ac5634fc6778fc7$export$7568632d0d33d16d(trigger).then(()=>inTransition.dispose());
        const inTransition = $9ac5634fc6778fc7$var$ExternalSourceFactory(c.fn, triggerInTransition);
        c.fn = (x)=>{
            track();
            return $9ac5634fc6778fc7$var$Transition && $9ac5634fc6778fc7$var$Transition.running ? inTransition.track(x) : ordinary.track(x);
        };
    }
    return c;
}
function $9ac5634fc6778fc7$var$runTop(node) {
    const runningTransition = $9ac5634fc6778fc7$var$Transition && $9ac5634fc6778fc7$var$Transition.running;
    if ((runningTransition ? node.tState : node.state) === 0) return;
    if ((runningTransition ? node.tState : node.state) === $9ac5634fc6778fc7$var$PENDING) return $9ac5634fc6778fc7$var$lookUpstream(node);
    if (node.suspense && $9ac5634fc6778fc7$export$363ebc4b78b8f807(node.suspense.inFallback)) return node.suspense.effects.push(node);
    const ancestors = [
        node
    ];
    while((node = node.owner) && (!node.updatedAt || node.updatedAt < $9ac5634fc6778fc7$var$ExecCount)){
        if (runningTransition && $9ac5634fc6778fc7$var$Transition.disposed.has(node)) return;
        if (runningTransition ? node.tState : node.state) ancestors.push(node);
    }
    for(let i = ancestors.length - 1; i >= 0; i--){
        node = ancestors[i];
        if (runningTransition) {
            let top = node, prev = ancestors[i + 1];
            while((top = top.owner) && top !== prev){
                if ($9ac5634fc6778fc7$var$Transition.disposed.has(top)) return;
            }
        }
        if ((runningTransition ? node.tState : node.state) === $9ac5634fc6778fc7$var$STALE) $9ac5634fc6778fc7$var$updateComputation(node);
        else if ((runningTransition ? node.tState : node.state) === $9ac5634fc6778fc7$var$PENDING) {
            const updates = $9ac5634fc6778fc7$var$Updates;
            $9ac5634fc6778fc7$var$Updates = null;
            $9ac5634fc6778fc7$var$runUpdates(()=>$9ac5634fc6778fc7$var$lookUpstream(node, ancestors[0]), false);
            $9ac5634fc6778fc7$var$Updates = updates;
        }
    }
}
function $9ac5634fc6778fc7$var$runUpdates(fn, init) {
    if ($9ac5634fc6778fc7$var$Updates) return fn();
    let wait = false;
    if (!init) $9ac5634fc6778fc7$var$Updates = [];
    if ($9ac5634fc6778fc7$var$Effects) wait = true;
    else $9ac5634fc6778fc7$var$Effects = [];
    $9ac5634fc6778fc7$var$ExecCount++;
    try {
        const res = fn();
        $9ac5634fc6778fc7$var$completeUpdates(wait);
        return res;
    } catch (err) {
        if (!wait) $9ac5634fc6778fc7$var$Effects = null;
        $9ac5634fc6778fc7$var$Updates = null;
        $9ac5634fc6778fc7$var$handleError(err);
    }
}
function $9ac5634fc6778fc7$var$completeUpdates(wait) {
    if ($9ac5634fc6778fc7$var$Updates) {
        if ($9ac5634fc6778fc7$var$Scheduler && $9ac5634fc6778fc7$var$Transition && $9ac5634fc6778fc7$var$Transition.running) $9ac5634fc6778fc7$var$scheduleQueue($9ac5634fc6778fc7$var$Updates);
        else $9ac5634fc6778fc7$var$runQueue($9ac5634fc6778fc7$var$Updates);
        $9ac5634fc6778fc7$var$Updates = null;
    }
    if (wait) return;
    let res;
    if ($9ac5634fc6778fc7$var$Transition) {
        if (!$9ac5634fc6778fc7$var$Transition.promises.size && !$9ac5634fc6778fc7$var$Transition.queue.size) {
            const sources = $9ac5634fc6778fc7$var$Transition.sources;
            const disposed = $9ac5634fc6778fc7$var$Transition.disposed;
            $9ac5634fc6778fc7$var$Effects.push.apply($9ac5634fc6778fc7$var$Effects, $9ac5634fc6778fc7$var$Transition.effects);
            res = $9ac5634fc6778fc7$var$Transition.resolve;
            for (const e of $9ac5634fc6778fc7$var$Effects){
                "tState" in e && (e.state = e.tState);
                delete e.tState;
            }
            $9ac5634fc6778fc7$var$Transition = null;
            $9ac5634fc6778fc7$var$runUpdates(()=>{
                for (const d of disposed)$9ac5634fc6778fc7$var$cleanNode(d);
                for (const v of sources){
                    v.value = v.tValue;
                    if (v.owned) for(let i = 0, len = v.owned.length; i < len; i++)$9ac5634fc6778fc7$var$cleanNode(v.owned[i]);
                    if (v.tOwned) v.owned = v.tOwned;
                    delete v.tValue;
                    delete v.tOwned;
                    v.tState = 0;
                }
                $9ac5634fc6778fc7$var$setTransPending(false);
            }, false);
        } else if ($9ac5634fc6778fc7$var$Transition.running) {
            $9ac5634fc6778fc7$var$Transition.running = false;
            $9ac5634fc6778fc7$var$Transition.effects.push.apply($9ac5634fc6778fc7$var$Transition.effects, $9ac5634fc6778fc7$var$Effects);
            $9ac5634fc6778fc7$var$Effects = null;
            $9ac5634fc6778fc7$var$setTransPending(true);
            return;
        }
    }
    const e = $9ac5634fc6778fc7$var$Effects;
    $9ac5634fc6778fc7$var$Effects = null;
    if (e.length) $9ac5634fc6778fc7$var$runUpdates(()=>$9ac5634fc6778fc7$var$runEffects(e), false);
    if (res) res();
}
function $9ac5634fc6778fc7$var$runQueue(queue) {
    for(let i = 0; i < queue.length; i++)$9ac5634fc6778fc7$var$runTop(queue[i]);
}
function $9ac5634fc6778fc7$var$scheduleQueue(queue) {
    for(let i = 0; i < queue.length; i++){
        const item = queue[i];
        const tasks = $9ac5634fc6778fc7$var$Transition.queue;
        if (!tasks.has(item)) {
            tasks.add(item);
            $9ac5634fc6778fc7$var$Scheduler(()=>{
                tasks.delete(item);
                $9ac5634fc6778fc7$var$runUpdates(()=>{
                    $9ac5634fc6778fc7$var$Transition.running = true;
                    $9ac5634fc6778fc7$var$runTop(item);
                }, false);
                $9ac5634fc6778fc7$var$Transition && ($9ac5634fc6778fc7$var$Transition.running = false);
            });
        }
    }
}
function $9ac5634fc6778fc7$var$runUserEffects(queue) {
    let i, userLength = 0;
    for(i = 0; i < queue.length; i++){
        const e = queue[i];
        if (!e.user) $9ac5634fc6778fc7$var$runTop(e);
        else queue[userLength++] = e;
    }
    if ($9ac5634fc6778fc7$export$2cb4986bed338027.context) {
        if ($9ac5634fc6778fc7$export$2cb4986bed338027.count) {
            $9ac5634fc6778fc7$export$2cb4986bed338027.effects || ($9ac5634fc6778fc7$export$2cb4986bed338027.effects = []);
            $9ac5634fc6778fc7$export$2cb4986bed338027.effects.push(...queue.slice(0, userLength));
            return;
        } else if ($9ac5634fc6778fc7$export$2cb4986bed338027.effects) {
            queue = [
                ...$9ac5634fc6778fc7$export$2cb4986bed338027.effects,
                ...queue
            ];
            userLength += $9ac5634fc6778fc7$export$2cb4986bed338027.effects.length;
            delete $9ac5634fc6778fc7$export$2cb4986bed338027.effects;
        }
        $9ac5634fc6778fc7$var$setHydrateContext();
    }
    for(i = 0; i < userLength; i++)$9ac5634fc6778fc7$var$runTop(queue[i]);
}
function $9ac5634fc6778fc7$var$lookUpstream(node, ignore) {
    const runningTransition = $9ac5634fc6778fc7$var$Transition && $9ac5634fc6778fc7$var$Transition.running;
    if (runningTransition) node.tState = 0;
    else node.state = 0;
    for(let i = 0; i < node.sources.length; i += 1){
        const source = node.sources[i];
        if (source.sources) {
            const state = runningTransition ? source.tState : source.state;
            if (state === $9ac5634fc6778fc7$var$STALE) {
                if (source !== ignore && (!source.updatedAt || source.updatedAt < $9ac5634fc6778fc7$var$ExecCount)) $9ac5634fc6778fc7$var$runTop(source);
            } else if (state === $9ac5634fc6778fc7$var$PENDING) $9ac5634fc6778fc7$var$lookUpstream(source, ignore);
        }
    }
}
function $9ac5634fc6778fc7$var$markDownstream(node) {
    const runningTransition = $9ac5634fc6778fc7$var$Transition && $9ac5634fc6778fc7$var$Transition.running;
    for(let i = 0; i < node.observers.length; i += 1){
        const o = node.observers[i];
        if (runningTransition ? !o.tState : !o.state) {
            if (runningTransition) o.tState = $9ac5634fc6778fc7$var$PENDING;
            else o.state = $9ac5634fc6778fc7$var$PENDING;
            if (o.pure) $9ac5634fc6778fc7$var$Updates.push(o);
            else $9ac5634fc6778fc7$var$Effects.push(o);
            o.observers && $9ac5634fc6778fc7$var$markDownstream(o);
        }
    }
}
function $9ac5634fc6778fc7$var$cleanNode(node) {
    let i;
    if (node.sources) while(node.sources.length){
        const source = node.sources.pop(), index = node.sourceSlots.pop(), obs = source.observers;
        if (obs && obs.length) {
            const n = obs.pop(), s = source.observerSlots.pop();
            if (index < obs.length) {
                n.sourceSlots[s] = index;
                obs[index] = n;
                source.observerSlots[index] = s;
            }
        }
    }
    if ($9ac5634fc6778fc7$var$Transition && $9ac5634fc6778fc7$var$Transition.running && node.pure) {
        if (node.tOwned) {
            for(i = node.tOwned.length - 1; i >= 0; i--)$9ac5634fc6778fc7$var$cleanNode(node.tOwned[i]);
            delete node.tOwned;
        }
        $9ac5634fc6778fc7$var$reset(node, true);
    } else if (node.owned) {
        for(i = node.owned.length - 1; i >= 0; i--)$9ac5634fc6778fc7$var$cleanNode(node.owned[i]);
        node.owned = null;
    }
    if (node.cleanups) {
        for(i = node.cleanups.length - 1; i >= 0; i--)node.cleanups[i]();
        node.cleanups = null;
    }
    if ($9ac5634fc6778fc7$var$Transition && $9ac5634fc6778fc7$var$Transition.running) node.tState = 0;
    else node.state = 0;
}
function $9ac5634fc6778fc7$var$reset(node, top) {
    if (!top) {
        node.tState = 0;
        $9ac5634fc6778fc7$var$Transition.disposed.add(node);
    }
    if (node.owned) for(let i = 0; i < node.owned.length; i++)$9ac5634fc6778fc7$var$reset(node.owned[i]);
}
function $9ac5634fc6778fc7$var$castError(err) {
    if (err instanceof Error) return err;
    return new Error(typeof err === "string" ? err : "Unknown error", {
        cause: err
    });
}
function $9ac5634fc6778fc7$var$runErrors(err, fns, owner) {
    try {
        for (const f of fns)f(err);
    } catch (e) {
        $9ac5634fc6778fc7$var$handleError(e, owner && owner.owner || null);
    }
}
function $9ac5634fc6778fc7$var$handleError(err, owner = $9ac5634fc6778fc7$var$Owner) {
    const fns = $9ac5634fc6778fc7$var$ERROR && owner && owner.context && owner.context[$9ac5634fc6778fc7$var$ERROR];
    const error = $9ac5634fc6778fc7$var$castError(err);
    if (!fns) throw error;
    if ($9ac5634fc6778fc7$var$Effects) $9ac5634fc6778fc7$var$Effects.push({
        fn () {
            $9ac5634fc6778fc7$var$runErrors(error, fns, owner);
        },
        state: $9ac5634fc6778fc7$var$STALE
    });
    else $9ac5634fc6778fc7$var$runErrors(error, fns, owner);
}
function $9ac5634fc6778fc7$var$resolveChildren(children) {
    if (typeof children === "function" && !children.length) return $9ac5634fc6778fc7$var$resolveChildren(children());
    if (Array.isArray(children)) {
        const results = [];
        for(let i = 0; i < children.length; i++){
            const result = $9ac5634fc6778fc7$var$resolveChildren(children[i]);
            Array.isArray(result) ? results.push.apply(results, result) : results.push(result);
        }
        return results;
    }
    return children;
}
function $9ac5634fc6778fc7$var$createProvider(id, options) {
    return function provider(props) {
        let res;
        $9ac5634fc6778fc7$export$314dade334ae905d(()=>res = $9ac5634fc6778fc7$export$363ebc4b78b8f807(()=>{
                $9ac5634fc6778fc7$var$Owner.context = {
                    ...$9ac5634fc6778fc7$var$Owner.context,
                    [id]: props.value
                };
                return $9ac5634fc6778fc7$export$bacb5cc5a11aef16(()=>props.children);
            }), undefined);
        return res;
    };
}
function $9ac5634fc6778fc7$export$2288787135a8f66e(fn) {
    $9ac5634fc6778fc7$var$ERROR || ($9ac5634fc6778fc7$var$ERROR = Symbol("error"));
    if ($9ac5634fc6778fc7$var$Owner === null) ;
    else if ($9ac5634fc6778fc7$var$Owner.context === null || !$9ac5634fc6778fc7$var$Owner.context[$9ac5634fc6778fc7$var$ERROR]) {
        $9ac5634fc6778fc7$var$Owner.context = {
            ...$9ac5634fc6778fc7$var$Owner.context,
            [$9ac5634fc6778fc7$var$ERROR]: [
                fn
            ]
        };
        $9ac5634fc6778fc7$var$mutateContext($9ac5634fc6778fc7$var$Owner, $9ac5634fc6778fc7$var$ERROR, [
            fn
        ]);
    } else $9ac5634fc6778fc7$var$Owner.context[$9ac5634fc6778fc7$var$ERROR].push(fn);
}
function $9ac5634fc6778fc7$var$mutateContext(o, key, value) {
    if (o.owned) for(let i = 0; i < o.owned.length; i++){
        if (o.owned[i].context === o.context) $9ac5634fc6778fc7$var$mutateContext(o.owned[i], key, value);
        if (!o.owned[i].context) {
            o.owned[i].context = o.context;
            $9ac5634fc6778fc7$var$mutateContext(o.owned[i], key, value);
        } else if (!o.owned[i].context[key]) {
            o.owned[i].context[key] = value;
            $9ac5634fc6778fc7$var$mutateContext(o.owned[i], key, value);
        }
    }
}
function $9ac5634fc6778fc7$export$5ab46cbf6120b33a(input) {
    return {
        subscribe (observer) {
            if (!(observer instanceof Object) || observer == null) throw new TypeError("Expected the observer to be an object.");
            const handler = typeof observer === "function" ? observer : observer.next && observer.next.bind(observer);
            if (!handler) return {
                unsubscribe () {}
            };
            const dispose = $9ac5634fc6778fc7$export$882461b6382ed46c((disposer)=>{
                $9ac5634fc6778fc7$export$7ea7134f704deda4(()=>{
                    const v = input();
                    $9ac5634fc6778fc7$export$363ebc4b78b8f807(()=>handler(v));
                });
                return disposer;
            });
            if ($9ac5634fc6778fc7$export$5f4ed0d56c2c0edf()) $9ac5634fc6778fc7$export$b36e5eaa3e8c43ab(dispose);
            return {
                unsubscribe () {
                    dispose();
                }
            };
        },
        [Symbol.observable || "@@observable"] () {
            return this;
        }
    };
}
function $9ac5634fc6778fc7$export$6788812c4e6611e6(producer) {
    const [s, set] = $9ac5634fc6778fc7$export$c1e1e1ecbbe76a5(undefined, {
        equals: false
    });
    if ("subscribe" in producer) {
        const unsub = producer.subscribe((v)=>set(()=>v));
        $9ac5634fc6778fc7$export$b36e5eaa3e8c43ab(()=>"unsubscribe" in unsub ? unsub.unsubscribe() : unsub());
    } else {
        const clean = producer(set);
        $9ac5634fc6778fc7$export$b36e5eaa3e8c43ab(clean);
    }
    return s;
}
const $9ac5634fc6778fc7$var$FALLBACK = Symbol("fallback");
function $9ac5634fc6778fc7$var$dispose(d) {
    for(let i = 0; i < d.length; i++)d[i]();
}
function $9ac5634fc6778fc7$export$4c9116dcf1374231(list, mapFn, options = {}) {
    let items = [], mapped = [], disposers = [], len = 0, indexes = mapFn.length > 1 ? [] : null;
    $9ac5634fc6778fc7$export$b36e5eaa3e8c43ab(()=>$9ac5634fc6778fc7$var$dispose(disposers));
    return ()=>{
        let newItems = list() || [], i, j;
        newItems[$9ac5634fc6778fc7$export$17a675b7c02a7b1d];
        return $9ac5634fc6778fc7$export$363ebc4b78b8f807(()=>{
            let newLen = newItems.length, newIndices, newIndicesNext, temp, tempdisposers, tempIndexes, start, end, newEnd, item;
            if (newLen === 0) {
                if (len !== 0) {
                    $9ac5634fc6778fc7$var$dispose(disposers);
                    disposers = [];
                    items = [];
                    mapped = [];
                    len = 0;
                    indexes && (indexes = []);
                }
                if (options.fallback) {
                    items = [
                        $9ac5634fc6778fc7$var$FALLBACK
                    ];
                    mapped[0] = $9ac5634fc6778fc7$export$882461b6382ed46c((disposer)=>{
                        disposers[0] = disposer;
                        return options.fallback();
                    });
                    len = 1;
                }
            } else if (len === 0) {
                mapped = new Array(newLen);
                for(j = 0; j < newLen; j++){
                    items[j] = newItems[j];
                    mapped[j] = $9ac5634fc6778fc7$export$882461b6382ed46c(mapper);
                }
                len = newLen;
            } else {
                temp = new Array(newLen);
                tempdisposers = new Array(newLen);
                indexes && (tempIndexes = new Array(newLen));
                for(start = 0, end = Math.min(len, newLen); start < end && items[start] === newItems[start]; start++);
                for(end = len - 1, newEnd = newLen - 1; end >= start && newEnd >= start && items[end] === newItems[newEnd]; end--, newEnd--){
                    temp[newEnd] = mapped[end];
                    tempdisposers[newEnd] = disposers[end];
                    indexes && (tempIndexes[newEnd] = indexes[end]);
                }
                newIndices = new Map();
                newIndicesNext = new Array(newEnd + 1);
                for(j = newEnd; j >= start; j--){
                    item = newItems[j];
                    i = newIndices.get(item);
                    newIndicesNext[j] = i === undefined ? -1 : i;
                    newIndices.set(item, j);
                }
                for(i = start; i <= end; i++){
                    item = items[i];
                    j = newIndices.get(item);
                    if (j !== undefined && j !== -1) {
                        temp[j] = mapped[i];
                        tempdisposers[j] = disposers[i];
                        indexes && (tempIndexes[j] = indexes[i]);
                        j = newIndicesNext[j];
                        newIndices.set(item, j);
                    } else disposers[i]();
                }
                for(j = start; j < newLen; j++)if (j in temp) {
                    mapped[j] = temp[j];
                    disposers[j] = tempdisposers[j];
                    if (indexes) {
                        indexes[j] = tempIndexes[j];
                        indexes[j](j);
                    }
                } else mapped[j] = $9ac5634fc6778fc7$export$882461b6382ed46c(mapper);
                mapped = mapped.slice(0, len = newLen);
                items = newItems.slice(0);
            }
            return mapped;
        });
        function mapper(disposer) {
            disposers[j] = disposer;
            if (indexes) {
                const [s, set] = $9ac5634fc6778fc7$export$c1e1e1ecbbe76a5(j);
                indexes[j] = set;
                return mapFn(newItems[j], s);
            }
            return mapFn(newItems[j]);
        }
    };
}
function $9ac5634fc6778fc7$export$2cd1c249765cd0a4(list, mapFn, options = {}) {
    let items = [], mapped = [], disposers = [], signals = [], len = 0, i;
    $9ac5634fc6778fc7$export$b36e5eaa3e8c43ab(()=>$9ac5634fc6778fc7$var$dispose(disposers));
    return ()=>{
        const newItems = list() || [];
        newItems[$9ac5634fc6778fc7$export$17a675b7c02a7b1d];
        return $9ac5634fc6778fc7$export$363ebc4b78b8f807(()=>{
            if (newItems.length === 0) {
                if (len !== 0) {
                    $9ac5634fc6778fc7$var$dispose(disposers);
                    disposers = [];
                    items = [];
                    mapped = [];
                    len = 0;
                    signals = [];
                }
                if (options.fallback) {
                    items = [
                        $9ac5634fc6778fc7$var$FALLBACK
                    ];
                    mapped[0] = $9ac5634fc6778fc7$export$882461b6382ed46c((disposer)=>{
                        disposers[0] = disposer;
                        return options.fallback();
                    });
                    len = 1;
                }
                return mapped;
            }
            if (items[0] === $9ac5634fc6778fc7$var$FALLBACK) {
                disposers[0]();
                disposers = [];
                items = [];
                mapped = [];
                len = 0;
            }
            for(i = 0; i < newItems.length; i++){
                if (i < items.length && items[i] !== newItems[i]) signals[i](()=>newItems[i]);
                else if (i >= items.length) mapped[i] = $9ac5634fc6778fc7$export$882461b6382ed46c(mapper);
            }
            for(; i < items.length; i++)disposers[i]();
            len = signals.length = disposers.length = newItems.length;
            items = newItems.slice(0);
            return mapped = mapped.slice(0, len);
        });
        function mapper(disposer) {
            disposers[i] = disposer;
            const [s, set] = $9ac5634fc6778fc7$export$c1e1e1ecbbe76a5(newItems[i]);
            signals[i] = set;
            return mapFn(s, i);
        }
    };
}
let $9ac5634fc6778fc7$var$hydrationEnabled = false;
function $9ac5634fc6778fc7$export$849801d35d2160c9() {
    $9ac5634fc6778fc7$var$hydrationEnabled = true;
}
function $9ac5634fc6778fc7$export$60e54eaca7e7fb38(Comp, props) {
    if ($9ac5634fc6778fc7$var$hydrationEnabled) {
        if ($9ac5634fc6778fc7$export$2cb4986bed338027.context) {
            const c = $9ac5634fc6778fc7$export$2cb4986bed338027.context;
            $9ac5634fc6778fc7$var$setHydrateContext($9ac5634fc6778fc7$var$nextHydrateContext());
            const r = $9ac5634fc6778fc7$export$363ebc4b78b8f807(()=>Comp(props || {}));
            $9ac5634fc6778fc7$var$setHydrateContext(c);
            return r;
        }
    }
    return $9ac5634fc6778fc7$export$363ebc4b78b8f807(()=>Comp(props || {}));
}
function $9ac5634fc6778fc7$var$trueFn() {
    return true;
}
const $9ac5634fc6778fc7$var$propTraps = {
    get (_, property, receiver) {
        if (property === $9ac5634fc6778fc7$export$5cd89106e2f6c2c5) return receiver;
        return _.get(property);
    },
    has (_, property) {
        if (property === $9ac5634fc6778fc7$export$5cd89106e2f6c2c5) return true;
        return _.has(property);
    },
    set: $9ac5634fc6778fc7$var$trueFn,
    deleteProperty: $9ac5634fc6778fc7$var$trueFn,
    getOwnPropertyDescriptor (_, property) {
        return {
            configurable: true,
            enumerable: true,
            get () {
                return _.get(property);
            },
            set: $9ac5634fc6778fc7$var$trueFn,
            deleteProperty: $9ac5634fc6778fc7$var$trueFn
        };
    },
    ownKeys (_) {
        return _.keys();
    }
};
function $9ac5634fc6778fc7$var$resolveSource(s) {
    return !(s = typeof s === "function" ? s() : s) ? {} : s;
}
function $9ac5634fc6778fc7$var$resolveSources() {
    for(let i = 0, length = this.length; i < length; ++i){
        const v = this[i]();
        if (v !== undefined) return v;
    }
}
function $9ac5634fc6778fc7$export$9d1611c77c2fe928(...sources) {
    let proxy = false;
    for(let i = 0; i < sources.length; i++){
        const s = sources[i];
        proxy = proxy || !!s && $9ac5634fc6778fc7$export$5cd89106e2f6c2c5 in s;
        sources[i] = typeof s === "function" ? (proxy = true, $9ac5634fc6778fc7$export$c0c6c8b9c16bf6aa(s)) : s;
    }
    if (proxy) return new Proxy({
        get (property) {
            for(let i = sources.length - 1; i >= 0; i--){
                const v = $9ac5634fc6778fc7$var$resolveSource(sources[i])[property];
                if (v !== undefined) return v;
            }
        },
        has (property) {
            for(let i = sources.length - 1; i >= 0; i--){
                if (property in $9ac5634fc6778fc7$var$resolveSource(sources[i])) return true;
            }
            return false;
        },
        keys () {
            const keys = [];
            for(let i = 0; i < sources.length; i++)keys.push(...Object.keys($9ac5634fc6778fc7$var$resolveSource(sources[i])));
            return [
                ...new Set(keys)
            ];
        }
    }, $9ac5634fc6778fc7$var$propTraps);
    const target = {};
    const sourcesMap = {};
    const defined = new Set();
    for(let i = sources.length - 1; i >= 0; i--){
        const source = sources[i];
        if (!source) continue;
        const sourceKeys = Object.getOwnPropertyNames(source);
        for(let i = 0, length = sourceKeys.length; i < length; i++){
            const key = sourceKeys[i];
            if (key === "__proto__" || key === "constructor") continue;
            const desc = Object.getOwnPropertyDescriptor(source, key);
            if (!defined.has(key)) {
                if (desc.get) {
                    defined.add(key);
                    Object.defineProperty(target, key, {
                        enumerable: true,
                        configurable: true,
                        get: $9ac5634fc6778fc7$var$resolveSources.bind(sourcesMap[key] = [
                            desc.get.bind(source)
                        ])
                    });
                } else {
                    if (desc.value !== undefined) defined.add(key);
                    target[key] = desc.value;
                }
            } else {
                const sources = sourcesMap[key];
                if (sources) {
                    if (desc.get) sources.push(desc.get.bind(source));
                    else if (desc.value !== undefined) sources.push(()=>desc.value);
                } else if (target[key] === undefined) target[key] = desc.value;
            }
        }
    }
    return target;
}
function $9ac5634fc6778fc7$export$45029c61b0073d87(props, ...keys) {
    if ($9ac5634fc6778fc7$export$5cd89106e2f6c2c5 in props) {
        const blocked = new Set(keys.length > 1 ? keys.flat() : keys[0]);
        const res = keys.map((k)=>{
            return new Proxy({
                get (property) {
                    return k.includes(property) ? props[property] : undefined;
                },
                has (property) {
                    return k.includes(property) && property in props;
                },
                keys () {
                    return k.filter((property)=>property in props);
                }
            }, $9ac5634fc6778fc7$var$propTraps);
        });
        res.push(new Proxy({
            get (property) {
                return blocked.has(property) ? undefined : props[property];
            },
            has (property) {
                return blocked.has(property) ? false : property in props;
            },
            keys () {
                return Object.keys(props).filter((k)=>!blocked.has(k));
            }
        }, $9ac5634fc6778fc7$var$propTraps));
        return res;
    }
    const otherObject = {};
    const objects = keys.map(()=>({}));
    for (const propName of Object.getOwnPropertyNames(props)){
        const desc = Object.getOwnPropertyDescriptor(props, propName);
        const isDefaultDesc = !desc.get && !desc.set && desc.enumerable && desc.writable && desc.configurable;
        let blocked = false;
        let objectIndex = 0;
        for (const k of keys){
            if (k.includes(propName)) {
                blocked = true;
                isDefaultDesc ? objects[objectIndex][propName] = desc.value : Object.defineProperty(objects[objectIndex], propName, desc);
            }
            ++objectIndex;
        }
        if (!blocked) isDefaultDesc ? otherObject[propName] = desc.value : Object.defineProperty(otherObject, propName, desc);
    }
    return [
        ...objects,
        otherObject
    ];
}
function $9ac5634fc6778fc7$export$488013bae63b21da(fn) {
    let comp;
    let p;
    const wrap = (props)=>{
        const ctx = $9ac5634fc6778fc7$export$2cb4986bed338027.context;
        if (ctx) {
            const [s, set] = $9ac5634fc6778fc7$export$c1e1e1ecbbe76a5();
            $9ac5634fc6778fc7$export$2cb4986bed338027.count || ($9ac5634fc6778fc7$export$2cb4986bed338027.count = 0);
            $9ac5634fc6778fc7$export$2cb4986bed338027.count++;
            (p || (p = fn())).then((mod)=>{
                $9ac5634fc6778fc7$var$setHydrateContext(ctx);
                $9ac5634fc6778fc7$export$2cb4986bed338027.count--;
                set(()=>mod.default);
                $9ac5634fc6778fc7$var$setHydrateContext();
            });
            comp = s;
        } else if (!comp) {
            const [s] = $9ac5634fc6778fc7$export$edd172c6c83c39cc(()=>(p || (p = fn())).then((mod)=>mod.default));
            comp = s;
        }
        let Comp;
        return $9ac5634fc6778fc7$export$c0c6c8b9c16bf6aa(()=>(Comp = comp()) && $9ac5634fc6778fc7$export$363ebc4b78b8f807(()=>{
                if (!ctx) return Comp(props);
                const c = $9ac5634fc6778fc7$export$2cb4986bed338027.context;
                $9ac5634fc6778fc7$var$setHydrateContext(ctx);
                const r = Comp(props);
                $9ac5634fc6778fc7$var$setHydrateContext(c);
                return r;
            }));
    };
    wrap.preload = ()=>p || ((p = fn()).then((mod)=>comp = ()=>mod.default), p);
    return wrap;
}
let $9ac5634fc6778fc7$var$counter = 0;
function $9ac5634fc6778fc7$export$33208d63bc845a83() {
    const ctx = $9ac5634fc6778fc7$export$2cb4986bed338027.context;
    return ctx ? `${ctx.id}${ctx.count++}` : `cl-${$9ac5634fc6778fc7$var$counter++}`;
}
const $9ac5634fc6778fc7$var$narrowedError = (name)=>`Stale read from <${name}>.`;
function $9ac5634fc6778fc7$export$bdf530073099ce9f(props) {
    const fallback = "fallback" in props && {
        fallback: ()=>props.fallback
    };
    return $9ac5634fc6778fc7$export$c0c6c8b9c16bf6aa($9ac5634fc6778fc7$export$4c9116dcf1374231(()=>props.each, props.children, fallback || undefined));
}
function $9ac5634fc6778fc7$export$cf17b003b6192af3(props) {
    const fallback = "fallback" in props && {
        fallback: ()=>props.fallback
    };
    return $9ac5634fc6778fc7$export$c0c6c8b9c16bf6aa($9ac5634fc6778fc7$export$2cd1c249765cd0a4(()=>props.each, props.children, fallback || undefined));
}
function $9ac5634fc6778fc7$export$f6a3d19be20f5819(props) {
    const keyed = props.keyed;
    const condition = $9ac5634fc6778fc7$export$c0c6c8b9c16bf6aa(()=>props.when, undefined, {
        equals: (a, b)=>keyed ? a === b : !a === !b
    });
    return $9ac5634fc6778fc7$export$c0c6c8b9c16bf6aa(()=>{
        const c = condition();
        if (c) {
            const child = props.children;
            const fn = typeof child === "function" && child.length > 0;
            return fn ? $9ac5634fc6778fc7$export$363ebc4b78b8f807(()=>child(keyed ? c : ()=>{
                    if (!$9ac5634fc6778fc7$export$363ebc4b78b8f807(condition)) throw $9ac5634fc6778fc7$var$narrowedError("Show");
                    return props.when;
                })) : child;
        }
        return props.fallback;
    }, undefined, undefined);
}
function $9ac5634fc6778fc7$export$b5d5cf8927ab7262(props) {
    let keyed = false;
    const equals = (a, b)=>a[0] === b[0] && (keyed ? a[1] === b[1] : !a[1] === !b[1]) && a[2] === b[2];
    const conditions = $9ac5634fc6778fc7$export$bacb5cc5a11aef16(()=>props.children), evalConditions = $9ac5634fc6778fc7$export$c0c6c8b9c16bf6aa(()=>{
        let conds = conditions();
        if (!Array.isArray(conds)) conds = [
            conds
        ];
        for(let i = 0; i < conds.length; i++){
            const c = conds[i].when;
            if (c) {
                keyed = !!conds[i].keyed;
                return [
                    i,
                    c,
                    conds[i]
                ];
            }
        }
        return [
            -1
        ];
    }, undefined, {
        equals: equals
    });
    return $9ac5634fc6778fc7$export$c0c6c8b9c16bf6aa(()=>{
        const [index, when, cond] = evalConditions();
        if (index < 0) return props.fallback;
        const c = cond.children;
        const fn = typeof c === "function" && c.length > 0;
        return fn ? $9ac5634fc6778fc7$export$363ebc4b78b8f807(()=>c(keyed ? when : ()=>{
                if ($9ac5634fc6778fc7$export$363ebc4b78b8f807(evalConditions)[0] !== index) throw $9ac5634fc6778fc7$var$narrowedError("Match");
                return cond.when;
            })) : c;
    }, undefined, undefined);
}
function $9ac5634fc6778fc7$export$f421feb8fad20413(props) {
    return props;
}
let $9ac5634fc6778fc7$var$Errors;
function $9ac5634fc6778fc7$export$4eaee74ee7a14dca() {
    $9ac5634fc6778fc7$var$Errors && [
        ...$9ac5634fc6778fc7$var$Errors
    ].forEach((fn)=>fn());
}
function $9ac5634fc6778fc7$export$e926676385687eaf(props) {
    let err;
    if ($9ac5634fc6778fc7$export$2cb4986bed338027.context && $9ac5634fc6778fc7$export$2cb4986bed338027.load) err = $9ac5634fc6778fc7$export$2cb4986bed338027.load($9ac5634fc6778fc7$export$2cb4986bed338027.context.id + $9ac5634fc6778fc7$export$2cb4986bed338027.context.count);
    const [errored, setErrored] = $9ac5634fc6778fc7$export$c1e1e1ecbbe76a5(err, undefined);
    $9ac5634fc6778fc7$var$Errors || ($9ac5634fc6778fc7$var$Errors = new Set());
    $9ac5634fc6778fc7$var$Errors.add(setErrored);
    $9ac5634fc6778fc7$export$b36e5eaa3e8c43ab(()=>$9ac5634fc6778fc7$var$Errors.delete(setErrored));
    return $9ac5634fc6778fc7$export$c0c6c8b9c16bf6aa(()=>{
        let e;
        if (e = errored()) {
            const f = props.fallback;
            return typeof f === "function" && f.length ? $9ac5634fc6778fc7$export$363ebc4b78b8f807(()=>f(e, ()=>setErrored())) : f;
        }
        return $9ac5634fc6778fc7$export$3dede90624df3ba9(()=>props.children, setErrored);
    }, undefined, undefined);
}
const $9ac5634fc6778fc7$var$suspenseListEquals = (a, b)=>a.showContent === b.showContent && a.showFallback === b.showFallback;
const $9ac5634fc6778fc7$var$SuspenseListContext = $9ac5634fc6778fc7$export$fd42f52fd3ae1109();
function $9ac5634fc6778fc7$export$998bcd577473dd93(props) {
    let [wrapper, setWrapper] = $9ac5634fc6778fc7$export$c1e1e1ecbbe76a5(()=>({
            inFallback: false
        })), show;
    const listContext = $9ac5634fc6778fc7$export$fae74005e78b1a27($9ac5634fc6778fc7$var$SuspenseListContext);
    const [registry, setRegistry] = $9ac5634fc6778fc7$export$c1e1e1ecbbe76a5([]);
    if (listContext) show = listContext.register($9ac5634fc6778fc7$export$c0c6c8b9c16bf6aa(()=>wrapper()().inFallback));
    const resolved = $9ac5634fc6778fc7$export$c0c6c8b9c16bf6aa((prev)=>{
        const reveal = props.revealOrder, tail = props.tail, { showContent: showContent = true, showFallback: showFallback = true } = show ? show() : {}, reg = registry(), reverse = reveal === "backwards";
        if (reveal === "together") {
            const all = reg.every((inFallback)=>!inFallback());
            const res = reg.map(()=>({
                    showContent: all && showContent,
                    showFallback: showFallback
                }));
            res.inFallback = !all;
            return res;
        }
        let stop = false;
        let inFallback = prev.inFallback;
        const res = [];
        for(let i = 0, len = reg.length; i < len; i++){
            const n = reverse ? len - i - 1 : i, s = reg[n]();
            if (!stop && !s) res[n] = {
                showContent: showContent,
                showFallback: showFallback
            };
            else {
                const next = !stop;
                if (next) inFallback = true;
                res[n] = {
                    showContent: next,
                    showFallback: !tail || next && tail === "collapsed" ? showFallback : false
                };
                stop = true;
            }
        }
        if (!stop) inFallback = false;
        res.inFallback = inFallback;
        return res;
    }, {
        inFallback: false
    });
    setWrapper(()=>resolved);
    return $9ac5634fc6778fc7$export$60e54eaca7e7fb38($9ac5634fc6778fc7$var$SuspenseListContext.Provider, {
        value: {
            register: (inFallback)=>{
                let index;
                setRegistry((registry)=>{
                    index = registry.length;
                    return [
                        ...registry,
                        inFallback
                    ];
                });
                return $9ac5634fc6778fc7$export$c0c6c8b9c16bf6aa(()=>resolved()[index], undefined, {
                    equals: $9ac5634fc6778fc7$var$suspenseListEquals
                });
            }
        },
        get children () {
            return props.children;
        }
    });
}
function $9ac5634fc6778fc7$export$74bf444e3cd11ea5(props) {
    let counter = 0, show, ctx, p, flicker, error;
    const [inFallback, setFallback] = $9ac5634fc6778fc7$export$c1e1e1ecbbe76a5(false), SuspenseContext = $9ac5634fc6778fc7$var$getSuspenseContext(), store = {
        increment: ()=>{
            if (++counter === 1) setFallback(true);
        },
        decrement: ()=>{
            if (--counter === 0) setFallback(false);
        },
        inFallback: inFallback,
        effects: [],
        resolved: false
    }, owner = $9ac5634fc6778fc7$export$5f4ed0d56c2c0edf();
    if ($9ac5634fc6778fc7$export$2cb4986bed338027.context && $9ac5634fc6778fc7$export$2cb4986bed338027.load) {
        const key = $9ac5634fc6778fc7$export$2cb4986bed338027.context.id + $9ac5634fc6778fc7$export$2cb4986bed338027.context.count;
        let ref = $9ac5634fc6778fc7$export$2cb4986bed338027.load(key);
        if (ref && (typeof ref !== "object" || ref.status !== "success")) p = ref;
        if (p && p !== "$$f") {
            const [s, set] = $9ac5634fc6778fc7$export$c1e1e1ecbbe76a5(undefined, {
                equals: false
            });
            flicker = s;
            p.then(()=>{
                $9ac5634fc6778fc7$export$2cb4986bed338027.gather(key);
                $9ac5634fc6778fc7$var$setHydrateContext(ctx);
                set();
                $9ac5634fc6778fc7$var$setHydrateContext();
            }).catch((err)=>{
                if (err || $9ac5634fc6778fc7$export$2cb4986bed338027.done) {
                    err && (error = err);
                    return set();
                }
            });
        }
    }
    const listContext = $9ac5634fc6778fc7$export$fae74005e78b1a27($9ac5634fc6778fc7$var$SuspenseListContext);
    if (listContext) show = listContext.register(store.inFallback);
    let dispose;
    $9ac5634fc6778fc7$export$b36e5eaa3e8c43ab(()=>dispose && dispose());
    return $9ac5634fc6778fc7$export$60e54eaca7e7fb38(SuspenseContext.Provider, {
        value: store,
        get children () {
            return $9ac5634fc6778fc7$export$c0c6c8b9c16bf6aa(()=>{
                if (error) throw error;
                ctx = $9ac5634fc6778fc7$export$2cb4986bed338027.context;
                if (flicker) {
                    flicker();
                    return flicker = undefined;
                }
                if (ctx && p === "$$f") $9ac5634fc6778fc7$var$setHydrateContext();
                const rendered = $9ac5634fc6778fc7$export$c0c6c8b9c16bf6aa(()=>props.children);
                return $9ac5634fc6778fc7$export$c0c6c8b9c16bf6aa((prev)=>{
                    const inFallback = store.inFallback(), { showContent: showContent = true, showFallback: showFallback = true } = show ? show() : {};
                    if ((!inFallback || p && p !== "$$f") && showContent) {
                        store.resolved = true;
                        dispose && dispose();
                        dispose = ctx = p = undefined;
                        $9ac5634fc6778fc7$var$resumeEffects(store.effects);
                        return rendered();
                    }
                    if (!showFallback) return;
                    if (dispose) return prev;
                    return $9ac5634fc6778fc7$export$882461b6382ed46c((disposer)=>{
                        dispose = disposer;
                        if (ctx) {
                            $9ac5634fc6778fc7$var$setHydrateContext({
                                id: ctx.id + "f",
                                count: 0
                            });
                            ctx = undefined;
                        }
                        return props.fallback;
                    }, owner);
                });
            });
        }
    });
}
const $9ac5634fc6778fc7$export$404582bc18fe4d9e = undefined;


const $55de8698182680ee$var$booleans = [
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "disabled",
    "formnovalidate",
    "hidden",
    "indeterminate",
    "ismap",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "seamless",
    "selected"
];
const $55de8698182680ee$export$8714badcfa4caafb = /*#__PURE__*/ new Set([
    "className",
    "value",
    "readOnly",
    "formNoValidate",
    "isMap",
    "noModule",
    "playsInline",
    ...$55de8698182680ee$var$booleans
]);
const $55de8698182680ee$export$2c72a9edec54d5d9 = /*#__PURE__*/ new Set([
    "innerHTML",
    "textContent",
    "innerText",
    "children"
]);
const $55de8698182680ee$export$8915b7db7f70cfed = /*#__PURE__*/ Object.assign(Object.create(null), {
    className: "class",
    htmlFor: "for"
});
const $55de8698182680ee$var$PropAliases = /*#__PURE__*/ Object.assign(Object.create(null), {
    class: "className",
    formnovalidate: {
        $: "formNoValidate",
        BUTTON: 1,
        INPUT: 1
    },
    ismap: {
        $: "isMap",
        IMG: 1
    },
    nomodule: {
        $: "noModule",
        SCRIPT: 1
    },
    playsinline: {
        $: "playsInline",
        VIDEO: 1
    },
    readonly: {
        $: "readOnly",
        INPUT: 1,
        TEXTAREA: 1
    }
});
function $55de8698182680ee$export$72dcdd3761a309a9(prop, tagName) {
    const a = $55de8698182680ee$var$PropAliases[prop];
    return typeof a === "object" ? a[tagName] ? a["$"] : undefined : a;
}
const $55de8698182680ee$export$389d7c657d123a81 = /*#__PURE__*/ new Set([
    "beforeinput",
    "click",
    "dblclick",
    "contextmenu",
    "focusin",
    "focusout",
    "input",
    "keydown",
    "keyup",
    "mousedown",
    "mousemove",
    "mouseout",
    "mouseover",
    "mouseup",
    "pointerdown",
    "pointermove",
    "pointerout",
    "pointerover",
    "pointerup",
    "touchend",
    "touchmove",
    "touchstart"
]);
const $55de8698182680ee$export$ccaf9b9a82de4b98 = /*#__PURE__*/ new Set([
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animate",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "circle",
    "clipPath",
    "color-profile",
    "cursor",
    "defs",
    "desc",
    "ellipse",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "filter",
    "font",
    "font-face",
    "font-face-format",
    "font-face-name",
    "font-face-src",
    "font-face-uri",
    "foreignObject",
    "g",
    "glyph",
    "glyphRef",
    "hkern",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "metadata",
    "missing-glyph",
    "mpath",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "set",
    "stop",
    "svg",
    "switch",
    "symbol",
    "text",
    "textPath",
    "tref",
    "tspan",
    "use",
    "view",
    "vkern"
]);
const $55de8698182680ee$export$fa927d1d0495a67d = {
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace"
};
const $55de8698182680ee$export$87d0e790667228e9 = /*#__PURE__*/ new Set([
    "html",
    "base",
    "head",
    "link",
    "meta",
    "style",
    "title",
    "body",
    "address",
    "article",
    "aside",
    "footer",
    "header",
    "main",
    "nav",
    "section",
    "body",
    "blockquote",
    "dd",
    "div",
    "dl",
    "dt",
    "figcaption",
    "figure",
    "hr",
    "li",
    "ol",
    "p",
    "pre",
    "ul",
    "a",
    "abbr",
    "b",
    "bdi",
    "bdo",
    "br",
    "cite",
    "code",
    "data",
    "dfn",
    "em",
    "i",
    "kbd",
    "mark",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "small",
    "span",
    "strong",
    "sub",
    "sup",
    "time",
    "u",
    "var",
    "wbr",
    "area",
    "audio",
    "img",
    "map",
    "track",
    "video",
    "embed",
    "iframe",
    "object",
    "param",
    "picture",
    "portal",
    "source",
    "svg",
    "math",
    "canvas",
    "noscript",
    "script",
    "del",
    "ins",
    "caption",
    "col",
    "colgroup",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "tr",
    "button",
    "datalist",
    "fieldset",
    "form",
    "input",
    "label",
    "legend",
    "meter",
    "optgroup",
    "option",
    "output",
    "progress",
    "select",
    "textarea",
    "details",
    "dialog",
    "menu",
    "summary",
    "details",
    "slot",
    "template",
    "acronym",
    "applet",
    "basefont",
    "bgsound",
    "big",
    "blink",
    "center",
    "content",
    "dir",
    "font",
    "frame",
    "frameset",
    "hgroup",
    "image",
    "keygen",
    "marquee",
    "menuitem",
    "nobr",
    "noembed",
    "noframes",
    "plaintext",
    "rb",
    "rtc",
    "shadow",
    "spacer",
    "strike",
    "tt",
    "xmp",
    "a",
    "abbr",
    "acronym",
    "address",
    "applet",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "basefont",
    "bdi",
    "bdo",
    "bgsound",
    "big",
    "blink",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "center",
    "cite",
    "code",
    "col",
    "colgroup",
    "content",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "font",
    "footer",
    "form",
    "frame",
    "frameset",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "image",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "nobr",
    "noembed",
    "noframes",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "plaintext",
    "portal",
    "pre",
    "progress",
    "q",
    "rb",
    "rp",
    "rt",
    "rtc",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "shadow",
    "slot",
    "small",
    "source",
    "spacer",
    "span",
    "strike",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "template",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "tt",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "xmp",
    "input",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6"
]);
function $55de8698182680ee$var$reconcileArrays(parentNode, a, b) {
    let bLength = b.length, aEnd = a.length, bEnd = bLength, aStart = 0, bStart = 0, after = a[aEnd - 1].nextSibling, map = null;
    while(aStart < aEnd || bStart < bEnd){
        if (a[aStart] === b[bStart]) {
            aStart++;
            bStart++;
            continue;
        }
        while(a[aEnd - 1] === b[bEnd - 1]){
            aEnd--;
            bEnd--;
        }
        if (aEnd === aStart) {
            const node = bEnd < bLength ? bStart ? b[bStart - 1].nextSibling : b[bEnd - bStart] : after;
            while(bStart < bEnd)parentNode.insertBefore(b[bStart++], node);
        } else if (bEnd === bStart) while(aStart < aEnd){
            if (!map || !map.has(a[aStart])) a[aStart].remove();
            aStart++;
        }
        else if (a[aStart] === b[bEnd - 1] && b[bStart] === a[aEnd - 1]) {
            const node = a[--aEnd].nextSibling;
            parentNode.insertBefore(b[bStart++], a[aStart++].nextSibling);
            parentNode.insertBefore(b[--bEnd], node);
            a[aEnd] = b[bEnd];
        } else {
            if (!map) {
                map = new Map();
                let i = bStart;
                while(i < bEnd)map.set(b[i], i++);
            }
            const index = map.get(a[aStart]);
            if (index != null) {
                if (bStart < index && index < bEnd) {
                    let i = aStart, sequence = 1, t;
                    while(++i < aEnd && i < bEnd){
                        if ((t = map.get(a[i])) == null || t !== index + sequence) break;
                        sequence++;
                    }
                    if (sequence > index - bStart) {
                        const node = a[aStart];
                        while(bStart < index)parentNode.insertBefore(b[bStart++], node);
                    } else parentNode.replaceChild(b[bStart++], a[aStart++]);
                } else aStart++;
            } else a[aStart++].remove();
        }
    }
}
const $55de8698182680ee$var$$$EVENTS = "_$DX_DELEGATE";
function $55de8698182680ee$export$b3890eb0ae9dca99(code, element, init, options = {}) {
    let disposer;
    (0, $9ac5634fc6778fc7$export$882461b6382ed46c)((dispose)=>{
        disposer = dispose;
        element === document ? code() : $55de8698182680ee$export$21a5ca8aa77d35ff(element, code(), element.firstChild ? null : undefined, init);
    }, options.owner);
    return ()=>{
        disposer();
        element.textContent = "";
    };
}
function $55de8698182680ee$export$ce69bd05624d0c48(html, isCE, isSVG) {
    let node;
    const create = ()=>{
        const t = document.createElement("template");
        t.innerHTML = html;
        return isSVG ? t.content.firstChild.firstChild : t.content.firstChild;
    };
    const fn = isCE ? ()=>(0, $9ac5634fc6778fc7$export$363ebc4b78b8f807)(()=>document.importNode(node || (node = create()), true)) : ()=>(node || (node = create())).cloneNode(true);
    fn.cloneNode = fn;
    return fn;
}
function $55de8698182680ee$export$ad0f7f87f67e17d6(eventNames, document1 = window.document) {
    const e = document1[$55de8698182680ee$var$$$EVENTS] || (document1[$55de8698182680ee$var$$$EVENTS] = new Set());
    for(let i = 0, l = eventNames.length; i < l; i++){
        const name = eventNames[i];
        if (!e.has(name)) {
            e.add(name);
            document1.addEventListener(name, $55de8698182680ee$var$eventHandler);
        }
    }
}
function $55de8698182680ee$export$aedd29ca2033b694(document1 = window.document) {
    if (document1[$55de8698182680ee$var$$$EVENTS]) {
        for (let name of document1[$55de8698182680ee$var$$$EVENTS].keys())document1.removeEventListener(name, $55de8698182680ee$var$eventHandler);
        delete document1[$55de8698182680ee$var$$$EVENTS];
    }
}
function $55de8698182680ee$export$a41c68a4eb5ff164(node, name, value) {
    !(0, $9ac5634fc6778fc7$export$2cb4986bed338027).context && (node[name] = value);
}
function $55de8698182680ee$export$9fec4d97f1922e0b(node, name, value) {
    if ((0, $9ac5634fc6778fc7$export$2cb4986bed338027).context) return;
    if (value == null) node.removeAttribute(name);
    else node.setAttribute(name, value);
}
function $55de8698182680ee$export$75900142c9e21800(node, namespace, name, value) {
    if ((0, $9ac5634fc6778fc7$export$2cb4986bed338027).context) return;
    if (value == null) node.removeAttributeNS(namespace, name);
    else node.setAttributeNS(namespace, name, value);
}
function $55de8698182680ee$export$2913c0c0b5623090(node, value) {
    if ((0, $9ac5634fc6778fc7$export$2cb4986bed338027).context) return;
    if (value == null) node.removeAttribute("class");
    else node.className = value;
}
function $55de8698182680ee$export$3f65cefe8380dbea(node, name, handler, delegate) {
    if (delegate) {
        if (Array.isArray(handler)) {
            node[`$$${name}`] = handler[0];
            node[`$$${name}Data`] = handler[1];
        } else node[`$$${name}`] = handler;
    } else if (Array.isArray(handler)) {
        const handlerFn = handler[0];
        node.addEventListener(name, handler[0] = (e)=>handlerFn.call(node, handler[1], e));
    } else node.addEventListener(name, handler);
}
function $55de8698182680ee$export$11c615ce16f87241(node, value, prev = {}) {
    const classKeys = Object.keys(value || {}), prevKeys = Object.keys(prev);
    let i, len;
    for(i = 0, len = prevKeys.length; i < len; i++){
        const key = prevKeys[i];
        if (!key || key === "undefined" || value[key]) continue;
        $55de8698182680ee$var$toggleClassKey(node, key, false);
        delete prev[key];
    }
    for(i = 0, len = classKeys.length; i < len; i++){
        const key = classKeys[i], classValue = !!value[key];
        if (!key || key === "undefined" || prev[key] === classValue || !classValue) continue;
        $55de8698182680ee$var$toggleClassKey(node, key, true);
        prev[key] = classValue;
    }
    return prev;
}
function $55de8698182680ee$export$1d567c320f4763bc(node, value, prev) {
    if (!value) return prev ? $55de8698182680ee$export$9fec4d97f1922e0b(node, "style") : value;
    const nodeStyle = node.style;
    if (typeof value === "string") return nodeStyle.cssText = value;
    typeof prev === "string" && (nodeStyle.cssText = prev = undefined);
    prev || (prev = {});
    value || (value = {});
    let v, s;
    for(s in prev){
        value[s] == null && nodeStyle.removeProperty(s);
        delete prev[s];
    }
    for(s in value){
        v = value[s];
        if (v !== prev[s]) {
            nodeStyle.setProperty(s, v);
            prev[s] = v;
        }
    }
    return prev;
}
function $55de8698182680ee$export$3ae0fd4797ed47c8(node, props = {}, isSVG, skipChildren) {
    const prevProps = {};
    if (!skipChildren) (0, $9ac5634fc6778fc7$export$314dade334ae905d)(()=>prevProps.children = $55de8698182680ee$var$insertExpression(node, props.children, prevProps.children));
    (0, $9ac5634fc6778fc7$export$314dade334ae905d)(()=>props.ref && props.ref(node));
    (0, $9ac5634fc6778fc7$export$314dade334ae905d)(()=>$55de8698182680ee$export$e6e34fd1f2686227(node, props, isSVG, true, prevProps, true));
    return prevProps;
}
function $55de8698182680ee$export$2810486c22c942e9(props, key) {
    const src = props[key];
    Object.defineProperty(props, key, {
        get () {
            return src();
        },
        enumerable: true
    });
    return props;
}
function $55de8698182680ee$export$1f96ae73734a86cc(fn, element, arg) {
    return (0, $9ac5634fc6778fc7$export$363ebc4b78b8f807)(()=>fn(element, arg));
}
function $55de8698182680ee$export$21a5ca8aa77d35ff(parent, accessor, marker, initial) {
    if (marker !== undefined && !initial) initial = [];
    if (typeof accessor !== "function") return $55de8698182680ee$var$insertExpression(parent, accessor, initial, marker);
    (0, $9ac5634fc6778fc7$export$314dade334ae905d)((current)=>$55de8698182680ee$var$insertExpression(parent, accessor(), current, marker), initial);
}
function $55de8698182680ee$export$e6e34fd1f2686227(node, props, isSVG, skipChildren, prevProps = {}, skipRef = false) {
    props || (props = {});
    for(const prop in prevProps)if (!(prop in props)) {
        if (prop === "children") continue;
        prevProps[prop] = $55de8698182680ee$var$assignProp(node, prop, null, prevProps[prop], isSVG, skipRef);
    }
    for(const prop in props){
        if (prop === "children") {
            if (!skipChildren) $55de8698182680ee$var$insertExpression(node, props.children);
            continue;
        }
        const value = props[prop];
        prevProps[prop] = $55de8698182680ee$var$assignProp(node, prop, value, prevProps[prop], isSVG, skipRef);
    }
}
function $55de8698182680ee$var$hydrate$1(code, element, options = {}) {
    (0, $9ac5634fc6778fc7$export$2cb4986bed338027).completed = globalThis._$HY.completed;
    (0, $9ac5634fc6778fc7$export$2cb4986bed338027).events = globalThis._$HY.events;
    (0, $9ac5634fc6778fc7$export$2cb4986bed338027).load = (id)=>globalThis._$HY.r[id];
    (0, $9ac5634fc6778fc7$export$2cb4986bed338027).has = (id)=>id in globalThis._$HY.r;
    (0, $9ac5634fc6778fc7$export$2cb4986bed338027).gather = (root)=>$55de8698182680ee$var$gatherHydratable(element, root);
    (0, $9ac5634fc6778fc7$export$2cb4986bed338027).registry = new Map();
    (0, $9ac5634fc6778fc7$export$2cb4986bed338027).context = {
        id: options.renderId || "",
        count: 0
    };
    $55de8698182680ee$var$gatherHydratable(element, options.renderId);
    const dispose = $55de8698182680ee$export$b3890eb0ae9dca99(code, element, [
        ...element.childNodes
    ], options);
    (0, $9ac5634fc6778fc7$export$2cb4986bed338027).context = null;
    return dispose;
}
function $55de8698182680ee$export$4109ed81edd7716d(template) {
    let node, key;
    if (!(0, $9ac5634fc6778fc7$export$2cb4986bed338027).context || !(node = (0, $9ac5634fc6778fc7$export$2cb4986bed338027).registry.get(key = $55de8698182680ee$export$a5a9dff0691837de()))) return template();
    if ((0, $9ac5634fc6778fc7$export$2cb4986bed338027).completed) (0, $9ac5634fc6778fc7$export$2cb4986bed338027).completed.add(node);
    (0, $9ac5634fc6778fc7$export$2cb4986bed338027).registry.delete(key);
    return node;
}
function $55de8698182680ee$export$c19731b2c49ee4c9(el, nodeName) {
    while(el && el.localName !== nodeName)el = el.nextSibling;
    return el;
}
function $55de8698182680ee$export$5cf9b6f37b7c0802(start) {
    let end = start, count = 0, current = [];
    if ((0, $9ac5634fc6778fc7$export$2cb4986bed338027).context) while(end){
        if (end.nodeType === 8) {
            const v = end.nodeValue;
            if (v === "$") count++;
            else if (v === "/") {
                if (count === 0) return [
                    end,
                    current
                ];
                count--;
            }
        }
        current.push(end);
        end = end.nextSibling;
    }
    return [
        end,
        current
    ];
}
function $55de8698182680ee$export$6fef5763b6d3688d() {
    if ((0, $9ac5634fc6778fc7$export$2cb4986bed338027).events && !(0, $9ac5634fc6778fc7$export$2cb4986bed338027).events.queued) {
        queueMicrotask(()=>{
            const { completed: completed, events: events } = (0, $9ac5634fc6778fc7$export$2cb4986bed338027);
            events.queued = false;
            while(events.length){
                const [el, e] = events[0];
                if (!completed.has(el)) return;
                $55de8698182680ee$var$eventHandler(e);
                events.shift();
            }
        });
        (0, $9ac5634fc6778fc7$export$2cb4986bed338027).events.queued = true;
    }
}
function $55de8698182680ee$var$toPropertyName(name) {
    return name.toLowerCase().replace(/-([a-z])/g, (_, w)=>w.toUpperCase());
}
function $55de8698182680ee$var$toggleClassKey(node, key, value) {
    const classNames = key.trim().split(/\s+/);
    for(let i = 0, nameLen = classNames.length; i < nameLen; i++)node.classList.toggle(classNames[i], value);
}
function $55de8698182680ee$var$assignProp(node, prop, value, prev, isSVG, skipRef) {
    let isCE, isProp, isChildProp, propAlias, forceProp;
    if (prop === "style") return $55de8698182680ee$export$1d567c320f4763bc(node, value, prev);
    if (prop === "classList") return $55de8698182680ee$export$11c615ce16f87241(node, value, prev);
    if (value === prev) return prev;
    if (prop === "ref") {
        if (!skipRef) value(node);
    } else if (prop.slice(0, 3) === "on:") {
        const e = prop.slice(3);
        prev && node.removeEventListener(e, prev);
        value && node.addEventListener(e, value);
    } else if (prop.slice(0, 10) === "oncapture:") {
        const e = prop.slice(10);
        prev && node.removeEventListener(e, prev, true);
        value && node.addEventListener(e, value, true);
    } else if (prop.slice(0, 2) === "on") {
        const name = prop.slice(2).toLowerCase();
        const delegate = $55de8698182680ee$export$389d7c657d123a81.has(name);
        if (!delegate && prev) {
            const h = Array.isArray(prev) ? prev[0] : prev;
            node.removeEventListener(name, h);
        }
        if (delegate || value) {
            $55de8698182680ee$export$3f65cefe8380dbea(node, name, value, delegate);
            delegate && $55de8698182680ee$export$ad0f7f87f67e17d6([
                name
            ]);
        }
    } else if (prop.slice(0, 5) === "attr:") $55de8698182680ee$export$9fec4d97f1922e0b(node, prop.slice(5), value);
    else if ((forceProp = prop.slice(0, 5) === "prop:") || (isChildProp = $55de8698182680ee$export$2c72a9edec54d5d9.has(prop)) || !isSVG && ((propAlias = $55de8698182680ee$export$72dcdd3761a309a9(prop, node.tagName)) || (isProp = $55de8698182680ee$export$8714badcfa4caafb.has(prop))) || (isCE = node.nodeName.includes("-"))) {
        if (forceProp) {
            prop = prop.slice(5);
            isProp = true;
        } else if ((0, $9ac5634fc6778fc7$export$2cb4986bed338027).context) return value;
        if (prop === "class" || prop === "className") $55de8698182680ee$export$2913c0c0b5623090(node, value);
        else if (isCE && !isProp && !isChildProp) node[$55de8698182680ee$var$toPropertyName(prop)] = value;
        else node[propAlias || prop] = value;
    } else {
        const ns = isSVG && prop.indexOf(":") > -1 && $55de8698182680ee$export$fa927d1d0495a67d[prop.split(":")[0]];
        if (ns) $55de8698182680ee$export$75900142c9e21800(node, ns, prop, value);
        else $55de8698182680ee$export$9fec4d97f1922e0b(node, $55de8698182680ee$export$8915b7db7f70cfed[prop] || prop, value);
    }
    return value;
}
function $55de8698182680ee$var$eventHandler(e) {
    const key = `$$${e.type}`;
    let node = e.composedPath && e.composedPath()[0] || e.target;
    if (e.target !== node) Object.defineProperty(e, "target", {
        configurable: true,
        value: node
    });
    Object.defineProperty(e, "currentTarget", {
        configurable: true,
        get () {
            return node || document;
        }
    });
    if ((0, $9ac5634fc6778fc7$export$2cb4986bed338027).registry && !(0, $9ac5634fc6778fc7$export$2cb4986bed338027).done) (0, $9ac5634fc6778fc7$export$2cb4986bed338027).done = _$HY.done = true;
    while(node){
        const handler = node[key];
        if (handler && !node.disabled) {
            const data = node[`${key}Data`];
            data !== undefined ? handler.call(node, data, e) : handler.call(node, e);
            if (e.cancelBubble) return;
        }
        node = node._$host || node.parentNode || node.host;
    }
}
function $55de8698182680ee$var$insertExpression(parent, value, current, marker, unwrapArray) {
    if ((0, $9ac5634fc6778fc7$export$2cb4986bed338027).context) {
        !current && (current = [
            ...parent.childNodes
        ]);
        let cleaned = [];
        for(let i = 0; i < current.length; i++){
            const node = current[i];
            if (node.nodeType === 8 && node.data.slice(0, 2) === "!$") node.remove();
            else cleaned.push(node);
        }
        current = cleaned;
    }
    while(typeof current === "function")current = current();
    if (value === current) return current;
    const t = typeof value, multi = marker !== undefined;
    parent = multi && current[0] && current[0].parentNode || parent;
    if (t === "string" || t === "number") {
        if ((0, $9ac5634fc6778fc7$export$2cb4986bed338027).context) return current;
        if (t === "number") value = value.toString();
        if (multi) {
            let node = current[0];
            if (node && node.nodeType === 3) node.data = value;
            else node = document.createTextNode(value);
            current = $55de8698182680ee$var$cleanChildren(parent, current, marker, node);
        } else if (current !== "" && typeof current === "string") current = parent.firstChild.data = value;
        else current = parent.textContent = value;
    } else if (value == null || t === "boolean") {
        if ((0, $9ac5634fc6778fc7$export$2cb4986bed338027).context) return current;
        current = $55de8698182680ee$var$cleanChildren(parent, current, marker);
    } else if (t === "function") {
        (0, $9ac5634fc6778fc7$export$314dade334ae905d)(()=>{
            let v = value();
            while(typeof v === "function")v = v();
            current = $55de8698182680ee$var$insertExpression(parent, v, current, marker);
        });
        return ()=>current;
    } else if (Array.isArray(value)) {
        const array = [];
        const currentArray = current && Array.isArray(current);
        if ($55de8698182680ee$var$normalizeIncomingArray(array, value, current, unwrapArray)) {
            (0, $9ac5634fc6778fc7$export$314dade334ae905d)(()=>current = $55de8698182680ee$var$insertExpression(parent, array, current, marker, true));
            return ()=>current;
        }
        if ((0, $9ac5634fc6778fc7$export$2cb4986bed338027).context) {
            if (!array.length) return current;
            if (marker === undefined) return [
                ...parent.childNodes
            ];
            let node = array[0];
            let nodes = [
                node
            ];
            while((node = node.nextSibling) !== marker)nodes.push(node);
            return current = nodes;
        }
        if (array.length === 0) {
            current = $55de8698182680ee$var$cleanChildren(parent, current, marker);
            if (multi) return current;
        } else if (currentArray) {
            if (current.length === 0) $55de8698182680ee$var$appendNodes(parent, array, marker);
            else $55de8698182680ee$var$reconcileArrays(parent, current, array);
        } else {
            current && $55de8698182680ee$var$cleanChildren(parent);
            $55de8698182680ee$var$appendNodes(parent, array);
        }
        current = array;
    } else if (value.nodeType) {
        if ((0, $9ac5634fc6778fc7$export$2cb4986bed338027).context && value.parentNode) return current = multi ? [
            value
        ] : value;
        if (Array.isArray(current)) {
            if (multi) return current = $55de8698182680ee$var$cleanChildren(parent, current, marker, value);
            $55de8698182680ee$var$cleanChildren(parent, current, null, value);
        } else if (current == null || current === "" || !parent.firstChild) parent.appendChild(value);
        else parent.replaceChild(value, parent.firstChild);
        current = value;
    }
    return current;
}
function $55de8698182680ee$var$normalizeIncomingArray(normalized, array, current, unwrap) {
    let dynamic = false;
    for(let i = 0, len = array.length; i < len; i++){
        let item = array[i], prev = current && current[i], t;
        if (item == null || item === true || item === false) ;
        else if ((t = typeof item) === "object" && item.nodeType) normalized.push(item);
        else if (Array.isArray(item)) dynamic = $55de8698182680ee$var$normalizeIncomingArray(normalized, item, prev) || dynamic;
        else if (t === "function") {
            if (unwrap) {
                while(typeof item === "function")item = item();
                dynamic = $55de8698182680ee$var$normalizeIncomingArray(normalized, Array.isArray(item) ? item : [
                    item
                ], Array.isArray(prev) ? prev : [
                    prev
                ]) || dynamic;
            } else {
                normalized.push(item);
                dynamic = true;
            }
        } else {
            const value = String(item);
            if (prev && prev.nodeType === 3 && prev.data === value) normalized.push(prev);
            else normalized.push(document.createTextNode(value));
        }
    }
    return dynamic;
}
function $55de8698182680ee$var$appendNodes(parent, array, marker = null) {
    for(let i = 0, len = array.length; i < len; i++)parent.insertBefore(array[i], marker);
}
function $55de8698182680ee$var$cleanChildren(parent, current, marker, replacement) {
    if (marker === undefined) return parent.textContent = "";
    const node = replacement || document.createTextNode("");
    if (current.length) {
        let inserted = false;
        for(let i = current.length - 1; i >= 0; i--){
            const el = current[i];
            if (node !== el) {
                const isParent = el.parentNode === parent;
                if (!inserted && !i) isParent ? parent.replaceChild(node, el) : parent.insertBefore(node, marker);
                else isParent && el.remove();
            } else inserted = true;
        }
    } else parent.insertBefore(node, marker);
    return [
        node
    ];
}
function $55de8698182680ee$var$gatherHydratable(element, root) {
    const templates = element.querySelectorAll(`*[data-hk]`);
    for(let i = 0; i < templates.length; i++){
        const node = templates[i];
        const key = node.getAttribute("data-hk");
        if ((!root || key.startsWith(root)) && !(0, $9ac5634fc6778fc7$export$2cb4986bed338027).registry.has(key)) (0, $9ac5634fc6778fc7$export$2cb4986bed338027).registry.set(key, node);
    }
}
function $55de8698182680ee$export$a5a9dff0691837de() {
    const hydrate = (0, $9ac5634fc6778fc7$export$2cb4986bed338027).context;
    return `${hydrate.id}${hydrate.count++}`;
}
function $55de8698182680ee$export$36143b7c9c07dd39(props) {
    return (0, $9ac5634fc6778fc7$export$2cb4986bed338027).context ? undefined : props.children;
}
function $55de8698182680ee$export$da8cca6e5dfa3577(props) {
    return props.children;
}
function $55de8698182680ee$export$c8eca95e306f7116() {}
const $55de8698182680ee$export$5df49ba75ba1c1f9 = Symbol();
function $55de8698182680ee$export$8bd3fff6c675ca8d(parent, content) {
    !(0, $9ac5634fc6778fc7$export$2cb4986bed338027).context && (parent.innerHTML = content);
}
function $55de8698182680ee$var$throwInBrowser(func) {
    const err = new Error(`${func.name} is not supported in the browser, returning undefined`);
    console.error(err);
}
function $55de8698182680ee$export$80e7718417253a51(fn, options) {
    $55de8698182680ee$var$throwInBrowser($55de8698182680ee$export$80e7718417253a51);
}
function $55de8698182680ee$export$f3aefc4196cd5f3e(fn, options) {
    $55de8698182680ee$var$throwInBrowser($55de8698182680ee$export$f3aefc4196cd5f3e);
}
function $55de8698182680ee$export$97f86213fef5749d(fn, options) {
    $55de8698182680ee$var$throwInBrowser($55de8698182680ee$export$97f86213fef5749d);
}
function $55de8698182680ee$export$ea2375f6c0c9ffdc(template, ...nodes) {}
function $55de8698182680ee$export$1844beb7faeb4553(name, props, children, needsId) {}
function $55de8698182680ee$export$e92e0c287593a882(value) {}
function $55de8698182680ee$export$9e97f11b9d683d7a(value) {}
function $55de8698182680ee$export$9ab8bdc1e27e51e1(key, value) {}
function $55de8698182680ee$export$7e66a08c0b8ab2aa() {}
function $55de8698182680ee$export$755e9f954b4fd36e(node) {}
function $55de8698182680ee$export$4e7f196112fea3c5(html) {}
function $55de8698182680ee$export$8c2b042ce8153017(props, isSVG, skipChildren) {}
const $55de8698182680ee$export$6acf61af03e62db = false;
const $55de8698182680ee$export$40edfb7eeb78c4e8 = false;
const $55de8698182680ee$var$SVG_NAMESPACE = "http://www.w3.org/2000/svg";
function $55de8698182680ee$var$createElement(tagName, isSVG = false) {
    return isSVG ? document.createElementNS($55de8698182680ee$var$SVG_NAMESPACE, tagName) : document.createElement(tagName);
}
const $55de8698182680ee$export$fa8d919ba61d84db = (...args)=>{
    (0, $9ac5634fc6778fc7$export$849801d35d2160c9)();
    return $55de8698182680ee$var$hydrate$1(...args);
};
function $55de8698182680ee$export$602eac185826482c(props) {
    const { useShadow: useShadow } = props, marker = document.createTextNode(""), mount = ()=>props.mount || document.body, owner = (0, $9ac5634fc6778fc7$export$5f4ed0d56c2c0edf)();
    let content;
    let hydrating = !!(0, $9ac5634fc6778fc7$export$2cb4986bed338027).context;
    (0, $9ac5634fc6778fc7$export$7ea7134f704deda4)(()=>{
        if (hydrating) (0, $9ac5634fc6778fc7$export$5f4ed0d56c2c0edf)().user = hydrating = false;
        content || (content = (0, $9ac5634fc6778fc7$export$c14f3e3abbc7d6b5)(owner, ()=>(0, $9ac5634fc6778fc7$export$c0c6c8b9c16bf6aa)(()=>props.children)));
        const el = mount();
        if (el instanceof HTMLHeadElement) {
            const [clean, setClean] = (0, $9ac5634fc6778fc7$export$c1e1e1ecbbe76a5)(false);
            const cleanup = ()=>setClean(true);
            (0, $9ac5634fc6778fc7$export$882461b6382ed46c)((dispose)=>$55de8698182680ee$export$21a5ca8aa77d35ff(el, ()=>!clean() ? content() : dispose(), null));
            (0, $9ac5634fc6778fc7$export$b36e5eaa3e8c43ab)(cleanup);
        } else {
            const container = $55de8698182680ee$var$createElement(props.isSVG ? "g" : "div", props.isSVG), renderRoot = useShadow && container.attachShadow ? container.attachShadow({
                mode: "open"
            }) : container;
            Object.defineProperty(container, "_$host", {
                get () {
                    return marker.parentNode;
                },
                configurable: true
            });
            $55de8698182680ee$export$21a5ca8aa77d35ff(renderRoot, content);
            el.appendChild(container);
            props.ref && props.ref(container);
            (0, $9ac5634fc6778fc7$export$b36e5eaa3e8c43ab)(()=>el.removeChild(container));
        }
    }, undefined, {
        render: !hydrating
    });
    return marker;
}
function $55de8698182680ee$export$e18282e419e46834(props) {
    const [p, others] = (0, $9ac5634fc6778fc7$export$45029c61b0073d87)(props, [
        "component"
    ]);
    const cached = (0, $9ac5634fc6778fc7$export$c0c6c8b9c16bf6aa)(()=>p.component);
    return (0, $9ac5634fc6778fc7$export$c0c6c8b9c16bf6aa)(()=>{
        const component = cached();
        switch(typeof component){
            case "function":
                return (0, $9ac5634fc6778fc7$export$363ebc4b78b8f807)(()=>component(others));
            case "string":
                const isSvg = $55de8698182680ee$export$ccaf9b9a82de4b98.has(component);
                const el = (0, $9ac5634fc6778fc7$export$2cb4986bed338027).context ? $55de8698182680ee$export$4109ed81edd7716d() : $55de8698182680ee$var$createElement(component, isSvg);
                $55de8698182680ee$export$3ae0fd4797ed47c8(el, others, isSvg);
                return el;
        }
    });
}



/**
 * Mock DHT class for browser environment
 */ class $9711f37caea5d809$export$3b91528db97c32c {
    constructor(){
        throw new Error("not implmented in browser, use Pkarr.relayPut() and Pkarr.relayGet() instead.");
    }
}
var $9711f37caea5d809$export$2e2bcd8739ae039 = $9711f37caea5d809$export$3b91528db97c32c;


var $032165b12ce1198f$exports = {};

$parcel$export($032165b12ce1198f$exports, "encode", function () { return $032165b12ce1198f$export$c564cdbbe6da493; }, function (v) { return $032165b12ce1198f$export$c564cdbbe6da493 = v; });
$parcel$export($032165b12ce1198f$exports, "decode", function () { return $032165b12ce1198f$export$2f872c0f2117be69; }, function (v) { return $032165b12ce1198f$export$2f872c0f2117be69 = v; });
var $032165b12ce1198f$export$c564cdbbe6da493;
var $032165b12ce1198f$export$2f872c0f2117be69;

var $hsTwZ = parcelRequire("hsTwZ");
const $032165b12ce1198f$var$ALPHABET = "ybndrfg8ejkmcpqxot1uwisza345h769";
const $032165b12ce1198f$var$MIN = 0x31 // 1
;
const $032165b12ce1198f$var$MAX = 0x7a // z
;
const $032165b12ce1198f$var$REVERSE = new Int8Array(1 + $032165b12ce1198f$var$MAX - $032165b12ce1198f$var$MIN);
$032165b12ce1198f$var$REVERSE.fill(-1);
for(let i = 0; i < $032165b12ce1198f$var$ALPHABET.length; i++){
    const v = $032165b12ce1198f$var$ALPHABET.charCodeAt(i) - $032165b12ce1198f$var$MIN;
    $032165b12ce1198f$var$REVERSE[v] = i;
}
$032165b12ce1198f$export$c564cdbbe6da493 = $032165b12ce1198f$var$encode;
$032165b12ce1198f$export$2f872c0f2117be69 = $032165b12ce1198f$var$decode;
function $032165b12ce1198f$var$decode(s, out) {
    let pb = 0;
    let ps = 0;
    const r = s.length & 7;
    const q = (s.length - r) / 8;
    if (!out) out = $hsTwZ.allocUnsafe(Math.ceil(s.length * 5 / 8));
    // 0 5 2 7 4 1 6 3 (+5 mod 8)
    for(let i = 0; i < q; i++){
        const a = $032165b12ce1198f$var$quintet(s, ps++);
        const b = $032165b12ce1198f$var$quintet(s, ps++);
        const c = $032165b12ce1198f$var$quintet(s, ps++);
        const d = $032165b12ce1198f$var$quintet(s, ps++);
        const e = $032165b12ce1198f$var$quintet(s, ps++);
        const f = $032165b12ce1198f$var$quintet(s, ps++);
        const g = $032165b12ce1198f$var$quintet(s, ps++);
        const h = $032165b12ce1198f$var$quintet(s, ps++);
        out[pb++] = a << 3 | b >>> 2;
        out[pb++] = (b & 3) << 6 | c << 1 | d >>> 4;
        out[pb++] = (d & 15) << 4 | e >>> 1;
        out[pb++] = (e & 1) << 7 | f << 2 | g >>> 3;
        out[pb++] = (g & 7) << 5 | h;
    }
    if (r === 0) return out.subarray(0, pb);
    const a = $032165b12ce1198f$var$quintet(s, ps++);
    const b = $032165b12ce1198f$var$quintet(s, ps++);
    out[pb++] = a << 3 | b >>> 2;
    if (r <= 2) return out.subarray(0, pb);
    const c = $032165b12ce1198f$var$quintet(s, ps++);
    const d = $032165b12ce1198f$var$quintet(s, ps++);
    out[pb++] = (b & 3) << 6 | c << 1 | d >>> 4;
    if (r <= 4) return out.subarray(0, pb);
    const e = $032165b12ce1198f$var$quintet(s, ps++);
    out[pb++] = (d & 15) << 4 | e >>> 1;
    if (r <= 5) return out.subarray(0, pb);
    const f = $032165b12ce1198f$var$quintet(s, ps++);
    const g = $032165b12ce1198f$var$quintet(s, ps++);
    out[pb++] = (e & 1) << 7 | f << 2 | g >>> 3;
    if (r <= 7) return out.subarray(0, pb);
    const h = $032165b12ce1198f$var$quintet(s, ps++);
    out[pb++] = (g & 7) << 5 | h;
    return out.subarray(0, pb);
}
function $032165b12ce1198f$var$encode(buf) {
    if (typeof buf === "string") buf = $hsTwZ.from(buf);
    const max = buf.byteLength * 8;
    let s = "";
    for(let p = 0; p < max; p += 5){
        const i = p >>> 3;
        const j = p & 7;
        if (j <= 3) {
            s += $032165b12ce1198f$var$ALPHABET[buf[i] >>> 3 - j & 31];
            continue;
        }
        const of = j - 3;
        const h = buf[i] << of & 31;
        const l = (i >= buf.byteLength ? 0 : buf[i + 1]) >>> 8 - of;
        s += $032165b12ce1198f$var$ALPHABET[h | l];
    }
    return s;
}
function $032165b12ce1198f$var$quintet(s, i) {
    if (i > s.length) return 0;
    const v = s.charCodeAt(i);
    if (v < $032165b12ce1198f$var$MIN || v > $032165b12ce1198f$var$MAX) throw Error('Invalid character in base32 input: "' + s[i] + '" at position ' + i);
    const bits = $032165b12ce1198f$var$REVERSE[v - $032165b12ce1198f$var$MIN];
    if (bits === -1) throw Error('Invalid character in base32 input: "' + s[i] + '" at position ' + i);
    return bits;
}


var $83620c096ed20185$exports = {};

$parcel$export($83620c096ed20185$exports, "name", function () { return $83620c096ed20185$export$a8ff84c12d48cfa6; }, function (v) { return $83620c096ed20185$export$a8ff84c12d48cfa6 = v; });
$parcel$export($83620c096ed20185$exports, "unknown", function () { return $83620c096ed20185$export$19282c40b967aec6; }, function (v) { return $83620c096ed20185$export$19282c40b967aec6 = v; });
$parcel$export($83620c096ed20185$exports, "ns", function () { return $83620c096ed20185$export$76f050bd65425e13; }, function (v) { return $83620c096ed20185$export$76f050bd65425e13 = v; });
$parcel$export($83620c096ed20185$exports, "soa", function () { return $83620c096ed20185$export$b752097795bbaebd; }, function (v) { return $83620c096ed20185$export$b752097795bbaebd = v; });
$parcel$export($83620c096ed20185$exports, "txt", function () { return $83620c096ed20185$export$ac96b34a74de2f22; }, function (v) { return $83620c096ed20185$export$ac96b34a74de2f22 = v; });
$parcel$export($83620c096ed20185$exports, "null", function () { return $83620c096ed20185$export$7b1b591b262c240; }, function (v) { return $83620c096ed20185$export$7b1b591b262c240 = v; });
$parcel$export($83620c096ed20185$exports, "hinfo", function () { return $83620c096ed20185$export$2542a5a654329437; }, function (v) { return $83620c096ed20185$export$2542a5a654329437 = v; });
$parcel$export($83620c096ed20185$exports, "ptr", function () { return $83620c096ed20185$export$56b93c6175ee8274; }, function (v) { return $83620c096ed20185$export$56b93c6175ee8274 = v; });
$parcel$export($83620c096ed20185$exports, "cname", function () { return $83620c096ed20185$export$2322a2658b955e5; }, function (v) { return $83620c096ed20185$export$2322a2658b955e5 = v; });
$parcel$export($83620c096ed20185$exports, "dname", function () { return $83620c096ed20185$export$dbcbf189e660012; }, function (v) { return $83620c096ed20185$export$dbcbf189e660012 = v; });
$parcel$export($83620c096ed20185$exports, "srv", function () { return $83620c096ed20185$export$a4ab9e1166fe1f1b; }, function (v) { return $83620c096ed20185$export$a4ab9e1166fe1f1b = v; });
$parcel$export($83620c096ed20185$exports, "caa", function () { return $83620c096ed20185$export$eae95cd38d620409; }, function (v) { return $83620c096ed20185$export$eae95cd38d620409 = v; });
$parcel$export($83620c096ed20185$exports, "mx", function () { return $83620c096ed20185$export$1ed5cc9cac6d3e38; }, function (v) { return $83620c096ed20185$export$1ed5cc9cac6d3e38 = v; });
$parcel$export($83620c096ed20185$exports, "a", function () { return $83620c096ed20185$export$407448d2b89b1813; }, function (v) { return $83620c096ed20185$export$407448d2b89b1813 = v; });
$parcel$export($83620c096ed20185$exports, "aaaa", function () { return $83620c096ed20185$export$8b02350718d87164; }, function (v) { return $83620c096ed20185$export$8b02350718d87164 = v; });
$parcel$export($83620c096ed20185$exports, "option", function () { return $83620c096ed20185$export$a75d1723e6bda2ec; }, function (v) { return $83620c096ed20185$export$a75d1723e6bda2ec = v; });
$parcel$export($83620c096ed20185$exports, "opt", function () { return $83620c096ed20185$export$2b91d3689f613272; }, function (v) { return $83620c096ed20185$export$2b91d3689f613272 = v; });
$parcel$export($83620c096ed20185$exports, "dnskey", function () { return $83620c096ed20185$export$ad4f294ad38147a3; }, function (v) { return $83620c096ed20185$export$ad4f294ad38147a3 = v; });
$parcel$export($83620c096ed20185$exports, "rrsig", function () { return $83620c096ed20185$export$c008f777d94a4783; }, function (v) { return $83620c096ed20185$export$c008f777d94a4783 = v; });
$parcel$export($83620c096ed20185$exports, "rp", function () { return $83620c096ed20185$export$6d4c73e3ddf8818b; }, function (v) { return $83620c096ed20185$export$6d4c73e3ddf8818b = v; });
$parcel$export($83620c096ed20185$exports, "nsec", function () { return $83620c096ed20185$export$2ab2dccc8f32ce46; }, function (v) { return $83620c096ed20185$export$2ab2dccc8f32ce46 = v; });
$parcel$export($83620c096ed20185$exports, "nsec3", function () { return $83620c096ed20185$export$b05393b09543e5f2; }, function (v) { return $83620c096ed20185$export$b05393b09543e5f2 = v; });
$parcel$export($83620c096ed20185$exports, "ds", function () { return $83620c096ed20185$export$6c6581d59e81d1b9; }, function (v) { return $83620c096ed20185$export$6c6581d59e81d1b9 = v; });
$parcel$export($83620c096ed20185$exports, "sshfp", function () { return $83620c096ed20185$export$1b9c36835e28a5f9; }, function (v) { return $83620c096ed20185$export$1b9c36835e28a5f9 = v; });
$parcel$export($83620c096ed20185$exports, "naptr", function () { return $83620c096ed20185$export$c4773623ab5afffc; }, function (v) { return $83620c096ed20185$export$c4773623ab5afffc = v; });
$parcel$export($83620c096ed20185$exports, "tlsa", function () { return $83620c096ed20185$export$dc8e86e1bd9ea40f; }, function (v) { return $83620c096ed20185$export$dc8e86e1bd9ea40f = v; });
$parcel$export($83620c096ed20185$exports, "record", function () { return $83620c096ed20185$export$e5185e241753e543; }, function (v) { return $83620c096ed20185$export$e5185e241753e543 = v; });
$parcel$export($83620c096ed20185$exports, "answer", function () { return $83620c096ed20185$export$50a780d71cf22a88; }, function (v) { return $83620c096ed20185$export$50a780d71cf22a88 = v; });
$parcel$export($83620c096ed20185$exports, "question", function () { return $83620c096ed20185$export$db9f06b5d27d15d8; }, function (v) { return $83620c096ed20185$export$db9f06b5d27d15d8 = v; });
$parcel$export($83620c096ed20185$exports, "AUTHORITATIVE_ANSWER", function () { return $83620c096ed20185$export$6556f847e8047304; }, function (v) { return $83620c096ed20185$export$6556f847e8047304 = v; });
$parcel$export($83620c096ed20185$exports, "TRUNCATED_RESPONSE", function () { return $83620c096ed20185$export$94f7062ce7df4e6e; }, function (v) { return $83620c096ed20185$export$94f7062ce7df4e6e = v; });
$parcel$export($83620c096ed20185$exports, "RECURSION_DESIRED", function () { return $83620c096ed20185$export$fcc51f37815e5e3c; }, function (v) { return $83620c096ed20185$export$fcc51f37815e5e3c = v; });
$parcel$export($83620c096ed20185$exports, "RECURSION_AVAILABLE", function () { return $83620c096ed20185$export$1f33e1212d848957; }, function (v) { return $83620c096ed20185$export$1f33e1212d848957 = v; });
$parcel$export($83620c096ed20185$exports, "AUTHENTIC_DATA", function () { return $83620c096ed20185$export$13c4d202e90d4d94; }, function (v) { return $83620c096ed20185$export$13c4d202e90d4d94 = v; });
$parcel$export($83620c096ed20185$exports, "CHECKING_DISABLED", function () { return $83620c096ed20185$export$292cc2af10c2b6ab; }, function (v) { return $83620c096ed20185$export$292cc2af10c2b6ab = v; });
$parcel$export($83620c096ed20185$exports, "DNSSEC_OK", function () { return $83620c096ed20185$export$c8da3c371062d568; }, function (v) { return $83620c096ed20185$export$c8da3c371062d568 = v; });
$parcel$export($83620c096ed20185$exports, "encode", function () { return $83620c096ed20185$export$c564cdbbe6da493; }, function (v) { return $83620c096ed20185$export$c564cdbbe6da493 = v; });
$parcel$export($83620c096ed20185$exports, "encodingLength", function () { return $83620c096ed20185$export$cbee51f25f0626d7; }, function (v) { return $83620c096ed20185$export$cbee51f25f0626d7 = v; });
$parcel$export($83620c096ed20185$exports, "decode", function () { return $83620c096ed20185$export$2f872c0f2117be69; }, function (v) { return $83620c096ed20185$export$2f872c0f2117be69 = v; });
$parcel$export($83620c096ed20185$exports, "streamEncode", function () { return $83620c096ed20185$export$374620bdcb396bcd; }, function (v) { return $83620c096ed20185$export$374620bdcb396bcd = v; });
$parcel$export($83620c096ed20185$exports, "streamDecode", function () { return $83620c096ed20185$export$7873fbe3f1f05fa6; }, function (v) { return $83620c096ed20185$export$7873fbe3f1f05fa6 = v; });
var $83620c096ed20185$export$a8ff84c12d48cfa6;
var $83620c096ed20185$export$19282c40b967aec6;
var $83620c096ed20185$export$76f050bd65425e13;
var $83620c096ed20185$export$b752097795bbaebd;
var $83620c096ed20185$export$ac96b34a74de2f22;
var $83620c096ed20185$export$7b1b591b262c240;
var $83620c096ed20185$export$2542a5a654329437;
var $83620c096ed20185$export$56b93c6175ee8274;
var $83620c096ed20185$export$2322a2658b955e5;
var $83620c096ed20185$export$dbcbf189e660012;
var $83620c096ed20185$export$a4ab9e1166fe1f1b;
var $83620c096ed20185$export$eae95cd38d620409;
var $83620c096ed20185$export$1ed5cc9cac6d3e38;
var $83620c096ed20185$export$407448d2b89b1813;
var $83620c096ed20185$export$8b02350718d87164;
var $83620c096ed20185$export$a75d1723e6bda2ec;
var $83620c096ed20185$export$2b91d3689f613272;
var $83620c096ed20185$export$ad4f294ad38147a3;
var $83620c096ed20185$export$c008f777d94a4783;
var $83620c096ed20185$export$6d4c73e3ddf8818b;
var $83620c096ed20185$export$2ab2dccc8f32ce46;
var $83620c096ed20185$export$b05393b09543e5f2;
var $83620c096ed20185$export$6c6581d59e81d1b9;
var $83620c096ed20185$export$1b9c36835e28a5f9;
var $83620c096ed20185$export$c4773623ab5afffc;
var $83620c096ed20185$export$dc8e86e1bd9ea40f;
var $83620c096ed20185$export$e5185e241753e543;
var $83620c096ed20185$export$50a780d71cf22a88;
var $83620c096ed20185$export$db9f06b5d27d15d8;
var $83620c096ed20185$export$6556f847e8047304;
var $83620c096ed20185$export$94f7062ce7df4e6e;
var $83620c096ed20185$export$fcc51f37815e5e3c;
var $83620c096ed20185$export$1f33e1212d848957;
var $83620c096ed20185$export$13c4d202e90d4d94;
var $83620c096ed20185$export$292cc2af10c2b6ab;
var $83620c096ed20185$export$c8da3c371062d568;
var $83620c096ed20185$export$c564cdbbe6da493;
var $83620c096ed20185$export$2f872c0f2117be69;
var $83620c096ed20185$export$cbee51f25f0626d7;
var $83620c096ed20185$export$374620bdcb396bcd;
var $83620c096ed20185$export$7873fbe3f1f05fa6;
"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $24f87a6f86a8996f$export$a143d493d941bafc;
var $24f87a6f86a8996f$export$e4cf37d7f6fb9e0a;
var $24f87a6f86a8996f$export$f99ded8fe4b79145;
var $24f87a6f86a8996f$export$599f31c3813fae4d;
"use strict";
var $3caef5c332c7293f$export$a48f0734ac7c2329;
var $3caef5c332c7293f$export$d622b2ad8d90c771;
var $3caef5c332c7293f$export$6100ba28696e12de;
"use strict";
$3caef5c332c7293f$export$a48f0734ac7c2329 = $3caef5c332c7293f$var$byteLength;
$3caef5c332c7293f$export$d622b2ad8d90c771 = $3caef5c332c7293f$var$toByteArray;
$3caef5c332c7293f$export$6100ba28696e12de = $3caef5c332c7293f$var$fromByteArray;
var $3caef5c332c7293f$var$lookup = [];
var $3caef5c332c7293f$var$revLookup = [];
var $3caef5c332c7293f$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $3caef5c332c7293f$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $3caef5c332c7293f$var$i = 0, $3caef5c332c7293f$var$len = $3caef5c332c7293f$var$code.length; $3caef5c332c7293f$var$i < $3caef5c332c7293f$var$len; ++$3caef5c332c7293f$var$i){
    $3caef5c332c7293f$var$lookup[$3caef5c332c7293f$var$i] = $3caef5c332c7293f$var$code[$3caef5c332c7293f$var$i];
    $3caef5c332c7293f$var$revLookup[$3caef5c332c7293f$var$code.charCodeAt($3caef5c332c7293f$var$i)] = $3caef5c332c7293f$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$3caef5c332c7293f$var$revLookup["-".charCodeAt(0)] = 62;
$3caef5c332c7293f$var$revLookup["_".charCodeAt(0)] = 63;
function $3caef5c332c7293f$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $3caef5c332c7293f$var$byteLength(b64) {
    var lens = $3caef5c332c7293f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3caef5c332c7293f$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3caef5c332c7293f$var$toByteArray(b64) {
    var tmp;
    var lens = $3caef5c332c7293f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $3caef5c332c7293f$var$Arr($3caef5c332c7293f$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 18 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 2 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 10 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $3caef5c332c7293f$var$tripletToBase64(num) {
    return $3caef5c332c7293f$var$lookup[num >> 18 & 0x3F] + $3caef5c332c7293f$var$lookup[num >> 12 & 0x3F] + $3caef5c332c7293f$var$lookup[num >> 6 & 0x3F] + $3caef5c332c7293f$var$lookup[num & 0x3F];
}
function $3caef5c332c7293f$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($3caef5c332c7293f$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $3caef5c332c7293f$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($3caef5c332c7293f$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($3caef5c332c7293f$var$lookup[tmp >> 2] + $3caef5c332c7293f$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($3caef5c332c7293f$var$lookup[tmp >> 10] + $3caef5c332c7293f$var$lookup[tmp >> 4 & 0x3F] + $3caef5c332c7293f$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $56a54f6ebabce67d$export$aafa59e2e03f2942;
var $56a54f6ebabce67d$export$68d8715fc104d294;
$56a54f6ebabce67d$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$56a54f6ebabce67d$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $24f87a6f86a8996f$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$24f87a6f86a8996f$export$a143d493d941bafc = $24f87a6f86a8996f$var$Buffer;
$24f87a6f86a8996f$export$e4cf37d7f6fb9e0a = $24f87a6f86a8996f$var$SlowBuffer;
$24f87a6f86a8996f$export$f99ded8fe4b79145 = 50;
const $24f87a6f86a8996f$var$K_MAX_LENGTH = 0x7fffffff;
$24f87a6f86a8996f$export$599f31c3813fae4d = $24f87a6f86a8996f$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $24f87a6f86a8996f$var$Buffer.TYPED_ARRAY_SUPPORT = $24f87a6f86a8996f$var$typedArraySupport();
if (!$24f87a6f86a8996f$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $24f87a6f86a8996f$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($24f87a6f86a8996f$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$24f87a6f86a8996f$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($24f87a6f86a8996f$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$24f87a6f86a8996f$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $24f87a6f86a8996f$var$createBuffer(length) {
    if (length > $24f87a6f86a8996f$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $24f87a6f86a8996f$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $24f87a6f86a8996f$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $24f87a6f86a8996f$var$allocUnsafe(arg);
    }
    return $24f87a6f86a8996f$var$from(arg, encodingOrOffset, length);
}
$24f87a6f86a8996f$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $24f87a6f86a8996f$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $24f87a6f86a8996f$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $24f87a6f86a8996f$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($24f87a6f86a8996f$var$isInstance(value, ArrayBuffer) || value && $24f87a6f86a8996f$var$isInstance(value.buffer, ArrayBuffer)) return $24f87a6f86a8996f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($24f87a6f86a8996f$var$isInstance(value, SharedArrayBuffer) || value && $24f87a6f86a8996f$var$isInstance(value.buffer, SharedArrayBuffer))) return $24f87a6f86a8996f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $24f87a6f86a8996f$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $24f87a6f86a8996f$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $24f87a6f86a8996f$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $24f87a6f86a8996f$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $24f87a6f86a8996f$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($24f87a6f86a8996f$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($24f87a6f86a8996f$var$Buffer, Uint8Array);
function $24f87a6f86a8996f$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $24f87a6f86a8996f$var$alloc(size, fill, encoding) {
    $24f87a6f86a8996f$var$assertSize(size);
    if (size <= 0) return $24f87a6f86a8996f$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $24f87a6f86a8996f$var$createBuffer(size).fill(fill, encoding) : $24f87a6f86a8996f$var$createBuffer(size).fill(fill);
    return $24f87a6f86a8996f$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $24f87a6f86a8996f$var$Buffer.alloc = function(size, fill, encoding) {
    return $24f87a6f86a8996f$var$alloc(size, fill, encoding);
};
function $24f87a6f86a8996f$var$allocUnsafe(size) {
    $24f87a6f86a8996f$var$assertSize(size);
    return $24f87a6f86a8996f$var$createBuffer(size < 0 ? 0 : $24f87a6f86a8996f$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $24f87a6f86a8996f$var$Buffer.allocUnsafe = function(size) {
    return $24f87a6f86a8996f$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $24f87a6f86a8996f$var$Buffer.allocUnsafeSlow = function(size) {
    return $24f87a6f86a8996f$var$allocUnsafe(size);
};
function $24f87a6f86a8996f$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$24f87a6f86a8996f$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $24f87a6f86a8996f$var$byteLength(string, encoding) | 0;
    let buf = $24f87a6f86a8996f$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $24f87a6f86a8996f$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $24f87a6f86a8996f$var$checked(array.length) | 0;
    const buf = $24f87a6f86a8996f$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $24f87a6f86a8996f$var$fromArrayView(arrayView) {
    if ($24f87a6f86a8996f$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $24f87a6f86a8996f$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $24f87a6f86a8996f$var$fromArrayLike(arrayView);
}
function $24f87a6f86a8996f$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $24f87a6f86a8996f$var$Buffer.prototype);
    return buf;
}
function $24f87a6f86a8996f$var$fromObject(obj) {
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(obj)) {
        const len = $24f87a6f86a8996f$var$checked(obj.length) | 0;
        const buf = $24f87a6f86a8996f$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $24f87a6f86a8996f$var$numberIsNaN(obj.length)) return $24f87a6f86a8996f$var$createBuffer(0);
        return $24f87a6f86a8996f$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $24f87a6f86a8996f$var$fromArrayLike(obj.data);
}
function $24f87a6f86a8996f$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $24f87a6f86a8996f$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $24f87a6f86a8996f$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $24f87a6f86a8996f$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $24f87a6f86a8996f$var$Buffer.alloc(+length);
}
$24f87a6f86a8996f$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $24f87a6f86a8996f$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$24f87a6f86a8996f$var$Buffer.compare = function compare(a, b) {
    if ($24f87a6f86a8996f$var$isInstance(a, Uint8Array)) a = $24f87a6f86a8996f$var$Buffer.from(a, a.offset, a.byteLength);
    if ($24f87a6f86a8996f$var$isInstance(b, Uint8Array)) b = $24f87a6f86a8996f$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(a) || !$24f87a6f86a8996f$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$24f87a6f86a8996f$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$24f87a6f86a8996f$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $24f87a6f86a8996f$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $24f87a6f86a8996f$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($24f87a6f86a8996f$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) buf = $24f87a6f86a8996f$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $24f87a6f86a8996f$var$byteLength(string, encoding) {
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $24f87a6f86a8996f$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $24f87a6f86a8996f$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $24f87a6f86a8996f$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $24f87a6f86a8996f$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$24f87a6f86a8996f$var$Buffer.byteLength = $24f87a6f86a8996f$var$byteLength;
function $24f87a6f86a8996f$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $24f87a6f86a8996f$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $24f87a6f86a8996f$var$utf8Slice(this, start, end);
        case "ascii":
            return $24f87a6f86a8996f$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $24f87a6f86a8996f$var$latin1Slice(this, start, end);
        case "base64":
            return $24f87a6f86a8996f$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $24f87a6f86a8996f$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$24f87a6f86a8996f$var$Buffer.prototype._isBuffer = true;
function $24f87a6f86a8996f$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$24f87a6f86a8996f$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$24f87a6f86a8996f$var$swap(this, i, i + 1);
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $24f87a6f86a8996f$var$swap(this, i, i + 3);
        $24f87a6f86a8996f$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $24f87a6f86a8996f$var$swap(this, i, i + 7);
        $24f87a6f86a8996f$var$swap(this, i + 1, i + 6);
        $24f87a6f86a8996f$var$swap(this, i + 2, i + 5);
        $24f87a6f86a8996f$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $24f87a6f86a8996f$var$utf8Slice(this, 0, length);
    return $24f87a6f86a8996f$var$slowToString.apply(this, arguments);
};
$24f87a6f86a8996f$var$Buffer.prototype.toLocaleString = $24f87a6f86a8996f$var$Buffer.prototype.toString;
$24f87a6f86a8996f$var$Buffer.prototype.equals = function equals(b) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $24f87a6f86a8996f$var$Buffer.compare(this, b) === 0;
};
$24f87a6f86a8996f$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $24f87a6f86a8996f$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($24f87a6f86a8996f$var$customInspectSymbol) $24f87a6f86a8996f$var$Buffer.prototype[$24f87a6f86a8996f$var$customInspectSymbol] = $24f87a6f86a8996f$var$Buffer.prototype.inspect;
$24f87a6f86a8996f$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($24f87a6f86a8996f$var$isInstance(target, Uint8Array)) target = $24f87a6f86a8996f$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $24f87a6f86a8996f$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($24f87a6f86a8996f$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $24f87a6f86a8996f$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $24f87a6f86a8996f$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $24f87a6f86a8996f$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $24f87a6f86a8996f$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$24f87a6f86a8996f$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$24f87a6f86a8996f$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $24f87a6f86a8996f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$24f87a6f86a8996f$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $24f87a6f86a8996f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $24f87a6f86a8996f$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($24f87a6f86a8996f$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $24f87a6f86a8996f$var$utf8Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $24f87a6f86a8996f$var$asciiWrite(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$asciiToBytes(string), buf, offset, length);
}
function $24f87a6f86a8996f$var$base64Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$base64ToBytes(string), buf, offset, length);
}
function $24f87a6f86a8996f$var$ucs2Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$24f87a6f86a8996f$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $24f87a6f86a8996f$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $24f87a6f86a8996f$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $24f87a6f86a8996f$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $24f87a6f86a8996f$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $24f87a6f86a8996f$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$24f87a6f86a8996f$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $24f87a6f86a8996f$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $3caef5c332c7293f$export$6100ba28696e12de(buf);
    else return $3caef5c332c7293f$export$6100ba28696e12de(buf.slice(start, end));
}
function $24f87a6f86a8996f$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $24f87a6f86a8996f$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $24f87a6f86a8996f$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $24f87a6f86a8996f$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $24f87a6f86a8996f$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $24f87a6f86a8996f$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $24f87a6f86a8996f$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $24f87a6f86a8996f$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$24f87a6f86a8996f$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $24f87a6f86a8996f$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $24f87a6f86a8996f$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$24f87a6f86a8996f$var$Buffer.prototype.readUintLE = $24f87a6f86a8996f$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUintBE = $24f87a6f86a8996f$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint8 = $24f87a6f86a8996f$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint16LE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint16BE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint32LE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint32BE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$24f87a6f86a8996f$var$Buffer.prototype.readBigUInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$24f87a6f86a8996f$var$Buffer.prototype.readBigUInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$24f87a6f86a8996f$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$24f87a6f86a8996f$var$Buffer.prototype.readBigInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$24f87a6f86a8996f$var$Buffer.prototype.readBigInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$24f87a6f86a8996f$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return $56a54f6ebabce67d$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$24f87a6f86a8996f$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return $56a54f6ebabce67d$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$24f87a6f86a8996f$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 8, this.length);
    return $56a54f6ebabce67d$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$24f87a6f86a8996f$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 8, this.length);
    return $56a54f6ebabce67d$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $24f87a6f86a8996f$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$24f87a6f86a8996f$var$Buffer.prototype.writeUintLE = $24f87a6f86a8996f$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUintBE = $24f87a6f86a8996f$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint8 = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint16LE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint16BE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint32LE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint32BE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $24f87a6f86a8996f$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $24f87a6f86a8996f$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeBigUInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeBigUInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeBigInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeBigInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $24f87a6f86a8996f$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $56a54f6ebabce67d$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeFloat(this, value, offset, true, noAssert);
};
$24f87a6f86a8996f$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeFloat(this, value, offset, false, noAssert);
};
function $24f87a6f86a8996f$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $56a54f6ebabce67d$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeDouble(this, value, offset, true, noAssert);
};
$24f87a6f86a8996f$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$24f87a6f86a8996f$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$24f87a6f86a8996f$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$24f87a6f86a8996f$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $24f87a6f86a8996f$var$Buffer.isBuffer(val) ? val : $24f87a6f86a8996f$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $24f87a6f86a8996f$var$errors = {};
function $24f87a6f86a8996f$var$E(sym, getMessage, Base) {
    $24f87a6f86a8996f$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$24f87a6f86a8996f$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$24f87a6f86a8996f$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$24f87a6f86a8996f$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $24f87a6f86a8996f$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $24f87a6f86a8996f$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $24f87a6f86a8996f$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $24f87a6f86a8996f$var$checkBounds(buf, offset, byteLength) {
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $24f87a6f86a8996f$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $24f87a6f86a8996f$var$checkBounds(buf, offset, byteLength);
}
function $24f87a6f86a8996f$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $24f87a6f86a8996f$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $24f87a6f86a8996f$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $24f87a6f86a8996f$var$validateNumber(value, type);
        throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $24f87a6f86a8996f$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $24f87a6f86a8996f$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $24f87a6f86a8996f$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($24f87a6f86a8996f$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $24f87a6f86a8996f$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $24f87a6f86a8996f$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $24f87a6f86a8996f$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $24f87a6f86a8996f$var$base64ToBytes(str) {
    return $3caef5c332c7293f$export$d622b2ad8d90c771($24f87a6f86a8996f$var$base64clean(str));
}
function $24f87a6f86a8996f$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $24f87a6f86a8996f$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $24f87a6f86a8996f$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $24f87a6f86a8996f$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $24f87a6f86a8996f$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $24f87a6f86a8996f$var$BufferBigIntNotDefined : fn;
}
function $24f87a6f86a8996f$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $83620c096ed20185$require$Buffer = $24f87a6f86a8996f$export$a143d493d941bafc;
var $82a51adef14173f8$export$f84e8e69fd4488a5;
var $82a51adef14173f8$export$2fe53163c7bc4eaf;
"use strict";
$82a51adef14173f8$export$f84e8e69fd4488a5 = function(type) {
    switch(type){
        case 1:
            return "A";
        case 10:
            return "NULL";
        case 28:
            return "AAAA";
        case 18:
            return "AFSDB";
        case 42:
            return "APL";
        case 257:
            return "CAA";
        case 60:
            return "CDNSKEY";
        case 59:
            return "CDS";
        case 37:
            return "CERT";
        case 5:
            return "CNAME";
        case 49:
            return "DHCID";
        case 32769:
            return "DLV";
        case 39:
            return "DNAME";
        case 48:
            return "DNSKEY";
        case 43:
            return "DS";
        case 55:
            return "HIP";
        case 13:
            return "HINFO";
        case 45:
            return "IPSECKEY";
        case 25:
            return "KEY";
        case 36:
            return "KX";
        case 29:
            return "LOC";
        case 15:
            return "MX";
        case 35:
            return "NAPTR";
        case 2:
            return "NS";
        case 47:
            return "NSEC";
        case 50:
            return "NSEC3";
        case 51:
            return "NSEC3PARAM";
        case 12:
            return "PTR";
        case 46:
            return "RRSIG";
        case 17:
            return "RP";
        case 24:
            return "SIG";
        case 6:
            return "SOA";
        case 99:
            return "SPF";
        case 33:
            return "SRV";
        case 44:
            return "SSHFP";
        case 32768:
            return "TA";
        case 249:
            return "TKEY";
        case 52:
            return "TLSA";
        case 250:
            return "TSIG";
        case 16:
            return "TXT";
        case 252:
            return "AXFR";
        case 251:
            return "IXFR";
        case 41:
            return "OPT";
        case 255:
            return "ANY";
    }
    return "UNKNOWN_" + type;
};
$82a51adef14173f8$export$2fe53163c7bc4eaf = function(name) {
    switch(name.toUpperCase()){
        case "A":
            return 1;
        case "NULL":
            return 10;
        case "AAAA":
            return 28;
        case "AFSDB":
            return 18;
        case "APL":
            return 42;
        case "CAA":
            return 257;
        case "CDNSKEY":
            return 60;
        case "CDS":
            return 59;
        case "CERT":
            return 37;
        case "CNAME":
            return 5;
        case "DHCID":
            return 49;
        case "DLV":
            return 32769;
        case "DNAME":
            return 39;
        case "DNSKEY":
            return 48;
        case "DS":
            return 43;
        case "HIP":
            return 55;
        case "HINFO":
            return 13;
        case "IPSECKEY":
            return 45;
        case "KEY":
            return 25;
        case "KX":
            return 36;
        case "LOC":
            return 29;
        case "MX":
            return 15;
        case "NAPTR":
            return 35;
        case "NS":
            return 2;
        case "NSEC":
            return 47;
        case "NSEC3":
            return 50;
        case "NSEC3PARAM":
            return 51;
        case "PTR":
            return 12;
        case "RRSIG":
            return 46;
        case "RP":
            return 17;
        case "SIG":
            return 24;
        case "SOA":
            return 6;
        case "SPF":
            return 99;
        case "SRV":
            return 33;
        case "SSHFP":
            return 44;
        case "TA":
            return 32768;
        case "TKEY":
            return 249;
        case "TLSA":
            return 52;
        case "TSIG":
            return 250;
        case "TXT":
            return 16;
        case "AXFR":
            return 252;
        case "IXFR":
            return 251;
        case "OPT":
            return 41;
        case "ANY":
            return 255;
        case "*":
            return 255;
    }
    if (name.toUpperCase().startsWith("UNKNOWN_")) return parseInt(name.slice(8));
    return 0;
};


/*
 * Traditional DNS header RCODEs (4-bits) defined by IANA in
 * https://www.iana.org/assignments/dns-parameters/dns-parameters.xhtml
 */ var $3b4fe4f035198d57$export$f84e8e69fd4488a5;
var $3b4fe4f035198d57$export$d953b9b6771b427c;
"use strict";
$3b4fe4f035198d57$export$f84e8e69fd4488a5 = function(rcode) {
    switch(rcode){
        case 0:
            return "NOERROR";
        case 1:
            return "FORMERR";
        case 2:
            return "SERVFAIL";
        case 3:
            return "NXDOMAIN";
        case 4:
            return "NOTIMP";
        case 5:
            return "REFUSED";
        case 6:
            return "YXDOMAIN";
        case 7:
            return "YXRRSET";
        case 8:
            return "NXRRSET";
        case 9:
            return "NOTAUTH";
        case 10:
            return "NOTZONE";
        case 11:
            return "RCODE_11";
        case 12:
            return "RCODE_12";
        case 13:
            return "RCODE_13";
        case 14:
            return "RCODE_14";
        case 15:
            return "RCODE_15";
    }
    return "RCODE_" + rcode;
};
$3b4fe4f035198d57$export$d953b9b6771b427c = function(code) {
    switch(code.toUpperCase()){
        case "NOERROR":
            return 0;
        case "FORMERR":
            return 1;
        case "SERVFAIL":
            return 2;
        case "NXDOMAIN":
            return 3;
        case "NOTIMP":
            return 4;
        case "REFUSED":
            return 5;
        case "YXDOMAIN":
            return 6;
        case "YXRRSET":
            return 7;
        case "NXRRSET":
            return 8;
        case "NOTAUTH":
            return 9;
        case "NOTZONE":
            return 10;
        case "RCODE_11":
            return 11;
        case "RCODE_12":
            return 12;
        case "RCODE_13":
            return 13;
        case "RCODE_14":
            return 14;
        case "RCODE_15":
            return 15;
    }
    return 0;
};


/*
 * Traditional DNS header OPCODEs (4-bits) defined by IANA in
 * https://www.iana.org/assignments/dns-parameters/dns-parameters.xhtml#dns-parameters-5
 */ var $c44dab2b6c40d189$export$f84e8e69fd4488a5;
var $c44dab2b6c40d189$export$c8419906046b1656;
"use strict";
$c44dab2b6c40d189$export$f84e8e69fd4488a5 = function(opcode) {
    switch(opcode){
        case 0:
            return "QUERY";
        case 1:
            return "IQUERY";
        case 2:
            return "STATUS";
        case 3:
            return "OPCODE_3";
        case 4:
            return "NOTIFY";
        case 5:
            return "UPDATE";
        case 6:
            return "OPCODE_6";
        case 7:
            return "OPCODE_7";
        case 8:
            return "OPCODE_8";
        case 9:
            return "OPCODE_9";
        case 10:
            return "OPCODE_10";
        case 11:
            return "OPCODE_11";
        case 12:
            return "OPCODE_12";
        case 13:
            return "OPCODE_13";
        case 14:
            return "OPCODE_14";
        case 15:
            return "OPCODE_15";
    }
    return "OPCODE_" + opcode;
};
$c44dab2b6c40d189$export$c8419906046b1656 = function(code) {
    switch(code.toUpperCase()){
        case "QUERY":
            return 0;
        case "IQUERY":
            return 1;
        case "STATUS":
            return 2;
        case "OPCODE_3":
            return 3;
        case "NOTIFY":
            return 4;
        case "UPDATE":
            return 5;
        case "OPCODE_6":
            return 6;
        case "OPCODE_7":
            return 7;
        case "OPCODE_8":
            return 8;
        case "OPCODE_9":
            return 9;
        case "OPCODE_10":
            return 10;
        case "OPCODE_11":
            return 11;
        case "OPCODE_12":
            return 12;
        case "OPCODE_13":
            return 13;
        case "OPCODE_14":
            return 14;
        case "OPCODE_15":
            return 15;
    }
    return 0;
};


var $ac8c08d9785de89a$export$f84e8e69fd4488a5;
var $ac8c08d9785de89a$export$e0575f7ae787892f;
"use strict";
$ac8c08d9785de89a$export$f84e8e69fd4488a5 = function(klass) {
    switch(klass){
        case 1:
            return "IN";
        case 2:
            return "CS";
        case 3:
            return "CH";
        case 4:
            return "HS";
        case 255:
            return "ANY";
    }
    return "UNKNOWN_" + klass;
};
$ac8c08d9785de89a$export$e0575f7ae787892f = function(name) {
    switch(name.toUpperCase()){
        case "IN":
            return 1;
        case "CS":
            return 2;
        case "CH":
            return 3;
        case "HS":
            return 4;
        case "ANY":
            return 255;
    }
    return 0;
};


var $8b96021e11e0dc20$export$f84e8e69fd4488a5;
var $8b96021e11e0dc20$export$efcacb532bf2dd2a;
"use strict";
$8b96021e11e0dc20$export$f84e8e69fd4488a5 = function(type) {
    switch(type){
        // list at
        // https://www.iana.org/assignments/dns-parameters/dns-parameters.xhtml#dns-parameters-11
        case 1:
            return "LLQ";
        case 2:
            return "UL";
        case 3:
            return "NSID";
        case 5:
            return "DAU";
        case 6:
            return "DHU";
        case 7:
            return "N3U";
        case 8:
            return "CLIENT_SUBNET";
        case 9:
            return "EXPIRE";
        case 10:
            return "COOKIE";
        case 11:
            return "TCP_KEEPALIVE";
        case 12:
            return "PADDING";
        case 13:
            return "CHAIN";
        case 14:
            return "KEY_TAG";
        case 26946:
            return "DEVICEID";
    }
    if (type < 0) return null;
    return `OPTION_${type}`;
};
$8b96021e11e0dc20$export$efcacb532bf2dd2a = function(name) {
    if (typeof name === "number") return name;
    if (!name) return -1;
    switch(name.toUpperCase()){
        case "OPTION_0":
            return 0;
        case "LLQ":
            return 1;
        case "UL":
            return 2;
        case "NSID":
            return 3;
        case "OPTION_4":
            return 4;
        case "DAU":
            return 5;
        case "DHU":
            return 6;
        case "N3U":
            return 7;
        case "CLIENT_SUBNET":
            return 8;
        case "EXPIRE":
            return 9;
        case "COOKIE":
            return 10;
        case "TCP_KEEPALIVE":
            return 11;
        case "PADDING":
            return 12;
        case "CHAIN":
            return 13;
        case "KEY_TAG":
            return 14;
        case "DEVICEID":
            return 26946;
        case "OPTION_65535":
            return 65535;
    }
    const m = name.match(/_(\d+)$/);
    if (m) return parseInt(m[1], 10);
    return -1;
};


var $12c37352b22e272c$exports = {};
// GENERATED FILE. DO NOT EDIT.
var $12c37352b22e272c$var$ipCodec = function(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.decode = decode;
    exports.encode = encode;
    exports.familyOf = familyOf;
    exports.name = void 0;
    exports.sizeOf = sizeOf;
    exports.v6 = exports.v4 = void 0;
    const v4Regex = /^(\d{1,3}\.){3,3}\d{1,3}$/;
    const v4Size = 4;
    const v6Regex = /^(::)?(((\d{1,3}\.){3}(\d{1,3}){1})?([0-9a-f]){0,4}:{0,2}){1,8}(::)?$/i;
    const v6Size = 16;
    const v4 = {
        name: "v4",
        size: v4Size,
        isFormat: (ip)=>v4Regex.test(ip),
        encode (ip, buff, offset) {
            offset = ~~offset;
            buff = buff || new Uint8Array(offset + v4Size);
            const max = ip.length;
            let n = 0;
            for(let i = 0; i < max;){
                const c = ip.charCodeAt(i++);
                if (c === 46) {
                    // "."
                    buff[offset++] = n;
                    n = 0;
                } else n = n * 10 + (c - 48);
            }
            buff[offset] = n;
            return buff;
        },
        decode (buff, offset) {
            offset = ~~offset;
            return `${buff[offset++]}.${buff[offset++]}.${buff[offset++]}.${buff[offset]}`;
        }
    };
    exports.v4 = v4;
    const v6 = {
        name: "v6",
        size: v6Size,
        isFormat: (ip)=>ip.length > 0 && v6Regex.test(ip),
        encode (ip, buff, offset) {
            offset = ~~offset;
            let end = offset + v6Size;
            let fill = -1;
            let hexN = 0;
            let decN = 0;
            let prevColon = true;
            let useDec = false;
            buff = buff || new Uint8Array(offset + v6Size); // Note: This algorithm needs to check if the offset
            // could exceed the buffer boundaries as it supports
            // non-standard compliant encodings that may go beyond
            // the boundary limits. if (offset < end) checks should
            // not be necessary...
            for(let i = 0; i < ip.length; i++){
                let c = ip.charCodeAt(i);
                if (c === 58) {
                    // :
                    if (prevColon) {
                        if (fill !== -1) {
                            // Not Standard! (standard doesn't allow multiple ::)
                            // We need to treat
                            if (offset < end) buff[offset] = 0;
                            if (offset < end - 1) buff[offset + 1] = 0;
                            offset += 2;
                        } else if (offset < end) // :: in the middle
                        fill = offset;
                    } else {
                        // : ends the previous number
                        if (useDec === true) {
                            // Non-standard! (ipv4 should be at end only)
                            // A ipv4 address should not be found anywhere else but at
                            // the end. This codec also support putting characters
                            // after the ipv4 address..
                            if (offset < end) buff[offset] = decN;
                            offset++;
                        } else {
                            if (offset < end) buff[offset] = hexN >> 8;
                            if (offset < end - 1) buff[offset + 1] = hexN & 0xff;
                            offset += 2;
                        }
                        hexN = 0;
                        decN = 0;
                    }
                    prevColon = true;
                    useDec = false;
                } else if (c === 46) {
                    // . indicates IPV4 notation
                    if (offset < end) buff[offset] = decN;
                    offset++;
                    decN = 0;
                    hexN = 0;
                    prevColon = false;
                    useDec = true;
                } else {
                    prevColon = false;
                    if (c >= 97) c -= 87; // a-f ... 97~102 -87 => 10~15
                    else if (c >= 65) c -= 55; // A-F ... 65~70 -55 => 10~15
                    else {
                        c -= 48; // 0-9 ... starting from charCode 48
                        decN = decN * 10 + c;
                    } // We don't know yet if its a dec or hex number
                    hexN = (hexN << 4) + c;
                }
            }
            if (prevColon === false) {
                // Commiting last number
                if (useDec === true) {
                    if (offset < end) buff[offset] = decN;
                    offset++;
                } else {
                    if (offset < end) buff[offset] = hexN >> 8;
                    if (offset < end - 1) buff[offset + 1] = hexN & 0xff;
                    offset += 2;
                }
            } else if (fill === 0) {
                // Not Standard! (standard doesn't allow multiple ::)
                // This means that a : was found at the start AND end which means the
                // end needs to be treated as 0 entry...
                if (offset < end) buff[offset] = 0;
                if (offset < end - 1) buff[offset + 1] = 0;
                offset += 2;
            } else if (fill !== -1) {
                // Non-standard! (standard doens't allow multiple ::)
                // Here we find that there has been a :: somewhere in the middle
                // and the end. To treat the end with priority we need to move all
                // written data two bytes to the right.
                offset += 2;
                for(let i = Math.min(offset - 1, end - 1); i >= fill + 2; i--)buff[i] = buff[i - 2];
                buff[fill] = 0;
                buff[fill + 1] = 0;
                fill = offset;
            }
            if (fill !== offset && fill !== -1) {
                // Move the written numbers to the end while filling the everything
                // "fill" to the bytes with zeros.
                if (offset > end - 2) // Non Standard support, when the cursor exceeds bounds.
                offset = end - 2;
                while(end > fill)buff[--end] = offset < end && offset > fill ? buff[--offset] : 0;
            } else // Fill the rest with zeros
            while(offset < end)buff[offset++] = 0;
            return buff;
        },
        decode (buff, offset) {
            offset = ~~offset;
            let result = "";
            for(let i = 0; i < v6Size; i += 2){
                if (i !== 0) result += ":";
                result += (buff[offset + i] << 8 | buff[offset + i + 1]).toString(16);
            }
            return result.replace(/(^|:)0(:0)*:0(:|$)/, "$1::$3").replace(/:{3,4}/, "::");
        }
    };
    exports.v6 = v6;
    const name = "ip";
    exports.name = name;
    function sizeOf(ip) {
        if (v4.isFormat(ip)) return v4.size;
        if (v6.isFormat(ip)) return v6.size;
        throw Error(`Invalid ip address: ${ip}`);
    }
    function familyOf(string) {
        return sizeOf(string) === v4.size ? 1 : 2;
    }
    function encode(ip, buff, offset) {
        offset = ~~offset;
        const size = sizeOf(ip);
        if (typeof buff === "function") buff = buff(offset + size);
        if (size === v4.size) return v4.encode(ip, buff, offset);
        return v6.encode(ip, buff, offset);
    }
    function decode(buff, offset, length) {
        offset = ~~offset;
        length = length || buff.length - offset;
        if (length === v4.size) return v4.decode(buff, offset, length);
        if (length === v6.size) return v6.decode(buff, offset, length);
        throw Error(`Invalid buffer size needs to be ${v4.size} for v4 or ${v6.size} for v6.`);
    }
    return "default" in exports ? exports.default : exports;
}({});
if (typeof define === "function" && define.amd) define([], function() {
    return $12c37352b22e272c$var$ipCodec;
});
else $12c37352b22e272c$exports = $12c37352b22e272c$var$ipCodec;


const $83620c096ed20185$var$QUERY_FLAG = 0;
const $83620c096ed20185$var$RESPONSE_FLAG = 32768;
const $83620c096ed20185$var$FLUSH_MASK = 32768;
const $83620c096ed20185$var$NOT_FLUSH_MASK = ~$83620c096ed20185$var$FLUSH_MASK;
const $83620c096ed20185$var$QU_MASK = 32768;
const $83620c096ed20185$var$NOT_QU_MASK = ~$83620c096ed20185$var$QU_MASK;
const $83620c096ed20185$var$name = $83620c096ed20185$export$a8ff84c12d48cfa6 = {};
$83620c096ed20185$var$name.encode = function(str, buf, offset, { mail: mail = false } = {}) {
    if (!buf) buf = $83620c096ed20185$require$Buffer.alloc($83620c096ed20185$var$name.encodingLength(str));
    if (!offset) offset = 0;
    const oldOffset = offset;
    // strip leading and trailing .
    const n = str.replace(/^\.|\.$/gm, "");
    if (n.length) {
        let list = [];
        if (mail) {
            let localPart = "";
            n.split(".").forEach((label)=>{
                if (label.endsWith("\\")) localPart += (localPart.length ? "." : "") + label.slice(0, -1);
                else if (list.length === 0 && localPart.length) list.push(localPart + "." + label);
                else list.push(label);
            });
        } else list = n.split(".");
        for(let i = 0; i < list.length; i++){
            const len = buf.write(list[i], offset + 1);
            buf[offset] = len;
            offset += len + 1;
        }
    }
    buf[offset++] = 0;
    $83620c096ed20185$var$name.encode.bytes = offset - oldOffset;
    return buf;
};
$83620c096ed20185$var$name.encode.bytes = 0;
$83620c096ed20185$var$name.decode = function(buf, offset, { mail: mail = false } = {}) {
    if (!offset) offset = 0;
    const list = [];
    let oldOffset = offset;
    let totalLength = 0;
    let consumedBytes = 0;
    let jumped = false;
    while(true){
        if (offset >= buf.length) throw new Error("Cannot decode name (buffer overflow)");
        const len = buf[offset++];
        consumedBytes += jumped ? 0 : 1;
        if (len === 0) break;
        else if ((len & 0xc0) === 0) {
            if (offset + len > buf.length) throw new Error("Cannot decode name (buffer overflow)");
            totalLength += len + 1;
            if (totalLength > 254) throw new Error("Cannot decode name (name too long)");
            let label = buf.toString("utf-8", offset, offset + len);
            if (mail) label = label.replace(/\./g, "\\.");
            list.push(label);
            offset += len;
            consumedBytes += jumped ? 0 : len;
        } else if ((len & 0xc0) === 0xc0) {
            if (offset + 1 > buf.length) throw new Error("Cannot decode name (buffer overflow)");
            const jumpOffset = buf.readUInt16BE(offset - 1) - 0xc000;
            if (jumpOffset >= oldOffset) // Allow only pointers to prior data. RFC 1035, section 4.1.4 states:
            // "[...] an entire domain name or a list of labels at the end of a domain name
            // is replaced with a pointer to a prior occurance (sic) of the same name."
            throw new Error("Cannot decode name (bad pointer)");
            offset = jumpOffset;
            oldOffset = jumpOffset;
            consumedBytes += jumped ? 0 : 1;
            jumped = true;
        } else throw new Error("Cannot decode name (bad label)");
    }
    $83620c096ed20185$var$name.decode.bytes = consumedBytes;
    return list.length === 0 ? "." : list.join(".");
};
$83620c096ed20185$var$name.decode.bytes = 0;
$83620c096ed20185$var$name.encodingLength = function(n) {
    if (n === "." || n === "..") return 1;
    return $83620c096ed20185$require$Buffer.byteLength(n.replace(/^\.|\.$/gm, "")) + 2;
};
const $83620c096ed20185$var$string = {};
$83620c096ed20185$var$string.encode = function(s, buf, offset) {
    if (!buf) buf = $83620c096ed20185$require$Buffer.alloc($83620c096ed20185$var$string.encodingLength(s));
    if (!offset) offset = 0;
    const len = buf.write(s, offset + 1);
    buf[offset] = len;
    $83620c096ed20185$var$string.encode.bytes = len + 1;
    return buf;
};
$83620c096ed20185$var$string.encode.bytes = 0;
$83620c096ed20185$var$string.decode = function(buf, offset) {
    if (!offset) offset = 0;
    const len = buf[offset];
    const s = buf.toString("utf-8", offset + 1, offset + 1 + len);
    $83620c096ed20185$var$string.decode.bytes = len + 1;
    return s;
};
$83620c096ed20185$var$string.decode.bytes = 0;
$83620c096ed20185$var$string.encodingLength = function(s) {
    return $83620c096ed20185$require$Buffer.byteLength(s) + 1;
};
const $83620c096ed20185$var$header = {};
$83620c096ed20185$var$header.encode = function(h, buf, offset) {
    if (!buf) buf = $83620c096ed20185$var$header.encodingLength(h);
    if (!offset) offset = 0;
    const flags = (h.flags || 0) & 32767;
    const type = h.type === "response" ? $83620c096ed20185$var$RESPONSE_FLAG : $83620c096ed20185$var$QUERY_FLAG;
    buf.writeUInt16BE(h.id || 0, offset);
    buf.writeUInt16BE(flags | type, offset + 2);
    buf.writeUInt16BE(h.questions.length, offset + 4);
    buf.writeUInt16BE(h.answers.length, offset + 6);
    buf.writeUInt16BE(h.authorities.length, offset + 8);
    buf.writeUInt16BE(h.additionals.length, offset + 10);
    return buf;
};
$83620c096ed20185$var$header.encode.bytes = 12;
$83620c096ed20185$var$header.decode = function(buf, offset) {
    if (!offset) offset = 0;
    if (buf.length < 12) throw new Error("Header must be 12 bytes");
    const flags = buf.readUInt16BE(offset + 2);
    return {
        id: buf.readUInt16BE(offset),
        type: flags & $83620c096ed20185$var$RESPONSE_FLAG ? "response" : "query",
        flags: flags & 32767,
        flag_qr: (flags >> 15 & 0x1) === 1,
        opcode: $c44dab2b6c40d189$export$f84e8e69fd4488a5(flags >> 11 & 0xf),
        flag_aa: (flags >> 10 & 0x1) === 1,
        flag_tc: (flags >> 9 & 0x1) === 1,
        flag_rd: (flags >> 8 & 0x1) === 1,
        flag_ra: (flags >> 7 & 0x1) === 1,
        flag_z: (flags >> 6 & 0x1) === 1,
        flag_ad: (flags >> 5 & 0x1) === 1,
        flag_cd: (flags >> 4 & 0x1) === 1,
        rcode: $3b4fe4f035198d57$export$f84e8e69fd4488a5(flags & 0xf),
        questions: new Array(buf.readUInt16BE(offset + 4)),
        answers: new Array(buf.readUInt16BE(offset + 6)),
        authorities: new Array(buf.readUInt16BE(offset + 8)),
        additionals: new Array(buf.readUInt16BE(offset + 10))
    };
};
$83620c096ed20185$var$header.decode.bytes = 12;
$83620c096ed20185$var$header.encodingLength = function() {
    return 12;
};
const $83620c096ed20185$var$runknown = $83620c096ed20185$export$19282c40b967aec6 = {};
$83620c096ed20185$var$runknown.encode = function(data, buf, offset) {
    if (!buf) buf = $83620c096ed20185$require$Buffer.alloc($83620c096ed20185$var$runknown.encodingLength(data));
    if (!offset) offset = 0;
    buf.writeUInt16BE(data.length, offset);
    data.copy(buf, offset + 2);
    $83620c096ed20185$var$runknown.encode.bytes = data.length + 2;
    return buf;
};
$83620c096ed20185$var$runknown.encode.bytes = 0;
$83620c096ed20185$var$runknown.decode = function(buf, offset) {
    if (!offset) offset = 0;
    const len = buf.readUInt16BE(offset);
    const data = buf.slice(offset + 2, offset + 2 + len);
    $83620c096ed20185$var$runknown.decode.bytes = len + 2;
    return data;
};
$83620c096ed20185$var$runknown.decode.bytes = 0;
$83620c096ed20185$var$runknown.encodingLength = function(data) {
    return data.length + 2;
};
const $83620c096ed20185$var$rns = $83620c096ed20185$export$76f050bd65425e13 = {};
$83620c096ed20185$var$rns.encode = function(data, buf, offset) {
    if (!buf) buf = $83620c096ed20185$require$Buffer.alloc($83620c096ed20185$var$rns.encodingLength(data));
    if (!offset) offset = 0;
    $83620c096ed20185$var$name.encode(data, buf, offset + 2);
    buf.writeUInt16BE($83620c096ed20185$var$name.encode.bytes, offset);
    $83620c096ed20185$var$rns.encode.bytes = $83620c096ed20185$var$name.encode.bytes + 2;
    return buf;
};
$83620c096ed20185$var$rns.encode.bytes = 0;
$83620c096ed20185$var$rns.decode = function(buf, offset) {
    if (!offset) offset = 0;
    const len = buf.readUInt16BE(offset);
    const dd = $83620c096ed20185$var$name.decode(buf, offset + 2);
    $83620c096ed20185$var$rns.decode.bytes = len + 2;
    return dd;
};
$83620c096ed20185$var$rns.decode.bytes = 0;
$83620c096ed20185$var$rns.encodingLength = function(data) {
    return $83620c096ed20185$var$name.encodingLength(data) + 2;
};
const $83620c096ed20185$var$rsoa = $83620c096ed20185$export$b752097795bbaebd = {};
$83620c096ed20185$var$rsoa.encode = function(data, buf, offset) {
    if (!buf) buf = $83620c096ed20185$require$Buffer.alloc($83620c096ed20185$var$rsoa.encodingLength(data));
    if (!offset) offset = 0;
    const oldOffset = offset;
    offset += 2;
    $83620c096ed20185$var$name.encode(data.mname, buf, offset);
    offset += $83620c096ed20185$var$name.encode.bytes;
    $83620c096ed20185$var$name.encode(data.rname, buf, offset, {
        mail: true
    });
    offset += $83620c096ed20185$var$name.encode.bytes;
    buf.writeUInt32BE(data.serial || 0, offset);
    offset += 4;
    buf.writeUInt32BE(data.refresh || 0, offset);
    offset += 4;
    buf.writeUInt32BE(data.retry || 0, offset);
    offset += 4;
    buf.writeUInt32BE(data.expire || 0, offset);
    offset += 4;
    buf.writeUInt32BE(data.minimum || 0, offset);
    offset += 4;
    buf.writeUInt16BE(offset - oldOffset - 2, oldOffset);
    $83620c096ed20185$var$rsoa.encode.bytes = offset - oldOffset;
    return buf;
};
$83620c096ed20185$var$rsoa.encode.bytes = 0;
$83620c096ed20185$var$rsoa.decode = function(buf, offset) {
    if (!offset) offset = 0;
    const oldOffset = offset;
    const data = {};
    offset += 2;
    data.mname = $83620c096ed20185$var$name.decode(buf, offset);
    offset += $83620c096ed20185$var$name.decode.bytes;
    data.rname = $83620c096ed20185$var$name.decode(buf, offset, {
        mail: true
    });
    offset += $83620c096ed20185$var$name.decode.bytes;
    data.serial = buf.readUInt32BE(offset);
    offset += 4;
    data.refresh = buf.readUInt32BE(offset);
    offset += 4;
    data.retry = buf.readUInt32BE(offset);
    offset += 4;
    data.expire = buf.readUInt32BE(offset);
    offset += 4;
    data.minimum = buf.readUInt32BE(offset);
    offset += 4;
    $83620c096ed20185$var$rsoa.decode.bytes = offset - oldOffset;
    return data;
};
$83620c096ed20185$var$rsoa.decode.bytes = 0;
$83620c096ed20185$var$rsoa.encodingLength = function(data) {
    return 22 + $83620c096ed20185$var$name.encodingLength(data.mname) + $83620c096ed20185$var$name.encodingLength(data.rname);
};
const $83620c096ed20185$var$rtxt = $83620c096ed20185$export$ac96b34a74de2f22 = {};
$83620c096ed20185$var$rtxt.encode = function(data, buf, offset) {
    if (!Array.isArray(data)) data = [
        data
    ];
    for(let i = 0; i < data.length; i++){
        if (typeof data[i] === "string") data[i] = $83620c096ed20185$require$Buffer.from(data[i]);
        if (!$83620c096ed20185$require$Buffer.isBuffer(data[i])) throw new Error("Must be a Buffer");
    }
    if (!buf) buf = $83620c096ed20185$require$Buffer.alloc($83620c096ed20185$var$rtxt.encodingLength(data));
    if (!offset) offset = 0;
    const oldOffset = offset;
    offset += 2;
    data.forEach(function(d) {
        buf[offset++] = d.length;
        d.copy(buf, offset, 0, d.length);
        offset += d.length;
    });
    buf.writeUInt16BE(offset - oldOffset - 2, oldOffset);
    $83620c096ed20185$var$rtxt.encode.bytes = offset - oldOffset;
    return buf;
};
$83620c096ed20185$var$rtxt.encode.bytes = 0;
$83620c096ed20185$var$rtxt.decode = function(buf, offset) {
    if (!offset) offset = 0;
    const oldOffset = offset;
    let remaining = buf.readUInt16BE(offset);
    offset += 2;
    let data = [];
    while(remaining > 0){
        const len = buf[offset++];
        --remaining;
        if (remaining < len) throw new Error("Buffer overflow");
        data.push(buf.slice(offset, offset + len));
        offset += len;
        remaining -= len;
    }
    $83620c096ed20185$var$rtxt.decode.bytes = offset - oldOffset;
    return data;
};
$83620c096ed20185$var$rtxt.decode.bytes = 0;
$83620c096ed20185$var$rtxt.encodingLength = function(data) {
    if (!Array.isArray(data)) data = [
        data
    ];
    let length = 2;
    data.forEach(function(buf) {
        if (typeof buf === "string") length += $83620c096ed20185$require$Buffer.byteLength(buf) + 1;
        else length += buf.length + 1;
    });
    return length;
};
const $83620c096ed20185$var$rnull = $83620c096ed20185$export$7b1b591b262c240 = {};
$83620c096ed20185$var$rnull.encode = function(data, buf, offset) {
    if (!buf) buf = $83620c096ed20185$require$Buffer.alloc($83620c096ed20185$var$rnull.encodingLength(data));
    if (!offset) offset = 0;
    if (typeof data === "string") data = $83620c096ed20185$require$Buffer.from(data);
    if (!data) data = $83620c096ed20185$require$Buffer.alloc(0);
    const oldOffset = offset;
    offset += 2;
    const len = data.length;
    data.copy(buf, offset, 0, len);
    offset += len;
    buf.writeUInt16BE(offset - oldOffset - 2, oldOffset);
    $83620c096ed20185$var$rnull.encode.bytes = offset - oldOffset;
    return buf;
};
$83620c096ed20185$var$rnull.encode.bytes = 0;
$83620c096ed20185$var$rnull.decode = function(buf, offset) {
    if (!offset) offset = 0;
    const oldOffset = offset;
    const len = buf.readUInt16BE(offset);
    offset += 2;
    const data = buf.slice(offset, offset + len);
    offset += len;
    $83620c096ed20185$var$rnull.decode.bytes = offset - oldOffset;
    return data;
};
$83620c096ed20185$var$rnull.decode.bytes = 0;
$83620c096ed20185$var$rnull.encodingLength = function(data) {
    if (!data) return 2;
    return ($83620c096ed20185$require$Buffer.isBuffer(data) ? data.length : $83620c096ed20185$require$Buffer.byteLength(data)) + 2;
};
const $83620c096ed20185$var$rhinfo = $83620c096ed20185$export$2542a5a654329437 = {};
$83620c096ed20185$var$rhinfo.encode = function(data, buf, offset) {
    if (!buf) buf = $83620c096ed20185$require$Buffer.alloc($83620c096ed20185$var$rhinfo.encodingLength(data));
    if (!offset) offset = 0;
    const oldOffset = offset;
    offset += 2;
    $83620c096ed20185$var$string.encode(data.cpu, buf, offset);
    offset += $83620c096ed20185$var$string.encode.bytes;
    $83620c096ed20185$var$string.encode(data.os, buf, offset);
    offset += $83620c096ed20185$var$string.encode.bytes;
    buf.writeUInt16BE(offset - oldOffset - 2, oldOffset);
    $83620c096ed20185$var$rhinfo.encode.bytes = offset - oldOffset;
    return buf;
};
$83620c096ed20185$var$rhinfo.encode.bytes = 0;
$83620c096ed20185$var$rhinfo.decode = function(buf, offset) {
    if (!offset) offset = 0;
    const oldOffset = offset;
    const data = {};
    offset += 2;
    data.cpu = $83620c096ed20185$var$string.decode(buf, offset);
    offset += $83620c096ed20185$var$string.decode.bytes;
    data.os = $83620c096ed20185$var$string.decode(buf, offset);
    offset += $83620c096ed20185$var$string.decode.bytes;
    $83620c096ed20185$var$rhinfo.decode.bytes = offset - oldOffset;
    return data;
};
$83620c096ed20185$var$rhinfo.decode.bytes = 0;
$83620c096ed20185$var$rhinfo.encodingLength = function(data) {
    return $83620c096ed20185$var$string.encodingLength(data.cpu) + $83620c096ed20185$var$string.encodingLength(data.os) + 2;
};
const $83620c096ed20185$var$rptr = $83620c096ed20185$export$56b93c6175ee8274 = {};
const $83620c096ed20185$var$rcname = $83620c096ed20185$export$2322a2658b955e5 = $83620c096ed20185$var$rptr;
const $83620c096ed20185$var$rdname = $83620c096ed20185$export$dbcbf189e660012 = $83620c096ed20185$var$rptr;
$83620c096ed20185$var$rptr.encode = function(data, buf, offset) {
    if (!buf) buf = $83620c096ed20185$require$Buffer.alloc($83620c096ed20185$var$rptr.encodingLength(data));
    if (!offset) offset = 0;
    $83620c096ed20185$var$name.encode(data, buf, offset + 2);
    buf.writeUInt16BE($83620c096ed20185$var$name.encode.bytes, offset);
    $83620c096ed20185$var$rptr.encode.bytes = $83620c096ed20185$var$name.encode.bytes + 2;
    return buf;
};
$83620c096ed20185$var$rptr.encode.bytes = 0;
$83620c096ed20185$var$rptr.decode = function(buf, offset) {
    if (!offset) offset = 0;
    const data = $83620c096ed20185$var$name.decode(buf, offset + 2);
    $83620c096ed20185$var$rptr.decode.bytes = $83620c096ed20185$var$name.decode.bytes + 2;
    return data;
};
$83620c096ed20185$var$rptr.decode.bytes = 0;
$83620c096ed20185$var$rptr.encodingLength = function(data) {
    return $83620c096ed20185$var$name.encodingLength(data) + 2;
};
const $83620c096ed20185$var$rsrv = $83620c096ed20185$export$a4ab9e1166fe1f1b = {};
$83620c096ed20185$var$rsrv.encode = function(data, buf, offset) {
    if (!buf) buf = $83620c096ed20185$require$Buffer.alloc($83620c096ed20185$var$rsrv.encodingLength(data));
    if (!offset) offset = 0;
    buf.writeUInt16BE(data.priority || 0, offset + 2);
    buf.writeUInt16BE(data.weight || 0, offset + 4);
    buf.writeUInt16BE(data.port || 0, offset + 6);
    $83620c096ed20185$var$name.encode(data.target, buf, offset + 8);
    const len = $83620c096ed20185$var$name.encode.bytes + 6;
    buf.writeUInt16BE(len, offset);
    $83620c096ed20185$var$rsrv.encode.bytes = len + 2;
    return buf;
};
$83620c096ed20185$var$rsrv.encode.bytes = 0;
$83620c096ed20185$var$rsrv.decode = function(buf, offset) {
    if (!offset) offset = 0;
    const len = buf.readUInt16BE(offset);
    const data = {};
    data.priority = buf.readUInt16BE(offset + 2);
    data.weight = buf.readUInt16BE(offset + 4);
    data.port = buf.readUInt16BE(offset + 6);
    data.target = $83620c096ed20185$var$name.decode(buf, offset + 8);
    $83620c096ed20185$var$rsrv.decode.bytes = len + 2;
    return data;
};
$83620c096ed20185$var$rsrv.decode.bytes = 0;
$83620c096ed20185$var$rsrv.encodingLength = function(data) {
    return 8 + $83620c096ed20185$var$name.encodingLength(data.target);
};
const $83620c096ed20185$var$rcaa = $83620c096ed20185$export$eae95cd38d620409 = {};
$83620c096ed20185$var$rcaa.ISSUER_CRITICAL = 128;
$83620c096ed20185$var$rcaa.encode = function(data, buf, offset) {
    const len = $83620c096ed20185$var$rcaa.encodingLength(data);
    if (!buf) buf = $83620c096ed20185$require$Buffer.alloc($83620c096ed20185$var$rcaa.encodingLength(data));
    if (!offset) offset = 0;
    if (data.issuerCritical) data.flags = $83620c096ed20185$var$rcaa.ISSUER_CRITICAL;
    buf.writeUInt16BE(len - 2, offset);
    offset += 2;
    buf.writeUInt8(data.flags || 0, offset);
    offset += 1;
    $83620c096ed20185$var$string.encode(data.tag, buf, offset);
    offset += $83620c096ed20185$var$string.encode.bytes;
    buf.write(data.value, offset);
    offset += $83620c096ed20185$require$Buffer.byteLength(data.value);
    $83620c096ed20185$var$rcaa.encode.bytes = len;
    return buf;
};
$83620c096ed20185$var$rcaa.encode.bytes = 0;
$83620c096ed20185$var$rcaa.decode = function(buf, offset) {
    if (!offset) offset = 0;
    const len = buf.readUInt16BE(offset);
    offset += 2;
    const oldOffset = offset;
    const data = {};
    data.flags = buf.readUInt8(offset);
    offset += 1;
    data.tag = $83620c096ed20185$var$string.decode(buf, offset);
    offset += $83620c096ed20185$var$string.decode.bytes;
    data.value = buf.toString("utf-8", offset, oldOffset + len);
    data.issuerCritical = !!(data.flags & $83620c096ed20185$var$rcaa.ISSUER_CRITICAL);
    $83620c096ed20185$var$rcaa.decode.bytes = len + 2;
    return data;
};
$83620c096ed20185$var$rcaa.decode.bytes = 0;
$83620c096ed20185$var$rcaa.encodingLength = function(data) {
    return $83620c096ed20185$var$string.encodingLength(data.tag) + $83620c096ed20185$var$string.encodingLength(data.value) + 2;
};
const $83620c096ed20185$var$rmx = $83620c096ed20185$export$1ed5cc9cac6d3e38 = {};
$83620c096ed20185$var$rmx.encode = function(data, buf, offset) {
    if (!buf) buf = $83620c096ed20185$require$Buffer.alloc($83620c096ed20185$var$rmx.encodingLength(data));
    if (!offset) offset = 0;
    const oldOffset = offset;
    offset += 2;
    buf.writeUInt16BE(data.preference || 0, offset);
    offset += 2;
    $83620c096ed20185$var$name.encode(data.exchange, buf, offset);
    offset += $83620c096ed20185$var$name.encode.bytes;
    buf.writeUInt16BE(offset - oldOffset - 2, oldOffset);
    $83620c096ed20185$var$rmx.encode.bytes = offset - oldOffset;
    return buf;
};
$83620c096ed20185$var$rmx.encode.bytes = 0;
$83620c096ed20185$var$rmx.decode = function(buf, offset) {
    if (!offset) offset = 0;
    const oldOffset = offset;
    const data = {};
    offset += 2;
    data.preference = buf.readUInt16BE(offset);
    offset += 2;
    data.exchange = $83620c096ed20185$var$name.decode(buf, offset);
    offset += $83620c096ed20185$var$name.decode.bytes;
    $83620c096ed20185$var$rmx.decode.bytes = offset - oldOffset;
    return data;
};
$83620c096ed20185$var$rmx.encodingLength = function(data) {
    return 4 + $83620c096ed20185$var$name.encodingLength(data.exchange);
};
const $83620c096ed20185$var$ra = $83620c096ed20185$export$407448d2b89b1813 = {};
$83620c096ed20185$var$ra.encode = function(host, buf, offset) {
    if (!buf) buf = $83620c096ed20185$require$Buffer.alloc($83620c096ed20185$var$ra.encodingLength(host));
    if (!offset) offset = 0;
    buf.writeUInt16BE(4, offset);
    offset += 2;
    $12c37352b22e272c$exports.v4.encode(host, buf, offset);
    $83620c096ed20185$var$ra.encode.bytes = 6;
    return buf;
};
$83620c096ed20185$var$ra.encode.bytes = 0;
$83620c096ed20185$var$ra.decode = function(buf, offset) {
    if (!offset) offset = 0;
    offset += 2;
    const host = $12c37352b22e272c$exports.v4.decode(buf, offset);
    $83620c096ed20185$var$ra.decode.bytes = 6;
    return host;
};
$83620c096ed20185$var$ra.decode.bytes = 0;
$83620c096ed20185$var$ra.encodingLength = function() {
    return 6;
};
const $83620c096ed20185$var$raaaa = $83620c096ed20185$export$8b02350718d87164 = {};
$83620c096ed20185$var$raaaa.encode = function(host, buf, offset) {
    if (!buf) buf = $83620c096ed20185$require$Buffer.alloc($83620c096ed20185$var$raaaa.encodingLength(host));
    if (!offset) offset = 0;
    buf.writeUInt16BE(16, offset);
    offset += 2;
    $12c37352b22e272c$exports.v6.encode(host, buf, offset);
    $83620c096ed20185$var$raaaa.encode.bytes = 18;
    return buf;
};
$83620c096ed20185$var$raaaa.encode.bytes = 0;
$83620c096ed20185$var$raaaa.decode = function(buf, offset) {
    if (!offset) offset = 0;
    offset += 2;
    const host = $12c37352b22e272c$exports.v6.decode(buf, offset);
    $83620c096ed20185$var$raaaa.decode.bytes = 18;
    return host;
};
$83620c096ed20185$var$raaaa.decode.bytes = 0;
$83620c096ed20185$var$raaaa.encodingLength = function() {
    return 18;
};
const $83620c096ed20185$var$roption = $83620c096ed20185$export$a75d1723e6bda2ec = {};
$83620c096ed20185$var$roption.encode = function(option, buf, offset) {
    if (!buf) buf = $83620c096ed20185$require$Buffer.alloc($83620c096ed20185$var$roption.encodingLength(option));
    if (!offset) offset = 0;
    const oldOffset = offset;
    const code = $8b96021e11e0dc20$export$efcacb532bf2dd2a(option.code);
    buf.writeUInt16BE(code, offset);
    offset += 2;
    if (option.data) {
        buf.writeUInt16BE(option.data.length, offset);
        offset += 2;
        option.data.copy(buf, offset);
        offset += option.data.length;
    } else switch(code){
        // case 3: NSID.  No encode makes sense.
        // case 5,6,7: Not implementable
        case 8:
            // note: do IP math before calling
            const spl = option.sourcePrefixLength || 0;
            const fam = option.family || $12c37352b22e272c$exports.familyOf(option.ip);
            const ipBuf = $12c37352b22e272c$exports.encode(option.ip, $83620c096ed20185$require$Buffer.alloc);
            const ipLen = Math.ceil(spl / 8);
            buf.writeUInt16BE(ipLen + 4, offset);
            offset += 2;
            buf.writeUInt16BE(fam, offset);
            offset += 2;
            buf.writeUInt8(spl, offset++);
            buf.writeUInt8(option.scopePrefixLength || 0, offset++);
            ipBuf.copy(buf, offset, 0, ipLen);
            offset += ipLen;
            break;
        // case 9: EXPIRE (experimental)
        // case 10: COOKIE.  No encode makes sense.
        case 11:
            if (option.timeout) {
                buf.writeUInt16BE(2, offset);
                offset += 2;
                buf.writeUInt16BE(option.timeout, offset);
                offset += 2;
            } else {
                buf.writeUInt16BE(0, offset);
                offset += 2;
            }
            break;
        case 12:
            const len = option.length || 0;
            buf.writeUInt16BE(len, offset);
            offset += 2;
            buf.fill(0, offset, offset + len);
            offset += len;
            break;
        // case 13:  CHAIN.  Experimental.
        case 14:
            const tagsLen = option.tags.length * 2;
            buf.writeUInt16BE(tagsLen, offset);
            offset += 2;
            for (const tag of option.tags){
                buf.writeUInt16BE(tag, offset);
                offset += 2;
            }
            break;
        default:
            throw new Error(`Unknown roption code: ${option.code}`);
    }
    $83620c096ed20185$var$roption.encode.bytes = offset - oldOffset;
    return buf;
};
$83620c096ed20185$var$roption.encode.bytes = 0;
$83620c096ed20185$var$roption.decode = function(buf, offset) {
    if (!offset) offset = 0;
    const option = {};
    option.code = buf.readUInt16BE(offset);
    option.type = $8b96021e11e0dc20$export$f84e8e69fd4488a5(option.code);
    offset += 2;
    const len = buf.readUInt16BE(offset);
    offset += 2;
    option.data = buf.slice(offset, offset + len);
    switch(option.code){
        // case 3: NSID.  No decode makes sense.
        case 8:
            option.family = buf.readUInt16BE(offset);
            offset += 2;
            option.sourcePrefixLength = buf.readUInt8(offset++);
            option.scopePrefixLength = buf.readUInt8(offset++);
            const padded = $83620c096ed20185$require$Buffer.alloc(option.family === 1 ? 4 : 16);
            buf.copy(padded, 0, offset, offset + len - 4);
            option.ip = $12c37352b22e272c$exports.decode(padded);
            break;
        // case 12: Padding.  No decode makes sense.
        case 11:
            if (len > 0) {
                option.timeout = buf.readUInt16BE(offset);
                offset += 2;
            }
            break;
        case 14:
            option.tags = [];
            for(let i = 0; i < len; i += 2){
                option.tags.push(buf.readUInt16BE(offset));
                offset += 2;
            }
    }
    $83620c096ed20185$var$roption.decode.bytes = len + 4;
    return option;
};
$83620c096ed20185$var$roption.decode.bytes = 0;
$83620c096ed20185$var$roption.encodingLength = function(option) {
    if (option.data) return option.data.length + 4;
    const code = $8b96021e11e0dc20$export$efcacb532bf2dd2a(option.code);
    switch(code){
        case 8:
            const spl = option.sourcePrefixLength || 0;
            return Math.ceil(spl / 8) + 8;
        case 11:
            return typeof option.timeout === "number" ? 6 : 4;
        case 12:
            return option.length + 4;
        case 14:
            return 4 + option.tags.length * 2;
    }
    throw new Error(`Unknown roption code: ${option.code}`);
};
const $83620c096ed20185$var$ropt = $83620c096ed20185$export$2b91d3689f613272 = {};
$83620c096ed20185$var$ropt.encode = function(options, buf, offset) {
    if (!buf) buf = $83620c096ed20185$require$Buffer.alloc($83620c096ed20185$var$ropt.encodingLength(options));
    if (!offset) offset = 0;
    const oldOffset = offset;
    const rdlen = $83620c096ed20185$var$encodingLengthList(options, $83620c096ed20185$var$roption);
    buf.writeUInt16BE(rdlen, offset);
    offset = $83620c096ed20185$var$encodeList(options, $83620c096ed20185$var$roption, buf, offset + 2);
    $83620c096ed20185$var$ropt.encode.bytes = offset - oldOffset;
    return buf;
};
$83620c096ed20185$var$ropt.encode.bytes = 0;
$83620c096ed20185$var$ropt.decode = function(buf, offset) {
    if (!offset) offset = 0;
    const oldOffset = offset;
    const options = [];
    let rdlen = buf.readUInt16BE(offset);
    offset += 2;
    let o = 0;
    while(rdlen > 0){
        options[o++] = $83620c096ed20185$var$roption.decode(buf, offset);
        offset += $83620c096ed20185$var$roption.decode.bytes;
        rdlen -= $83620c096ed20185$var$roption.decode.bytes;
    }
    $83620c096ed20185$var$ropt.decode.bytes = offset - oldOffset;
    return options;
};
$83620c096ed20185$var$ropt.decode.bytes = 0;
$83620c096ed20185$var$ropt.encodingLength = function(options) {
    return 2 + $83620c096ed20185$var$encodingLengthList(options || [], $83620c096ed20185$var$roption);
};
const $83620c096ed20185$var$rdnskey = $83620c096ed20185$export$ad4f294ad38147a3 = {};
$83620c096ed20185$var$rdnskey.PROTOCOL_DNSSEC = 3;
$83620c096ed20185$var$rdnskey.ZONE_KEY = 0x80;
$83620c096ed20185$var$rdnskey.SECURE_ENTRYPOINT = 0x8000;
$83620c096ed20185$var$rdnskey.encode = function(key, buf, offset) {
    if (!buf) buf = $83620c096ed20185$require$Buffer.alloc($83620c096ed20185$var$rdnskey.encodingLength(key));
    if (!offset) offset = 0;
    const oldOffset = offset;
    const keydata = key.key;
    if (!$83620c096ed20185$require$Buffer.isBuffer(keydata)) throw new Error("Key must be a Buffer");
    offset += 2 // Leave space for length
    ;
    buf.writeUInt16BE(key.flags, offset);
    offset += 2;
    buf.writeUInt8($83620c096ed20185$var$rdnskey.PROTOCOL_DNSSEC, offset);
    offset += 1;
    buf.writeUInt8(key.algorithm, offset);
    offset += 1;
    keydata.copy(buf, offset, 0, keydata.length);
    offset += keydata.length;
    $83620c096ed20185$var$rdnskey.encode.bytes = offset - oldOffset;
    buf.writeUInt16BE($83620c096ed20185$var$rdnskey.encode.bytes - 2, oldOffset);
    return buf;
};
$83620c096ed20185$var$rdnskey.encode.bytes = 0;
$83620c096ed20185$var$rdnskey.decode = function(buf, offset) {
    if (!offset) offset = 0;
    const oldOffset = offset;
    var key = {};
    var length = buf.readUInt16BE(offset);
    offset += 2;
    key.flags = buf.readUInt16BE(offset);
    offset += 2;
    if (buf.readUInt8(offset) !== $83620c096ed20185$var$rdnskey.PROTOCOL_DNSSEC) throw new Error("Protocol must be 3");
    offset += 1;
    key.algorithm = buf.readUInt8(offset);
    offset += 1;
    key.key = buf.slice(offset, oldOffset + length + 2);
    offset += key.key.length;
    $83620c096ed20185$var$rdnskey.decode.bytes = offset - oldOffset;
    return key;
};
$83620c096ed20185$var$rdnskey.decode.bytes = 0;
$83620c096ed20185$var$rdnskey.encodingLength = function(key) {
    return 6 + $83620c096ed20185$require$Buffer.byteLength(key.key);
};
const $83620c096ed20185$var$rrrsig = $83620c096ed20185$export$c008f777d94a4783 = {};
$83620c096ed20185$var$rrrsig.encode = function(sig, buf, offset) {
    if (!buf) buf = $83620c096ed20185$require$Buffer.alloc($83620c096ed20185$var$rrrsig.encodingLength(sig));
    if (!offset) offset = 0;
    const oldOffset = offset;
    const signature = sig.signature;
    if (!$83620c096ed20185$require$Buffer.isBuffer(signature)) throw new Error("Signature must be a Buffer");
    offset += 2 // Leave space for length
    ;
    buf.writeUInt16BE($82a51adef14173f8$export$2fe53163c7bc4eaf(sig.typeCovered), offset);
    offset += 2;
    buf.writeUInt8(sig.algorithm, offset);
    offset += 1;
    buf.writeUInt8(sig.labels, offset);
    offset += 1;
    buf.writeUInt32BE(sig.originalTTL, offset);
    offset += 4;
    buf.writeUInt32BE(sig.expiration, offset);
    offset += 4;
    buf.writeUInt32BE(sig.inception, offset);
    offset += 4;
    buf.writeUInt16BE(sig.keyTag, offset);
    offset += 2;
    $83620c096ed20185$var$name.encode(sig.signersName, buf, offset);
    offset += $83620c096ed20185$var$name.encode.bytes;
    signature.copy(buf, offset, 0, signature.length);
    offset += signature.length;
    $83620c096ed20185$var$rrrsig.encode.bytes = offset - oldOffset;
    buf.writeUInt16BE($83620c096ed20185$var$rrrsig.encode.bytes - 2, oldOffset);
    return buf;
};
$83620c096ed20185$var$rrrsig.encode.bytes = 0;
$83620c096ed20185$var$rrrsig.decode = function(buf, offset) {
    if (!offset) offset = 0;
    const oldOffset = offset;
    var sig = {};
    var length = buf.readUInt16BE(offset);
    offset += 2;
    sig.typeCovered = $82a51adef14173f8$export$f84e8e69fd4488a5(buf.readUInt16BE(offset));
    offset += 2;
    sig.algorithm = buf.readUInt8(offset);
    offset += 1;
    sig.labels = buf.readUInt8(offset);
    offset += 1;
    sig.originalTTL = buf.readUInt32BE(offset);
    offset += 4;
    sig.expiration = buf.readUInt32BE(offset);
    offset += 4;
    sig.inception = buf.readUInt32BE(offset);
    offset += 4;
    sig.keyTag = buf.readUInt16BE(offset);
    offset += 2;
    sig.signersName = $83620c096ed20185$var$name.decode(buf, offset);
    offset += $83620c096ed20185$var$name.decode.bytes;
    sig.signature = buf.slice(offset, oldOffset + length + 2);
    offset += sig.signature.length;
    $83620c096ed20185$var$rrrsig.decode.bytes = offset - oldOffset;
    return sig;
};
$83620c096ed20185$var$rrrsig.decode.bytes = 0;
$83620c096ed20185$var$rrrsig.encodingLength = function(sig) {
    return 20 + $83620c096ed20185$var$name.encodingLength(sig.signersName) + $83620c096ed20185$require$Buffer.byteLength(sig.signature);
};
const $83620c096ed20185$var$rrp = $83620c096ed20185$export$6d4c73e3ddf8818b = {};
$83620c096ed20185$var$rrp.encode = function(data, buf, offset) {
    if (!buf) buf = $83620c096ed20185$require$Buffer.alloc($83620c096ed20185$var$rrp.encodingLength(data));
    if (!offset) offset = 0;
    const oldOffset = offset;
    offset += 2 // Leave space for length
    ;
    $83620c096ed20185$var$name.encode(data.mbox || ".", buf, offset, {
        mail: true
    });
    offset += $83620c096ed20185$var$name.encode.bytes;
    $83620c096ed20185$var$name.encode(data.txt || ".", buf, offset);
    offset += $83620c096ed20185$var$name.encode.bytes;
    $83620c096ed20185$var$rrp.encode.bytes = offset - oldOffset;
    buf.writeUInt16BE($83620c096ed20185$var$rrp.encode.bytes - 2, oldOffset);
    return buf;
};
$83620c096ed20185$var$rrp.encode.bytes = 0;
$83620c096ed20185$var$rrp.decode = function(buf, offset) {
    if (!offset) offset = 0;
    const oldOffset = offset;
    const data = {};
    offset += 2;
    data.mbox = $83620c096ed20185$var$name.decode(buf, offset, {
        mail: true
    }) || ".";
    offset += $83620c096ed20185$var$name.decode.bytes;
    data.txt = $83620c096ed20185$var$name.decode(buf, offset) || ".";
    offset += $83620c096ed20185$var$name.decode.bytes;
    $83620c096ed20185$var$rrp.decode.bytes = offset - oldOffset;
    return data;
};
$83620c096ed20185$var$rrp.decode.bytes = 0;
$83620c096ed20185$var$rrp.encodingLength = function(data) {
    return 2 + $83620c096ed20185$var$name.encodingLength(data.mbox || ".") + $83620c096ed20185$var$name.encodingLength(data.txt || ".");
};
const $83620c096ed20185$var$typebitmap = {};
$83620c096ed20185$var$typebitmap.encode = function(typelist, buf, offset) {
    if (!buf) buf = $83620c096ed20185$require$Buffer.alloc($83620c096ed20185$var$typebitmap.encodingLength(typelist));
    if (!offset) offset = 0;
    const oldOffset = offset;
    var typesByWindow = [];
    for(var i = 0; i < typelist.length; i++){
        var typeid = $82a51adef14173f8$export$2fe53163c7bc4eaf(typelist[i]);
        if (typesByWindow[typeid >> 8] === undefined) typesByWindow[typeid >> 8] = [];
        typesByWindow[typeid >> 8][typeid >> 3 & 0x1F] |= 1 << 7 - (typeid & 0x7);
    }
    for(i = 0; i < typesByWindow.length; i++)if (typesByWindow[i] !== undefined) {
        var windowBuf = $83620c096ed20185$require$Buffer.from(typesByWindow[i]);
        buf.writeUInt8(i, offset);
        offset += 1;
        buf.writeUInt8(windowBuf.length, offset);
        offset += 1;
        windowBuf.copy(buf, offset);
        offset += windowBuf.length;
    }
    $83620c096ed20185$var$typebitmap.encode.bytes = offset - oldOffset;
    return buf;
};
$83620c096ed20185$var$typebitmap.encode.bytes = 0;
$83620c096ed20185$var$typebitmap.decode = function(buf, offset, length) {
    if (!offset) offset = 0;
    const oldOffset = offset;
    var typelist = [];
    while(offset - oldOffset < length){
        var window = buf.readUInt8(offset);
        offset += 1;
        var windowLength = buf.readUInt8(offset);
        offset += 1;
        for(var i = 0; i < windowLength; i++){
            var b = buf.readUInt8(offset + i);
            for(var j = 0; j < 8; j++)if (b & 1 << 7 - j) {
                var typeid = $82a51adef14173f8$export$f84e8e69fd4488a5(window << 8 | i << 3 | j);
                typelist.push(typeid);
            }
        }
        offset += windowLength;
    }
    $83620c096ed20185$var$typebitmap.decode.bytes = offset - oldOffset;
    return typelist;
};
$83620c096ed20185$var$typebitmap.decode.bytes = 0;
$83620c096ed20185$var$typebitmap.encodingLength = function(typelist) {
    var extents = [];
    for(var i = 0; i < typelist.length; i++){
        var typeid = $82a51adef14173f8$export$2fe53163c7bc4eaf(typelist[i]);
        extents[typeid >> 8] = Math.max(extents[typeid >> 8] || 0, typeid & 0xFF);
    }
    var len = 0;
    for(i = 0; i < extents.length; i++)if (extents[i] !== undefined) len += 2 + Math.ceil((extents[i] + 1) / 8);
    return len;
};
const $83620c096ed20185$var$rnsec = $83620c096ed20185$export$2ab2dccc8f32ce46 = {};
$83620c096ed20185$var$rnsec.encode = function(record, buf, offset) {
    if (!buf) buf = $83620c096ed20185$require$Buffer.alloc($83620c096ed20185$var$rnsec.encodingLength(record));
    if (!offset) offset = 0;
    const oldOffset = offset;
    offset += 2 // Leave space for length
    ;
    $83620c096ed20185$var$name.encode(record.nextDomain, buf, offset);
    offset += $83620c096ed20185$var$name.encode.bytes;
    $83620c096ed20185$var$typebitmap.encode(record.rrtypes, buf, offset);
    offset += $83620c096ed20185$var$typebitmap.encode.bytes;
    $83620c096ed20185$var$rnsec.encode.bytes = offset - oldOffset;
    buf.writeUInt16BE($83620c096ed20185$var$rnsec.encode.bytes - 2, oldOffset);
    return buf;
};
$83620c096ed20185$var$rnsec.encode.bytes = 0;
$83620c096ed20185$var$rnsec.decode = function(buf, offset) {
    if (!offset) offset = 0;
    const oldOffset = offset;
    var record = {};
    var length = buf.readUInt16BE(offset);
    offset += 2;
    record.nextDomain = $83620c096ed20185$var$name.decode(buf, offset);
    offset += $83620c096ed20185$var$name.decode.bytes;
    record.rrtypes = $83620c096ed20185$var$typebitmap.decode(buf, offset, length - (offset - oldOffset));
    offset += $83620c096ed20185$var$typebitmap.decode.bytes;
    $83620c096ed20185$var$rnsec.decode.bytes = offset - oldOffset;
    return record;
};
$83620c096ed20185$var$rnsec.decode.bytes = 0;
$83620c096ed20185$var$rnsec.encodingLength = function(record) {
    return 2 + $83620c096ed20185$var$name.encodingLength(record.nextDomain) + $83620c096ed20185$var$typebitmap.encodingLength(record.rrtypes);
};
const $83620c096ed20185$var$rnsec3 = $83620c096ed20185$export$b05393b09543e5f2 = {};
$83620c096ed20185$var$rnsec3.encode = function(record, buf, offset) {
    if (!buf) buf = $83620c096ed20185$require$Buffer.alloc($83620c096ed20185$var$rnsec3.encodingLength(record));
    if (!offset) offset = 0;
    const oldOffset = offset;
    const salt = record.salt;
    if (!$83620c096ed20185$require$Buffer.isBuffer(salt)) throw new Error("salt must be a Buffer");
    const nextDomain = record.nextDomain;
    if (!$83620c096ed20185$require$Buffer.isBuffer(nextDomain)) throw new Error("nextDomain must be a Buffer");
    offset += 2 // Leave space for length
    ;
    buf.writeUInt8(record.algorithm, offset);
    offset += 1;
    buf.writeUInt8(record.flags, offset);
    offset += 1;
    buf.writeUInt16BE(record.iterations, offset);
    offset += 2;
    buf.writeUInt8(salt.length, offset);
    offset += 1;
    salt.copy(buf, offset, 0, salt.length);
    offset += salt.length;
    buf.writeUInt8(nextDomain.length, offset);
    offset += 1;
    nextDomain.copy(buf, offset, 0, nextDomain.length);
    offset += nextDomain.length;
    $83620c096ed20185$var$typebitmap.encode(record.rrtypes, buf, offset);
    offset += $83620c096ed20185$var$typebitmap.encode.bytes;
    $83620c096ed20185$var$rnsec3.encode.bytes = offset - oldOffset;
    buf.writeUInt16BE($83620c096ed20185$var$rnsec3.encode.bytes - 2, oldOffset);
    return buf;
};
$83620c096ed20185$var$rnsec3.encode.bytes = 0;
$83620c096ed20185$var$rnsec3.decode = function(buf, offset) {
    if (!offset) offset = 0;
    const oldOffset = offset;
    var record = {};
    var length = buf.readUInt16BE(offset);
    offset += 2;
    record.algorithm = buf.readUInt8(offset);
    offset += 1;
    record.flags = buf.readUInt8(offset);
    offset += 1;
    record.iterations = buf.readUInt16BE(offset);
    offset += 2;
    const saltLength = buf.readUInt8(offset);
    offset += 1;
    record.salt = buf.slice(offset, offset + saltLength);
    offset += saltLength;
    const hashLength = buf.readUInt8(offset);
    offset += 1;
    record.nextDomain = buf.slice(offset, offset + hashLength);
    offset += hashLength;
    record.rrtypes = $83620c096ed20185$var$typebitmap.decode(buf, offset, length - (offset - oldOffset));
    offset += $83620c096ed20185$var$typebitmap.decode.bytes;
    $83620c096ed20185$var$rnsec3.decode.bytes = offset - oldOffset;
    return record;
};
$83620c096ed20185$var$rnsec3.decode.bytes = 0;
$83620c096ed20185$var$rnsec3.encodingLength = function(record) {
    return 8 + record.salt.length + record.nextDomain.length + $83620c096ed20185$var$typebitmap.encodingLength(record.rrtypes);
};
const $83620c096ed20185$var$rds = $83620c096ed20185$export$6c6581d59e81d1b9 = {};
$83620c096ed20185$var$rds.encode = function(digest, buf, offset) {
    if (!buf) buf = $83620c096ed20185$require$Buffer.alloc($83620c096ed20185$var$rds.encodingLength(digest));
    if (!offset) offset = 0;
    const oldOffset = offset;
    const digestdata = digest.digest;
    if (!$83620c096ed20185$require$Buffer.isBuffer(digestdata)) throw new Error("Digest must be a Buffer");
    offset += 2 // Leave space for length
    ;
    buf.writeUInt16BE(digest.keyTag, offset);
    offset += 2;
    buf.writeUInt8(digest.algorithm, offset);
    offset += 1;
    buf.writeUInt8(digest.digestType, offset);
    offset += 1;
    digestdata.copy(buf, offset, 0, digestdata.length);
    offset += digestdata.length;
    $83620c096ed20185$var$rds.encode.bytes = offset - oldOffset;
    buf.writeUInt16BE($83620c096ed20185$var$rds.encode.bytes - 2, oldOffset);
    return buf;
};
$83620c096ed20185$var$rds.encode.bytes = 0;
$83620c096ed20185$var$rds.decode = function(buf, offset) {
    if (!offset) offset = 0;
    const oldOffset = offset;
    var digest = {};
    var length = buf.readUInt16BE(offset);
    offset += 2;
    digest.keyTag = buf.readUInt16BE(offset);
    offset += 2;
    digest.algorithm = buf.readUInt8(offset);
    offset += 1;
    digest.digestType = buf.readUInt8(offset);
    offset += 1;
    digest.digest = buf.slice(offset, oldOffset + length + 2);
    offset += digest.digest.length;
    $83620c096ed20185$var$rds.decode.bytes = offset - oldOffset;
    return digest;
};
$83620c096ed20185$var$rds.decode.bytes = 0;
$83620c096ed20185$var$rds.encodingLength = function(digest) {
    return 6 + $83620c096ed20185$require$Buffer.byteLength(digest.digest);
};
const $83620c096ed20185$var$rsshfp = $83620c096ed20185$export$1b9c36835e28a5f9 = {};
$83620c096ed20185$var$rsshfp.getFingerprintLengthForHashType = function getFingerprintLengthForHashType(hashType) {
    switch(hashType){
        case 1:
            return 20;
        case 2:
            return 32;
    }
};
$83620c096ed20185$var$rsshfp.encode = function encode(record, buf, offset) {
    if (!buf) buf = $83620c096ed20185$require$Buffer.alloc($83620c096ed20185$var$rsshfp.encodingLength(record));
    if (!offset) offset = 0;
    const oldOffset = offset;
    offset += 2 // The function call starts with the offset pointer at the RDLENGTH field, not the RDATA one
    ;
    buf[offset] = record.algorithm;
    offset += 1;
    buf[offset] = record.hash;
    offset += 1;
    const fingerprintBuf = $83620c096ed20185$require$Buffer.from(record.fingerprint.toUpperCase(), "hex");
    if (fingerprintBuf.length !== $83620c096ed20185$var$rsshfp.getFingerprintLengthForHashType(record.hash)) throw new Error("Invalid fingerprint length");
    fingerprintBuf.copy(buf, offset);
    offset += fingerprintBuf.byteLength;
    $83620c096ed20185$var$rsshfp.encode.bytes = offset - oldOffset;
    buf.writeUInt16BE($83620c096ed20185$var$rsshfp.encode.bytes - 2, oldOffset);
    return buf;
};
$83620c096ed20185$var$rsshfp.encode.bytes = 0;
$83620c096ed20185$var$rsshfp.decode = function decode(buf, offset) {
    if (!offset) offset = 0;
    const oldOffset = offset;
    const record = {};
    offset += 2 // Account for the RDLENGTH field
    ;
    record.algorithm = buf[offset];
    offset += 1;
    record.hash = buf[offset];
    offset += 1;
    const fingerprintLength = $83620c096ed20185$var$rsshfp.getFingerprintLengthForHashType(record.hash);
    record.fingerprint = buf.slice(offset, offset + fingerprintLength).toString("hex").toUpperCase();
    offset += fingerprintLength;
    $83620c096ed20185$var$rsshfp.decode.bytes = offset - oldOffset;
    return record;
};
$83620c096ed20185$var$rsshfp.decode.bytes = 0;
$83620c096ed20185$var$rsshfp.encodingLength = function(record) {
    return 4 + $83620c096ed20185$require$Buffer.from(record.fingerprint, "hex").byteLength;
};
const $83620c096ed20185$var$rnaptr = $83620c096ed20185$export$c4773623ab5afffc = {};
$83620c096ed20185$var$rnaptr.encode = function(data, buf, offset) {
    if (!buf) buf = $83620c096ed20185$require$Buffer.alloc($83620c096ed20185$var$rnaptr.encodingLength(data));
    if (!offset) offset = 0;
    const oldOffset = offset;
    offset += 2;
    buf.writeUInt16BE(data.order || 0, offset);
    offset += 2;
    buf.writeUInt16BE(data.preference || 0, offset);
    offset += 2;
    $83620c096ed20185$var$string.encode(data.flags, buf, offset);
    offset += $83620c096ed20185$var$string.encode.bytes;
    $83620c096ed20185$var$string.encode(data.services, buf, offset);
    offset += $83620c096ed20185$var$string.encode.bytes;
    $83620c096ed20185$var$string.encode(data.regexp, buf, offset);
    offset += $83620c096ed20185$var$string.encode.bytes;
    $83620c096ed20185$var$name.encode(data.replacement, buf, offset);
    offset += $83620c096ed20185$var$name.encode.bytes;
    $83620c096ed20185$var$rnaptr.encode.bytes = offset - oldOffset;
    buf.writeUInt16BE($83620c096ed20185$var$rnaptr.encode.bytes - 2, oldOffset);
    return buf;
};
$83620c096ed20185$var$rnaptr.encode.bytes = 0;
$83620c096ed20185$var$rnaptr.decode = function(buf, offset) {
    if (!offset) offset = 0;
    const oldOffset = offset;
    const data = {};
    offset += 2;
    data.order = buf.readUInt16BE(offset);
    offset += 2;
    data.preference = buf.readUInt16BE(offset);
    offset += 2;
    data.flags = $83620c096ed20185$var$string.decode(buf, offset);
    offset += $83620c096ed20185$var$string.decode.bytes;
    data.services = $83620c096ed20185$var$string.decode(buf, offset);
    offset += $83620c096ed20185$var$string.decode.bytes;
    data.regexp = $83620c096ed20185$var$string.decode(buf, offset);
    offset += $83620c096ed20185$var$string.decode.bytes;
    data.replacement = $83620c096ed20185$var$name.decode(buf, offset);
    offset += $83620c096ed20185$var$name.decode.bytes;
    $83620c096ed20185$var$rnaptr.decode.bytes = offset - oldOffset;
    return data;
};
$83620c096ed20185$var$rnaptr.decode.bytes = 0;
$83620c096ed20185$var$rnaptr.encodingLength = function(data) {
    return $83620c096ed20185$var$string.encodingLength(data.flags) + $83620c096ed20185$var$string.encodingLength(data.services) + $83620c096ed20185$var$string.encodingLength(data.regexp) + $83620c096ed20185$var$name.encodingLength(data.replacement) + 6;
};
const $83620c096ed20185$var$rtlsa = $83620c096ed20185$export$dc8e86e1bd9ea40f = {};
$83620c096ed20185$var$rtlsa.encode = function(cert, buf, offset) {
    if (!buf) buf = $83620c096ed20185$require$Buffer.alloc($83620c096ed20185$var$rtlsa.encodingLength(cert));
    if (!offset) offset = 0;
    const oldOffset = offset;
    const certdata = cert.certificate;
    if (!$83620c096ed20185$require$Buffer.isBuffer(certdata)) throw new Error("Certificate must be a Buffer");
    offset += 2 // Leave space for length
    ;
    buf.writeUInt8(cert.usage, offset);
    offset += 1;
    buf.writeUInt8(cert.selector, offset);
    offset += 1;
    buf.writeUInt8(cert.matchingType, offset);
    offset += 1;
    certdata.copy(buf, offset, 0, certdata.length);
    offset += certdata.length;
    $83620c096ed20185$var$rtlsa.encode.bytes = offset - oldOffset;
    buf.writeUInt16BE($83620c096ed20185$var$rtlsa.encode.bytes - 2, oldOffset);
    return buf;
};
$83620c096ed20185$var$rtlsa.encode.bytes = 0;
$83620c096ed20185$var$rtlsa.decode = function(buf, offset) {
    if (!offset) offset = 0;
    const oldOffset = offset;
    const cert = {};
    const length = buf.readUInt16BE(offset);
    offset += 2;
    cert.usage = buf.readUInt8(offset);
    offset += 1;
    cert.selector = buf.readUInt8(offset);
    offset += 1;
    cert.matchingType = buf.readUInt8(offset);
    offset += 1;
    cert.certificate = buf.slice(offset, oldOffset + length + 2);
    offset += cert.certificate.length;
    $83620c096ed20185$var$rtlsa.decode.bytes = offset - oldOffset;
    return cert;
};
$83620c096ed20185$var$rtlsa.decode.bytes = 0;
$83620c096ed20185$var$rtlsa.encodingLength = function(cert) {
    return 5 + $83620c096ed20185$require$Buffer.byteLength(cert.certificate);
};
const $83620c096ed20185$var$renc = $83620c096ed20185$export$e5185e241753e543 = function(type) {
    switch(type.toUpperCase()){
        case "A":
            return $83620c096ed20185$var$ra;
        case "PTR":
            return $83620c096ed20185$var$rptr;
        case "CNAME":
            return $83620c096ed20185$var$rcname;
        case "DNAME":
            return $83620c096ed20185$var$rdname;
        case "TXT":
            return $83620c096ed20185$var$rtxt;
        case "NULL":
            return $83620c096ed20185$var$rnull;
        case "AAAA":
            return $83620c096ed20185$var$raaaa;
        case "SRV":
            return $83620c096ed20185$var$rsrv;
        case "HINFO":
            return $83620c096ed20185$var$rhinfo;
        case "CAA":
            return $83620c096ed20185$var$rcaa;
        case "NS":
            return $83620c096ed20185$var$rns;
        case "SOA":
            return $83620c096ed20185$var$rsoa;
        case "MX":
            return $83620c096ed20185$var$rmx;
        case "OPT":
            return $83620c096ed20185$var$ropt;
        case "DNSKEY":
            return $83620c096ed20185$var$rdnskey;
        case "RRSIG":
            return $83620c096ed20185$var$rrrsig;
        case "RP":
            return $83620c096ed20185$var$rrp;
        case "NSEC":
            return $83620c096ed20185$var$rnsec;
        case "NSEC3":
            return $83620c096ed20185$var$rnsec3;
        case "SSHFP":
            return $83620c096ed20185$var$rsshfp;
        case "DS":
            return $83620c096ed20185$var$rds;
        case "NAPTR":
            return $83620c096ed20185$var$rnaptr;
        case "TLSA":
            return $83620c096ed20185$var$rtlsa;
    }
    return $83620c096ed20185$var$runknown;
};
const $83620c096ed20185$var$answer = $83620c096ed20185$export$50a780d71cf22a88 = {};
$83620c096ed20185$var$answer.encode = function(a, buf, offset) {
    if (!buf) buf = $83620c096ed20185$require$Buffer.alloc($83620c096ed20185$var$answer.encodingLength(a));
    if (!offset) offset = 0;
    const oldOffset = offset;
    $83620c096ed20185$var$name.encode(a.name, buf, offset);
    offset += $83620c096ed20185$var$name.encode.bytes;
    buf.writeUInt16BE($82a51adef14173f8$export$2fe53163c7bc4eaf(a.type), offset);
    if (a.type.toUpperCase() === "OPT") {
        if (a.name !== ".") throw new Error("OPT name must be root.");
        buf.writeUInt16BE(a.udpPayloadSize || 4096, offset + 2);
        buf.writeUInt8(a.extendedRcode || 0, offset + 4);
        buf.writeUInt8(a.ednsVersion || 0, offset + 5);
        buf.writeUInt16BE(a.flags || 0, offset + 6);
        offset += 8;
        $83620c096ed20185$var$ropt.encode(a.options || [], buf, offset);
        offset += $83620c096ed20185$var$ropt.encode.bytes;
    } else {
        let klass = $ac8c08d9785de89a$export$e0575f7ae787892f(a.class === undefined ? "IN" : a.class);
        if (a.flush) klass |= $83620c096ed20185$var$FLUSH_MASK // the 1st bit of the class is the flush bit
        ;
        buf.writeUInt16BE(klass, offset + 2);
        buf.writeUInt32BE(a.ttl || 0, offset + 4);
        offset += 8;
        const enc = $83620c096ed20185$var$renc(a.type);
        enc.encode(a.data, buf, offset);
        offset += enc.encode.bytes;
    }
    $83620c096ed20185$var$answer.encode.bytes = offset - oldOffset;
    return buf;
};
$83620c096ed20185$var$answer.encode.bytes = 0;
$83620c096ed20185$var$answer.decode = function(buf, offset) {
    if (!offset) offset = 0;
    const a = {};
    const oldOffset = offset;
    a.name = $83620c096ed20185$var$name.decode(buf, offset);
    offset += $83620c096ed20185$var$name.decode.bytes;
    a.type = $82a51adef14173f8$export$f84e8e69fd4488a5(buf.readUInt16BE(offset));
    if (a.type === "OPT") {
        a.udpPayloadSize = buf.readUInt16BE(offset + 2);
        a.extendedRcode = buf.readUInt8(offset + 4);
        a.ednsVersion = buf.readUInt8(offset + 5);
        a.flags = buf.readUInt16BE(offset + 6);
        a.flag_do = (a.flags >> 15 & 0x1) === 1;
        a.options = $83620c096ed20185$var$ropt.decode(buf, offset + 8);
        offset += 8 + $83620c096ed20185$var$ropt.decode.bytes;
    } else {
        const klass = buf.readUInt16BE(offset + 2);
        a.ttl = buf.readUInt32BE(offset + 4);
        a.class = $ac8c08d9785de89a$export$f84e8e69fd4488a5(klass & $83620c096ed20185$var$NOT_FLUSH_MASK);
        a.flush = !!(klass & $83620c096ed20185$var$FLUSH_MASK);
        const enc = $83620c096ed20185$var$renc(a.type);
        a.data = enc.decode(buf, offset + 8);
        offset += 8 + enc.decode.bytes;
    }
    $83620c096ed20185$var$answer.decode.bytes = offset - oldOffset;
    return a;
};
$83620c096ed20185$var$answer.decode.bytes = 0;
$83620c096ed20185$var$answer.encodingLength = function(a) {
    const data = a.data !== null && a.data !== undefined ? a.data : a.options;
    return $83620c096ed20185$var$name.encodingLength(a.name) + 8 + $83620c096ed20185$var$renc(a.type).encodingLength(data);
};
const $83620c096ed20185$var$question = $83620c096ed20185$export$db9f06b5d27d15d8 = {};
$83620c096ed20185$var$question.encode = function(q, buf, offset) {
    if (!buf) buf = $83620c096ed20185$require$Buffer.alloc($83620c096ed20185$var$question.encodingLength(q));
    if (!offset) offset = 0;
    const oldOffset = offset;
    $83620c096ed20185$var$name.encode(q.name, buf, offset);
    offset += $83620c096ed20185$var$name.encode.bytes;
    buf.writeUInt16BE($82a51adef14173f8$export$2fe53163c7bc4eaf(q.type), offset);
    offset += 2;
    buf.writeUInt16BE($ac8c08d9785de89a$export$e0575f7ae787892f(q.class === undefined ? "IN" : q.class), offset);
    offset += 2;
    $83620c096ed20185$var$question.encode.bytes = offset - oldOffset;
    return q;
};
$83620c096ed20185$var$question.encode.bytes = 0;
$83620c096ed20185$var$question.decode = function(buf, offset) {
    if (!offset) offset = 0;
    const oldOffset = offset;
    const q = {};
    q.name = $83620c096ed20185$var$name.decode(buf, offset);
    offset += $83620c096ed20185$var$name.decode.bytes;
    q.type = $82a51adef14173f8$export$f84e8e69fd4488a5(buf.readUInt16BE(offset));
    offset += 2;
    q.class = $ac8c08d9785de89a$export$f84e8e69fd4488a5(buf.readUInt16BE(offset));
    offset += 2;
    const qu = !!(q.class & $83620c096ed20185$var$QU_MASK);
    if (qu) q.class &= $83620c096ed20185$var$NOT_QU_MASK;
    $83620c096ed20185$var$question.decode.bytes = offset - oldOffset;
    return q;
};
$83620c096ed20185$var$question.decode.bytes = 0;
$83620c096ed20185$var$question.encodingLength = function(q) {
    return $83620c096ed20185$var$name.encodingLength(q.name) + 4;
};
$83620c096ed20185$export$6556f847e8047304 = 1024;
$83620c096ed20185$export$94f7062ce7df4e6e = 512;
$83620c096ed20185$export$fcc51f37815e5e3c = 256;
$83620c096ed20185$export$1f33e1212d848957 = 128;
$83620c096ed20185$export$13c4d202e90d4d94 = 32;
$83620c096ed20185$export$292cc2af10c2b6ab = 16;
$83620c096ed20185$export$c8da3c371062d568 = 32768;
$83620c096ed20185$export$c564cdbbe6da493 = function(result, buf, offset) {
    const allocing = !buf;
    if (allocing) buf = $83620c096ed20185$require$Buffer.alloc($83620c096ed20185$export$cbee51f25f0626d7(result));
    if (!offset) offset = 0;
    const oldOffset = offset;
    if (!result.questions) result.questions = [];
    if (!result.answers) result.answers = [];
    if (!result.authorities) result.authorities = [];
    if (!result.additionals) result.additionals = [];
    $83620c096ed20185$var$header.encode(result, buf, offset);
    offset += $83620c096ed20185$var$header.encode.bytes;
    offset = $83620c096ed20185$var$encodeList(result.questions, $83620c096ed20185$var$question, buf, offset);
    offset = $83620c096ed20185$var$encodeList(result.answers, $83620c096ed20185$var$answer, buf, offset);
    offset = $83620c096ed20185$var$encodeList(result.authorities, $83620c096ed20185$var$answer, buf, offset);
    offset = $83620c096ed20185$var$encodeList(result.additionals, $83620c096ed20185$var$answer, buf, offset);
    $83620c096ed20185$export$c564cdbbe6da493.bytes = offset - oldOffset;
    // just a quick sanity check
    if (allocing && $83620c096ed20185$export$c564cdbbe6da493.bytes !== buf.length) return buf.slice(0, $83620c096ed20185$export$c564cdbbe6da493.bytes);
    return buf;
};
$83620c096ed20185$export$c564cdbbe6da493.bytes = 0;
$83620c096ed20185$export$2f872c0f2117be69 = function(buf, offset) {
    if (!offset) offset = 0;
    const oldOffset = offset;
    const result = $83620c096ed20185$var$header.decode(buf, offset);
    offset += $83620c096ed20185$var$header.decode.bytes;
    offset = $83620c096ed20185$var$decodeList(result.questions, $83620c096ed20185$var$question, buf, offset);
    offset = $83620c096ed20185$var$decodeList(result.answers, $83620c096ed20185$var$answer, buf, offset);
    offset = $83620c096ed20185$var$decodeList(result.authorities, $83620c096ed20185$var$answer, buf, offset);
    offset = $83620c096ed20185$var$decodeList(result.additionals, $83620c096ed20185$var$answer, buf, offset);
    $83620c096ed20185$export$2f872c0f2117be69.bytes = offset - oldOffset;
    return result;
};
$83620c096ed20185$export$2f872c0f2117be69.bytes = 0;
$83620c096ed20185$export$cbee51f25f0626d7 = function(result) {
    return $83620c096ed20185$var$header.encodingLength(result) + $83620c096ed20185$var$encodingLengthList(result.questions || [], $83620c096ed20185$var$question) + $83620c096ed20185$var$encodingLengthList(result.answers || [], $83620c096ed20185$var$answer) + $83620c096ed20185$var$encodingLengthList(result.authorities || [], $83620c096ed20185$var$answer) + $83620c096ed20185$var$encodingLengthList(result.additionals || [], $83620c096ed20185$var$answer);
};
$83620c096ed20185$export$374620bdcb396bcd = function(result) {
    const buf = $83620c096ed20185$export$c564cdbbe6da493(result);
    const sbuf = $83620c096ed20185$require$Buffer.alloc(2);
    sbuf.writeUInt16BE(buf.byteLength);
    const combine = $83620c096ed20185$require$Buffer.concat([
        sbuf,
        buf
    ]);
    $83620c096ed20185$export$374620bdcb396bcd.bytes = combine.byteLength;
    return combine;
};
$83620c096ed20185$export$374620bdcb396bcd.bytes = 0;
$83620c096ed20185$export$7873fbe3f1f05fa6 = function(sbuf) {
    const len = sbuf.readUInt16BE(0);
    if (sbuf.byteLength < len + 2) // not enough data
    return null;
    const result = $83620c096ed20185$export$2f872c0f2117be69(sbuf.slice(2));
    $83620c096ed20185$export$7873fbe3f1f05fa6.bytes = $83620c096ed20185$export$2f872c0f2117be69.bytes;
    return result;
};
$83620c096ed20185$export$7873fbe3f1f05fa6.bytes = 0;
function $83620c096ed20185$var$encodingLengthList(list, enc) {
    let len = 0;
    for(let i = 0; i < list.length; i++)len += enc.encodingLength(list[i]);
    return len;
}
function $83620c096ed20185$var$encodeList(list, enc, buf, offset) {
    for(let i = 0; i < list.length; i++){
        enc.encode(list[i], buf, offset);
        offset += enc.encode.bytes;
    }
    return offset;
}
function $83620c096ed20185$var$decodeList(list, enc, buf, offset) {
    for(let i = 0; i < list.length; i++){
        list[i] = enc.decode(buf, offset);
        offset += enc.decode.bytes;
    }
    return offset;
}


var $458bdf6d2826aa14$exports = {};

$458bdf6d2826aa14$exports = (parcelRequire("b11PC"));


/* Common package for dealing with hex/string/uint8 conversions (and sha1 hashing)
*
* @author   Jimmy Wärting <jimmy@warting.se> (https://jimmy.warting.se/opensource)
* @license  MIT
*/ const $250d12c4048d99a7$export$1b9ece1fd5efdcd7 = "0123456789abcdef";
const $250d12c4048d99a7$var$encodeLookup = [];
const $250d12c4048d99a7$var$decodeLookup = [];
for(let i = 0; i < 256; i++){
    $250d12c4048d99a7$var$encodeLookup[i] = $250d12c4048d99a7$export$1b9ece1fd5efdcd7[i >> 4 & 0xf] + $250d12c4048d99a7$export$1b9ece1fd5efdcd7[i & 0xf];
    if (i < 16) {
        if (i < 10) $250d12c4048d99a7$var$decodeLookup[0x30 + i] = i;
        else $250d12c4048d99a7$var$decodeLookup[87 + i] = i;
    }
}
const $250d12c4048d99a7$export$70d45ef99b984e19 = (data)=>{
    const length = data.length;
    let string = "";
    let i = 0;
    while(i < length)string += $250d12c4048d99a7$var$encodeLookup[data[i++]];
    return string;
};
const $250d12c4048d99a7$export$30a0448ba3664bd6 = (str)=>{
    const sizeof = str.length >> 1;
    const length = sizeof << 1;
    const array = new Uint8Array(sizeof);
    let n = 0;
    let i = 0;
    while(i < length)array[n++] = $250d12c4048d99a7$var$decodeLookup[str.charCodeAt(i++)] << 4 | $250d12c4048d99a7$var$decodeLookup[str.charCodeAt(i++)];
    return array;
};
const $250d12c4048d99a7$export$ee1b3e54f0441b22 = (chunks, size = 0)=>{
    const length = chunks.length || 0;
    if (!size) {
        let i = length;
        while(i--)size += chunks[i].length;
    }
    const b = new Uint8Array(size);
    let offset = size;
    let i = length;
    while(i--){
        offset -= chunks[i].length;
        b.set(chunks[i], offset);
    }
    return b;
};
const $250d12c4048d99a7$export$411ce8e5a71e3069 = (a, b)=>{
    if (a.length !== b.length) return false;
    for(let i = a.length; i > -1; i -= 1){
        if (a[i] !== b[i]) return false;
    }
    return true;
};


/*
 * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ var $6e4a09eefdefdb9a$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
// Use a lookup table to find the index.
var $6e4a09eefdefdb9a$var$lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(var $6e4a09eefdefdb9a$var$i = 0; $6e4a09eefdefdb9a$var$i < $6e4a09eefdefdb9a$var$chars.length; $6e4a09eefdefdb9a$var$i++)$6e4a09eefdefdb9a$var$lookup[$6e4a09eefdefdb9a$var$chars.charCodeAt($6e4a09eefdefdb9a$var$i)] = $6e4a09eefdefdb9a$var$i;
var $6e4a09eefdefdb9a$export$c564cdbbe6da493 = function(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = "";
    for(i = 0; i < len; i += 3){
        base64 += $6e4a09eefdefdb9a$var$chars[bytes[i] >> 2];
        base64 += $6e4a09eefdefdb9a$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $6e4a09eefdefdb9a$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $6e4a09eefdefdb9a$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + "=";
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + "==";
    return base64;
};
var $6e4a09eefdefdb9a$export$2f872c0f2117be69 = function(base64) {
    var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === "=") {
        bufferLength--;
        if (base64[base64.length - 2] === "=") bufferLength--;
    }
    var arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for(i = 0; i < len; i += 4){
        encoded1 = $6e4a09eefdefdb9a$var$lookup[base64.charCodeAt(i)];
        encoded2 = $6e4a09eefdefdb9a$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $6e4a09eefdefdb9a$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $6e4a09eefdefdb9a$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
};


const $30a78db839b82430$var$decoder = new TextDecoder();
const $30a78db839b82430$export$7a7f11c15ae14c9b = (data, enc)=>{
    if (!enc) return $30a78db839b82430$var$decoder.decode(data);
    const dec = new TextDecoder(enc);
    return dec.decode(data);
};
// sacrifice ~20% speed for bundle size
const $30a78db839b82430$var$encoder = new TextEncoder();
const $30a78db839b82430$export$5ef417313c99c2ea = (str)=>$30a78db839b82430$var$encoder.encode(str);
const $30a78db839b82430$export$7c3185bb3390e93 = (data)=>(0, $6e4a09eefdefdb9a$export$c564cdbbe6da493)(data);
const $30a78db839b82430$export$69f449cc2c99fa62 = (str)=>new Uint8Array((0, $6e4a09eefdefdb9a$export$2f872c0f2117be69)(str));
const $30a78db839b82430$export$49fe209f945af2c = (str)=>{
    let res = "";
    let c;
    let i = 0;
    const len = str.length;
    while(i < len){
        c = str.charCodeAt(i++);
        res += (0, $250d12c4048d99a7$export$1b9ece1fd5efdcd7)[c >> 4] + (0, $250d12c4048d99a7$export$1b9ece1fd5efdcd7)[c & 0xF];
    }
    return res;
};
const $30a78db839b82430$var$MAX_ARGUMENTS_LENGTH = 0x10000;
const $30a78db839b82430$export$dac5d37a50f22f11 = (hex)=>{
    const points = (0, $250d12c4048d99a7$export$30a0448ba3664bd6)(hex);
    if (points.length <= $30a78db839b82430$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode(...points);
    let res = "";
    let i = 0;
    while(i < points.length)res += String.fromCharCode(...points.subarray(i, i += $30a78db839b82430$var$MAX_ARGUMENTS_LENGTH));
    return res;
};
const $30a78db839b82430$var$scope = typeof window !== "undefined" ? window : self;
const $30a78db839b82430$var$crypto = $30a78db839b82430$var$scope.crypto || $30a78db839b82430$var$scope.msCrypto || {};
const $30a78db839b82430$var$subtle = $30a78db839b82430$var$crypto.subtle || $30a78db839b82430$var$crypto.webkitSubtle;
const $30a78db839b82430$var$formatMap = {
    hex: (0, $250d12c4048d99a7$export$70d45ef99b984e19),
    base64: $30a78db839b82430$export$7c3185bb3390e93
};
const $30a78db839b82430$export$d6af199866bfb566 = async (data, format, algo = "sha-1")=>{
    if (!$30a78db839b82430$var$subtle) throw new Error("no web crypto support");
    if (typeof data === "string") data = $30a78db839b82430$export$5ef417313c99c2ea(data);
    const out = new Uint8Array(await $30a78db839b82430$var$subtle.digest(algo, data));
    return format ? $30a78db839b82430$var$formatMap[format](out) : out;
};
const $30a78db839b82430$export$5f828d93ff035aa8 = (size)=>{
    const view = new Uint8Array(size);
    return $30a78db839b82430$var$crypto.getRandomValues(view);
};


function $b376cd615ea6cea1$export$b41b8ba04df1a98a(value) {
    // Add a digit for negative numbers, as the sign will be prefixed
    const sign = value < 0 ? 1 : 0;
    // Guard against negative numbers & zero going into log10(),
    // as that would return -Infinity
    value = Math.abs(Number(value || 1));
    return Math.floor(Math.log10(value)) + 1 + sign;
}
function $b376cd615ea6cea1$export$e2b5c5db9e2009fd(value) {
    if (ArrayBuffer.isView(value)) return "arraybufferview";
    if (Array.isArray(value)) return "array";
    if (value instanceof Number) return "number";
    if (value instanceof Boolean) return "boolean";
    if (value instanceof Set) return "set";
    if (value instanceof Map) return "map";
    if (value instanceof String) return "string";
    if (value instanceof ArrayBuffer) return "arraybuffer";
    return typeof value;
}


/**
 * Encodes data in bencode.
 *
 * @param  {Uint8Array|Array|String|Object|Number|Boolean} data
 * @return {Uint8Array}
 */ function $b7eec699152b2b65$var$encode(data, buffer, offset) {
    const buffers = [];
    let result = null;
    $b7eec699152b2b65$var$encode._encode(buffers, data);
    result = (0, $250d12c4048d99a7$export$ee1b3e54f0441b22)(buffers);
    $b7eec699152b2b65$var$encode.bytes = result.length;
    if (ArrayBuffer.isView(buffer)) {
        buffer.set(result, offset);
        return buffer;
    }
    return result;
}
$b7eec699152b2b65$var$encode.bytes = -1;
$b7eec699152b2b65$var$encode._floatConversionDetected = false;
$b7eec699152b2b65$var$encode._encode = function(buffers, data) {
    if (data == null) return;
    switch((0, $b376cd615ea6cea1$export$e2b5c5db9e2009fd)(data)){
        case "object":
            $b7eec699152b2b65$var$encode.dict(buffers, data);
            break;
        case "map":
            $b7eec699152b2b65$var$encode.dictMap(buffers, data);
            break;
        case "array":
            $b7eec699152b2b65$var$encode.list(buffers, data);
            break;
        case "set":
            $b7eec699152b2b65$var$encode.listSet(buffers, data);
            break;
        case "string":
            $b7eec699152b2b65$var$encode.string(buffers, data);
            break;
        case "number":
            $b7eec699152b2b65$var$encode.number(buffers, data);
            break;
        case "boolean":
            $b7eec699152b2b65$var$encode.number(buffers, data);
            break;
        case "arraybufferview":
            $b7eec699152b2b65$var$encode.buffer(buffers, new Uint8Array(data.buffer, data.byteOffset, data.byteLength));
            break;
        case "arraybuffer":
            $b7eec699152b2b65$var$encode.buffer(buffers, new Uint8Array(data));
            break;
    }
};
const $b7eec699152b2b65$var$buffE = new Uint8Array([
    0x65
]);
const $b7eec699152b2b65$var$buffD = new Uint8Array([
    0x64
]);
const $b7eec699152b2b65$var$buffL = new Uint8Array([
    0x6C
]);
$b7eec699152b2b65$var$encode.buffer = function(buffers, data) {
    buffers.push((0, $30a78db839b82430$export$5ef417313c99c2ea)(data.length + ":"), data);
};
$b7eec699152b2b65$var$encode.string = function(buffers, data) {
    buffers.push((0, $30a78db839b82430$export$5ef417313c99c2ea)((0, $30a78db839b82430$export$5ef417313c99c2ea)(data).byteLength + ":" + data));
};
$b7eec699152b2b65$var$encode.number = function(buffers, data) {
    const maxLo = 0x80000000;
    const hi = data / maxLo << 0;
    const lo = data % maxLo << 0;
    const val = hi * maxLo + lo;
    buffers.push((0, $30a78db839b82430$export$5ef417313c99c2ea)("i" + val + "e"));
    if (val !== data && !$b7eec699152b2b65$var$encode._floatConversionDetected) {
        $b7eec699152b2b65$var$encode._floatConversionDetected = true;
        console.warn('WARNING: Possible data corruption detected with value "' + data + '":', 'Bencoding only defines support for integers, value was converted to "' + val + '"');
        console.trace();
    }
};
$b7eec699152b2b65$var$encode.dict = function(buffers, data) {
    buffers.push($b7eec699152b2b65$var$buffD);
    let j = 0;
    let k;
    // fix for issue #13 - sorted dicts
    const keys = Object.keys(data).sort();
    const kl = keys.length;
    for(; j < kl; j++){
        k = keys[j];
        if (data[k] == null) continue;
        $b7eec699152b2b65$var$encode.string(buffers, k);
        $b7eec699152b2b65$var$encode._encode(buffers, data[k]);
    }
    buffers.push($b7eec699152b2b65$var$buffE);
};
$b7eec699152b2b65$var$encode.dictMap = function(buffers, data) {
    buffers.push($b7eec699152b2b65$var$buffD);
    const keys = Array.from(data.keys()).sort();
    for (const key of keys){
        if (data.get(key) == null) continue;
        ArrayBuffer.isView(key) ? $b7eec699152b2b65$var$encode._encode(buffers, key) : $b7eec699152b2b65$var$encode.string(buffers, String(key));
        $b7eec699152b2b65$var$encode._encode(buffers, data.get(key));
    }
    buffers.push($b7eec699152b2b65$var$buffE);
};
$b7eec699152b2b65$var$encode.list = function(buffers, data) {
    let i = 0;
    const c = data.length;
    buffers.push($b7eec699152b2b65$var$buffL);
    for(; i < c; i++){
        if (data[i] == null) continue;
        $b7eec699152b2b65$var$encode._encode(buffers, data[i]);
    }
    buffers.push($b7eec699152b2b65$var$buffE);
};
$b7eec699152b2b65$var$encode.listSet = function(buffers, data) {
    buffers.push($b7eec699152b2b65$var$buffL);
    for (const item of data){
        if (item == null) continue;
        $b7eec699152b2b65$var$encode._encode(buffers, item);
    }
    buffers.push($b7eec699152b2b65$var$buffE);
};
var $b7eec699152b2b65$export$2e2bcd8739ae039 = $b7eec699152b2b65$var$encode;



const $9d9b4c5fca31a09a$var$INTEGER_START = 0x69 // 'i'
;
const $9d9b4c5fca31a09a$var$STRING_DELIM = 0x3A // ':'
;
const $9d9b4c5fca31a09a$var$DICTIONARY_START = 0x64 // 'd'
;
const $9d9b4c5fca31a09a$var$LIST_START = 0x6C // 'l'
;
const $9d9b4c5fca31a09a$var$END_OF_TYPE = 0x65 // 'e'
;
/**
 * replaces parseInt(buffer.toString('ascii', start, end)).
 * For strings with less then ~30 charachters, this is actually a lot faster.
 *
 * @param {Uint8Array} data
 * @param {Number} start
 * @param {Number} end
 * @return {Number} calculated number
 */ function $9d9b4c5fca31a09a$var$getIntFromBuffer(buffer, start, end) {
    let sum = 0;
    let sign = 1;
    for(let i = start; i < end; i++){
        const num = buffer[i];
        if (num < 58 && num >= 48) {
            sum = sum * 10 + (num - 48);
            continue;
        }
        if (i === start && num === 43) continue;
        if (i === start && num === 45) {
            sign = -1;
            continue;
        }
        if (num === 46) break;
        throw new Error("not a number: buffer[" + i + "] = " + num);
    }
    return sum * sign;
}
/**
 * Decodes bencoded data.
 *
 * @param  {Uint8Array} data
 * @param  {Number} start (optional)
 * @param  {Number} end (optional)
 * @param  {String} encoding (optional)
 * @return {Object|Array|Uint8Array|String|Number}
 */ function $9d9b4c5fca31a09a$var$decode(data, start, end, encoding) {
    if (data == null || data.length === 0) return null;
    if (typeof start !== "number" && encoding == null) {
        encoding = start;
        start = undefined;
    }
    if (typeof end !== "number" && encoding == null) {
        encoding = end;
        end = undefined;
    }
    $9d9b4c5fca31a09a$var$decode.position = 0;
    $9d9b4c5fca31a09a$var$decode.encoding = encoding || null;
    $9d9b4c5fca31a09a$var$decode.data = !ArrayBuffer.isView(data) ? (0, $30a78db839b82430$export$5ef417313c99c2ea)(data) : new Uint8Array(data.slice(start, end));
    $9d9b4c5fca31a09a$var$decode.bytes = $9d9b4c5fca31a09a$var$decode.data.length;
    return $9d9b4c5fca31a09a$var$decode.next();
}
$9d9b4c5fca31a09a$var$decode.bytes = 0;
$9d9b4c5fca31a09a$var$decode.position = 0;
$9d9b4c5fca31a09a$var$decode.data = null;
$9d9b4c5fca31a09a$var$decode.encoding = null;
$9d9b4c5fca31a09a$var$decode.next = function() {
    switch($9d9b4c5fca31a09a$var$decode.data[$9d9b4c5fca31a09a$var$decode.position]){
        case $9d9b4c5fca31a09a$var$DICTIONARY_START:
            return $9d9b4c5fca31a09a$var$decode.dictionary();
        case $9d9b4c5fca31a09a$var$LIST_START:
            return $9d9b4c5fca31a09a$var$decode.list();
        case $9d9b4c5fca31a09a$var$INTEGER_START:
            return $9d9b4c5fca31a09a$var$decode.integer();
        default:
            return $9d9b4c5fca31a09a$var$decode.buffer();
    }
};
$9d9b4c5fca31a09a$var$decode.find = function(chr) {
    let i = $9d9b4c5fca31a09a$var$decode.position;
    const c = $9d9b4c5fca31a09a$var$decode.data.length;
    const d = $9d9b4c5fca31a09a$var$decode.data;
    while(i < c){
        if (d[i] === chr) return i;
        i++;
    }
    throw new Error('Invalid data: Missing delimiter "' + String.fromCharCode(chr) + '" [0x' + chr.toString(16) + "]");
};
$9d9b4c5fca31a09a$var$decode.dictionary = function() {
    $9d9b4c5fca31a09a$var$decode.position++;
    const dict = {};
    while($9d9b4c5fca31a09a$var$decode.data[$9d9b4c5fca31a09a$var$decode.position] !== $9d9b4c5fca31a09a$var$END_OF_TYPE)dict[(0, $30a78db839b82430$export$7a7f11c15ae14c9b)($9d9b4c5fca31a09a$var$decode.buffer())] = $9d9b4c5fca31a09a$var$decode.next();
    $9d9b4c5fca31a09a$var$decode.position++;
    return dict;
};
$9d9b4c5fca31a09a$var$decode.list = function() {
    $9d9b4c5fca31a09a$var$decode.position++;
    const lst = [];
    while($9d9b4c5fca31a09a$var$decode.data[$9d9b4c5fca31a09a$var$decode.position] !== $9d9b4c5fca31a09a$var$END_OF_TYPE)lst.push($9d9b4c5fca31a09a$var$decode.next());
    $9d9b4c5fca31a09a$var$decode.position++;
    return lst;
};
$9d9b4c5fca31a09a$var$decode.integer = function() {
    const end = $9d9b4c5fca31a09a$var$decode.find($9d9b4c5fca31a09a$var$END_OF_TYPE);
    const number = $9d9b4c5fca31a09a$var$getIntFromBuffer($9d9b4c5fca31a09a$var$decode.data, $9d9b4c5fca31a09a$var$decode.position + 1, end);
    $9d9b4c5fca31a09a$var$decode.position += end + 1 - $9d9b4c5fca31a09a$var$decode.position;
    return number;
};
$9d9b4c5fca31a09a$var$decode.buffer = function() {
    let sep = $9d9b4c5fca31a09a$var$decode.find($9d9b4c5fca31a09a$var$STRING_DELIM);
    const length = $9d9b4c5fca31a09a$var$getIntFromBuffer($9d9b4c5fca31a09a$var$decode.data, $9d9b4c5fca31a09a$var$decode.position, sep);
    const end = ++sep + length;
    $9d9b4c5fca31a09a$var$decode.position = end;
    return $9d9b4c5fca31a09a$var$decode.encoding ? (0, $30a78db839b82430$export$7a7f11c15ae14c9b)($9d9b4c5fca31a09a$var$decode.data.slice(sep, end)) : $9d9b4c5fca31a09a$var$decode.data.slice(sep, end);
};
var $9d9b4c5fca31a09a$export$2e2bcd8739ae039 = $9d9b4c5fca31a09a$var$decode;




function $8295391f3a10f07b$var$listLength(list) {
    let length = 2 // type marker + end-of-type marker
    ;
    for (const value of list)length += $8295391f3a10f07b$var$encodingLength(value);
    return length;
}
function $8295391f3a10f07b$var$mapLength(map) {
    let length = 2 // type marker + end-of-type marker
    ;
    for (const [key, value] of map){
        const keyLength = (0, $30a78db839b82430$export$5ef417313c99c2ea)(key).byteLength;
        length += (0, $b376cd615ea6cea1$export$b41b8ba04df1a98a)(keyLength) + 1 + keyLength;
        length += $8295391f3a10f07b$var$encodingLength(value);
    }
    return length;
}
function $8295391f3a10f07b$var$objectLength(value) {
    let length = 2 // type marker + end-of-type marker
    ;
    const keys = Object.keys(value);
    for(let i = 0; i < keys.length; i++){
        const keyLength = (0, $30a78db839b82430$export$5ef417313c99c2ea)(keys[i]).byteLength;
        length += (0, $b376cd615ea6cea1$export$b41b8ba04df1a98a)(keyLength) + 1 + keyLength;
        length += $8295391f3a10f07b$var$encodingLength(value[keys[i]]);
    }
    return length;
}
function $8295391f3a10f07b$var$stringLength(value) {
    const length = (0, $30a78db839b82430$export$5ef417313c99c2ea)(value).byteLength;
    return (0, $b376cd615ea6cea1$export$b41b8ba04df1a98a)(length) + 1 + length;
}
function $8295391f3a10f07b$var$arrayBufferLength(value) {
    const length = value.byteLength - value.byteOffset;
    return (0, $b376cd615ea6cea1$export$b41b8ba04df1a98a)(length) + 1 + length;
}
function $8295391f3a10f07b$var$encodingLength(value) {
    const length = 0;
    if (value == null) return length;
    const type = (0, $b376cd615ea6cea1$export$e2b5c5db9e2009fd)(value);
    switch(type){
        case "arraybufferview":
            return $8295391f3a10f07b$var$arrayBufferLength(value);
        case "string":
            return $8295391f3a10f07b$var$stringLength(value);
        case "array":
        case "set":
            return $8295391f3a10f07b$var$listLength(value);
        case "number":
            return 1 + (0, $b376cd615ea6cea1$export$b41b8ba04df1a98a)(Math.floor(value)) + 1;
        case "bigint":
            return 1 + value.toString().length + 1;
        case "object":
            return $8295391f3a10f07b$var$objectLength(value);
        case "map":
            return $8295391f3a10f07b$var$mapLength(value);
        default:
            throw new TypeError(`Unsupported value of type "${type}"`);
    }
}
var $8295391f3a10f07b$export$2e2bcd8739ae039 = $8295391f3a10f07b$var$encodingLength;


/**
 * Determines the amount of bytes
 * needed to encode the given value
 * @param  {Object|Array|Uint8Array|String|Number|Boolean} value
 * @return {Number} byteCount
 */ const $e1f47be2d671f691$var$encodingLength = (0, $8295391f3a10f07b$export$2e2bcd8739ae039);
var $e1f47be2d671f691$export$2e2bcd8739ae039 = {
    encode: $b7eec699152b2b65$export$2e2bcd8739ae039,
    decode: $9d9b4c5fca31a09a$export$2e2bcd8739ae039,
    byteLength: $8295391f3a10f07b$export$2e2bcd8739ae039,
    encodingLength: $e1f47be2d671f691$var$encodingLength
};




var $901bb76aa68864ab$require$Buffer = $24f87a6f86a8996f$export$a143d493d941bafc;
const $901bb76aa68864ab$export$532244b5b8b0b4b6 = (0, (/*@__PURE__*/$parcel$interopDefault($458bdf6d2826aa14$exports))).crypto_sign_verify_detached;
function $901bb76aa68864ab$export$5f828d93ff035aa8(n = 32) {
    const buf = $901bb76aa68864ab$require$Buffer.alloc(n);
    (0, (/*@__PURE__*/$parcel$interopDefault($458bdf6d2826aa14$exports))).randombytes_buf(buf);
    return buf;
}
const $901bb76aa68864ab$export$587ce9d5f94ca511 = (msg)=>{
    const ref = {
        seq: msg.seq || 0,
        v: msg.v
    };
    const bencoded = (0, $e1f47be2d671f691$export$2e2bcd8739ae039).encode(ref).subarray(1, -1);
    return bencoded;
};
const $901bb76aa68864ab$export$727d4d48f67a3991 = (sigData)=>{
    const dict = new Uint8Array(sigData.length + 2);
    dict[0] = 100 // d
    ;
    dict.set(sigData, 1);
    dict[sigData.length + 1] = 101 // e
    ;
    return (0, $e1f47be2d671f691$export$2e2bcd8739ae039).decode(dict);
};
const $901bb76aa68864ab$export$a949d36eab55b41f = (seed)=>{
    const publicKey = $901bb76aa68864ab$require$Buffer.allocUnsafe((0, (/*@__PURE__*/$parcel$interopDefault($458bdf6d2826aa14$exports))).crypto_sign_PUBLICKEYBYTES);
    const secretKey = $901bb76aa68864ab$require$Buffer.allocUnsafe((0, (/*@__PURE__*/$parcel$interopDefault($458bdf6d2826aa14$exports))).crypto_sign_SECRETKEYBYTES);
    if (seed) (0, (/*@__PURE__*/$parcel$interopDefault($458bdf6d2826aa14$exports))).crypto_sign_seed_keypair(publicKey, secretKey, seed);
    else (0, (/*@__PURE__*/$parcel$interopDefault($458bdf6d2826aa14$exports))).crypto_sign_keypair(publicKey, secretKey);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
};
const $901bb76aa68864ab$export$b983cdf2c2084305 = (url)=>{
    if (typeof url !== "string") return url;
    const keyBytes = (0, (/*@__PURE__*/$parcel$interopDefault($032165b12ce1198f$exports))).decode(url.replace("pk:", ""));
    if (keyBytes.byteLength !== 32) throw new Error("Invalid key");
    return keyBytes;
} /**
 * @typedef {{secretKey: Uint8Array, publicKey: Uint8Array}} KeyPair
 */ ;







var $f1b48f883215b743$require$Buffer = $24f87a6f86a8996f$export$a143d493d941bafc;
const $f1b48f883215b743$var$verify = (0, (/*@__PURE__*/$parcel$interopDefault($458bdf6d2826aa14$exports))).crypto_sign_verify_detached;
class $f1b48f883215b743$export$2e2bcd8739ae039 {
    /** @type {Uint8Array} */ #publicKey;
    /** @type {Packet} */ #packet;
    /** @type {Uint8Array} */ #bytes;
    /** @type {number} */ #timestamp;
    /**
   * Creates a new SignedPacket from a Keypair and a DNS Packet.
   *
   * It will also normalize the names of the ResourceRecords to be relative to the origin, which would be the zbase32 encoded PublicKey of the Keypair used to sign the Packet.
   *
   * @param {Keypair} keypair
   * @param {Packet} packet
   *
   * @param {object} [options] - Optional arguments mostly useful for unit testing
   * @param {object} [options.timestamp] - timestamp in microseconds
   *
   * @returns {SignedPacket}
   */ static fromPacket(keypair, packet, options = {}) {
        const origin = (0, (/*@__PURE__*/$parcel$interopDefault($032165b12ce1198f$exports))).encode(keypair.publicKey);
        packet.answers = packet.answers.map((answer)=>{
            answer.name = $f1b48f883215b743$var$normalizeName(origin, answer.name);
            return answer;
        });
        const signedPacket = new $f1b48f883215b743$export$2e2bcd8739ae039();
        signedPacket.#packet = packet;
        const timestamp = Math.ceil(options.timestamp || Date.now() * 1000) // Micro seconds
        ;
        const encodedPacket = (0, (/*@__PURE__*/$parcel$interopDefault($83620c096ed20185$exports))).encode(packet);
        const signable = (0, $901bb76aa68864ab$export$587ce9d5f94ca511)({
            seq: timestamp,
            v: encodedPacket
        });
        const signature = $f1b48f883215b743$require$Buffer.alloc((0, (/*@__PURE__*/$parcel$interopDefault($458bdf6d2826aa14$exports))).crypto_sign_BYTES);
        (0, (/*@__PURE__*/$parcel$interopDefault($458bdf6d2826aa14$exports))).crypto_sign_detached(signature, signable, keypair.secretKey);
        signedPacket.#timestamp = timestamp;
        signedPacket.#publicKey = keypair.publicKey;
        const bytes = $f1b48f883215b743$require$Buffer.alloc(encodedPacket.length + 72);
        bytes.set(signature);
        bytes.writeBigUInt64BE(BigInt(timestamp), 64);
        bytes.set(encodedPacket, 72);
        signedPacket.#bytes = bytes;
        return signedPacket;
    }
    /**
   * Creates a new [SignedPacket] from a [PublicKey] and the concatenated 64 bytes Signature,
   * 8 bytes timestamp and encoded [Packet] as defined in the [relays](https://github.com/Nuhvi/pkarr/blob/main/design/relays.md) spec.
   *
   * @param {Uint8Array} publicKey
   * @param {Uint8Array} bytes
   */ static fromBytes(publicKey, bytes) {
        const buffer = $f1b48f883215b743$require$Buffer.from(bytes);
        if (buffer.length < 72) throw new Error(`Invalid SignedPacket bytes length, expected at least 72 bytes but got: ${buffer.length}`);
        if (buffer.length > 1072) throw new Error(`Encoded and compressed DNS Packet is too large, expected max 1000 bytes but got: ${buffer.length}`);
        const seq = Number(buffer.readBigUInt64BE(64));
        const v = buffer.subarray(72);
        const sig = buffer.subarray(0, 64);
        return $f1b48f883215b743$export$2e2bcd8739ae039.fromBep44Args({
            k: publicKey,
            seq: seq,
            v: v,
            sig: sig
        });
    }
    /**
   * @param {Bep44Args} args
   */ static fromBep44Args(args) {
        const publicKey = args.k;
        const signature = args.sig;
        const encodedPacket = $f1b48f883215b743$require$Buffer.from(args.v);
        const timestamp = args.seq;
        const signable = (0, $901bb76aa68864ab$export$587ce9d5f94ca511)({
            seq: timestamp,
            v: encodedPacket
        });
        const valid = $f1b48f883215b743$var$verify(signature, signable, publicKey);
        if (!valid) throw Error("Invalid signature");
        const packet = (0, (/*@__PURE__*/$parcel$interopDefault($83620c096ed20185$exports))).decode(encodedPacket);
        const signedPacket = new $f1b48f883215b743$export$2e2bcd8739ae039();
        signedPacket.#publicKey = publicKey;
        signedPacket.#packet = packet;
        signedPacket.#timestamp = timestamp;
        const buffer = $f1b48f883215b743$require$Buffer.alloc(args.v.length + 72);
        buffer.set(signature);
        buffer.writeBigUInt64BE(BigInt(timestamp), 64);
        buffer.set(encodedPacket, 72);
        signedPacket.#bytes = buffer;
        return signedPacket;
    }
    /**
   * Returns a list of resource records with the target `name`.
   * `name` can be not normalized, for example `@` or `subdomain.`.
   *
   * @param {string} name
   */ resourceRecords(name) {
        const origin = (0, (/*@__PURE__*/$parcel$interopDefault($032165b12ce1198f$exports))).encode(this.publicKey());
        const normalizedName = $f1b48f883215b743$var$normalizeName(origin, name);
        return this.packet().answers.filter((rr)=>rr.name === normalizedName);
    }
    /**
   * Returns the publicKey singing this packet
   *
   * @returns{Uint8Array}
   * */ publicKey() {
        return this.#publicKey;
    }
    /**
   * Returns the DNS packet
   *
   * @returns{Packet}
   * */ packet() {
        return this.#packet;
    }
    /**
   * Returns the timestamp of the creation of the signed packet
   *
   * @returns {number}
   */ timestamp() {
        return this.#timestamp;
    }
    /**
   * Returns the signature over the encoded DNS packet and timestamp as defined by BEP44
   *
   * @returns{Uint8Array}
   * */ signature() {
        return this.#bytes.subarray(0, 64);
    }
    /**
   * Returns the encoded signature, timestamp and packet as defined in the [relays](https://github.com/Nuhvi/pkarr/blob/main/design/relays.md) spec.
   *
   * @returns {Uint8Array}
   */ bytes() {
        return this.#bytes;
    }
    /**
   * Returns BEP0044 arguments { seq, v, sig }
   *
   * @returns {Bep44Args}
   */ bep44Args() {
        return {
            k: this.publicKey(),
            seq: this.timestamp(),
            sig: this.signature(),
            v: this.#bytes.subarray(72)
        };
    }
    /**
   * Returns the size of the encoded packet
   */ size() {
        return this.#bytes.length - 72;
    }
}
/**
 *
 * @param {string} origin
 * @param {string} name
 *
 * @returns {string}
 */ function $f1b48f883215b743$var$normalizeName(origin, name) {
    if (name.endsWith(".")) name = name.slice(0, -1);
    const parts = name.split(".");
    const last = parts[parts.length - 1];
    if (last === origin) // Already normalized.
    return name;
    else if (last === "@" || last.length === 0) // Shorthand of origin
    return origin;
    return name.concat(".").concat(origin);
} /**
 * @typedef {import('dns-packet').Packet} Packet
 * @typedef {{secretKey: Uint8Array, publicKey: Uint8Array}} Keypair
 * @typedef {{k:Uint8Array, seq: number, v: Uint8Array, sig: Uint8Array}} Bep44Args
 */ 



var $a3ab9fa3f7cde392$require$Buffer = $24f87a6f86a8996f$export$a143d493d941bafc;
const $a3ab9fa3f7cde392$export$287a00fa5ebac8f3 = (0, $f1b48f883215b743$export$2e2bcd8739ae039);
const $a3ab9fa3f7cde392$export$4be6b92acc95a574 = (0, (/*@__PURE__*/$parcel$interopDefault($032165b12ce1198f$exports)));
const $a3ab9fa3f7cde392$export$75bcf2fe483cb517 = (0, (/*@__PURE__*/$parcel$interopDefault($83620c096ed20185$exports)));
const $a3ab9fa3f7cde392$export$a949d36eab55b41f = (0, $901bb76aa68864ab$export$a949d36eab55b41f);
class $a3ab9fa3f7cde392$export$757029e5d4b731bf {
    static generateKeyPair = (0, $901bb76aa68864ab$export$a949d36eab55b41f);
    static generateSeed = (0, $901bb76aa68864ab$export$5f828d93ff035aa8);
    /**
   * Publishes a signed packet using relay. returns the Fetch response.
   *
   * @param {string} relay - Relay url
   * @param {SignedPacket} signedPacket
   */ static async relayPut(relay, signedPacket) {
        const id = $a3ab9fa3f7cde392$export$4be6b92acc95a574.encode(signedPacket.publicKey());
        const url = relay.replace(/\/+$/, "") + "/" + id;
        return fetch(url, {
            method: "PUT",
            body: signedPacket.bytes()
        });
    }
    /**
   * Publishes a signed packet using relay. returns the Fetch response.
   *
   * @param {string} relay - Relay url
   * @param {Uint8Array} publicKey
   */ static async relayGet(relay, publicKey) {
        const id = $a3ab9fa3f7cde392$export$4be6b92acc95a574.encode(publicKey);
        const url = relay.replace(/\/+$/, "") + "/" + id;
        const response = await fetch(url);
        if (!response.ok) {
            if (response.status === 404) return null;
            else throw new Error(response.statusText);
        }
        const bytes = $a3ab9fa3f7cde392$require$Buffer.from(await response.arrayBuffer());
        return $a3ab9fa3f7cde392$export$287a00fa5ebac8f3.fromBytes(publicKey, bytes);
    }
    /**
   * Publishes a signed packet to the DHT.
   * Throws an error in browser environment.
   *
   * @param {SignedPacket} signedPacket
   *
   * @returns {Promise<boolean>}
   */ static async publish(signedPacket) {
        const dht = new (0, $9711f37caea5d809$export$2e2bcd8739ae039)();
        return dht.put(signedPacket.bep44Args()).then(()=>true).catch(()=>false).finally(()=>dht.destroy());
    }
    /**
   * Resolves a signed packet from the DHT.
   * Throws an error in browser environment.
   *
   * @param {Uint8Array | string} key
   * @param {object} [options]
   * @param {boolean} [options.fullLookup=false] - perform a full lookup through the DHT, defaults to false, meaning it will return the first result it finds
   *
   * @throws {Error<'Invalid key'>}
   * @returns {Promise<{signedPacket: SignedPacket, nodes: {host: string, port: number}[]} | null>}
   */ static async resolve(key, options = {}) {
        const dht = new (0, $9711f37caea5d809$export$2e2bcd8739ae039)();
        try {
            const result = await dht.get((0, $901bb76aa68864ab$export$b983cdf2c2084305)(key), options).finally(()=>dht.destroy());
            if (!result) return null;
            return {
                signedPacket: $a3ab9fa3f7cde392$export$287a00fa5ebac8f3.fromBep44Args(result),
                nodes: result.nodes
            };
        } catch (error) {
            dht.destroy();
            throw error;
        }
    }
}
var $a3ab9fa3f7cde392$export$2e2bcd8739ae039 /**
 * @typedef {import('./lib/signed_packet.js').Packet} Packet
 * @typedef {import('./lib/signed_packet.js').default} SignedPacket
 */  = $a3ab9fa3f7cde392$export$757029e5d4b731bf;




const $2a8968f0c4d5fe8f$export$9f4df9bfaca7e3b7 = Symbol("store-raw"), $2a8968f0c4d5fe8f$var$$NODE = Symbol("store-node"), $2a8968f0c4d5fe8f$var$$HAS = Symbol("store-has"), $2a8968f0c4d5fe8f$var$$SELF = Symbol("store-self");
function $2a8968f0c4d5fe8f$var$wrap$1(value) {
    let p = value[0, $9ac5634fc6778fc7$export$5cd89106e2f6c2c5];
    if (!p) {
        Object.defineProperty(value, (0, $9ac5634fc6778fc7$export$5cd89106e2f6c2c5), {
            value: p = new Proxy(value, $2a8968f0c4d5fe8f$var$proxyTraps$1)
        });
        if (!Array.isArray(value)) {
            const keys = Object.keys(value), desc = Object.getOwnPropertyDescriptors(value);
            for(let i = 0, l = keys.length; i < l; i++){
                const prop = keys[i];
                if (desc[prop].get) Object.defineProperty(value, prop, {
                    enumerable: desc[prop].enumerable,
                    get: desc[prop].get.bind(p)
                });
            }
        }
    }
    return p;
}
function $2a8968f0c4d5fe8f$var$isWrappable(obj) {
    let proto;
    return obj != null && typeof obj === "object" && (obj[0, $9ac5634fc6778fc7$export$5cd89106e2f6c2c5] || !(proto = Object.getPrototypeOf(obj)) || proto === Object.prototype || Array.isArray(obj));
}
function $2a8968f0c4d5fe8f$export$debb760848ca95a(item, set = new Set()) {
    let result, unwrapped, v, prop;
    if (result = item != null && item[$2a8968f0c4d5fe8f$export$9f4df9bfaca7e3b7]) return result;
    if (!$2a8968f0c4d5fe8f$var$isWrappable(item) || set.has(item)) return item;
    if (Array.isArray(item)) {
        if (Object.isFrozen(item)) item = item.slice(0);
        else set.add(item);
        for(let i = 0, l = item.length; i < l; i++){
            v = item[i];
            if ((unwrapped = $2a8968f0c4d5fe8f$export$debb760848ca95a(v, set)) !== v) item[i] = unwrapped;
        }
    } else {
        if (Object.isFrozen(item)) item = Object.assign({}, item);
        else set.add(item);
        const keys = Object.keys(item), desc = Object.getOwnPropertyDescriptors(item);
        for(let i = 0, l = keys.length; i < l; i++){
            prop = keys[i];
            if (desc[prop].get) continue;
            v = item[prop];
            if ((unwrapped = $2a8968f0c4d5fe8f$export$debb760848ca95a(v, set)) !== v) item[prop] = unwrapped;
        }
    }
    return item;
}
function $2a8968f0c4d5fe8f$var$getNodes(target, symbol) {
    let nodes = target[symbol];
    if (!nodes) Object.defineProperty(target, symbol, {
        value: nodes = Object.create(null)
    });
    return nodes;
}
function $2a8968f0c4d5fe8f$var$getNode(nodes, property, value) {
    if (nodes[property]) return nodes[property];
    const [s, set] = (0, $9ac5634fc6778fc7$export$c1e1e1ecbbe76a5)(value, {
        equals: false,
        internal: true
    });
    s.$ = set;
    return nodes[property] = s;
}
function $2a8968f0c4d5fe8f$var$proxyDescriptor$1(target, property) {
    const desc = Reflect.getOwnPropertyDescriptor(target, property);
    if (!desc || desc.get || !desc.configurable || property === (0, $9ac5634fc6778fc7$export$5cd89106e2f6c2c5) || property === $2a8968f0c4d5fe8f$var$$NODE) return desc;
    delete desc.value;
    delete desc.writable;
    desc.get = ()=>target[0, $9ac5634fc6778fc7$export$5cd89106e2f6c2c5][property];
    return desc;
}
function $2a8968f0c4d5fe8f$var$trackSelf(target) {
    (0, $9ac5634fc6778fc7$export$12abb5141c6fdc9c)() && $2a8968f0c4d5fe8f$var$getNode($2a8968f0c4d5fe8f$var$getNodes(target, $2a8968f0c4d5fe8f$var$$NODE), $2a8968f0c4d5fe8f$var$$SELF)();
}
function $2a8968f0c4d5fe8f$var$ownKeys(target) {
    $2a8968f0c4d5fe8f$var$trackSelf(target);
    return Reflect.ownKeys(target);
}
const $2a8968f0c4d5fe8f$var$proxyTraps$1 = {
    get (target, property, receiver) {
        if (property === $2a8968f0c4d5fe8f$export$9f4df9bfaca7e3b7) return target;
        if (property === (0, $9ac5634fc6778fc7$export$5cd89106e2f6c2c5)) return receiver;
        if (property === (0, $9ac5634fc6778fc7$export$17a675b7c02a7b1d)) {
            $2a8968f0c4d5fe8f$var$trackSelf(target);
            return receiver;
        }
        const nodes = $2a8968f0c4d5fe8f$var$getNodes(target, $2a8968f0c4d5fe8f$var$$NODE);
        const tracked = nodes[property];
        let value = tracked ? tracked() : target[property];
        if (property === $2a8968f0c4d5fe8f$var$$NODE || property === $2a8968f0c4d5fe8f$var$$HAS || property === "__proto__") return value;
        if (!tracked) {
            const desc = Object.getOwnPropertyDescriptor(target, property);
            if ((0, $9ac5634fc6778fc7$export$12abb5141c6fdc9c)() && (typeof value !== "function" || target.hasOwnProperty(property)) && !(desc && desc.get)) value = $2a8968f0c4d5fe8f$var$getNode(nodes, property, value)();
        }
        return $2a8968f0c4d5fe8f$var$isWrappable(value) ? $2a8968f0c4d5fe8f$var$wrap$1(value) : value;
    },
    has (target, property) {
        if (property === $2a8968f0c4d5fe8f$export$9f4df9bfaca7e3b7 || property === (0, $9ac5634fc6778fc7$export$5cd89106e2f6c2c5) || property === (0, $9ac5634fc6778fc7$export$17a675b7c02a7b1d) || property === $2a8968f0c4d5fe8f$var$$NODE || property === $2a8968f0c4d5fe8f$var$$HAS || property === "__proto__") return true;
        (0, $9ac5634fc6778fc7$export$12abb5141c6fdc9c)() && $2a8968f0c4d5fe8f$var$getNode($2a8968f0c4d5fe8f$var$getNodes(target, $2a8968f0c4d5fe8f$var$$HAS), property)();
        return property in target;
    },
    set () {
        return true;
    },
    deleteProperty () {
        return true;
    },
    ownKeys: $2a8968f0c4d5fe8f$var$ownKeys,
    getOwnPropertyDescriptor: $2a8968f0c4d5fe8f$var$proxyDescriptor$1
};
function $2a8968f0c4d5fe8f$var$setProperty(state, property, value, deleting = false) {
    if (!deleting && state[property] === value) return;
    const prev = state[property], len = state.length;
    if (value === undefined) {
        delete state[property];
        if (state[$2a8968f0c4d5fe8f$var$$HAS] && state[$2a8968f0c4d5fe8f$var$$HAS][property] && prev !== undefined) state[$2a8968f0c4d5fe8f$var$$HAS][property].$();
    } else {
        state[property] = value;
        if (state[$2a8968f0c4d5fe8f$var$$HAS] && state[$2a8968f0c4d5fe8f$var$$HAS][property] && prev === undefined) state[$2a8968f0c4d5fe8f$var$$HAS][property].$();
    }
    let nodes = $2a8968f0c4d5fe8f$var$getNodes(state, $2a8968f0c4d5fe8f$var$$NODE), node;
    if (node = $2a8968f0c4d5fe8f$var$getNode(nodes, property, prev)) node.$(()=>value);
    if (Array.isArray(state) && state.length !== len) {
        for(let i = state.length; i < len; i++)(node = nodes[i]) && node.$();
        (node = $2a8968f0c4d5fe8f$var$getNode(nodes, "length", len)) && node.$(state.length);
    }
    (node = nodes[$2a8968f0c4d5fe8f$var$$SELF]) && node.$();
}
function $2a8968f0c4d5fe8f$var$mergeStoreNode(state, value) {
    const keys = Object.keys(value);
    for(let i = 0; i < keys.length; i += 1){
        const key = keys[i];
        $2a8968f0c4d5fe8f$var$setProperty(state, key, value[key]);
    }
}
function $2a8968f0c4d5fe8f$var$updateArray(current, next) {
    if (typeof next === "function") next = next(current);
    next = $2a8968f0c4d5fe8f$export$debb760848ca95a(next);
    if (Array.isArray(next)) {
        if (current === next) return;
        let i = 0, len = next.length;
        for(; i < len; i++){
            const value = next[i];
            if (current[i] !== value) $2a8968f0c4d5fe8f$var$setProperty(current, i, value);
        }
        $2a8968f0c4d5fe8f$var$setProperty(current, "length", len);
    } else $2a8968f0c4d5fe8f$var$mergeStoreNode(current, next);
}
function $2a8968f0c4d5fe8f$var$updatePath(current, path, traversed = []) {
    let part, prev = current;
    if (path.length > 1) {
        part = path.shift();
        const partType = typeof part, isArray = Array.isArray(current);
        if (Array.isArray(part)) {
            for(let i = 0; i < part.length; i++)$2a8968f0c4d5fe8f$var$updatePath(current, [
                part[i]
            ].concat(path), traversed);
            return;
        } else if (isArray && partType === "function") {
            for(let i = 0; i < current.length; i++)if (part(current[i], i)) $2a8968f0c4d5fe8f$var$updatePath(current, [
                i
            ].concat(path), traversed);
            return;
        } else if (isArray && partType === "object") {
            const { from: from = 0, to: to = current.length - 1, by: by = 1 } = part;
            for(let i = from; i <= to; i += by)$2a8968f0c4d5fe8f$var$updatePath(current, [
                i
            ].concat(path), traversed);
            return;
        } else if (path.length > 1) {
            $2a8968f0c4d5fe8f$var$updatePath(current[part], path, [
                part
            ].concat(traversed));
            return;
        }
        prev = current[part];
        traversed = [
            part
        ].concat(traversed);
    }
    let value = path[0];
    if (typeof value === "function") {
        value = value(prev, traversed);
        if (value === prev) return;
    }
    if (part === undefined && value == undefined) return;
    value = $2a8968f0c4d5fe8f$export$debb760848ca95a(value);
    if (part === undefined || $2a8968f0c4d5fe8f$var$isWrappable(prev) && $2a8968f0c4d5fe8f$var$isWrappable(value) && !Array.isArray(value)) $2a8968f0c4d5fe8f$var$mergeStoreNode(prev, value);
    else $2a8968f0c4d5fe8f$var$setProperty(current, part, value);
}
function $2a8968f0c4d5fe8f$export$f51a9068ac82ea43(...[store, options]) {
    const unwrappedStore = $2a8968f0c4d5fe8f$export$debb760848ca95a(store || {});
    const isArray = Array.isArray(unwrappedStore);
    const wrappedStore = $2a8968f0c4d5fe8f$var$wrap$1(unwrappedStore);
    function setStore(...args) {
        (0, $9ac5634fc6778fc7$export$712ea50be43a7858)(()=>{
            isArray && args.length === 1 ? $2a8968f0c4d5fe8f$var$updateArray(unwrappedStore, args[0]) : $2a8968f0c4d5fe8f$var$updatePath(unwrappedStore, args);
        });
    }
    return [
        wrappedStore,
        setStore
    ];
}
function $2a8968f0c4d5fe8f$var$proxyDescriptor(target, property) {
    const desc = Reflect.getOwnPropertyDescriptor(target, property);
    if (!desc || desc.get || desc.set || !desc.configurable || property === (0, $9ac5634fc6778fc7$export$5cd89106e2f6c2c5) || property === $2a8968f0c4d5fe8f$var$$NODE) return desc;
    delete desc.value;
    delete desc.writable;
    desc.get = ()=>target[0, $9ac5634fc6778fc7$export$5cd89106e2f6c2c5][property];
    desc.set = (v)=>target[0, $9ac5634fc6778fc7$export$5cd89106e2f6c2c5][property] = v;
    return desc;
}
const $2a8968f0c4d5fe8f$var$proxyTraps = {
    get (target, property, receiver) {
        if (property === $2a8968f0c4d5fe8f$export$9f4df9bfaca7e3b7) return target;
        if (property === (0, $9ac5634fc6778fc7$export$5cd89106e2f6c2c5)) return receiver;
        if (property === (0, $9ac5634fc6778fc7$export$17a675b7c02a7b1d)) {
            $2a8968f0c4d5fe8f$var$trackSelf(target);
            return receiver;
        }
        const nodes = $2a8968f0c4d5fe8f$var$getNodes(target, $2a8968f0c4d5fe8f$var$$NODE);
        const tracked = nodes[property];
        let value = tracked ? tracked() : target[property];
        if (property === $2a8968f0c4d5fe8f$var$$NODE || property === $2a8968f0c4d5fe8f$var$$HAS || property === "__proto__") return value;
        if (!tracked) {
            const desc = Object.getOwnPropertyDescriptor(target, property);
            const isFunction = typeof value === "function";
            if ((0, $9ac5634fc6778fc7$export$12abb5141c6fdc9c)() && (!isFunction || target.hasOwnProperty(property)) && !(desc && desc.get)) value = $2a8968f0c4d5fe8f$var$getNode(nodes, property, value)();
            else if (value != null && isFunction && value === Array.prototype[property]) return (...args)=>(0, $9ac5634fc6778fc7$export$712ea50be43a7858)(()=>Array.prototype[property].apply(receiver, args));
        }
        return $2a8968f0c4d5fe8f$var$isWrappable(value) ? $2a8968f0c4d5fe8f$var$wrap(value) : value;
    },
    has (target, property) {
        if (property === $2a8968f0c4d5fe8f$export$9f4df9bfaca7e3b7 || property === (0, $9ac5634fc6778fc7$export$5cd89106e2f6c2c5) || property === (0, $9ac5634fc6778fc7$export$17a675b7c02a7b1d) || property === $2a8968f0c4d5fe8f$var$$NODE || property === $2a8968f0c4d5fe8f$var$$HAS || property === "__proto__") return true;
        (0, $9ac5634fc6778fc7$export$12abb5141c6fdc9c)() && $2a8968f0c4d5fe8f$var$getNode($2a8968f0c4d5fe8f$var$getNodes(target, $2a8968f0c4d5fe8f$var$$HAS), property)();
        return property in target;
    },
    set (target, property, value) {
        (0, $9ac5634fc6778fc7$export$712ea50be43a7858)(()=>$2a8968f0c4d5fe8f$var$setProperty(target, property, $2a8968f0c4d5fe8f$export$debb760848ca95a(value)));
        return true;
    },
    deleteProperty (target, property) {
        (0, $9ac5634fc6778fc7$export$712ea50be43a7858)(()=>$2a8968f0c4d5fe8f$var$setProperty(target, property, undefined, true));
        return true;
    },
    ownKeys: $2a8968f0c4d5fe8f$var$ownKeys,
    getOwnPropertyDescriptor: $2a8968f0c4d5fe8f$var$proxyDescriptor
};
function $2a8968f0c4d5fe8f$var$wrap(value) {
    let p = value[0, $9ac5634fc6778fc7$export$5cd89106e2f6c2c5];
    if (!p) {
        Object.defineProperty(value, (0, $9ac5634fc6778fc7$export$5cd89106e2f6c2c5), {
            value: p = new Proxy(value, $2a8968f0c4d5fe8f$var$proxyTraps)
        });
        const keys = Object.keys(value), desc = Object.getOwnPropertyDescriptors(value);
        for(let i = 0, l = keys.length; i < l; i++){
            const prop = keys[i];
            if (desc[prop].get) {
                const get = desc[prop].get.bind(p);
                Object.defineProperty(value, prop, {
                    get: get
                });
            }
            if (desc[prop].set) {
                const og = desc[prop].set, set = (v)=>(0, $9ac5634fc6778fc7$export$712ea50be43a7858)(()=>og.call(p, v));
                Object.defineProperty(value, prop, {
                    set: set
                });
            }
        }
    }
    return p;
}
function $2a8968f0c4d5fe8f$export$ab7224b136d4492e(state, options) {
    const unwrappedStore = $2a8968f0c4d5fe8f$export$debb760848ca95a(state || {});
    const wrappedStore = $2a8968f0c4d5fe8f$var$wrap(unwrappedStore);
    return wrappedStore;
}
function $2a8968f0c4d5fe8f$export$4939f032d60167b6(state, modifier) {
    (0, $9ac5634fc6778fc7$export$712ea50be43a7858)(()=>modifier($2a8968f0c4d5fe8f$export$debb760848ca95a(state)));
}
const $2a8968f0c4d5fe8f$var$$ROOT = Symbol("store-root");
function $2a8968f0c4d5fe8f$var$applyState(target, parent, property, merge, key) {
    const previous = parent[property];
    if (target === previous) return;
    if (property !== $2a8968f0c4d5fe8f$var$$ROOT && (!$2a8968f0c4d5fe8f$var$isWrappable(target) || !$2a8968f0c4d5fe8f$var$isWrappable(previous) || key && target[key] !== previous[key])) {
        $2a8968f0c4d5fe8f$var$setProperty(parent, property, target);
        return;
    }
    if (Array.isArray(target)) {
        if (target.length && previous.length && (!merge || key && target[0] && target[0][key] != null)) {
            let i, j, start, end, newEnd, item, newIndicesNext, keyVal;
            for(start = 0, end = Math.min(previous.length, target.length); start < end && (previous[start] === target[start] || key && previous[start] && target[start] && previous[start][key] === target[start][key]); start++)$2a8968f0c4d5fe8f$var$applyState(target[start], previous, start, merge, key);
            const temp = new Array(target.length), newIndices = new Map();
            for(end = previous.length - 1, newEnd = target.length - 1; end >= start && newEnd >= start && (previous[end] === target[newEnd] || key && previous[start] && target[start] && previous[end][key] === target[newEnd][key]); end--, newEnd--)temp[newEnd] = previous[end];
            if (start > newEnd || start > end) {
                for(j = start; j <= newEnd; j++)$2a8968f0c4d5fe8f$var$setProperty(previous, j, target[j]);
                for(; j < target.length; j++){
                    $2a8968f0c4d5fe8f$var$setProperty(previous, j, temp[j]);
                    $2a8968f0c4d5fe8f$var$applyState(target[j], previous, j, merge, key);
                }
                if (previous.length > target.length) $2a8968f0c4d5fe8f$var$setProperty(previous, "length", target.length);
                return;
            }
            newIndicesNext = new Array(newEnd + 1);
            for(j = newEnd; j >= start; j--){
                item = target[j];
                keyVal = key && item ? item[key] : item;
                i = newIndices.get(keyVal);
                newIndicesNext[j] = i === undefined ? -1 : i;
                newIndices.set(keyVal, j);
            }
            for(i = start; i <= end; i++){
                item = previous[i];
                keyVal = key && item ? item[key] : item;
                j = newIndices.get(keyVal);
                if (j !== undefined && j !== -1) {
                    temp[j] = previous[i];
                    j = newIndicesNext[j];
                    newIndices.set(keyVal, j);
                }
            }
            for(j = start; j < target.length; j++)if (j in temp) {
                $2a8968f0c4d5fe8f$var$setProperty(previous, j, temp[j]);
                $2a8968f0c4d5fe8f$var$applyState(target[j], previous, j, merge, key);
            } else $2a8968f0c4d5fe8f$var$setProperty(previous, j, target[j]);
        } else for(let i = 0, len = target.length; i < len; i++)$2a8968f0c4d5fe8f$var$applyState(target[i], previous, i, merge, key);
        if (previous.length > target.length) $2a8968f0c4d5fe8f$var$setProperty(previous, "length", target.length);
        return;
    }
    const targetKeys = Object.keys(target);
    for(let i = 0, len = targetKeys.length; i < len; i++)$2a8968f0c4d5fe8f$var$applyState(target[targetKeys[i]], previous, targetKeys[i], merge, key);
    const previousKeys = Object.keys(previous);
    for(let i = 0, len = previousKeys.length; i < len; i++)if (target[previousKeys[i]] === undefined) $2a8968f0c4d5fe8f$var$setProperty(previous, previousKeys[i], undefined);
}
function $2a8968f0c4d5fe8f$export$38319cad1f6d89e0(value, options = {}) {
    const { merge: merge, key: key = "id" } = options, v = $2a8968f0c4d5fe8f$export$debb760848ca95a(value);
    return (state)=>{
        if (!$2a8968f0c4d5fe8f$var$isWrappable(state) || !$2a8968f0c4d5fe8f$var$isWrappable(v)) return v;
        const res = $2a8968f0c4d5fe8f$var$applyState(v, {
            [$2a8968f0c4d5fe8f$var$$ROOT]: state
        }, $2a8968f0c4d5fe8f$var$$ROOT, merge, key);
        return res === undefined ? state : res;
    };
}
const $2a8968f0c4d5fe8f$var$producers = new WeakMap();
const $2a8968f0c4d5fe8f$var$setterTraps = {
    get (target, property) {
        if (property === $2a8968f0c4d5fe8f$export$9f4df9bfaca7e3b7) return target;
        const value = target[property];
        let proxy;
        return $2a8968f0c4d5fe8f$var$isWrappable(value) ? $2a8968f0c4d5fe8f$var$producers.get(value) || ($2a8968f0c4d5fe8f$var$producers.set(value, proxy = new Proxy(value, $2a8968f0c4d5fe8f$var$setterTraps)), proxy) : value;
    },
    set (target, property, value) {
        $2a8968f0c4d5fe8f$var$setProperty(target, property, $2a8968f0c4d5fe8f$export$debb760848ca95a(value));
        return true;
    },
    deleteProperty (target, property) {
        $2a8968f0c4d5fe8f$var$setProperty(target, property, undefined, true);
        return true;
    }
};
function $2a8968f0c4d5fe8f$export$b46cabe22e78bc00(fn) {
    return (state)=>{
        if ($2a8968f0c4d5fe8f$var$isWrappable(state)) {
            let proxy;
            if (!(proxy = $2a8968f0c4d5fe8f$var$producers.get(state))) $2a8968f0c4d5fe8f$var$producers.set(state, proxy = new Proxy(state, $2a8968f0c4d5fe8f$var$setterTraps));
            fn(proxy);
        }
        return state;
    };
}
const $2a8968f0c4d5fe8f$export$404582bc18fe4d9e = undefined;



var $88700690a37410e3$require$Buffer = $24f87a6f86a8996f$export$a143d493d941bafc;
const $88700690a37410e3$var$DEFAULT_RELAYS = [
    "https://relay.pkarr.org"
];
const $88700690a37410e3$var$store = (0, $2a8968f0c4d5fe8f$export$ab7224b136d4492e)({
    seed: window.localStorage.getItem("seed"),
    records: [],
    relays: $88700690a37410e3$var$DEFAULT_RELAYS,
    lastPublished: "Not published yet",
    keyPair: null,
    pk () {
        if (!this.keyPair) return "...missing publicKey";
        return "pk:" + (0, $a3ab9fa3f7cde392$export$4be6b92acc95a574).encode(this.keyPair.publicKey);
    },
    records: [
        []
    ],
    recordsSize: 0,
    publishing: false,
    addRecord () {
        this.records = [
            ...this.records,
            {}
        ];
    },
    /**
   * @param {import('dns-packet').Answer[]} records
   */ updateRecords (records) {
        localStorage.setItem("records", JSON.stringify(records));
        records = $88700690a37410e3$var$store.getrecords();
        const packet = {
            id: 0,
            type: "response",
            answers: records.map((rr)=>({
                    name: "",
                    ttl: 30,
                    class: "IN",
                    type: "TXT",
                    data: "",
                    ...rr
                }))
        };
        const encodedPacket = (0, $a3ab9fa3f7cde392$export$75bcf2fe483cb517).encode(packet);
        this.recordsSize = encodedPacket.length || 0;
    },
    getrecords () {
        try {
            let json = localStorage.getItem("records");
            let records = JSON.parse(json);
            return records.filter((rr)=>rr.name && rr.data);
        } catch (error) {
            console.log(error);
            return [];
        }
    },
    publish () {
        const keyPair = {
            ...this.keyPair
        };
        const records = $88700690a37410e3$var$store.getrecords();
        const relays = [
            ...this.relays
        ];
        this.publishing = true;
        const packet = {
            id: 0,
            type: "response",
            answers: records.map((rr)=>({
                    name: "",
                    ttl: 30,
                    class: "IN",
                    type: "TXT",
                    data: "",
                    ...rr
                }))
        };
        const signedPacket = (0, $a3ab9fa3f7cde392$export$287a00fa5ebac8f3).fromPacket(keyPair, packet);
        const start = Date.now();
        (0, $a3ab9fa3f7cde392$export$757029e5d4b731bf).relayPut(relays[0], signedPacket).then((published)=>{
            if (published) {
                this.publishing = false;
                this.lastPublished = new Date().toLocaleString();
                localStorage.setItem("lastPublished", this.lastPublished);
                const time = Date.now() - start;
                this.temporaryMessage = "Published ... took " + time + " ms";
                setTimeout(()=>this.temporaryMessage = null, 2000);
            } else alert("Error publishing to all relays");
        });
    },
    resolved: [
        {}
    ],
    resolving: false,
    resolvedSize: 0,
    resolvedLastPublished: "Not resolved yet...",
    temporaryMessage: null,
    resolve (target) {
        let key = target.replace("pk:", "");
        try {
            key = (0, $a3ab9fa3f7cde392$export$4be6b92acc95a574).decode(key);
        } catch (error) {
            console.log("error: can't decode key", key);
            return;
        }
        this.resolving = true;
        const relays = [
            ...this.relays
        ];
        const start = Date.now();
        (0, $a3ab9fa3f7cde392$export$757029e5d4b731bf).relayGet(relays[0], key).then((signedPacket)=>{
            console.log({
                signedPacket: signedPacket
            });
            if (signedPacket) {
                this.resolved = signedPacket.packet().answers.map((rr)=>{
                    let denormalizedName = rr.name.replace((0, $a3ab9fa3f7cde392$export$4be6b92acc95a574).encode(key), "");
                    if (denormalizedName.length === 0) denormalizedName = "@";
                    if (denormalizedName.endsWith(".")) denormalizedName = denormalizedName.slice(0, -1);
                    return {
                        ...rr,
                        name: denormalizedName
                    };
                });
                this.resolvedLastPublished = new Date(signedPacket.timestamp() / 1000).toLocaleString();
                this.resolving = false;
                this.resolvedSize = signedPacket.size();
                const time = Date.now() - start;
                this.temporaryMessage = "Resolved ... took " + time + " ms";
                setTimeout(()=>this.temporaryMessage = null, 2000);
            } else alert("No records founds from any relay");
        }).catch((error)=>{
            alert("Error: " + error.message);
        });
    },
    updateSettings (seed, relays) {
        if (this.seed !== seed) {
            this.records = [
                {}
            ];
            localStorage.setItem("records", JSON.stringify(this.records));
        }
        this.seed = seed;
        this.keyPair = (0, $a3ab9fa3f7cde392$export$757029e5d4b731bf).generateKeyPair($88700690a37410e3$require$Buffer.from(seed, "hex"));
        this.relays = relays;
        localStorage.setItem("seed", seed);
        localStorage.setItem("relays", JSON.stringify(relays));
    },
    resetRelays () {
        this.relays = $88700690a37410e3$var$DEFAULT_RELAYS;
    },
    load () {
        {
            // Seeed
            const string = this.seed;
            const seed = string ? $88700690a37410e3$require$Buffer.from(string, "hex") : (0, $a3ab9fa3f7cde392$export$757029e5d4b731bf).generateSeed();
            this.seed = string || $88700690a37410e3$require$Buffer.from(seed).toString("hex");
            localStorage.setItem("seed", this.seed);
            // keyPair
            this.keyPair = (0, $a3ab9fa3f7cde392$export$757029e5d4b731bf).generateKeyPair(seed);
        }
        {
            // Relays
            const relays = localStorage.getItem("relays");
            try {
                this.relays = JSON.parse(relays) || $88700690a37410e3$var$DEFAULT_RELAYS;
            } catch  {}
        }
        {
            // Records
            const records = localStorage.getItem("records");
            if (records) try {
                this.records = JSON.parse(records);
                this.updateRecords(this.records);
            } catch  {}
        }
        // Last published
        this.lastPublished = localStorage.getItem("lastPublished");
    }
});
$88700690a37410e3$var$store.load();
var $88700690a37410e3$export$2e2bcd8739ae039 = $88700690a37410e3$var$store;



var $b8f9b7833fa37166$require$Buffer = $24f87a6f86a8996f$export$a143d493d941bafc;
const $b8f9b7833fa37166$var$_tmpl$ = /*#__PURE__*/ (0, $55de8698182680ee$export$ce69bd05624d0c48)(`<header><div class=row><a href=https://github.com/nuhvi/pkarr target=_blank><h1>Pkarr</h1></a><button id=settings-button title=Configure><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink fill=#000000 version=1.1 id=Capa_1 width=800px height=800px viewBox="0 0 45.973 45.973"xml:space=preserve><path d="M43.454,18.443h-2.437c-0.453-1.766-1.16-3.42-2.082-4.933l1.752-1.756c0.473-0.473,0.733-1.104,0.733-1.774    c0-0.669-0.262-1.301-0.733-1.773l-2.92-2.917c-0.947-0.948-2.602-0.947-3.545-0.001l-1.826,1.815    C30.9,6.232,29.296,5.56,27.529,5.128V2.52c0-1.383-1.105-2.52-2.488-2.52h-4.128c-1.383,0-2.471,1.137-2.471,2.52v2.607    c-1.766,0.431-3.38,1.104-4.878,1.977l-1.825-1.815c-0.946-0.948-2.602-0.947-3.551-0.001L5.27,8.205    C4.802,8.672,4.535,9.318,4.535,9.978c0,0.669,0.259,1.299,0.733,1.772l1.752,1.76c-0.921,1.513-1.629,3.167-2.081,4.933H2.501    C1.117,18.443,0,19.555,0,20.935v4.125c0,1.384,1.117,2.471,2.501,2.471h2.438c0.452,1.766,1.159,3.43,2.079,4.943l-1.752,1.763    c-0.474,0.473-0.734,1.106-0.734,1.776s0.261,1.303,0.734,1.776l2.92,2.919c0.474,0.473,1.103,0.733,1.772,0.733    s1.299-0.261,1.773-0.733l1.833-1.816c1.498,0.873,3.112,1.545,4.878,1.978v2.604c0,1.383,1.088,2.498,2.471,2.498h4.128    c1.383,0,2.488-1.115,2.488-2.498v-2.605c1.767-0.432,3.371-1.104,4.869-1.977l1.817,1.812c0.474,0.475,1.104,0.735,1.775,0.735    c0.67,0,1.301-0.261,1.774-0.733l2.92-2.917c0.473-0.472,0.732-1.103,0.734-1.772c0-0.67-0.262-1.299-0.734-1.773l-1.75-1.77    c0.92-1.514,1.627-3.179,2.08-4.943h2.438c1.383,0,2.52-1.087,2.52-2.471v-4.125C45.973,19.555,44.837,18.443,43.454,18.443z     M22.976,30.85c-4.378,0-7.928-3.517-7.928-7.852c0-4.338,3.55-7.85,7.928-7.85c4.379,0,7.931,3.512,7.931,7.85    C30.906,27.334,27.355,30.85,22.976,30.85z"></path></svg></button></div><p>Resolvable sovereign keys, now!`), $b8f9b7833fa37166$var$_tmpl$2 = /*#__PURE__*/ (0, $55de8698182680ee$export$ce69bd05624d0c48)(`<main><div class=tabs><button id=publish-tab>Publish</button><button id=resolve-tab>Resolve</button></div><article id=publish-content><h3 id=public-key></h3><ul class=fine-text><li>Add some records to your public-key, and publish it to the DHT when you are ready.</li><li>Copy your key \`pk:...\` and share with your friends so they can fecth and watch your records.</li><li>Paste any of your friend's keys in the Resolve tab to get their latest records.</li><li>You need to republish your records every hour or so, otherwise they will be dropped from the DHT.</li><li>Anyone can republish your records, and you can republish your friends records too.</li><li>Open settings to add or remove relays, you can also <a href=https://github.com/Nuhvi/pkarr/tree/main/server target=_blank>run your own relay</a>.</li><li>Open settings to export, import, or regenerate new seed.</li><li>It is safe to edit your records from multiple devices, but some changes might be lost.</li></ul></article><article id=resolve-content><h3>Resolve</h3><input id=resolve-input autofocus placeholder="paste a public-key to lookup and resolve">`), $b8f9b7833fa37166$var$_tmpl$3 = /*#__PURE__*/ (0, $55de8698182680ee$export$ce69bd05624d0c48)(`<div id=modal-container><div id=modal-content><div class=row><h2>Configure</h2><button id=modal-close>&times;</button></div><div class=modal-body id=settings><div class=row><label>Seed</label><input id=seed><div id=seed-buttons><button id=paste-seed>paste seed</button><button id=copy-seed></button><button id=generate-seed>generate</button></div></div><div class=row><label>Relays</label><textarea id=relays rows=5></textarea><button id=reset-relays>reset</button></div><button class=primary id=settings-save-button>Save`), $b8f9b7833fa37166$var$_tmpl$4 = /*#__PURE__*/ (0, $55de8698182680ee$export$ce69bd05624d0c48)(`<footer><p>This is a proof of concept for demonstration purposes only.</p><p>Read the motivation, architecture and how it works, <a href=https://github.com/nuhvi/pkarr target=_blank>README</a></p><p>Open an <a href=https://github.com/nuhvi/pkarr/issues target=_blank>Issue</a> offering a free relay, your expertise, or help shape the spec.`), $b8f9b7833fa37166$var$_tmpl$5 = /*#__PURE__*/ (0, $55de8698182680ee$export$ce69bd05624d0c48)(`<div class=table><div class=table-header><div class=table-header-cell>Name</div><div class=table-header-cell>Value</div></div><div class=records><form id=records-form></form><div class=details><div><b>last update: </b><span id=last-published></span></div><div><b>compressed size: </b> <span id=size></span>/1000 bytes</div></div><div id=add-record-button-container></div><div class=buttons-record-container><button id=publish-button class=primary>`), $b8f9b7833fa37166$var$_tmpl$6 = /*#__PURE__*/ (0, $55de8698182680ee$export$ce69bd05624d0c48)(`<div class=table-row><input type=text autofocus><input type=text>`), $b8f9b7833fa37166$var$_tmpl$7 = /*#__PURE__*/ (0, $55de8698182680ee$export$ce69bd05624d0c48)(`<button id=add-record-button><span>+</span> Add Record`);
const $b8f9b7833fa37166$var$App = ()=>{
    const [showSettings, setShowSettings] = (0, $9ac5634fc6778fc7$export$c1e1e1ecbbe76a5)(false);
    const [tab, setTab] = (0, $9ac5634fc6778fc7$export$c1e1e1ecbbe76a5)(0);
    const [target, setTarget] = (0, $9ac5634fc6778fc7$export$c1e1e1ecbbe76a5)(null);
    const [settingsSeed, setSettingsSeed] = (0, $9ac5634fc6778fc7$export$c1e1e1ecbbe76a5)((0, $88700690a37410e3$export$2e2bcd8739ae039).seed);
    const [copySeedText, setCopySeedText] = (0, $9ac5634fc6778fc7$export$c1e1e1ecbbe76a5)("copy seed");
    const [settingsRelays, setSettingsRelays] = (0, $9ac5634fc6778fc7$export$c1e1e1ecbbe76a5)((0, $88700690a37410e3$export$2e2bcd8739ae039).relays);
    (0, $9ac5634fc6778fc7$export$7ea7134f704deda4)(()=>{
        const location = window.location;
        const pk = new URL(location.toString()).searchParams.get("pk");
        if (!pk || pk.length !== 52) return;
        setTarget(pk);
        setTab(1);
    });
    const toggleSettings = ()=>{
        setSettingsSeed((0, $88700690a37410e3$export$2e2bcd8739ae039).seed);
        setShowSettings(!showSettings());
    };
    const copySeed = async ()=>{
        try {
            await navigator.clipboard.writeText(settingsSeed());
            setCopySeedText("Copied...");
        } catch (err) {
            console.error("Error copying text to clipboard:", err);
            setCopySeedText("Errorr copying to clipboard!");
        } finally{
            setTimeout(()=>setCopySeedText("copy seed"), 1000);
        }
    };
    const pasteSeed = async ()=>{
        const seed = await navigator.clipboard.readText();
        if (seed.length !== 64) {
            alert("Seed must be a 64 character hex encoded string");
            return;
        }
        setSettingsSeed(seed);
    };
    const handleSaveSettings = ()=>{
        (0, $88700690a37410e3$export$2e2bcd8739ae039).updateSettings(settingsSeed(), settingsRelays());
        setShowSettings(false);
    };
    const handleSettingsRelayChange = (event)=>{
        setSettingsRelays(event.target.value.split("\n"));
    };
    const handleResetRelays = ()=>{
        (0, $88700690a37410e3$export$2e2bcd8739ae039).resetRelays();
        setSettingsRelays((0, $88700690a37410e3$export$2e2bcd8739ae039).relays);
    };
    const toggleTab = ()=>{
        if (tab() === 1) window.location.search = "";
        setTab(tab() === 0 ? 1 : 0);
    };
    return [
        (()=>{
            const _el$ = $b8f9b7833fa37166$var$_tmpl$(), _el$2 = _el$.firstChild, _el$3 = _el$2.firstChild, _el$4 = _el$3.nextSibling;
            _el$4.$$click = ()=>toggleSettings();
            return _el$;
        })(),
        (()=>{
            const _el$5 = $b8f9b7833fa37166$var$_tmpl$2(), _el$6 = _el$5.firstChild, _el$7 = _el$6.firstChild, _el$8 = _el$7.nextSibling, _el$9 = _el$6.nextSibling, _el$10 = _el$9.firstChild, _el$11 = _el$10.nextSibling, _el$12 = _el$9.nextSibling, _el$13 = _el$12.firstChild, _el$14 = _el$13.nextSibling;
            _el$7.$$click = toggleTab;
            _el$8.$$click = toggleTab;
            (0, $55de8698182680ee$export$21a5ca8aa77d35ff)(_el$10, ()=>(0, $88700690a37410e3$export$2e2bcd8739ae039).pk());
            (0, $55de8698182680ee$export$21a5ca8aa77d35ff)(_el$9, (0, $9ac5634fc6778fc7$export$60e54eaca7e7fb38)($b8f9b7833fa37166$var$Records, {}), _el$11);
            _el$14.$$input = (e)=>setTarget(e.target.value);
            (0, $55de8698182680ee$export$21a5ca8aa77d35ff)(_el$12, (0, $9ac5634fc6778fc7$export$60e54eaca7e7fb38)($b8f9b7833fa37166$var$Records, {
                resolver: true,
                target: target
            }), null);
            (0, $9ac5634fc6778fc7$export$314dade334ae905d)((_p$)=>{
                const _v$ = `tab-button ${tab() === 0 && "active"}`, _v$2 = `tab-button ${tab() === 1 && "active"}`, _v$3 = "tab-content" + ` ${tab() === 1 && "hidden"}`, _v$4 = "tab-content" + ` ${tab() === 0 && "hidden"}`;
                _v$ !== _p$._v$ && (0, $55de8698182680ee$export$2913c0c0b5623090)(_el$7, _p$._v$ = _v$);
                _v$2 !== _p$._v$2 && (0, $55de8698182680ee$export$2913c0c0b5623090)(_el$8, _p$._v$2 = _v$2);
                _v$3 !== _p$._v$3 && (0, $55de8698182680ee$export$2913c0c0b5623090)(_el$9, _p$._v$3 = _v$3);
                _v$4 !== _p$._v$4 && (0, $55de8698182680ee$export$2913c0c0b5623090)(_el$12, _p$._v$4 = _v$4);
                return _p$;
            }, {
                _v$: undefined,
                _v$2: undefined,
                _v$3: undefined,
                _v$4: undefined
            });
            (0, $9ac5634fc6778fc7$export$314dade334ae905d)(()=>_el$14.value = target());
            return _el$5;
        })(),
        (()=>{
            const _el$15 = $b8f9b7833fa37166$var$_tmpl$3(), _el$16 = _el$15.firstChild, _el$17 = _el$16.firstChild, _el$18 = _el$17.firstChild, _el$19 = _el$18.nextSibling, _el$20 = _el$17.nextSibling, _el$21 = _el$20.firstChild, _el$22 = _el$21.firstChild, _el$23 = _el$22.nextSibling, _el$24 = _el$23.nextSibling, _el$25 = _el$24.firstChild, _el$26 = _el$25.nextSibling, _el$27 = _el$26.nextSibling, _el$28 = _el$21.nextSibling, _el$29 = _el$28.firstChild, _el$30 = _el$29.nextSibling, _el$31 = _el$30.nextSibling, _el$32 = _el$28.nextSibling;
            _el$19.$$click = ()=>toggleSettings();
            _el$25.$$click = pasteSeed;
            _el$26.$$click = copySeed;
            (0, $55de8698182680ee$export$21a5ca8aa77d35ff)(_el$26, copySeedText);
            _el$27.$$click = ()=>setSettingsSeed($b8f9b7833fa37166$require$Buffer.from((0, $a3ab9fa3f7cde392$export$757029e5d4b731bf).generateSeed()).toString("hex"));
            _el$30.addEventListener("change", handleSettingsRelayChange);
            (0, $55de8698182680ee$export$21a5ca8aa77d35ff)(_el$30, ()=>settingsRelays().join("\n"));
            _el$31.$$click = handleResetRelays;
            _el$32.$$click = handleSaveSettings;
            (0, $9ac5634fc6778fc7$export$314dade334ae905d)(()=>(0, $55de8698182680ee$export$2913c0c0b5623090)(_el$15, !showSettings() && "hidden"));
            (0, $9ac5634fc6778fc7$export$314dade334ae905d)(()=>_el$23.value = settingsSeed().slice(0, 8) + "*".repeat(56));
            return _el$15;
        })(),
        $b8f9b7833fa37166$var$_tmpl$4()
    ];
};
function $b8f9b7833fa37166$var$Records({ resolver: resolver, target: target }) {
    let form;
    function addRecord(e) {
        e?.preventDefault();
        (0, $88700690a37410e3$export$2e2bcd8739ae039).addRecord();
        const inputs = form.querySelectorAll("input");
        const input = inputs[inputs.length - 2];
        input.focus();
    }
    function onKeyDown(x) {
        if (x.code === "Enter") addRecord();
    }
    function handlePublish(e) {
        e?.preventDefault();
        (0, $88700690a37410e3$export$2e2bcd8739ae039).publish();
    }
    function handleResolve(e) {
        e?.preventDefault();
        (0, $88700690a37410e3$export$2e2bcd8739ae039).resolve(target());
        window.history.replaceState(null, "", `?pk=${target().replace("pk:", "")}`);
    }
    (0, $9ac5634fc6778fc7$export$1e848a9e87980bd5)(()=>{
        const _target = target?.();
        if (!_target) return;
        (0, $88700690a37410e3$export$2e2bcd8739ae039).resolve(_target);
    });
    let typingTimer;
    function handleInput() {
        clearTimeout(typingTimer);
        typingTimer = setTimeout(()=>{
            const records = [
                ...form.querySelectorAll("input")
            ].reduce((acc, input, i)=>{
                if (i % 2 === 0) acc.push({
                    name: input.value
                });
                else acc[acc.length - 1].data = input.value;
                return acc;
            }, []);
            (0, $88700690a37410e3$export$2e2bcd8739ae039).updateRecords(records);
        }, 10);
    }
    return (()=>{
        const _el$34 = $b8f9b7833fa37166$var$_tmpl$5(), _el$35 = _el$34.firstChild, _el$36 = _el$35.nextSibling, _el$37 = _el$36.firstChild, _el$38 = _el$37.nextSibling, _el$39 = _el$38.firstChild, _el$40 = _el$39.firstChild, _el$41 = _el$40.nextSibling, _el$42 = _el$39.nextSibling, _el$43 = _el$42.firstChild, _el$44 = _el$43.nextSibling, _el$45 = _el$44.nextSibling, _el$46 = _el$38.nextSibling, _el$47 = _el$46.nextSibling, _el$48 = _el$47.firstChild;
        _el$37.$$keydown = onKeyDown;
        const _ref$ = form;
        typeof _ref$ === "function" ? (0, $55de8698182680ee$export$1f96ae73734a86cc)(_ref$, _el$37) : form = _el$37;
        (0, $55de8698182680ee$export$21a5ca8aa77d35ff)(_el$37, (0, $9ac5634fc6778fc7$export$60e54eaca7e7fb38)((0, $9ac5634fc6778fc7$export$bdf530073099ce9f), {
            get each () {
                return resolver ? (0, $88700690a37410e3$export$2e2bcd8739ae039).resolved : (0, $88700690a37410e3$export$2e2bcd8739ae039).records;
            },
            children: (record, rowIndex)=>{
                return (()=>{
                    const _el$49 = $b8f9b7833fa37166$var$_tmpl$6(), _el$50 = _el$49.firstChild, _el$51 = _el$50.nextSibling;
                    _el$50.$$input = (e)=>handleInput(e, rowIndex(), 0);
                    _el$50.disabled = resolver;
                    (0, $55de8698182680ee$export$9fec4d97f1922e0b)(_el$50, "placeholder", !resolver ? "name" : "No records yet...");
                    _el$51.$$input = (e)=>handleInput(e, rowIndex(), 1);
                    _el$51.disabled = resolver;
                    (0, $55de8698182680ee$export$9fec4d97f1922e0b)(_el$51, "placeholder", !resolver ? "value" : "");
                    (0, $9ac5634fc6778fc7$export$314dade334ae905d)(()=>_el$50.value = record.name || "");
                    (0, $9ac5634fc6778fc7$export$314dade334ae905d)(()=>_el$51.value = record.data || "");
                    return _el$49;
                })();
            }
        }));
        (0, $55de8698182680ee$export$21a5ca8aa77d35ff)(_el$41, ()=>resolver ? (0, $88700690a37410e3$export$2e2bcd8739ae039).resolvedLastPublished : (0, $88700690a37410e3$export$2e2bcd8739ae039).lastPublished);
        (0, $55de8698182680ee$export$21a5ca8aa77d35ff)(_el$45, ()=>resolver ? (0, $88700690a37410e3$export$2e2bcd8739ae039).resolvedSize : (0, $88700690a37410e3$export$2e2bcd8739ae039).recordsSize);
        (0, $55de8698182680ee$export$21a5ca8aa77d35ff)(_el$46, !resolver && (()=>{
            const _el$52 = $b8f9b7833fa37166$var$_tmpl$7();
            _el$52.$$click = addRecord;
            return _el$52;
        })());
        (0, $55de8698182680ee$export$3f65cefe8380dbea)(_el$48, "click", resolver ? handleResolve : handlePublish, true);
        (0, $55de8698182680ee$export$21a5ca8aa77d35ff)(_el$48, ()=>(resolver ? (0, $88700690a37410e3$export$2e2bcd8739ae039).resolving ? "Resolving... this may take few seconds" : "Resolve" : (0, $88700690a37410e3$export$2e2bcd8739ae039).publishing ? "Publishing... this may take few seconds" : "Publish") + ((0, $88700690a37410e3$export$2e2bcd8739ae039).temporaryMessage || ""));
        (0, $9ac5634fc6778fc7$export$314dade334ae905d)(()=>_el$48.disabled = resolver ? (0, $88700690a37410e3$export$2e2bcd8739ae039).resolving : (0, $88700690a37410e3$export$2e2bcd8739ae039).publishing);
        return _el$34;
    })();
}
const $b8f9b7833fa37166$var$app = document.getElementById("app");
if ($b8f9b7833fa37166$var$app) (0, $55de8698182680ee$export$b3890eb0ae9dca99)(()=>(0, $9ac5634fc6778fc7$export$60e54eaca7e7fb38)($b8f9b7833fa37166$var$App, {}), $b8f9b7833fa37166$var$app);
(0, $55de8698182680ee$export$ad0f7f87f67e17d6)([
    "click",
    "input",
    "keydown"
]);

})();
//# sourceMappingURL=index.7b3b1ff9.js.map
